function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6qBzG", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$3409d202bfcc1da0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $grj9i;
    var $l8ruj;
    var $7DYR6;
    function $3409d202bfcc1da0$export$2e2bcd8739ae039() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "queues-issue-view-spa"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("grj9i")).default), {
            pageId: "queues-issue-view"
        }, ({ match: match, pageContext: pageContext, push: push })=>pageContext && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DYR6")).default), {
                pageContext: pageContext,
                push: push,
                match: match
            })));
    }
});
parcelRegister("grj9i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$412a33f5222e913d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $cf7yQ;
    var $53AcJ;
    var $kbi2o;
    var $jF62O;
    var $e33py;
    var $gq0sA;
    var $cz40O;
    var $8XAvX;
    var $1ilU2;
    var $g5X3G;
    var $4dRjY;
    var $dIdda = parcelRequire("dIdda");
    var $k30xR;
    var $6OeKD;
    const $412a33f5222e913d$var$QueuesAppBase = (props)=>{
        const { QueuesPushProvider: QueuesPushProvider, pageId: pageId } = props;
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const [{ data: pageContextData, error: error }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
        const { baseUrl: baseUrl = '' } = tenantContext || {};
        const { projectName: projectName } = projectContext || {};
        const pageContextProps = (0, $5uXOq.useMemo)(()=>({
                ...tenantContext,
                ...projectContext,
                ...serviceDeskContext
            }), [
            projectContext,
            serviceDeskContext,
            tenantContext
        ]);
        const projectKey = (0, (0, parcelRequire("g5X3G")).toProjectKey)(match.params.projectKey || '');
        const practice = (0, (0, parcelRequire("1ilU2")).toItsmPractice)(match.params.practiceType);
        const [categorizedQueues, categorizedQueuesLoading, categorizedError, methods] = (0, (0, parcelRequire("jF62O")).useCategorizedQueues)(baseUrl, projectKey, practice);
        let selectedQueueName;
        if (categorizedQueues && match.params.queueId) {
            const selectedQueue = categorizedQueues.find((queue)=>queue.id === Number(match.params.queueId));
            selectedQueueName = selectedQueue ? selectedQueue.name : undefined;
        }
        (0, (0, parcelRequire("k30xR")).useOnFavoritesChanged)(projectKey, practice, categorizedQueues, methods.editItemFavorite);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cz40O")).SpaPageWrapper), {
            pageId: pageId,
            baseUrl: baseUrl,
            currentUrl: match.url,
            projectContext: projectContext,
            isLoading: !pageContextData && !error || categorizedQueuesLoading,
            error: error
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(QueuesPushProvider, {
            projectKey: projectKey
        }, ({ push: push, replace: providerReplace })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).ServiceDeskDocumentTitle), {
                projectName: projectName,
                section: "queues",
                subsection: selectedQueueName
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children({
                push: push,
                match: match,
                replace: providerReplace,
                queuesData: {
                    data: (0, (0, parcelRequire("6OeKD")).pageToQueues)(categorizedQueues || []),
                    error: categorizedError ? categorizedError.message : undefined,
                    loading: categorizedQueuesLoading
                },
                category: practice,
                pageContext: pageContextProps
            }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null));
    };
    var $412a33f5222e913d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)($412a33f5222e913d$var$QueuesAppBase, {
        QueueProvider: (0, (0, parcelRequire("kbi2o")).default),
        QueuesApiDataProvider: (0, (0, parcelRequire("53AcJ")).default),
        QueuesPushProvider: (0, (0, parcelRequire("8XAvX")).default)
    });
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("6MoH3")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("ejgPJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("2VzMc")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("ahFso")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("6MoH3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("chQyv").then(()=>parcelRequire('hZyYK'));
});
parcelRegister("ejgPJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("2VzMc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("ahFso", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("53AcJ", function(module, exports) {
    $parcel$export(module.exports, "AvailableQueuesConsumer", ()=>$f81f7587879fbe9d$export$dfebed0fc9519fcc);
    $parcel$export(module.exports, "default", ()=>$f81f7587879fbe9d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dd29Z;
    var $3HGy4;
    var $5j0B5;
    var $gm93k;
    var $8nV9C;
    const $f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
    const $f81f7587879fbe9d$var$AvailableQueuesContext = (0, $5uXOq.createContext)({
        setFavorite: (0, ($parcel$interopDefault($8Rkzz))),
        deleteNavItem: (0, ($parcel$interopDefault($8Rkzz))),
        updateIssueCount: (0, ($parcel$interopDefault($8Rkzz))),
        markNavItemsAsStale: (0, ($parcel$interopDefault($8Rkzz))),
        getQueueCount: (0, ($parcel$interopDefault($8Rkzz))),
        setLastVisitedQueueId: (0, ($parcel$interopDefault($8Rkzz))),
        getLastVisitedQueueId: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const { Provider: $f81f7587879fbe9d$var$Provider, Consumer: $f81f7587879fbe9d$export$dfebed0fc9519fcc } = $f81f7587879fbe9d$var$AvailableQueuesContext;
    class $f81f7587879fbe9d$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                FavoriteSubscriber: (0, (0, parcelRequire("gm93k")).default),
                queuesPrefetchData: [],
                push: undefined,
                onDeleteNavItem: undefined
            };
        }
        constructor(props){
            const { onNavUpdated: onNavUpdated, onIssueCountUpdated: onIssueCountUpdated, queuesPrefetchData: queuesPrefetchData, push: push } = props;
            super(props);
            this.getQueueCount = ()=>{
                const { data: data } = this.state;
                return data ? Object.keys(data).filter((queueId)=>!this.deletedQueueIds.has((0, (0, parcelRequire("3HGy4")).toQueueIdString)(queueId))).length : 0;
            };
            this.getLastVisitedQueueId = (projectKey)=>{
                const { category: category } = this.props;
                if (!projectKey) return null;
                try {
                    if (category) return (0, (0, parcelRequire("5j0B5")).getFromLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
                    return (0, (0, parcelRequire("5j0B5")).getFromLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`);
                } catch (error) {
                    return null;
                }
            };
            this.setFavorite = (queueId, newValue)=>{
                const { FavoriteSubscriber: FavoriteSubscriber } = this.props;
                FavoriteSubscriber.setFavorite(queueId, newValue);
            };
            this.setLastVisitedQueueId = (queueId, projectKey)=>{
                const lastVisitedQueueId = this.getLastVisitedQueueId(projectKey);
                const { category: category } = this.props;
                if (projectKey && lastVisitedQueueId !== queueId) try {
                    if (category) (0, (0, parcelRequire("5j0B5")).setInLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, (0, parcelRequire("3HGy4")).fromQueueIdString)(queueId));
                    else (0, (0, parcelRequire("5j0B5")).setInLocalStorage)(`${$f81f7587879fbe9d$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`, (0, (0, parcelRequire("3HGy4")).fromQueueIdString)(queueId));
                } catch (error) {}
            };
            this.queuesContext = {
                deleteNavItem: this.deleteNavItem(push),
                updateIssueCount: onIssueCountUpdated,
                markNavItemsAsStale: ()=>onNavUpdated(false),
                setFavorite: this.setFavorite,
                getQueueCount: this.getQueueCount,
                setLastVisitedQueueId: this.setLastVisitedQueueId,
                getLastVisitedQueueId: this.getLastVisitedQueueId
            };
            this.deletedQueueIds = new Set();
            this.state = {
                loading: false,
                error: undefined,
                data: queuesPrefetchData.length ? (0, (0, parcelRequire("8nV9C")).pageToQueues)(queuesPrefetchData) : undefined
            };
        }
        static getDerivedStateFromProps(props, state) {
            const { queuesPrefetchData: queuesPrefetchData } = props;
            if (!(0, ($parcel$interopDefault($ajpes)))((0, (0, parcelRequire("8nV9C")).pageToQueues)(queuesPrefetchData), state.data) && queuesPrefetchData.length) return {
                data: (0, (0, parcelRequire("8nV9C")).pageToQueues)(queuesPrefetchData)
            };
            return null;
        }
        componentWillUnmount() {
            const { fetchSubscription: fetchSubscription, deleteItemSubscription: deleteItemSubscription } = this;
            fetchSubscription && fetchSubscription.unsubscribe();
            deleteItemSubscription && deleteItemSubscription.unsubscribe();
        }
        deleteNavItem(push) {
            return (queueId)=>{
                const { onDeleteNavItem: onDeleteNavItem } = this.props;
                onDeleteNavItem && onDeleteNavItem((0, (0, parcelRequire("3HGy4")).fromQueueIdString)(queueId));
                const updatedQueues = {
                    ...this.state.data
                };
                delete updatedQueues[(0, (0, parcelRequire("3HGy4")).fromQueueIdString)(queueId)];
                const deletedLastQueue = Object.keys(updatedQueues).length === 0;
                if (deletedLastQueue) push && push(`${(0, (0, parcelRequire("dd29Z")).getQueueFragment)()}/custom/new`);
                else push && push((0, (0, parcelRequire("dd29Z")).getQueueFragment)());
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($f81f7587879fbe9d$var$Provider, {
                value: this.queuesContext
            }, this.props.children(this.state));
        }
    }
});
parcelRegister("dd29Z", function(module, exports) {
    $parcel$export(module.exports, "QUEUE_ROUTES", ()=>$10cfdb56a53da9cf$export$410a6306dae101ca);
    $parcel$export(module.exports, "navigate", ()=>$10cfdb56a53da9cf$export$ff7962acd6052c28);
    $parcel$export(module.exports, "getQueueFragment", ()=>$10cfdb56a53da9cf$export$954f428fa284c7);
    $parcel$export(module.exports, "getEditQueueFragment", ()=>$10cfdb56a53da9cf$export$86f6a6d69e87f843);
    $parcel$export(module.exports, "getCloneQueueFragment", ()=>$10cfdb56a53da9cf$export$7a487d215c9c3f76);
    $parcel$export(module.exports, "getQueueIssueFragment", ()=>$10cfdb56a53da9cf$export$773cefb51b60b161);
    $parcel$export(module.exports, "getIssueFragment", ()=>$10cfdb56a53da9cf$export$a796bfaff67c9fae);
    $parcel$export(module.exports, "getQueueUrl", ()=>$10cfdb56a53da9cf$export$a29b42a005fecf0);
    $parcel$export(module.exports, "getEditQueueUrlFromManageQueue", ()=>$10cfdb56a53da9cf$export$91152835d12ca65f);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    parcelRequire("9o0uh");
    parcelRequire("fPS7b");
    parcelRequire("c66Ur");
    var $5viSR = parcelRequire("5viSR");
    var $oCMSG;
    var $hzd6p;
    const $10cfdb56a53da9cf$var$LOCATION = 'servicedesk.common.navigation.queues';
    let $10cfdb56a53da9cf$var$navigatorPromise;
    const $10cfdb56a53da9cf$var$getPushStateNavigator = ()=>{
        if (!$10cfdb56a53da9cf$var$navigatorPromise) $10cfdb56a53da9cf$var$navigatorPromise = (0, (0, parcelRequire("hzd6p")).createPushStateNavigator)();
        return $10cfdb56a53da9cf$var$navigatorPromise;
    };
    const $10cfdb56a53da9cf$export$410a6306dae101ca = {
        [(0, (0, parcelRequire("oCMSG")).INCIDENTS)]: 'section/incidents',
        [(0, (0, parcelRequire("oCMSG")).CHANGES)]: 'section/changes',
        [(0, (0, parcelRequire("oCMSG")).SERVICE_REQUEST)]: 'section/service-requests',
        [(0, (0, parcelRequire("oCMSG")).PROBLEMS)]: 'section/problems',
        [(0, (0, parcelRequire("oCMSG")).POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
        [(0, (0, parcelRequire("oCMSG")).NO_CATEGORY)]: 'queues'
    };
    const $10cfdb56a53da9cf$var$fromCategory = (category)=>$10cfdb56a53da9cf$export$410a6306dae101ca[category || (0, (0, parcelRequire("oCMSG")).NO_CATEGORY)];
    const $10cfdb56a53da9cf$export$ff7962acd6052c28 = (projectKey, fragment)=>{
        (0, $5viSR.emitSignal)($10cfdb56a53da9cf$var$LOCATION, {
            projectKey: projectKey,
            fragment: fragment
        });
        return (0, $kVLXA.Observable).fromPromise($10cfdb56a53da9cf$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
            pushStateNavigator.navigateToFragment(fragment);
            return (0, $kVLXA.Observable).empty();
        }).catch(()=>(0, $kVLXA.Observable).empty());
    };
    const $10cfdb56a53da9cf$export$954f428fa284c7 = (queueId, category)=>{
        const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
        return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
    };
    const $10cfdb56a53da9cf$export$86f6a6d69e87f843 = (queueId, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/edit`;
    const $10cfdb56a53da9cf$export$7a487d215c9c3f76 = (queueId, category)=>{
        const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
        return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
    };
    const $10cfdb56a53da9cf$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/${issueKey}`;
    const $10cfdb56a53da9cf$export$a796bfaff67c9fae = (issueKey)=>`${$10cfdb56a53da9cf$export$954f428fa284c7()}/issue/${issueKey}`;
    const $10cfdb56a53da9cf$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
        const urlSearchParams = new URLSearchParams();
        if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
            urlSearchParams.set(key, value);
        });
        const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
        return `/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
    };
    const $10cfdb56a53da9cf$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$86f6a6d69e87f843(queueId, category)}`;
});
parcelRegister("5viSR", function(module, exports) {
    $parcel$export(module.exports, "emitSignal", ()=>$8dc3d00171ca741d$export$a8a72bca1918549c);
    const $8dc3d00171ca741d$var$isProduction = ()=>true;
    const $8dc3d00171ca741d$var$registerSignal = (signal, meta)=>{
        window.cySignals.allSignals.push(signal);
        const signalsByName = window.cySignals.signalsByName;
        if (signalsByName[signal]) signalsByName[signal].push(meta);
        else signalsByName[signal] = [
            meta
        ];
    };
    const $8dc3d00171ca741d$var$initCySignals = ()=>{
        window.cySignals = {
            signalsByName: {},
            allSignals: []
        };
    };
    const $8dc3d00171ca741d$export$a8a72bca1918549c = (signal, meta = {})=>{
        if ($8dc3d00171ca741d$var$isProduction()) return;
        if (!window.cySignals) $8dc3d00171ca741d$var$initCySignals();
        $8dc3d00171ca741d$var$registerSignal(signal, meta);
    };
});
parcelRegister("hzd6p", function(module, exports) {
    $parcel$export(module.exports, "createPushStateNavigator", ()=>$ddde70bc55609ded$export$d3bf579f8e5cd838);
    var $6BZYo;
    const $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
    const $ddde70bc55609ded$var$REQUIRE_TIMEOUT = 100;
    const $ddde70bc55609ded$var$REQUIRE_RETRIES = 5;
    const $ddde70bc55609ded$export$d3bf579f8e5cd838 = ()=>(0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE,
            timeout: $ddde70bc55609ded$var$REQUIRE_TIMEOUT,
            tentatives: $ddde70bc55609ded$var$REQUIRE_RETRIES
        });
});
parcelRegister("3HGy4", function(module, exports) {
    $parcel$export(module.exports, "toQueueId", ()=>$ad23a38600e1d52f$export$dae52b119ebf2444);
    $parcel$export(module.exports, "fromQueueId", ()=>$ad23a38600e1d52f$export$999de35c9ca8105b);
    $parcel$export(module.exports, "toQueueIdString", ()=>$ad23a38600e1d52f$export$cda0e35414946580);
    $parcel$export(module.exports, "fromQueueIdString", ()=>$ad23a38600e1d52f$export$cde8da12f845d56f);
    $parcel$export(module.exports, "LOCAL_STORAGE_SOURCE", ()=>$ad23a38600e1d52f$export$6e21137db7aec966);
    $parcel$export(module.exports, "PREFETCHER_SOURCE", ()=>$ad23a38600e1d52f$export$ce13a6c409c4db7d);
    $parcel$export(module.exports, "REST_SOURCE", ()=>$ad23a38600e1d52f$export$e85fb1a0846db30f);
    $parcel$export(module.exports, "SSR_SOURCE", ()=>$ad23a38600e1d52f$export$c5c05bf31a872c73);
    const $ad23a38600e1d52f$export$dae52b119ebf2444 = (queueId)=>queueId;
    const $ad23a38600e1d52f$export$999de35c9ca8105b = (queueId)=>queueId;
    const $ad23a38600e1d52f$export$cda0e35414946580 = (queueId)=>$ad23a38600e1d52f$export$dae52b119ebf2444(Number(queueId));
    const $ad23a38600e1d52f$export$cde8da12f845d56f = (queueId)=>$ad23a38600e1d52f$export$999de35c9ca8105b(queueId).toString();
    const $ad23a38600e1d52f$export$6e21137db7aec966 = 'LOCAL_STORAGE';
    const $ad23a38600e1d52f$export$ce13a6c409c4db7d = 'PREFETCHER';
    const $ad23a38600e1d52f$export$e85fb1a0846db30f = 'REST';
    const $ad23a38600e1d52f$export$c5c05bf31a872c73 = 'SSR';
});
parcelRegister("5j0B5", function(module, exports) {
    $parcel$export(module.exports, "getFromLocalStorage", ()=>$a6505ee1b0c5b1ab$export$602bc7b349337fec);
    $parcel$export(module.exports, "setInLocalStorage", ()=>$a6505ee1b0c5b1ab$export$e7b9840f77b6b2a4);
    var $bSSG7;
    var $9vBS6;
    const $a6505ee1b0c5b1ab$export$f016358f0af18fa0 = (0, (0, parcelRequire("bSSG7")).createLocalExpirableStorageProvider)('servicedesk_queues');
    const $a6505ee1b0c5b1ab$var$TIME_BEFORE_EXPIRY = 1209600000;
    const $a6505ee1b0c5b1ab$export$602bc7b349337fec = (key)=>{
        try {
            return $a6505ee1b0c5b1ab$export$f016358f0af18fa0.get(key);
        } catch (e) {
            (0, (0, parcelRequire("9vBS6")).default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure on read');
            return null;
        }
    };
    const $a6505ee1b0c5b1ab$export$e7b9840f77b6b2a4 = (key, value)=>{
        try {
            const now = Date.now();
            $a6505ee1b0c5b1ab$export$f016358f0af18fa0.set(key, value, now + $a6505ee1b0c5b1ab$var$TIME_BEFORE_EXPIRY);
            $a6505ee1b0c5b1ab$export$f016358f0af18fa0.removeExpiredKeys();
            return true;
        } catch (_) {
            (0, (0, parcelRequire("9vBS6")).default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure');
            return false;
        }
    };
});
parcelRegister("bSSG7", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageProvider", ()=>$63804f80e89e547d$export$697e65b1658f821b);
    $parcel$export(module.exports, "createLocalExpirableStorageProvider", ()=>$63804f80e89e547d$export$59acef2b3ab1df90);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $dEJQ9;
    const $63804f80e89e547d$export$697e65b1658f821b = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("dEJQ9")).makeLocalStore)()));
    const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("dEJQ9")).makeLocalExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("fNVZf", function(module, exports) {
    $parcel$export(module.exports, "plugins", ()=>$04caddce42518619$export$8b3ca321c77fdea6);
    $parcel$export(module.exports, "createStorageProvider", ()=>$04caddce42518619$export$8441605555fbd60c);
    var $fKgem = parcelRequire("fKgem");
    var $c7J1U;
    const $04caddce42518619$export$8b3ca321c77fdea6 = [
        (0, ($parcel$interopDefault($fKgem))),
        (0, (0, parcelRequire("c7J1U")).default)
    ];
    const $04caddce42518619$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);
});
parcelRegister("c7J1U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99d922a6a243a194$export$2e2bcd8739ae039);
    var $jcw0u;
    var $cuNKJ;
    function $99d922a6a243a194$var$cleanUpPlugin() {
        const self = this;
        const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, (0, parcelRequire("cuNKJ")).NAMESPACE));
        function set(superFn, key, val) {
            try {
                if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.set(key, Date.now());
                superFn();
            } catch (e) {
                if (e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'browserLocalStorageFullError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            namespace: self._namespacePrefix
                        },
                        error: e,
                        skipSentry: true
                    });
                    if (self.cleanWhenFull()) self.set(superFn, key, val);
                } else {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'storageCleanupPluginError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            isLegacyFunction: false
                        },
                        error: e
                    });
                    throw e;
                }
            }
        }
        function remove(superFn, key) {
            if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.remove(key);
            return superFn();
        }
        function getTotalCount() {
            let count = 0;
            self.each(()=>{
                count += 1;
            });
            return count;
        }
        function cleanWhenFull(superFn, minAge = (0, (0, parcelRequire("cuNKJ")).FOUR_WEEKS)) {
            const currTime = Date.now();
            const numKeysBefore = self.getTotalCount();
            self.each((_value, key)=>{
                const created = !self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE)) ? timestamps.get(key) : null;
                if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
            });
            const itemsRemovedCount = numKeysBefore - self.getTotalCount();
            if (!itemsRemovedCount && minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK) >= (0, (0, parcelRequire("cuNKJ")).ONE_WEEK)) return self.cleanWhenFull(minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK));
            return itemsRemovedCount === 0;
        }
        return {
            set: set,
            remove: remove,
            cleanWhenFull: cleanWhenFull,
            getTotalCount: getTotalCount
        };
    }
    var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;
});
parcelRegister("cuNKJ", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE", ()=>$d21613ddd27d5bbf$export$6aad947bda0f3f46);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$d21613ddd27d5bbf$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "FOUR_WEEKS", ()=>$d21613ddd27d5bbf$export$6e952fa7d47190cf);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$da99ebca8f453abd);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$ea28dfd9333cda2d);
    const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
    const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
    const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
    const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
    const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;
});
parcelRegister("dEJQ9", function(module, exports) {
    $parcel$export(module.exports, "makeLocalStore", ()=>$dcae70c06981fc99$export$b2631085fe8db7af);
    $parcel$export(module.exports, "makeLocalExpirableStore", ()=>$dcae70c06981fc99$export$cf816b43e73de947);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $4Zgux = parcelRequire("4Zgux");
    var $2NjNT = parcelRequire("2NjNT");
    var $fNVZf;
    const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
parcelRegister("9vBS6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35c5e35df79dbfac$export$2e2bcd8739ae039);
    var $dJl1T;
    const $35c5e35df79dbfac$var$PREFIX = '[Queues]';
    const $35c5e35df79dbfac$var$safeErrorWithoutCustomerData = (location, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
    };
    const $35c5e35df79dbfac$var$safeWarnWithoutCustomerData = (location, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
    };
    const $35c5e35df79dbfac$var$safeInfoWithoutCustomerData = (location, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData(location, `${$35c5e35df79dbfac$var$PREFIX} ${message}`, event);
    };
    var $35c5e35df79dbfac$export$2e2bcd8739ae039 = {
        safeInfoWithoutCustomerData: $35c5e35df79dbfac$var$safeInfoWithoutCustomerData,
        safeWarnWithoutCustomerData: $35c5e35df79dbfac$var$safeWarnWithoutCustomerData,
        safeErrorWithoutCustomerData: $35c5e35df79dbfac$var$safeErrorWithoutCustomerData
    };
});
parcelRegister("gm93k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8292a018a8b0a76e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eXQym;
    var $3HGy4;
    class $8292a018a8b0a76e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static setFavorite() {}
        render() {
            return null;
        }
        constructor(...args){
            super(...args);
            this.onFavoritesChanged = (items)=>{
                const queueItemsObj = items[0, (0, parcelRequire("eXQym")).QUEUES_ITEM_TYPE];
                if (!queueItemsObj) return;
                const queueItems = Object.values(queueItemsObj);
                queueItems.forEach((item)=>this.props.onFavoriteItemChanged((0, (0, parcelRequire("3HGy4")).toQueueIdString)(item.id), item.value));
            };
        }
    }
});
parcelRegister("8nV9C", function(module, exports) {
    $parcel$export(module.exports, "pageToQueues", ()=>$fe4663d2a5f926fb$export$8ada91ce992fa66f);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $3HGy4;
    var $fe4663d2a5f926fb$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $kVLXA.Observable).of(transformFunc(payload)));
    const $fe4663d2a5f926fb$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
            const column = {
                id: responseColumn.fieldId,
                title: responseColumn.title,
                fieldType: responseColumn.fieldType,
                sortable: responseColumn.sortable
            };
            if (responseColumn.sortOrder) return {
                ...column,
                currentSorting: responseColumn.sortOrder
            };
            return column;
        });
    const $fe4663d2a5f926fb$export$8ada91ce992fa66f = (page)=>page.reduce((acc, queue)=>{
            acc[queue.id] = {
                id: (0, (0, parcelRequire("3HGy4")).toQueueId)(queue.id),
                name: queue.name,
                jql: queue.jql,
                completeJql: queue.completeJql,
                order: queue.order,
                columns: $fe4663d2a5f926fb$var$transformColumns(queue.columnsDetails),
                isFavorite: queue.favourite,
                category: queue.category,
                canBeHidden: queue.canBeHidden
            };
            return acc;
        }, {});
    const $fe4663d2a5f926fb$export$9fd203f323102996 = (prefetchData, queues)=>{
        if (queues === undefined) return [];
        return Object.keys(queues).map((queueId)=>{
            const updatedQueue = queues[queueId];
            const { isFavorite: isFavorite, columns: columns, isTransient: isTransient, ...queuesData } = updatedQueue;
            const cachedPage = prefetchData.find((q)=>String(q.id) === queueId);
            return {
                ...cachedPage,
                ...queuesData,
                favourite: isFavorite,
                columns: columns.map(({ id: id })=>id),
                columnsDetails: columns.map(({ id: id, currentSorting: currentSorting, ...remaining })=>({
                        fieldId: id,
                        sortOrder: currentSorting,
                        ...remaining
                    }))
            };
        });
    };
    const $fe4663d2a5f926fb$export$4906aa3ec3919ad9 = ()=>window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues;
    const $fe4663d2a5f926fb$export$17bdd949b6a9952 = ()=>{
        if (window.JSD_QUEUES_PRELOAD_PROMISES) window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
    };
});
parcelRegister("kbi2o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd787f787343b6f$export$2e2bcd8739ae039);
    var $8RXs9;
    var $cm25K;
    var $fbd787f787343b6f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)((0, (0, parcelRequire("cm25K")).default));
});
parcelRegister("cm25K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55d6194b196376c0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7uUwQ = parcelRequire("7uUwQ");
    var $eae50;
    var $79GY5;
    var $hN5eZ;
    var $PyWGC;
    const $55d6194b196376c0$var$findQueue = (source, id)=>(0, $7uUwQ.getIn)(source, [
            'data',
            id
        ]);
    var $55d6194b196376c0$export$2e2bcd8739ae039 = ({ queueId: queueId, queuesDataSource: queuesDataSource, baseUrl: baseUrl, projectKey: projectKey, children: children, intl: { formatMessage: formatMessage } })=>{
        const lastUnfoundQueue = (0, $5uXOq.useRef)('');
        if (queuesDataSource.loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("79GY5")).default), null);
        const queue = $55d6194b196376c0$var$findQueue(queuesDataSource, queueId);
        if (queue) {
            lastUnfoundQueue.current = '';
            (0, (0, parcelRequire("hN5eZ")).setLastVisitedQueueIdAndCategory)(queue.id, projectKey, queue.category);
            return children(queue);
        }
        if (lastUnfoundQueue.current === queueId) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eae50")).default), {
            header: formatMessage((0, (0, parcelRequire("PyWGC")).default).notFoundHeader),
            description: formatMessage((0, (0, parcelRequire("PyWGC")).default).notFoundDescription),
            onRetry: ()=>{
                if (queuesDataSource.error) window.location.reload();
                else window.location.assign(`${baseUrl}/jira/servicedesk/projects/${projectKey}/queues`);
            }
        });
        lastUnfoundQueue.current = queueId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("79GY5")).default), null);
    };
});
parcelRegister("eae50", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da809c0c454ce05f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $hTEpF;
    var $co1wz;
    var $az4zD;
    var $lB1Xg = parcelRequire("lB1Xg");
    var $9Le4I = parcelRequire("9Le4I");
    var $63TJV;
    function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
        const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
        const buttonAppearance = isSubtle ? 'default' : 'primary';
        const defaultImageUrl = isSubtle ? (0, ($parcel$interopDefault($lB1Xg))) : (0, ($parcel$interopDefault($9Le4I)));
        const fallbackImage = errorImage || defaultImageUrl;
        let imageUrl;
        if ((0, (0, parcelRequire("co1wz")).ff)('jfe-asset-consolidation-itsm-agni_po996')) {
            if (renderErrorImage) imageUrl = undefined;
            else imageUrl = fallbackImage;
        } else imageUrl = fallbackImage;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            testId: "common-components-error-state.empty-state",
            size: size,
            imageWidth: imageWidth,
            imageUrl: imageUrl,
            header: header,
            description: description,
            isLoading: isLoading,
            maxImageHeight: maxImageHeight,
            primaryAction: !onRetry ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: buttonAppearance,
                isDisabled: isLoading,
                onClick: onRetry
            }, formatMessage(retryMessage)),
            renderImage: renderErrorImage
        });
    }
    $da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
        header: '',
        size: 'wide',
        isLoading: false,
        isSubtle: false,
        retryMessage: (0, (0, parcelRequire("63TJV")).default).retry
    };
    var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);
});
parcelRegister("lB1Xg", function(module, exports) {
    module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();
});
parcelRegister("9Le4I", function(module, exports) {
    module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();
});
parcelRegister("63TJV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbeb04399739f055$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        retry: {
            "id": "common.components.error-state.retry-action",
            "defaultMessage": "Try again"
        }
    });
});
parcelRegister("79GY5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bdab3bb4aeae840$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $7bdab3bb4aeae840$var$LoadingSpinner = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($7bdab3bb4aeae840$var$SpinnerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            testId: "servicedesk-common.ui.components.page-spinner.spinner"
        }));
    var $7bdab3bb4aeae840$export$2e2bcd8739ae039 = $7bdab3bb4aeae840$var$LoadingSpinner;
    const $7bdab3bb4aeae840$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hN5eZ", function(module, exports) {
    $parcel$export(module.exports, "getLastVisitedQueueIdAndCategory", ()=>$3f3da0d4b812d0bb$export$b5b4407b2529d2c4);
    $parcel$export(module.exports, "setLastVisitedQueueIdAndCategory", ()=>$3f3da0d4b812d0bb$export$947aff127337ffa5);
    var $gccSB = parcelRequire("gccSB");
    var $3HGy4;
    var $5j0B5;
    var $oCMSG;
    var $1ilU2;
    const $3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
    const $3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX = 'last_visited_category';
    const $3f3da0d4b812d0bb$export$b5b4407b2529d2c4 = (projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY))=>{
        if ((0, ($parcel$interopDefault($gccSB)))(projectKey)) return [
            null,
            null
        ];
        try {
            if (category === (0, (0, parcelRequire("oCMSG")).NO_CATEGORY)) {
                const categoryToRedirectTo = (0, (0, parcelRequire("5j0B5")).getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`);
                const queueId = (0, (0, parcelRequire("5j0B5")).getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${categoryToRedirectTo}`);
                return [
                    queueId,
                    ...(0, (0, parcelRequire("1ilU2")).isValidItsmPractice)(categoryToRedirectTo) ? [
                        categoryToRedirectTo
                    ] : [
                        (0, (0, parcelRequire("oCMSG")).NO_CATEGORY)
                    ]
                ];
            }
            return [
                (0, (0, parcelRequire("5j0B5")).getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`),
                category
            ];
        } catch (error) {
            return [
                null,
                null
            ];
        }
    };
    const $3f3da0d4b812d0bb$export$947aff127337ffa5 = (queueId, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY))=>{
        let lastVisitedQueueId;
        try {
            if ((0, ($parcel$interopDefault($gccSB)))(projectKey)) throw new Error('project key is empty');
            lastVisitedQueueId = (0, (0, parcelRequire("5j0B5")).getFromLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
        } catch (error) {
            lastVisitedQueueId = null;
        }
        if (!(0, ($parcel$interopDefault($gccSB)))(projectKey) && lastVisitedQueueId !== queueId) try {
            (0, (0, parcelRequire("5j0B5")).setInLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, (0, parcelRequire("3HGy4")).fromQueueIdString)(queueId));
            (0, (0, parcelRequire("5j0B5")).setInLocalStorage)(`${$3f3da0d4b812d0bb$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`, category);
        } catch (error) {}
    };
});
parcelRegister("1ilU2", function(module, exports) {
    $parcel$export(module.exports, "toItsmPractice", ()=>$27eaa4458d2c6986$export$1b27246f3c7494c);
    $parcel$export(module.exports, "isValidItsmPractice", ()=>$27eaa4458d2c6986$export$357b94e419749e3d);
    var $oCMSG;
    const $27eaa4458d2c6986$export$1b27246f3c7494c = (practiceString)=>{
        switch(practiceString){
            case 'incidents':
                return 0, (0, parcelRequire("oCMSG")).INCIDENTS;
            case 'changes':
                return 0, (0, parcelRequire("oCMSG")).CHANGES;
            case 'service-requests':
                return 0, (0, parcelRequire("oCMSG")).SERVICE_REQUEST;
            case 'problems':
                return 0, (0, parcelRequire("oCMSG")).PROBLEMS;
            case 'post-incident-reviews':
                return 0, (0, parcelRequire("oCMSG")).POST_INCIDENT_REVIEWS;
            default:
                return 0, (0, parcelRequire("oCMSG")).NO_CATEGORY;
        }
    };
    const $27eaa4458d2c6986$export$357b94e419749e3d = (practiceString)=>{
        switch(practiceString){
            case 0, (0, parcelRequire("oCMSG")).INCIDENTS:
            case 0, (0, parcelRequire("oCMSG")).CHANGES:
            case 0, (0, parcelRequire("oCMSG")).SERVICE_REQUEST:
            case 0, (0, parcelRequire("oCMSG")).PROBLEMS:
            case 0, (0, parcelRequire("oCMSG")).POST_INCIDENT_REVIEWS:
            case 0, (0, parcelRequire("oCMSG")).NO_CATEGORY:
                return true;
            default:
                return false;
        }
    };
});
parcelRegister("PyWGC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3c71f925aa4f1e4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f3c71f925aa4f1e4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundHeader: {
            "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-header",
            "defaultMessage": "We couldn't find your queue"
        },
        notFoundDescription: {
            "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-description",
            "defaultMessage": "Looks like we\u2019re having trouble connecting, or it may have been removed."
        }
    });
});
parcelRegister("jF62O", function(module, exports) {
    $parcel$export(module.exports, "useCategorizedNavItems", ()=>$8f1bc4ac72406fd0$export$fec6561bcaa1c55b);
    $parcel$export(module.exports, "useCurrentCategorizedNavItems", ()=>$8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce);
    $parcel$export(module.exports, "useCategorizedQueues", ()=>$8f1bc4ac72406fd0$export$c4ca47ba8c81dba6);
    $parcel$export(module.exports, "useFavouriteNavItems", ()=>$8f1bc4ac72406fd0$export$e27d61833d43b175);
    $parcel$export(module.exports, "usePracticeMetadata", ()=>$8f1bc4ac72406fd0$export$f857eeb50ae9b1b2);
    $parcel$export(module.exports, "usePracticeList", ()=>$8f1bc4ac72406fd0$export$216a9245ead6e18a);
    $parcel$export(module.exports, "CategorizedQueuesStore", ()=>$8f1bc4ac72406fd0$export$5577ca8a6b2fed3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $1WlLE;
    var $oCMSG;
    var $bebaD;
    var $fyiDq;
    var $2lO5M;
    const $8f1bc4ac72406fd0$var$useCategorizedData = (category, dataSelector, customContext)=>{
        const { data: allData, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("1WlLE")).queuesNavigationItems), customContext);
        const memoizedData = (0, $5uXOq.useMemo)(()=>dataSelector(allData, category), [
            allData,
            category,
            dataSelector
        ]);
        return [
            memoizedData,
            loading,
            error,
            refresh
        ];
    };
    const $8f1bc4ac72406fd0$export$fec6561bcaa1c55b = (baseUrl, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY), customContext)=>{
        const [methods] = (0, (0, parcelRequire("2lO5M")).useCategorizedActions)(baseUrl, projectKey, category, customContext);
        const [data, loading, error, refresh] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).navDataSelector), customContext);
        return [
            data,
            loading,
            error,
            methods,
            refresh
        ];
    };
    const $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce = ()=>{
        const projectKey = (0, (0, parcelRequire("bebaD")).useProjectKey)();
        const category = (0, (0, parcelRequire("bebaD")).useCurrentCategory)();
        const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6('', projectKey, category);
        return [
            data,
            loading,
            error,
            methods
        ];
    };
    const $8f1bc4ac72406fd0$export$1dc9816387d038aa = (baseUrl, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY))=>{
        const [methods] = (0, (0, parcelRequire("2lO5M")).useCategorizedActions)(baseUrl, projectKey, category);
        const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).notFavouriteDataSelector));
        return [
            data,
            loading,
            error,
            methods
        ];
    };
    const $8f1bc4ac72406fd0$export$e27d61833d43b175 = (baseUrl, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY), customContext)=>{
        const [methods] = (0, (0, parcelRequire("2lO5M")).useCategorizedActions)(baseUrl, projectKey, category, customContext);
        const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).favouriteDataSelector), customContext);
        return [
            data,
            loading,
            error,
            methods
        ];
    };
    const $8f1bc4ac72406fd0$export$528be43f76fe19f7 = (baseUrl, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY), customContext)=>{
        const [methods] = (0, (0, parcelRequire("2lO5M")).useCategorizedActions)(baseUrl, projectKey, category, customContext);
        const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).notFavouriteAndCanBeHiddenDataSelector), customContext);
        return [
            data,
            loading,
            error,
            methods
        ];
    };
    const $8f1bc4ac72406fd0$export$4c168500ca36ad18 = (baseUrl, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY), customContext)=>{
        const [methods] = (0, (0, parcelRequire("2lO5M")).useCategorizedActions)(baseUrl, projectKey, category, customContext);
        const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).cannotBeHiddenAndNotFavouriteDataSelector), customContext);
        return [
            data,
            loading,
            error,
            methods
        ];
    };
    const $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6 = (baseUrl, projectKey, category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY))=>{
        const [methods] = (0, (0, parcelRequire("2lO5M")).useCategorizedActions)(baseUrl, projectKey, category);
        const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).queuesDataSelector));
        return [
            data,
            loading,
            error,
            methods
        ];
    };
    const $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2 = (category = (0, (0, parcelRequire("oCMSG")).NO_CATEGORY), customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData(category, (0, (0, parcelRequire("fyiDq")).practiceMetadataSelector), customContext);
    const $8f1bc4ac72406fd0$export$216a9245ead6e18a = (customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData((0, (0, parcelRequire("oCMSG")).NO_CATEGORY), (0, (0, parcelRequire("fyiDq")).practiceListSelector), customContext);
    const $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
        const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6(baseUrl, projectKey, category);
        return children({
            data: data,
            loading: loading,
            error: error,
            methods: methods
        });
    };
    const $8f1bc4ac72406fd0$export$aea9dc5735ed30c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
        const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$fec6561bcaa1c55b(baseUrl, projectKey, category);
        return children({
            data: data,
            loading: loading,
            error: error,
            methods: methods
        });
    };
    $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c.defaultProps = {
        category: (0, (0, parcelRequire("oCMSG")).NO_CATEGORY)
    };
    $8f1bc4ac72406fd0$export$aea9dc5735ed30c.defaultProps = {
        category: (0, (0, parcelRequire("oCMSG")).NO_CATEGORY)
    };
});
parcelRegister("bebaD", function(module, exports) {
    $parcel$export(module.exports, "getQueuesForCategory", ()=>$f538431335917e3a$export$fcf9c653a5f7167a);
    $parcel$export(module.exports, "setQueuesForCategory", ()=>$f538431335917e3a$export$7ca50bfd96f22f76);
    $parcel$export(module.exports, "queuesToNavItems", ()=>$f538431335917e3a$export$e6491f132367997c);
    $parcel$export(module.exports, "useProjectKey", ()=>$f538431335917e3a$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useCurrentCategory", ()=>$f538431335917e3a$export$e42116f2f5c27c35);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $dd29Z;
    var $1ilU2;
    var $g5X3G;
    var $dIdda = parcelRequire("dIdda");
    const $f538431335917e3a$export$fcf9c653a5f7167a = (data, category)=>(0, $7uUwQ.getIn)(data, [
            category,
            'queues'
        ]);
    const $f538431335917e3a$export$7ca50bfd96f22f76 = (data, category, newQueues)=>(0, $7uUwQ.updateIn)(data || {}, [
            category,
            'queues'
        ], (queues)=>{
            if (queues) return newQueues;
            throw new Error(`${category} does not exist in resource`);
        });
    const $f538431335917e3a$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
                id: String(id),
                name: name,
                url: `/projects/${projectKey}/${(0, (0, parcelRequire("dd29Z")).getQueueFragment)(id, category)}`,
                badgeCount: count,
                starred: favourite,
                canBeHidden: canBeHidden,
                shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
                category: category,
                lastRefreshedTime: lastRefreshedTime
            }));
    const $f538431335917e3a$export$f87be37f8e8be65 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(match.params.projectKey || '');
    };
    const $f538431335917e3a$export$e42116f2f5c27c35 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        return (0, (0, parcelRequire("1ilU2")).toItsmPractice)(match.params.practiceType);
    };
});
parcelRegister("fyiDq", function(module, exports) {
    $parcel$export(module.exports, "queuesDataSelector", ()=>$1df222051fb5e2fa$export$fe10e38dc2f0e4c8);
    $parcel$export(module.exports, "navDataSelector", ()=>$1df222051fb5e2fa$export$caf8de9cbdbf9102);
    $parcel$export(module.exports, "notFavouriteAndCanBeHiddenDataSelector", ()=>$1df222051fb5e2fa$export$231e113a2e075013);
    $parcel$export(module.exports, "notFavouriteDataSelector", ()=>$1df222051fb5e2fa$export$46aa703ec1a01e);
    $parcel$export(module.exports, "cannotBeHiddenAndNotFavouriteDataSelector", ()=>$1df222051fb5e2fa$export$f28545acfde3f70e);
    $parcel$export(module.exports, "favouriteDataSelector", ()=>$1df222051fb5e2fa$export$fc3fab89f453b08e);
    $parcel$export(module.exports, "practiceMetadataSelector", ()=>$1df222051fb5e2fa$export$b0af22bb6bff9c49);
    $parcel$export(module.exports, "isCountLoadingSelector", ()=>$1df222051fb5e2fa$export$efbcd30acb5e816f);
    $parcel$export(module.exports, "hasRequestedCountSelector", ()=>$1df222051fb5e2fa$export$54e54a1ac5e7098f);
    $parcel$export(module.exports, "practiceListSelector", ()=>$1df222051fb5e2fa$export$61d9fd7be029b514);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $bebaD;
    const $1df222051fb5e2fa$export$fe10e38dc2f0e4c8 = (data, category)=>(0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category) || null;
    const $1df222051fb5e2fa$export$caf8de9cbdbf9102 = (data, category)=>{
        const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
        return queues ? (0, (0, parcelRequire("bebaD")).queuesToNavItems)(queues) : null;
    };
    const $1df222051fb5e2fa$export$231e113a2e075013 = (data, category)=>{
        const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
        const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
        return otherQueuesData ? (0, (0, parcelRequire("bebaD")).queuesToNavItems)(otherQueuesData) : null;
    };
    const $1df222051fb5e2fa$export$46aa703ec1a01e = (data, category)=>{
        const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
        const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
        return otherQueuesData ? (0, (0, parcelRequire("bebaD")).queuesToNavItems)(otherQueuesData) : null;
    };
    const $1df222051fb5e2fa$export$f28545acfde3f70e = (data, category)=>{
        const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
        const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
        return defaultQueuesData ? (0, (0, parcelRequire("bebaD")).queuesToNavItems)(defaultQueuesData) : null;
    };
    const $1df222051fb5e2fa$export$fc3fab89f453b08e = (data, category)=>{
        const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
        const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
        return starredQueues ? (0, (0, parcelRequire("bebaD")).queuesToNavItems)(starredQueues) : null;
    };
    const $1df222051fb5e2fa$export$b0af22bb6bff9c49 = (data, category)=>{
        const practiceData = (0, $7uUwQ.getIn)(data, [
            category
        ]);
        return practiceData ? (0, $7uUwQ.dissoc)(practiceData, 'queues') : null;
    };
    const $1df222051fb5e2fa$export$efbcd30acb5e816f = (data, category)=>{
        const practiceData = (0, $7uUwQ.getIn)(data, [
            category
        ]);
        return practiceData ? practiceData.isCountLoading : false;
    };
    const $1df222051fb5e2fa$export$54e54a1ac5e7098f = (data, category)=>{
        const practiceData = (0, $7uUwQ.getIn)(data, [
            category
        ]);
        return practiceData ? practiceData.hasRequestedCount : false;
    };
    const $1df222051fb5e2fa$export$61d9fd7be029b514 = (data)=>data ? Object.keys(data) : null;
});
parcelRegister("2lO5M", function(module, exports) {
    $parcel$export(module.exports, "useCategorizedActions", ()=>$ff5cc066d5a13377$export$8632bfeb0b672958);
    $parcel$export(module.exports, "default", ()=>$ff5cc066d5a13377$export$2e2bcd8739ae039);
    var $324W5;
    var $1WlLE;
    var $a4M45;
    const $ff5cc066d5a13377$export$8632bfeb0b672958 = (baseUrl, projectKey, category, customContext)=>{
        const { update: update } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("1WlLE")).queuesNavigationItems), customContext);
        const cachedActions = (0, (0, parcelRequire("a4M45")).default)(category, update, {
            baseUrl: baseUrl,
            projectKey: projectKey
        });
        return [
            cachedActions
        ];
    };
    const $ff5cc066d5a13377$var$ActionsProvider = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
        const [actions] = $ff5cc066d5a13377$export$8632bfeb0b672958(baseUrl, projectKey, category);
        return children(actions);
    };
    var $ff5cc066d5a13377$export$2e2bcd8739ae039 = $ff5cc066d5a13377$var$ActionsProvider;
});
parcelRegister("a4M45", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64c8b4db868052f8$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7JoAD = parcelRequire("7JoAD");
    var $6vsnF;
    const $64c8b4db868052f8$export$36d128238e6b60f5 = {
        currentCacheKey: '',
        actionsByCategory: {}
    };
    const $64c8b4db868052f8$export$8b3bc28eb06c49b6 = {
        getActions: (...args)=>({ getState: getState, setState: setState })=>{
                const [category, , { projectKey: projectKey }] = args;
                const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
                const categoryActions = actionsByCategory[category];
                const hasSameKey = projectKey === currentCacheKey;
                if (hasSameKey && Boolean(categoryActions)) return categoryActions;
                const newCategoryActions = (0, (0, parcelRequire("6vsnF")).getActions)(...args);
                setState({
                    currentCacheKey: projectKey,
                    actionsByCategory: {
                        ...hasSameKey ? actionsByCategory : {},
                        [category]: newCategoryActions
                    }
                });
                return newCategoryActions;
            }
    };
    const $64c8b4db868052f8$var$Store = (0, $7JoAD.createStore)({
        initialState: $64c8b4db868052f8$export$36d128238e6b60f5,
        actions: $64c8b4db868052f8$export$8b3bc28eb06c49b6,
        name: 'jira-servicedesk-categorized-queues-actions-store'
    });
    const $64c8b4db868052f8$var$useActionsStore = (0, $7JoAD.createHook)($64c8b4db868052f8$var$Store, {
        selector: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $64c8b4db868052f8$export$193cb0fec61d3692 = (...args)=>{
        const [, { getActions: getActions }] = $64c8b4db868052f8$var$useActionsStore();
        return getActions(...args);
    };
    var $64c8b4db868052f8$export$2e2bcd8739ae039 = $64c8b4db868052f8$export$193cb0fec61d3692;
});
parcelRegister("6vsnF", function(module, exports) {
    $parcel$export(module.exports, "getActions", ()=>$62968e378f0259c7$export$fe3955935f564b31);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $34ck9 = parcelRequire("34ck9");
    var $co1wz;
    var $fZneA;
    var $2nYuf;
    var $jHq2C;
    var $90q41;
    var $bebaD;
    var $fyiDq;
    var $czC6V;
    var $kTfMz;
    const $62968e378f0259c7$var$throttleNavItemsRefreshRate = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jsm.dynamic.queues.issue.count.refresh.interval', '60000', [
            '60000',
            '120000',
            '300000',
            '90000',
            '86400000'
        ]);
    const $62968e378f0259c7$var$getThrottledRefresh = ()=>Number($62968e378f0259c7$var$throttleNavItemsRefreshRate());
    const $62968e378f0259c7$var$getAnalyticsPayload = (err)=>{
        const wasQueueDeleted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef);
        const queueConflictOccurred = err?.statusCode === (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f);
        const queueActionNotPermitted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3);
        return {
            wasQueueDeleted: wasQueueDeleted,
            queueConflictOccurred: queueConflictOccurred,
            queueActionNotPermitted: queueActionNotPermitted,
            isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(err)
        };
    };
    const $62968e378f0259c7$export$fe3955935f564b31 = (category, update, restParams)=>{
        const actions = {
            addItem: (item)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).addItem)(queues, item));
                    throw new Error(`Cannot add item because ${category} does not exist in resource`);
                });
            },
            deleteItem: (id)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).deleteItem)(queues, id));
                    throw new Error(`Cannot delete item because ${category} does not exist in resource`);
                });
            },
            editItem: (item)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).editItem)(queues, item));
                    throw new Error(`Cannot edit item because ${category} does not exist in resource`);
                });
            },
            moveItem: (from, to)=>{
                if (from !== to) update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) {
                        const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                        const result = (0, (0, parcelRequire("kTfMz")).moveItem)(queues, from, to);
                        (0, (0, parcelRequire("jHq2C")).setQueues)(baseUrl, projectKey, (0, (0, parcelRequire("bebaD")).queuesToNavItems)(result), category);
                        return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, result);
                    }
                    throw new Error(`Cannot move item because ${category} does not exist in resource`);
                });
            },
            moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) {
                        const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                        const result = (0, (0, parcelRequire("kTfMz")).moveItemBelow)(queues, queueId, targetQueueId);
                        (0, (0, parcelRequire("jHq2C")).setQueues)(baseUrl, projectKey, (0, (0, parcelRequire("bebaD")).queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                        return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, result);
                    }
                    throw new Error(`Cannot move item below because ${category} does not exist in resource`);
                });
            },
            moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) {
                        const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                        const result = (0, (0, parcelRequire("kTfMz")).moveItemAbove)(queues, queueId, targetQueueId);
                        (0, (0, parcelRequire("jHq2C")).setQueues)(baseUrl, projectKey, (0, (0, parcelRequire("bebaD")).queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                        return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, result);
                    }
                    throw new Error(`Cannot move item above because ${category} does not exist in resource`);
                });
            },
            moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) {
                        const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                        const result = (0, (0, parcelRequire("kTfMz")).moveToTop)(queues, queueId);
                        (0, (0, parcelRequire("jHq2C")).setQueues)(baseUrl, projectKey, (0, (0, parcelRequire("bebaD")).queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                        return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, result);
                    }
                    throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
                });
            },
            refreshNavItems: (0, ($parcel$interopDefault($34ck9)))((analyticsEvent)=>{
                setTimeout(()=>{
                    update((data)=>{
                        const isCountLoading = (0, (0, parcelRequire("fyiDq")).isCountLoadingSelector)(data, category);
                        if (isCountLoading) return data;
                        if (restParams.projectKey) (0, (0, parcelRequire("czC6V")).refreshIssueCountForVisibleAndStarredQueues)(update, {
                            ...restParams,
                            category: category
                        }, analyticsEvent);
                        const updatedData = data ? (0, $7uUwQ.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                        return updatedData;
                    });
                }, Math.floor(Math.random() * 5000) + 1000);
            }, $62968e378f0259c7$var$getThrottledRefresh()),
            initialFetchNavItems: (analyticsEvent)=>{
                update((data)=>{
                    const isCountLoading = (0, (0, parcelRequire("fyiDq")).isCountLoadingSelector)(data, category);
                    const hasRequestedCount = (0, (0, parcelRequire("fyiDq")).hasRequestedCountSelector)(data, category);
                    if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                    return data;
                });
            },
            refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
                (0, (0, parcelRequire("czC6V")).refreshIssueCountForQueues)(update, {
                    ...restParams,
                    category: category
                }, queueIds, analyticsEvent);
            },
            editItemIssueCount: (id, count)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).editItem)(queues, {
                        id: Number(id),
                        count: count,
                        lastRefreshedTime: Date.now()
                    }));
                    if (Number(id) === (0, (0, parcelRequire("2nYuf")).DEFAULT_QUEUE_ID)) return data;
                    throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
                });
            },
            editItemFavorite: (id, favourite)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).editItem)(queues, {
                        id: Number(id),
                        favourite: favourite
                    }));
                    throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
                });
            },
            editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    if (queues) {
                        (0, (0, parcelRequire("90q41")).updateQueuesVisibility)(baseUrl, projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                        return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).editItems)(queues, [
                            ...updatedItems
                        ]));
                    }
                    throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
                });
            },
            enableRefreshForQueues: (queueIds)=>{
                (0, (0, parcelRequire("czC6V")).enableRefreshForQueues)(update, {
                    ...restParams,
                    category: category
                }, queueIds);
            },
            enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
                update((data)=>{
                    const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                    if (queues) return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, (0, parcelRequire("kTfMz")).enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                    throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
                });
            }
        };
        return actions;
    };
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("2nYuf", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_COLUMNS", ()=>$55f991500b621537$export$50c19f60b9c144f7);
    $parcel$export(module.exports, "DEFAULT_QUEUE_ID", ()=>$55f991500b621537$export$e78379cc32bff512);
    $parcel$export(module.exports, "FETCH_BATCH_SIZE", ()=>$55f991500b621537$export$baa236d86cd0d3f5);
    const $55f991500b621537$export$50c19f60b9c144f7 = [
        'issuetype',
        'issuekey',
        'summary',
        'reporter',
        'assignee',
        'status',
        'created'
    ];
    const $55f991500b621537$export$e78379cc32bff512 = Number.MIN_VALUE;
    const $55f991500b621537$export$baa236d86cd0d3f5 = 100;
});
parcelRegister("jHq2C", function(module, exports) {
    $parcel$export(module.exports, "setQueues", ()=>$7a268253f439fbe8$export$51b06787b88b2bf2);
    var $eusud;
    var $2m5JT;
    const $7a268253f439fbe8$var$getQueuesUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
    const $7a268253f439fbe8$export$51b06787b88b2bf2 = (baseUrl, projectKey, queues, category)=>(0, (0, parcelRequire("eusud")).performPutRequest)($7a268253f439fbe8$var$getQueuesUrl(baseUrl, projectKey), {
            body: JSON.stringify((0, (0, parcelRequire("2m5JT")).transformQueues)(queues, category))
        });
});
parcelRegister("2m5JT", function(module, exports) {
    $parcel$export(module.exports, "transformQueues", ()=>$21e5ad652b3de239$export$66ec85c65393edb4);
    var $oCMSG;
    const $21e5ad652b3de239$export$66ec85c65393edb4 = (queues, category)=>({
            order: queues.map((queue)=>queue.id),
            id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
            inline: true,
            deleted: [],
            ...category && category !== (0, (0, parcelRequire("oCMSG")).NO_CATEGORY) ? {
                category: category
            } : undefined
        });
});
parcelRegister("90q41", function(module, exports) {
    $parcel$export(module.exports, "updateQueuesVisibility", ()=>$8ab251897e60612e$export$c0862f2fb17c23c2);
    var $eusud;
    const $8ab251897e60612e$var$getUpdateQueuesVisibilityUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
    const $8ab251897e60612e$export$c0862f2fb17c23c2 = (baseUrl, projectKey, modified)=>(0, (0, parcelRequire("eusud")).performPutRequest)($8ab251897e60612e$var$getUpdateQueuesVisibilityUrl(baseUrl, projectKey), {
            body: JSON.stringify({
                modified: modified
            })
        });
});
parcelRegister("czC6V", function(module, exports) {
    $parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", ()=>$d32f12b3757f33df$export$aaa6aeca5994daee);
    $parcel$export(module.exports, "enableRefreshForQueues", ()=>$d32f12b3757f33df$export$6b0c14cefee3edf5);
    $parcel$export(module.exports, "refreshIssueCountForQueues", ()=>$d32f12b3757f33df$export$b05e3887bfb123a8);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7qDUb = parcelRequire("7qDUb");
    var $jcw0u;
    var $bebaD;
    var $fyiDq;
    var $l6KG9;
    const $d32f12b3757f33df$export$defcbd4ba0fd3734 = 5;
    const $d32f12b3757f33df$var$RETRY_DELAY_IN_MS = 1000;
    const $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure = (error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'retryQueueIssueCountAction',
                packageName: 'jiraServicedeskCategorizedQueuesStore',
                teamName: 'jsd-shield'
            },
            error: error
        });
    };
    const $d32f12b3757f33df$export$ef7266a9f6c0de43 = ({ baseUrl: baseUrl, projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
            if (queueIds && queueIds.length === 0) return;
            if (retryCount >= $d32f12b3757f33df$export$defcbd4ba0fd3734) {
                (0, (0, parcelRequire("l6KG9")).fireManualOperationalAnalytics)({
                    source: 'refreshQueueIssueCountAction',
                    actionSubject: 'retryIssueCount',
                    action: 'limitExceeded',
                    attributes: {
                        retryCount: retryCount,
                        maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734
                    }
                });
                return;
            }
            setTimeout(()=>{
                try {
                    const newRetryCount = retryCount + 1;
                    update((data)=>{
                        const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                        if (queues && queues.length > 0) {
                            const retryCallback = $d32f12b3757f33df$export$ef7266a9f6c0de43({
                                baseUrl: baseUrl,
                                projectKey: projectKey,
                                category: category
                            }, true, update, newRetryCount, analyticsEvent);
                            (0, (0, parcelRequire("l6KG9")).updateIssueCountForQueues)(baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                            (0, (0, parcelRequire("l6KG9")).fireManualOperationalAnalytics)({
                                source: 'refreshQueueIssueCountAction',
                                actionSubject: 'retryQueueIssueCount',
                                action: 'triggered',
                                attributes: {
                                    retryCount: newRetryCount,
                                    maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734,
                                    queuesCount: queues.length
                                }
                            });
                            return data ? (0, $7uUwQ.assocIn)(data, [
                                category,
                                'isCountLoading'
                            ], true) : null;
                        }
                        return data;
                    });
                } catch (error) {
                    $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure(error);
                    throw error;
                }
            }, $d32f12b3757f33df$var$RETRY_DELAY_IN_MS);
        };
    const $d32f12b3757f33df$export$aaa6aeca5994daee = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, analyticsEvent)=>{
        try {
            update((data)=>{
                const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
                const retryCallback = !(0, (0, parcelRequire("fyiDq")).hasRequestedCountSelector)(data, category) ? $d32f12b3757f33df$export$ef7266a9f6c0de43({
                    baseUrl: baseUrl,
                    projectKey: projectKey,
                    category: category
                }, true, update, 0, analyticsEvent) : (0, ($parcel$interopDefault($8Rkzz)));
                if (queues) {
                    (0, (0, parcelRequire("l6KG9")).updateIssueCountForQueues)(baseUrl, projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                    return data ? (0, $7uUwQ.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                }
                return data;
            });
        } catch (error) {
            (0, (0, parcelRequire("l6KG9")).fireErrorAnalyticsForRefreshCountFailure)(error);
            throw error;
        }
    };
    const $d32f12b3757f33df$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
        update((data)=>{
            const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category);
            const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                    ...queue,
                    shouldSkipIssueCountRefresh: false,
                    count: undefined
                } : queue);
            const queuesMap = (0, ($parcel$interopDefault($4Xk2W)))(queues, 'id');
            refreshEnabledQueues?.forEach((queue)=>{
                queuesMap[queue.id] = queue;
            });
            return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, ($parcel$interopDefault($7qDUb)))(Object.values(queuesMap), 'order'));
        });
    };
    const $d32f12b3757f33df$export$b05e3887bfb123a8 = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
        try {
            update((data)=>{
                const queues = (0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
                if (queues && queues.length > 0) {
                    (0, (0, parcelRequire("l6KG9")).updateIssueCountForQueues)(baseUrl, projectKey, category, queues, false, update, (0, ($parcel$interopDefault($8Rkzz))), analyticsEvent);
                    return data ? (0, $7uUwQ.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                }
                return data;
            });
        } catch (error) {
            (0, (0, parcelRequire("l6KG9")).fireErrorAnalyticsForRefreshCountFailure)(error);
            throw error;
        }
    };
});
parcelRegister("4Xk2W", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
        $1m3dq(result, key, value);
    });
    module.exports = $39bc38f0156cacc0$var$keyBy;
});
parcelRegister("l6KG9", function(module, exports) {
    $parcel$export(module.exports, "fireManualOperationalAnalytics", ()=>$fa1880944e28b500$export$a9301d18019c11f9);
    $parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", ()=>$fa1880944e28b500$export$b5e2038970f91d6c);
    $parcel$export(module.exports, "updateIssueCountForQueues", ()=>$fa1880944e28b500$export$d436cbef77099410);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $hUobS = parcelRequire("hUobS");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $7qDUb = parcelRequire("7qDUb");
    var $dMEgP = parcelRequire("dMEgP");
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $g9E9n;
    var $7ZmbO;
    var $bebaD;
    const $fa1880944e28b500$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
    const $fa1880944e28b500$var$ERROR_UNKNOWN = 'error.unknown';
    const $fa1880944e28b500$export$cf85cf6a45b00808 = {
        FAILED: 'failed',
        SUCCESS: 'success',
        PENDING: 'pending'
    };
    const $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
    const $fa1880944e28b500$export$a9301d18019c11f9 = (payload)=>(0, (0, parcelRequire("g9E9n")).getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
    const $fa1880944e28b500$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
    const $fa1880944e28b500$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
    const $fa1880944e28b500$var$getIssueCountPerGroup = (issueCounts)=>Object.keys(issueCounts).reduce((curr, queueId)=>{
            const res = curr;
            if (issueCounts[Number(queueId)]) {
                if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
            }
            return res;
        }, {});
    const $fa1880944e28b500$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
        const starredQueues = [];
        const defaultQueues = [];
        let toGroupQueues = queues;
        let hasSkippedQueues = false;
        if (skipHiddenQueues === true) toGroupQueues = $fa1880944e28b500$var$filterOutHiddenQueues(queues);
        toGroupQueues = $fa1880944e28b500$var$filterOutBadQueues(toGroupQueues);
        let queueByGroups = {};
        toGroupQueues.forEach((queue)=>{
            if ((0, ($parcel$interopDefault($hUobS)))(queue.count) && queue.count > $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD) {
                hasSkippedQueues = true;
                return;
            }
            if (queue.favourite) starredQueues.push(queue);
            else defaultQueues.push(queue);
        });
        queueByGroups = {
            starredQueues: starredQueues,
            defaultQueues: defaultQueues
        };
        if (hasSkippedQueues) $fa1880944e28b500$export$a9301d18019c11f9({
            source: 'refreshQueueIssueCountAction',
            actionSubject: 'queueIssueCountRefresh',
            action: 'skipped'
        });
        return queueByGroups;
    };
    const $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
        let queuesSortByLastRefreshedTime = [];
        const queuesSortByGroup = [
            ...queuesBeforeSort.starredQueues,
            ...queuesBeforeSort.defaultQueues
        ];
        queuesSortByLastRefreshedTime = (0, ($parcel$interopDefault($7qDUb)))(queuesSortByGroup, [
            'lastRefreshedTime'
        ]);
        return queuesSortByLastRefreshedTime;
    };
    const $fa1880944e28b500$export$b5e2038970f91d6c = (error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'refreshQueueIssueCountAction',
                packageName: 'jiraServicedeskCategorizedQueuesStore',
                teamName: 'jsd-shield'
            },
            error: error
        });
    };
    const $fa1880944e28b500$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
    const $fa1880944e28b500$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $fa1880944e28b500$export$cf85cf6a45b00808.PENDING && !$fa1880944e28b500$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
    const $fa1880944e28b500$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
            body: JSON.stringify(queueIds)
        });
    const $fa1880944e28b500$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
        const queueRefreshData = {
            minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
            queueCountChanges: 0
        };
        return queueIds.reduce((changes, queueId)=>{
            if (issueCounts[queueId]) {
                if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                    const queue = queuesMap[queueId];
                    const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                    const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                    const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                    return {
                        minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                        queueCountChanges: queueCountChanges
                    };
                }
            }
            return changes;
        }, queueRefreshData);
    };
    const $fa1880944e28b500$var$fetchAndUpdateCount = async (baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback)=>{
        if (queueIds.length === 0) return;
        let maxQueuesPerSd = await (0, (0, parcelRequire("7ZmbO")).getLimit)((0, (0, parcelRequire("7ZmbO")).MAX_QUEUES_PER_SD));
        if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
        const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
        const startTime = Date.now();
        await $fa1880944e28b500$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
            update((data)=>{
                const queuesMap = (0, ($parcel$interopDefault($4Xk2W)))((0, (0, parcelRequire("bebaD")).getQueuesForCategory)(data, category), 'id');
                const skippedQueues = $fa1880944e28b500$var$getSkippedQueues(issueCounts, queuesMap);
                if (skippedQueues.length > 0) retryCallback(skippedQueues);
                const endTime = Date.now();
                let queueCountChanges = 0;
                let minLastRefreshTimeFromCurrentBatch = 0;
                let numberOfBadQueues = 0;
                const queueRefreshData = $fa1880944e28b500$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
                queueCountChanges = queueRefreshData.queueCountChanges;
                minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
                queueIds.forEach((queueId)=>{
                    const queue = queuesMap[queueId];
                    if (issueCounts[queueId]) {
                        if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                            ...queue,
                            count: issueCounts[queueId].issueCount,
                            lastRefreshedTime: endTime,
                            shouldSkipIssueCountRefresh: false
                        };
                        else if (issueCounts[queueId].errorCode === $fa1880944e28b500$var$ERROR_DB_TIMEOUT) {
                            numberOfBadQueues += 1;
                            queuesMap[queueId] = {
                                ...queue,
                                shouldSkipIssueCountRefresh: true
                            };
                        }
                    }
                });
                if (analyticsEvent) {
                    const issueCountPerGroup = $fa1880944e28b500$var$getIssueCountPerGroup(issueCounts);
                    const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                    const jiraShard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard') || '';
                    if (queueIssueCounts.length === 0) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                        category: category,
                        queuesRequested: queueIdsToFetch.length,
                        maxQueuesPerSd: maxQueuesPerSd,
                        timeToFetchIssueCount: endTime - startTime,
                        timeSinceBatchStart: endTime - batchStartProcessingTime,
                        jiraShard: jiraShard,
                        browserTabVisibilityState: document.visibilityState,
                        numberOfBadQueues: numberOfBadQueues
                    });
                    else (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                        category: category,
                        queues: queueIssueCounts.length,
                        queuesRequested: queueIdsToFetch.length,
                        maxQueuesPerSd: maxQueuesPerSd,
                        maxIssueCount: Math.max(...queueIssueCounts),
                        timeToFetchIssueCount: endTime - startTime,
                        timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                        timeSinceBatchStart: endTime - batchStartProcessingTime,
                        noOfQueuesWithUpdatedCount: queueCountChanges,
                        jiraShard: jiraShard,
                        browserTabVisibilityState: document.visibilityState,
                        numberOfBadQueues: numberOfBadQueues
                    });
                }
                return (0, (0, parcelRequire("bebaD")).setQueuesForCategory)(data, category, (0, ($parcel$interopDefault($7qDUb)))((0, ($parcel$interopDefault($dMEgP)))(queuesMap), 'order'));
            });
        }).catch((error)=>{
            $fa1880944e28b500$export$b5e2038970f91d6c(error);
        });
    };
    const $fa1880944e28b500$var$updateLoadingState = (category, queues, update)=>{
        update((data)=>data ? (0, $7uUwQ.chain)(data).setIn([
                category,
                'hasRequestedCount'
            ], true).setIn([
                category,
                'isCountLoading'
            ], false).value() : null);
    };
    const $fa1880944e28b500$export$d436cbef77099410 = async (baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
        const queuesPerGroup = $fa1880944e28b500$var$getQueuesPerGroup(queues, skipHiddenQueues);
        const queuesSortByLastRefreshedTime = $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
        const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
        const batchStartProcessingTime = Date.now();
        try {
            await $fa1880944e28b500$var$fetchAndUpdateCount(baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
        } catch (error) {
            $fa1880944e28b500$var$updateLoadingState(category, queues, update);
            $fa1880944e28b500$export$b5e2038970f91d6c(error);
            throw error;
        }
        $fa1880944e28b500$var$updateLoadingState(category, queues, update);
    };
});
parcelRegister("hUobS", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $d09a6e5a442af90c$var$numberTag = '[object Number]';
    function $d09a6e5a442af90c$var$isNumber(value) {
        return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
    }
    module.exports = $d09a6e5a442af90c$var$isNumber;
});
parcelRegister("7ZmbO", function(module, exports) {
    $parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", ()=>$92269289c1fdd627$export$dca2c2105b681490);
    $parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", ()=>$92269289c1fdd627$export$a48ac34d39e0fc22);
    $parcel$export(module.exports, "MAX_QUEUES_PER_SD", ()=>$92269289c1fdd627$export$2e0ba662d5bb7742);
    $parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", ()=>$92269289c1fdd627$export$eb69982aa3a172b4);
    $parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", ()=>$92269289c1fdd627$export$cb3888a8c43147d2);
    $parcel$export(module.exports, "LIMIT_DEFAULTS", ()=>$92269289c1fdd627$export$5ed1d2ac050e39d);
    $parcel$export(module.exports, "getLimit", ()=>$92269289c1fdd627$export$fb8ce379717a383d);
    $parcel$export(module.exports, "LimitData", ()=>$92269289c1fdd627$export$9989835030ecd317);
    $parcel$export(module.exports, "withLimitData", ()=>$92269289c1fdd627$export$c5d8aa8a650e690f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $7f4tk;
    const $92269289c1fdd627$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
    const $92269289c1fdd627$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
    const $92269289c1fdd627$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
    const $92269289c1fdd627$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
    const $92269289c1fdd627$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
    const $92269289c1fdd627$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
    const $92269289c1fdd627$export$5ed1d2ac050e39d = {
        [$92269289c1fdd627$export$dca2c2105b681490]: 30,
        [$92269289c1fdd627$export$a48ac34d39e0fc22]: 30,
        [$92269289c1fdd627$export$2e0ba662d5bb7742]: 300,
        [$92269289c1fdd627$export$eb69982aa3a172b4]: 30,
        [$92269289c1fdd627$export$cb3888a8c43147d2]: 20,
        [$92269289c1fdd627$export$801a603585fb94d8]: 50
    };
    const $92269289c1fdd627$var$limitCache = {};
    const $92269289c1fdd627$export$c419786abd6faaad = (limitProperty)=>{
        delete $92269289c1fdd627$var$limitCache[limitProperty];
    };
    const $92269289c1fdd627$export$fb8ce379717a383d = (limitProperty)=>{
        if (!$92269289c1fdd627$var$limitCache[limitProperty]) $92269289c1fdd627$var$limitCache[limitProperty] = (0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
            $92269289c1fdd627$export$c419786abd6faaad(limitProperty);
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
            throw error;
        });
        return $92269289c1fdd627$var$limitCache[limitProperty];
    };
    class $92269289c1fdd627$export$9989835030ecd317 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { limitProperty: limitProperty } = this.props;
            const defaultLimit = $92269289c1fdd627$export$5ed1d2ac050e39d[limitProperty];
            $92269289c1fdd627$export$fb8ce379717a383d(limitProperty).then((limit)=>{
                this.updateLimit(limit || defaultLimit);
            }).catch(()=>{
                this.updateLimit(defaultLimit);
            });
        }
        updateLimit(newLimit) {
            this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                    limit: newLimit
                } : undefined);
        }
        render() {
            return this.props.children(this.state.limit);
        }
        constructor(...args){
            super(...args);
            this.state = {
                limit: Infinity
            };
        }
    }
    const $92269289c1fdd627$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($92269289c1fdd627$export$9989835030ecd317, {
                limitProperty: limitProperty
            }, (limit)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    limit: limit,
                    ...props
                }));
});
parcelRegister("kTfMz", function(module, exports) {
    $parcel$export(module.exports, "addItem", ()=>$98056c458719acf6$export$fb9705de59d96855);
    $parcel$export(module.exports, "deleteItem", ()=>$98056c458719acf6$export$8d8542dbbc23fe1a);
    $parcel$export(module.exports, "editItem", ()=>$98056c458719acf6$export$60832f4899fbf6a1);
    $parcel$export(module.exports, "editItems", ()=>$98056c458719acf6$export$8c896bccb18e1db1);
    $parcel$export(module.exports, "moveItem", ()=>$98056c458719acf6$export$ec937e64de6c1257);
    $parcel$export(module.exports, "moveItemBelow", ()=>$98056c458719acf6$export$17c7ebc966cf5476);
    $parcel$export(module.exports, "moveItemAbove", ()=>$98056c458719acf6$export$d54386016cadff45);
    $parcel$export(module.exports, "moveToTop", ()=>$98056c458719acf6$export$f2c5cc4c3f787c3e);
    $parcel$export(module.exports, "enableSelectedQueuesVisibility", ()=>$98056c458719acf6$export$ce58537552972d29);
    var $fW7cr = parcelRequire("fW7cr");
    const $98056c458719acf6$export$fb9705de59d96855 = (source, item)=>[
            ...source,
            item
        ];
    const $98056c458719acf6$export$8d8542dbbc23fe1a = (source, id)=>{
        const result = source.slice();
        const index = (0, ($parcel$interopDefault($fW7cr)))(result, {
            id: Number(id)
        });
        if (index >= 0) result.splice(index, 1);
        return result;
    };
    const $98056c458719acf6$export$60832f4899fbf6a1 = (source, updatedItem)=>{
        const result = source.slice();
        const index = (0, ($parcel$interopDefault($fW7cr)))(result, {
            id: updatedItem.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...updatedItem
        };
        return result;
    };
    const $98056c458719acf6$export$8c896bccb18e1db1 = (source, updatedItems)=>{
        const result = source.slice();
        updatedItems.forEach((item)=>{
            const index = (0, ($parcel$interopDefault($fW7cr)))(result, {
                id: item.id
            });
            if (index >= 0) result[index] = {
                ...result[index],
                ...item
            };
        });
        return result;
    };
    const $98056c458719acf6$export$ec937e64de6c1257 = (source, from, to)=>{
        const result = source.slice();
        const item = result[from];
        if (from !== to && from >= 0) {
            result.splice(from, 1);
            result.splice(to, 0, item);
        }
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    };
    const $98056c458719acf6$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
        const result = source.slice();
        if (sourceId !== targetId) {
            const sourceIndex = (0, ($parcel$interopDefault($fW7cr)))(result, {
                id: sourceId
            });
            if (sourceIndex >= 0) {
                const sourceQueue = result[sourceIndex];
                result.splice(sourceIndex, 1);
                const targetIndex = (0, ($parcel$interopDefault($fW7cr)))(result, {
                    id: targetId
                });
                if (targetIndex >= 0) {
                    result.splice(targetIndex + 1, 0, sourceQueue);
                    return result.map((page, order)=>({
                            ...page,
                            order: order
                        }));
                }
            }
        }
        return source;
    };
    const $98056c458719acf6$export$d54386016cadff45 = (source, sourceId, targetId)=>{
        const result = source.slice();
        if (sourceId !== targetId) {
            const sourceIndex = (0, ($parcel$interopDefault($fW7cr)))(result, {
                id: sourceId
            });
            if (sourceIndex >= 0) {
                const sourceQueue = result[sourceIndex];
                result.splice(sourceIndex, 1);
                const targetIndex = (0, ($parcel$interopDefault($fW7cr)))(result, {
                    id: targetId
                });
                if (targetIndex >= 0) {
                    result.splice(targetIndex, 0, sourceQueue);
                    return result.map((page, order)=>({
                            ...page,
                            order: order
                        }));
                }
            }
        }
        return source;
    };
    const $98056c458719acf6$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
        const result = source.slice();
        if (result.length === 0) return source;
        const index = (0, ($parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (index > 0) {
            const sourceQueue = result[index];
            result.splice(index, 1);
            result.splice(0, 0, sourceQueue);
            return result.map((page, order)=>({
                    ...page,
                    order: order
                }));
        }
        return source;
    };
    const $98056c458719acf6$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
            if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
                if (!queue.canBeHidden) return queue;
                return {
                    ...queue,
                    canBeHidden: false
                };
            }
            if (queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: true
            };
        });
});
parcelRegister("fW7cr", function(module, exports) {
    var $b5dwA = parcelRequire("b5dwA");
    var $bxDef = parcelRequire("bxDef");
    var $kPZpS = parcelRequire("kPZpS");
    var $b9a1db7d7901532f$var$nativeMax = Math.max;
    function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) return -1;
        var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
        if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
        return $b5dwA(array, $bxDef(predicate, 3), index);
    }
    module.exports = $b9a1db7d7901532f$var$findIndex;
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        },
        virtualAgentAiAnswers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
            "defaultMessage": "Atlassian Intelligence answers"
        }
    });
});
parcelRegister("gq0sA", function(module, exports) {
    $parcel$export(module.exports, "usePageContext", ()=>$2299d7a4f1092420$export$9c25024bdfe755f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    var $9OXo1;
    var $dFOAR;
    const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache);
    const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
        const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
        const pageContextData = (0, $5uXOq.useMemo)(()=>({
                data: projectContext && serviceDeskContext ? {
                    serviceDeskContext: {
                        portalId: serviceDeskContext.portalId,
                        portalUrl: serviceDeskContext.portalUrl,
                        canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                        userRole: serviceDeskContext.userRole,
                        serviceDeskId: serviceDeskContext.serviceDeskId
                    },
                    projectContext: {
                        projectId: projectContext.projectId,
                        projectKey: projectContext.projectKey,
                        projectName: projectContext.projectName,
                        projectType: projectContext.projectType,
                        isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                        isProjectSimplified: projectContext.simplified
                    },
                    tenantContext: {
                        baseUrl: tenantContext.baseUrl,
                        locale: tenantContext.locale,
                        userFullname: tenantContext.userFullname,
                        cloudId: tenantContext.cloudId,
                        fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                        atlassianAccountId: tenantContext.atlassianAccountId,
                        isJiraAdmin: tenantContext.isAdmin,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        activationId: tenantContext.activationId
                    }
                } : null,
                loading: projectContextLoading || serviceDeskLoading,
                error: serviceDeskError || projectContextError || null
            }), [
            tenantContext,
            projectContext,
            serviceDeskContext,
            projectContextLoading,
            serviceDeskLoading,
            serviceDeskError,
            projectContextError
        ]);
        return [
            pageContextData
        ];
    };
});
parcelRegister("dFOAR", function(module, exports) {
    $parcel$export(module.exports, "useServiceDeskContext", ()=>$6c09349e97fba749$export$712ead87353ac687);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $cAofY;
    const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, (0, parcelRequire("cAofY")).serviceDeskContextResource);
    const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
});
parcelRegister("cz40O", function(module, exports) {
    $parcel$export(module.exports, "SpaPageWrapper", ()=>$2099b56eb86565d0$export$577514961fbf4842);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $9sGI6;
    var $9dbF6;
    var $9NiTW;
    var $cYaqS;
    var $8pMQX;
    const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
        const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : (0, ($parcel$interopDefault($5uXOq))).createElement(GenericError, null));
        }
        if (projectContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
            subProduct: "serviceDesk"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, (0, ($parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
        return null;
    };
    const $2099b56eb86565d0$export$577514961fbf4842 = (0, (0, parcelRequire("9sGI6")).default)($2099b56eb86565d0$export$91f88695e0d311a5, {
        AccessCheck: (0, (0, parcelRequire("cYaqS")).default),
        GenericError: (0, (0, parcelRequire("8pMQX")).GenericError),
        ProjectNotFound: (0, (0, parcelRequire("8pMQX")).ProjectNotFound),
        AuthenticationCheck: (0, (0, parcelRequire("9NiTW")).AuthenticationCheck),
        SubProductUpdater: (0, (0, parcelRequire("9dbF6")).SubProductUpdater)
    });
    var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cYaqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f72fff5a1e4c8937$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $4UFLs;
    var $g3A84;
    const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
        const isSettingsRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
        const Gate = isSettingsRoute ? (0, (0, parcelRequire("g3A84")).default) : (0, (0, parcelRequire("4UFLs")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
    };
    var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;
});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
parcelRegister("4UFLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9befbeaff9f5385d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daoB1;
    var $dIdda = parcelRequire("dIdda");
    var $iDvG9;
    const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
        const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
        if (projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDvG9")).default), null, children);
        return hasServiceDeskAccess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira"
        });
    };
    var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;
});
parcelRegister("daoB1", function(module, exports) {
    $parcel$export(module.exports, "ApplicationPermissionsSubscriber", ()=>$77add4b5420e5058$export$d8c76f7e52d0a856);
    $parcel$export(module.exports, "useApplicationPermissions", ()=>$77add4b5420e5058$export$4d9cadb4042acc1b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $7JoAD = parcelRequire("7JoAD");
    var $2gywT;
    var $9OXo1;
    const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
            data: {
                applicationPermissions: applicationPermissions
            }
        }));
    const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("2gywT")).default), {
        displayName: 'ApplicationPermissionsSubscriber',
        selector: $77add4b5420e5058$var$selector
    });
    const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appPermissions;
    };
});
parcelRegister("iDvG9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34dd3dc578b1a167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $dFOAR;
    var $fhAnU;
    const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
        const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
        const [{ data: data, error: error }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        if (data || error) {
            if (!(0, (0, parcelRequire("fhAnU")).isAccessError)(error)) {
                const { userRole: userRole = '' } = data || {};
                if (userRole === 'agent' || userRole === 'agent-project-admin') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
                if (error) throw error;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
            });
        }
        return null;
    };
    var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;
});
parcelRegister("fhAnU", function(module, exports) {
    $parcel$export(module.exports, "isAccessError", ()=>$1a790f4bb1355504$export$ddaebe4928e793cb);
    const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
    ];
    const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;
});
parcelRegister("g3A84", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e7d6646168c089$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8pMQX;
    var $dFOAR;
    var $fhAnU;
    const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
        const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        const userRole = serviceDeskContext?.userRole;
        const hasAccessError = (0, (0, parcelRequire("fhAnU")).isAccessError)(serviceDeskContextError);
        if (userRole === 'agent-project-admin' && !hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (userRole !== undefined || hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null);
        if (serviceDeskContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).GenericError), null);
        return null;
    };
    var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $hTEpF;
    var $dC5iT;
    var $8CUq3;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $tcn7E;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("tcn7E")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $b8Qxt;
    var $dC5iT;
    var $8CUq3;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b8Qxt")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("b8Qxt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fd53c1f9dbca185$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e4VnT;
    var $1HkQx;
    var $eCBnN;
    var $9Xp6L;
    const $4fd53c1f9dbca185$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("e4VnT")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("eCBnN")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Xp6L")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
    var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;
});
parcelRegister("e4VnT", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$a32b74c088f4b53f$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1HkQx", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$a9c1aabaca189fa1$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$a9c1aabaca189fa1$export$57a2d4b573afd64a);
    var $lBXbx;
    var $8CJbG;
    const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("lBXbx")).SPACING),
            marginRight: (0, (0, parcelRequire("lBXbx")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("lBXbx")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("lBXbx")).SPACING}px 0` : (0, (0, parcelRequire("lBXbx")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("lBXbx")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
                ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("lBXbx")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("lBXbx")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("8CJbG")).getBaseTheme)();
        const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("8CJbG")).getBaseTheme)(),
            ...(0, (0, parcelRequire("8CJbG")).getColorPalette)(),
            lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("lBXbx", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$6ec31795911692d1$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$6ec31795911692d1$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$6ec31795911692d1$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$6ec31795911692d1$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$6ec31795911692d1$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$6ec31795911692d1$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$6ec31795911692d1$export$1758fda69688282e);
    var $k5uoT;
    const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
    const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
    const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
    const $6ec31795911692d1$export$82ea42e772d49e5b = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
    const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
    const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("8CJbG", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$eac5fe855702cfc1$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$eac5fe855702cfc1$export$fe2a6478976e8b17);
    var $8QpSo;
    var $kTHGn;
    const $eac5fe855702cfc1$var$T800 = '#067384';
    const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
    const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("kTHGn")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
        });
    const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
        };
    });
    const $eac5fe855702cfc1$var$getTheme = ()=>({
            ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
            ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
        });
    var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("eCBnN", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$d00516a0f8207944$export$f38728011c178796);
    var $8QpSo;
    var $8Y2ZY;
    const $d00516a0f8207944$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("8Y2ZY")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("8Y2ZY", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$012a854d92762508$export$7c77c3a9bb93870d);
    const $012a854d92762508$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("9Xp6L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e296c4d390ff4a21$export$2e2bcd8739ae039);
    var $c8FD2;
    var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c8FD2")).default);
});
parcelRegister("c8FD2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64df4f4e00539958$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp89O;
    const $64df4f4e00539958$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("lp89O")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;
});
parcelRegister("lp89O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a813ccd1d5fae376$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iQkqt;
    var $jVB7m;
    const $a813ccd1d5fae376$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("iQkqt")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("jVB7m")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;
});
parcelRegister("iQkqt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55dc1424d34091d6$export$2e2bcd8739ae039);
    var $eJUOt;
    var $eTMIA;
    var $8bliZ;
    var $g6MVu;
    const $55dc1424d34091d6$var$newLineRegex = /\n/g;
    function $55dc1424d34091d6$var$getNewLines(str) {
        return str.match($55dc1424d34091d6$var$newLineRegex);
    }
    function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g6MVu")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("eJUOt")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("8bliZ")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $55dc1424d34091d6$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("eTMIA")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("eTMIA")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("eJUOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9ccdbf71436a137$export$2e2bcd8739ae039);
    var $eTMIA;
    var $5FOwT;
    function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("eTMIA")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("5FOwT")).default)(lineNumber));
                return children;
            }
        };
    }
    var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;
});
parcelRegister("eTMIA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6df5b208b9d23752$export$2e2bcd8739ae039);
    var $5FOwT;
    function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("5FOwT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6257c3f70e94feb$export$2e2bcd8739ae039);
    function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("8bliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9f6debfd276481a$export$2e2bcd8739ae039);
    var $eTMIA;
    function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("eTMIA")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g6MVu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8213b6c690eefe35$export$2e2bcd8739ae039);
    function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("jVB7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98c01cbb865d4c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fBvqm;
    function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("fBvqm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdda3a2c4411588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lrHA4;
    var $31cgS;
    var $d3zI6;
    function $2fdda3a2c4411588$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("31cgS")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lrHA4")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("d3zI6")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("lrHA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e6443bd1dfeaac7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $abxiq;
    function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("abxiq", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$59fdc1b7b0ae96c9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jldZL;
    const $59fdc1b7b0ae96c9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $59fdc1b7b0ae96c9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("31cgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e16562bd8c2aca9b$export$2e2bcd8739ae039);
    const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("d3zI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbc4a00f80b5d8f$export$2e2bcd8739ae039);
    var $fBvqm;
    function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $3Fq5M;
    var $dC5iT;
    var $8CUq3;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $3bDjY;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("8XAvX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95fd3039216adfa3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    var $dd29Z;
    var $dIdda = parcelRequire("dIdda");
    const $95fd3039216adfa3$var$QueuesPushProvider = (props)=>{
        const { projectKey: projectKey, children: children } = props;
        const { push: push, replace: replace } = (0, $dIdda.useRouterActions)();
        const pushWithSpaCompatibleUrl = (0, $5uXOq.useCallback)((path)=>{
            const pathWithLeadingSlash = path.charAt(0) === '/' ? `${path}` : `/${path}`;
            let fullPath = pathWithLeadingSlash;
            if (pathWithLeadingSlash.indexOf('/jira/servicedesk/projects') !== 0) fullPath = `/jira/servicedesk/projects/${projectKey}${pathWithLeadingSlash}`;
            push(fullPath);
            return (0, $kVLXA.Observable).empty();
        }, [
            projectKey,
            push
        ]);
        const navigateWithProjectKey = (0, $5uXOq.useCallback)((path)=>(0, (0, parcelRequire("dd29Z")).navigate)(projectKey, path), [
            projectKey
        ]);
        if (!projectKey) return children({
            push: undefined
        });
        return __SPA__ ? children({
            push: pushWithSpaCompatibleUrl,
            replace: replace
        }) : children({
            push: navigateWithProjectKey
        });
    };
    var $95fd3039216adfa3$export$2e2bcd8739ae039 = $95fd3039216adfa3$var$QueuesPushProvider;
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("k30xR", function(module, exports) {
    $parcel$export(module.exports, "useOnFavoritesChanged", ()=>$572c407f9743cbb2$export$ddf44c597e03063d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1sWm7 = parcelRequire("1sWm7");
    var $dMEgP = parcelRequire("dMEgP");
    var $eXQym;
    var $4041n;
    const $572c407f9743cbb2$export$ddf44c597e03063d = (projectKey, category, queues, callback)=>{
        const { items: items } = (0, $5uXOq.useContext)((0, (0, parcelRequire("4041n")).FavoriteChangeContext));
        const queueItemChanges = items[0, (0, parcelRequire("eXQym")).QUEUES_ITEM_TYPE];
        const previousChangesRef = (0, $5uXOq.useRef)({
            projectKey: projectKey,
            category: category,
            changedItems: undefined
        });
        const { current: previousChanges } = previousChangesRef;
        const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
        if (hasPotentialChanges) {
            previousChangesRef.current = {
                projectKey: projectKey,
                category: category,
                changedItems: queueItemChanges
            };
            if (queues) (0, ($parcel$interopDefault($dMEgP)))(queueItemChanges).forEach(({ id: id, value: value })=>{
                const queue = (0, ($parcel$interopDefault($1sWm7)))(queues, {
                    id: Number(id)
                });
                if (queue && queue.favourite !== value) callback(id, value);
            });
        }
    };
});
parcelRegister("1sWm7", function(module, exports) {
    var $bptzf = parcelRequire("bptzf");
    var $fW7cr = parcelRequire("fW7cr");
    var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
    module.exports = $1115ac3ae60cc7bc$var$find;
});
parcelRegister("bptzf", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $hTJwX = parcelRequire("hTJwX");
    var $66FNL = parcelRequire("66FNL");
    function $84e8f705a13e859f$var$createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
            var iterable = Object(collection);
            if (!$hTJwX(collection)) {
                var iteratee = $bxDef(predicate, 3);
                collection = $66FNL(collection);
                predicate = function(key) {
                    return iteratee(iterable[key], key, iterable);
                };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
        };
    }
    module.exports = $84e8f705a13e859f$var$createFind;
});
parcelRegister("6OeKD", function(module, exports) {
    $parcel$export(module.exports, "pageToQueues", ()=>$b8361afc4fd34fcb$export$8ada91ce992fa66f);
    var $3HGy4;
    const $b8361afc4fd34fcb$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
            const column = {
                id: responseColumn.fieldId,
                title: responseColumn.title,
                fieldType: responseColumn.fieldType,
                sortable: responseColumn.sortable
            };
            if (responseColumn.sortOrder) return {
                ...column,
                currentSorting: responseColumn.sortOrder
            };
            return column;
        });
    const $b8361afc4fd34fcb$export$8ada91ce992fa66f = (page)=>page.reduce((acc, queue)=>{
            acc[queue.id] = {
                id: (0, (0, parcelRequire("3HGy4")).toQueueId)(queue.id),
                name: queue.name,
                jql: queue.jql,
                completeJql: queue.completeJql,
                order: queue.order,
                columns: $b8361afc4fd34fcb$var$transformColumns(queue.columnsDetails),
                isFavorite: queue.favourite,
                category: queue.category,
                canBeHidden: queue.canBeHidden
            };
            return acc;
        }, {});
});
parcelRegister("l8ruj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6056b4460d0127e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1tcYS;
    var $bFU4G;
    var $8Ec39;
    var $cEm1b;
    function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
        const interactionContext = (0, (0, parcelRequire("1tcYS")).useInteractionContext)();
        const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
                getInteractionContext: ()=>interactionContext,
                wrapPrepareQueryResource (cb) {
                    return cb();
                },
                retainQuery (info) {
                    this.getInteractionContext().retainQuery(info);
                }
            }), [
            interactionContext
        ]);
        const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
            const moduleLoadingRequests = {};
            return {
                current: {
                    getInteractionContext () {
                        return interactionContext;
                    },
                    onPreload (moduleId, _priority) {
                        this.getInteractionContext().addPreload((0, (0, parcelRequire("bFU4G")).extractModuleName)(moduleId), performance.now());
                    },
                    onLoadStart (info) {
                        const timeoutId = setTimeout(()=>{
                            delete moduleLoadingRequests[info.identifier];
                        }, 30000);
                        const request = {
                            start: performance.now(),
                            timeoutId: timeoutId
                        };
                        moduleLoadingRequests[info.identifier] = request;
                    },
                    onLoadComplete (info) {
                        const request = moduleLoadingRequests[info.identifier];
                        if (request) {
                            clearTimeout(request.timeoutId);
                            delete moduleLoadingRequests[info.identifier];
                            this.getInteractionContext()?.addLoad((0, (0, parcelRequire("bFU4G")).extractModuleName)(info.identifier), request.start, performance.now());
                        }
                    },
                    placeholderFallBackMounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                    },
                    placeholderFallBackUnmounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                    }
                }
            };
        }, [
            interactionContext
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
            value: relayProfilerContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEm1b")).ProfilerContext).Provider, {
            value: reactLooselyLazyContext
        }, children));
    }
    function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ec39")).default), {
            name: segmentName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
    }
});
parcelRegister("7DYR6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ace41a9f8f324eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $4R6GH;
    var $1W0cQ;
    var $5jyD0;
    var $6FTcZ;
    var $aLr4F;
    var $9OXo1;
    var $l8ruj;
    var $dIdda = parcelRequire("dIdda");
    const $1ace41a9f8f324eb$var$LegacyIssueView = (props)=>{
        const { push: push, match: match } = props;
        const [{ location: location }] = (0, $dIdda.useRouter)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const projectKey = match && match.params && match.params.projectKey ? match.params.projectKey : undefined;
        const [{ data: kbLink, loading: loading }] = (0, (0, parcelRequire("6FTcZ")).useKbConfluenceContext)(projectKey);
        const { locale: locale } = tenantContext;
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        return match && match.params && match.params.issueKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "queues-legacy-issue-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5jyD0")).Page), {
            entity: match.params.queueId || '',
            issueKey: match.params.issueKey,
            onNavigation: push,
            locale: locale,
            wrmDataForPage: {
                'com.atlassian.servicedesk.core-ui:util-base-url.base-url': `https://${location.host || window.location.host}`,
                moment_user_locale: locale,
                'sd-kb-link': kbLink
            },
            pathname: location.pathname
        })) : null;
    };
    const $1ace41a9f8f324eb$var$QueuesIssueViewContent = (props)=>{
        const { pageContext: pageContext, push: push, match: match, issueNavigatorData: issueNavigatorData } = props;
        const { isProjectSimplified: isProjectSimplified, canSeeNewIssueView: canSeeNewIssueView } = pageContext;
        const [{ location: { search: search } }] = (0, $dIdda.useRouter)();
        const { showLegacyIssueView: showLegacyIssueView } = (0, (0, parcelRequire("aLr4F")).useShouldShowLegacyIssueView)(isProjectSimplified, canSeeNewIssueView, search);
        if (showLegacyIssueView && !(0, (0, parcelRequire("4R6GH")).fg)('remove_queues_legacy_issue_view')) return (0, ($parcel$interopDefault($5uXOq))).createElement($1ace41a9f8f324eb$var$LegacyIssueView, {
            push: push,
            match: match
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "queues-issue-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1W0cQ")).default), {
            issueNavigatorData: issueNavigatorData
        }));
    };
    var $1ace41a9f8f324eb$export$2e2bcd8739ae039 = $1ace41a9f8f324eb$var$QueuesIssueViewContent;
});
parcelRegister("1W0cQ", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$719e268c3759c45e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k3PbQ;
    var $4Eklo;
    var $bYtrC;
    var $9hUca;
    var $dd29Z;
    var $l8ruj;
    var $a1E0h;
    let $719e268c3759c45e$var$dispatchExternalAction;
    const $719e268c3759c45e$var$getIssueKey = ()=>(0, (0, parcelRequire("4Eklo")).parseIssueKey)(window.location.href);
    const $719e268c3759c45e$var$getPreviousUrl = ()=>{
        const urlParts = window.location.href.split('/');
        return urlParts.slice(0, urlParts.length - 1).join('/');
    };
    const $719e268c3759c45e$var$queueRoutesPattern = Object.values((0, (0, parcelRequire("dd29Z")).QUEUE_ROUTES)).join('|').replace(/\//g, '\\/');
    const $719e268c3759c45e$var$QUEUES_URL_REGEX = new RegExp(`.*\\/projects\\/[^/]+\\/(${$719e268c3759c45e$var$queueRoutesPattern})\\/custom\\/.*`);
    const $719e268c3759c45e$var$isComingFromQueue = ()=>window.location.pathname.match($719e268c3759c45e$var$QUEUES_URL_REGEX);
    const $719e268c3759c45e$var$REPORTS_URL_REGEX = /.*\/projects\/[^/]+\/reports\/.*/;
    const $719e268c3759c45e$var$isComingFromReport = ()=>window.location.pathname.match($719e268c3759c45e$var$REPORTS_URL_REGEX);
    const $719e268c3759c45e$var$isComingFromQueueOrReport = ()=>$719e268c3759c45e$var$isComingFromQueue() || $719e268c3759c45e$var$isComingFromReport();
    const $719e268c3759c45e$var$redirectAfterSuccessfulDelete = ()=>()=>{
            const issueKey = $719e268c3759c45e$var$getIssueKey();
            const projectKey = (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey);
            let url;
            if ($719e268c3759c45e$var$isComingFromQueueOrReport()) url = $719e268c3759c45e$var$getPreviousUrl();
            else url = `/projects/${projectKey}`;
            window.location.assign(url);
        };
    (0, (0, parcelRequire("bYtrC")).listenToExternalActionFromLegacy)(()=>({
            dispatchExternalAction: $719e268c3759c45e$var$dispatchExternalAction,
            modifiedIssueIssueKey: $719e268c3759c45e$var$getIssueKey()
        }));
    const $719e268c3759c45e$var$onDispatchExternalActionRef = (ref)=>{
        if (ref) $719e268c3759c45e$var$dispatchExternalAction = ref;
    };
    const $719e268c3759c45e$var$getAnalyticsSourceFromUrl = ()=>{
        const { pathname: pathname } = window.location;
        if (pathname.includes('section')) return 0, $fcf97b7a09088940$export$7063ee6d0035a982;
        if (pathname.includes('queues')) return 0, $fcf97b7a09088940$export$7063ee6d0035a982;
        return 0, $fcf97b7a09088940$export$5bd5011b6596a0e7;
    };
    var $719e268c3759c45e$export$2e2bcd8739ae039 = ({ issueNavigatorData: issueNavigatorData } = {})=>{
        (0, (0, parcelRequire("9hUca")).markFragmentReady)();
        const issueKey = $719e268c3759c45e$var$getIssueKey();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jsm-issue-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a1E0h")).default), {
            backButtonUrl: $719e268c3759c45e$var$isComingFromQueueOrReport() ? $719e268c3759c45e$var$getPreviousUrl() : undefined,
            issueNavigatorData: issueNavigatorData,
            analyticsSource: $719e268c3759c45e$var$getAnalyticsSourceFromUrl(),
            issueKey: issueKey,
            onIssueDeleteSuccess: $719e268c3759c45e$var$redirectAfterSuccessfulDelete(),
            onDispatchExternalActionRef: $719e268c3759c45e$var$onDispatchExternalActionRef
        }));
    };
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("k3PbQ", function(module, exports) {
    $parcel$export(module.exports, "extractProjectKey", ()=>$bfdd97e245e93328$export$f1a2e4721b127828);
    var $g5X3G;
    const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
});
parcelRegister("4Eklo", function(module, exports) {
    $parcel$export(module.exports, "parseIssueKey", ()=>$91413ecb65c044f0$export$775cba7641fc60e9);
    var $g5X3G;
    const $91413ecb65c044f0$export$775cba7641fc60e9 = (href)=>{
        const path = href.split('/').pop();
        return (0, (0, parcelRequire("g5X3G")).toIssueKey)(path.split('?')[0].split('#')[0]);
    };
});
parcelRegister("bYtrC", function(module, exports) {
    $parcel$export(module.exports, "listenToExternalActionFromLegacy", ()=>$3ad042b87162e1c7$export$60376d8e2c7d8037);
    var $6BZYo;
    const $3ad042b87162e1c7$export$60376d8e2c7d8037 = (getDispatcherAndModifiedIssue)=>{
        (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'jira/util/events',
            wrmKeys: 'wrc!jira.webresources:jira-events'
        }).then((Events)=>{
            Events.bind('modify-issue-view-via-external-action', (e, payload)=>{
                const { issueKey: issueKey, externalAction: externalAction } = payload;
                const { dispatchExternalAction: dispatchExternalAction, modifiedIssueIssueKey: modifiedIssueIssueKey } = getDispatcherAndModifiedIssue();
                if (issueKey === modifiedIssueIssueKey && externalAction && dispatchExternalAction) dispatchExternalAction(externalAction);
            });
        });
    };
});
parcelRegister("9hUca", function(module, exports) {
    $parcel$export(module.exports, "markFragmentReady", ()=>$09e694cdaae84ff1$export$f35671de67f03a2b);
    $parcel$export(module.exports, "initialiseMetrics", ()=>$09e694cdaae84ff1$export$1ac307e078c767d0);
    $parcel$export(module.exports, "markIssueStartRendering", ()=>$09e694cdaae84ff1$export$c039505b02c87616);
    $parcel$export(module.exports, "markIssueRender", ()=>$09e694cdaae84ff1$export$c16cf8a32075f588);
    $parcel$export(module.exports, "markIssueLegacyInteractive", ()=>$09e694cdaae84ff1$export$4d5d547fdbe28097);
    $parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", ()=>$09e694cdaae84ff1$export$a45a77102d75517f);
    $parcel$export(module.exports, "markIssueInteractive", ()=>$09e694cdaae84ff1$export$e57956c4b76a36f);
    $parcel$export(module.exports, "markIssueOnPageLoadEvent", ()=>$09e694cdaae84ff1$export$c30d9392d27ab5a8);
    $parcel$export(module.exports, "markStartIssue", ()=>$09e694cdaae84ff1$export$71cdf78946f275c);
    $parcel$export(module.exports, "markIssuePreviewRendered", ()=>$09e694cdaae84ff1$export$7f5545008a1e5a18);
    $parcel$export(module.exports, "setIsInitialRender", ()=>$09e694cdaae84ff1$export$eedeaa0a5b3bd3d1);
    $parcel$export(module.exports, "isFullIssueView", ()=>$09e694cdaae84ff1$export$db2ef91f6ace96c7);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $99gkn;
    var $aOr3t;
    var $gSA3s;
    var $bFU4G;
    var $fDtbf;
    var $x9xyg;
    var $dJl1T;
    var $7N30e;
    var $4R6GH;
    var $1XsIp;
    var $EKr1h;
    var $5x8df;
    var $72N4j;
    var $iAWa3;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    var $ieOir;
    var $Rsnea;
    var $1UioC;
    var $jf6us;
    var $fdHx2;
    const $09e694cdaae84ff1$var$LOG_LOCATION = 'issue.metrics';
    let $09e694cdaae84ff1$var$state;
    const $09e694cdaae84ff1$var$getSsrMark = ()=>{
        const ssrMark = (0, (0, parcelRequire("x9xyg")).getMark)((0, (0, parcelRequire("fDtbf")).SPA_SSR_RENDERED_MARK));
        if (ssrMark != null) return Math.floor(ssrMark.startTime);
        return null;
    };
    const $09e694cdaae84ff1$var$setMarkWithError = (markName)=>{
        try {
            (0, (0, parcelRequire("x9xyg")).setMark)(markName);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($09e694cdaae84ff1$var$LOG_LOCATION, 'Setting performance mark failed', error);
        }
    };
    const $09e694cdaae84ff1$export$f35671de67f03a2b = ()=>{
        $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$625e4e4c6eb56930);
    };
    const $09e694cdaae84ff1$export$1ac307e078c767d0 = (options)=>{
        try {
            const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
            $09e694cdaae84ff1$var$state = new (0, (0, parcelRequire("jf6us")).default)({
                isLoadedWithPage: isLoadedWithPage,
                isSPA: isSPA,
                isRecentIssue: isRecentIssue,
                analyticsSource: analyticsSource,
                recentIssuesCount: recentIssuesCount,
                correlationId: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                lazyMetricsProps: ()=>(0, (0, parcelRequire("fdHx2")).metricsStateSelector)(store.getState()),
                timingDataReporter: ()=>({
                        ...(0, (0, parcelRequire("72N4j")).serverTimingSelector)(store.getState()),
                        ...(0, (0, parcelRequire("1XsIp")).getFetchIssueNetworkTimes)()
                    }),
                issueScaleabilityReporter: (0, (0, parcelRequire("1UioC")).issueScaleabilityReporterFactory)(store, issueContextActions),
                dataProvider: dataProvider,
                route: route
            });
            (0, (0, parcelRequire("EKr1h")).issueViewLoad).mark('metrics_init');
            (0, (0, parcelRequire("EKr1h")).issueViewOnPageLoad).mark('metrics_init');
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($09e694cdaae84ff1$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
        }
    };
    const $09e694cdaae84ff1$export$c039505b02c87616 = ()=>{
        $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$10082883a7f4ea4d);
        (0, (0, parcelRequire("EKr1h")).issueViewLoad).mark($f0ab548eaf57140f$export$10082883a7f4ea4d);
    };
    const $09e694cdaae84ff1$export$c16cf8a32075f588 = ()=>{
        $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$7f7b606f70e669e6);
        (0, (0, parcelRequire("EKr1h")).issueViewOnPageLoad).mark($f0ab548eaf57140f$export$7f7b606f70e669e6);
    };
    const $09e694cdaae84ff1$export$4d5d547fdbe28097 = ()=>{
        $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$b292c195104c50d3);
        (0, (0, parcelRequire("EKr1h")).issueViewLoad).mark($f0ab548eaf57140f$export$b292c195104c50d3);
    };
    const $09e694cdaae84ff1$export$8bc8bca4478fe6d7 = (markTime)=>{
        (0, (0, parcelRequire("EKr1h")).issueViewOnPageLoad).mark($f0ab548eaf57140f$export$4d1080224e02ef0b, markTime);
    };
    const $09e694cdaae84ff1$export$a45a77102d75517f = ()=>{
        $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$434b58ebadf14df2);
        (0, (0, parcelRequire("EKr1h")).issueViewLoad).mark($f0ab548eaf57140f$export$434b58ebadf14df2);
    };
    const $09e694cdaae84ff1$var$getSharedCustomData = ()=>({
            ...$09e694cdaae84ff1$var$state.getIssueScaleabilityReporter()(),
            ...(0, (0, parcelRequire("Rsnea")).getBackendBlockingTime)({
                issueViewLoad: (0, (0, parcelRequire("EKr1h")).issueViewLoad)
            }),
            isBentoRecentIssue: $09e694cdaae84ff1$var$state.getIsRecentIssue(),
            bentoRecentIssuesCount: $09e694cdaae84ff1$var$state.getRecentIssuesCount(),
            correlationId: $09e694cdaae84ff1$var$state.getCorrelationId(),
            ...(0, (0, parcelRequire("4R6GH")).fg)('enable-metric-full-page-bundle-load-count') ? {
                initialLoadFullPageBundleLoadCount: $09e694cdaae84ff1$var$state.getIsInitial() ? performance.getEntriesByType('resource').filter((x)=>x.name.includes('async-issue-app--full-page')).length : 0
            } : {}
        });
    const $09e694cdaae84ff1$export$e57956c4b76a36f = ({ lastTransitionTime: lastTransitionTime })=>{
        const isFullIssue = $09e694cdaae84ff1$var$state.getIsFullIssue();
        $09e694cdaae84ff1$var$state.setInteractiveEnd(performance.now());
        if ($09e694cdaae84ff1$var$state) {
            const startTime = lastTransitionTime || $09e694cdaae84ff1$var$state.getStartTime();
            if ($09e694cdaae84ff1$var$state.getIsFullIssue()) (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
            const embeddedCustomData = !isFullIssue ? {
                embeddedIssueFMP: Math.floor($09e694cdaae84ff1$var$state.getFMP()),
                embeddedIssueTTI: Math.floor($09e694cdaae84ff1$var$state.getInteractiveEnd() - startTime),
                analyticsSource: $09e694cdaae84ff1$var$state.getAnalyticsSource(),
                featureFlags: Object.fromEntries((0, (0, parcelRequire("gSA3s")).allFeatureFlagsAccessed))
            } : {};
            const perfConfig = {
                stopTime: $09e694cdaae84ff1$var$state.getInteractiveEnd(),
                customData: {
                    ...$09e694cdaae84ff1$var$getSharedCustomData(),
                    ...embeddedCustomData
                }
            };
            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(perfConfig.customData);
            const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
            (0, (0, parcelRequire("bFU4G")).addApdexToAll)({
                key: ufoMetricKey,
                startTime: isFullIssue ? undefined : (0, (0, parcelRequire("EKr1h")).embeddedIssueViewLoad).getData()?.start ?? undefined,
                stopTime: perfConfig.stopTime
            });
            if (isFullIssue) (0, (0, parcelRequire("aOr3t")).addBM3TimingsToUFO)((0, (0, parcelRequire("EKr1h")).issueViewLoad).getData()?.marks, (0, (0, parcelRequire("EKr1h")).issueViewLoad).getData()?.config.timings);
            if (isFullIssue && (0, (0, parcelRequire("5x8df")).isBM3EmitOnRafTopExperiencesEnabled)()) (0, (0, parcelRequire("iAWa3")).afterPaintEmit)(()=>{
                (0, (0, parcelRequire("EKr1h")).issueViewLoad).stop(perfConfig);
            }, (0, (0, parcelRequire("EKr1h")).issueViewLoad));
            else (0, (0, parcelRequire("EKr1h")).issueViewLoad).stop(perfConfig);
            (0, (0, parcelRequire("ieOir")).markUimTtiIssueViewLoaded)();
            if (!isFullIssue) {
                if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
            }
        }
    };
    const $09e694cdaae84ff1$var$getBrowserNavigationMetrics = ()=>{
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
        const navigation = entries[0];
        return {
            connectEnd: Math.round(navigation.connectEnd),
            connectStart: Math.round(navigation.connectStart),
            domComplete: Math.round(navigation.domComplete),
            domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
            domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
            domInteractive: Math.round(navigation.domInteractive),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            fetchStart: Math.round(navigation.fetchStart),
            loadEventStart: Math.round(navigation.loadEventStart),
            requestStart: Math.round(navigation.requestStart),
            responseEnd: Math.round(navigation.responseEnd),
            responseStart: Math.round(navigation.responseStart),
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            redirectCount: navigation.redirectCount,
            type: navigation.type
        };
    };
    const $09e694cdaae84ff1$export$c30d9392d27ab5a8 = ()=>{
        const isFullIssue = $09e694cdaae84ff1$var$state.getIsFullIssue();
        if (!isFullIssue) return;
        if ($09e694cdaae84ff1$var$state) {
            try {
                new PerformanceObserver((entryList)=>{
                    entryList.getEntries().forEach((entry)=>$09e694cdaae84ff1$export$8bc8bca4478fe6d7(entry.startTime));
                }).observe({
                    type: 'largest-contentful-paint',
                    buffered: true
                });
            } catch (e) {}
            const customData = {
                ...$09e694cdaae84ff1$var$getSharedCustomData(),
                browserNavigationMetrics: $09e694cdaae84ff1$var$getBrowserNavigationMetrics()
            };
            (0, (0, parcelRequire("EKr1h")).issueViewOnPageLoad).stop(customData);
            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(customData);
        }
    };
    const $09e694cdaae84ff1$export$71cdf78946f275c = (isFullPage = false)=>{
        (0, (0, parcelRequire("EKr1h")).issueViewLoad).start();
        if (!isFullPage) {
            (0, (0, parcelRequire("EKr1h")).embeddedIssueViewLoad).start({
                startTime: performance.now()
            });
            if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).startLowPriorityEventDelay)();
        }
        if (isFullPage) (0, (0, parcelRequire("EKr1h")).issueViewOnPageLoad).start({
            startTime: 0
        });
        (0, (0, parcelRequire("ieOir")).startUimTti)();
    };
    const $09e694cdaae84ff1$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
        const ssrMark = $09e694cdaae84ff1$var$getSsrMark();
        const previewTime = performance.now();
        const startTime = $09e694cdaae84ff1$var$state.getStartTime();
        let fmp = 0;
        if ($09e694cdaae84ff1$var$state.getIsFullIssue()) {
            if (isInitialRender) fmp = ssrMark;
            else fmp = previewTime - (lastTransitionStartTime || startTime);
        } else fmp = previewTime - startTime;
        (0, (0, parcelRequire("EKr1h")).issueViewLoad).mark($f0ab548eaf57140f$export$62c04f0e896827e3);
        (0, (0, parcelRequire("EKr1h")).issueViewOnPageLoad).mark($f0ab548eaf57140f$export$62c04f0e896827e3);
        $09e694cdaae84ff1$var$state.setFMP(fmp);
        $09e694cdaae84ff1$var$state.setPreviewEnd(previewTime);
        $09e694cdaae84ff1$var$setMarkWithError($f0ab548eaf57140f$export$62c04f0e896827e3);
    };
    const $09e694cdaae84ff1$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
        if ($09e694cdaae84ff1$var$state) $09e694cdaae84ff1$var$state.setIsLoadedWithPage(isInitialRender);
    };
    const $09e694cdaae84ff1$export$db2ef91f6ace96c7 = ()=>$09e694cdaae84ff1$var$state && $09e694cdaae84ff1$var$state.getIsFullIssue();
});
parcelRegister("99gkn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a18f2c0b045372b$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "addUFOCustomData", ()=>$7a18f2c0b045372b$export$d12f56a472cdbe6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $7a18f2c0b045372b$export$2e2bcd8739ae039({ data: data }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        (0, $5uXOq.useMemo)(()=>{
            if (!interactionContext) return;
            interactionContext.addCustomData(data);
        }, [
            data,
            interactionContext
        ]);
        return null;
    }
    function $7a18f2c0b045372b$export$d12f56a472cdbe6c(data) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, (0, parcelRequire("bFU4G")).addCustomData)(currentInteractionId, [], data);
    }
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
const $f0ab548eaf57140f$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $f0ab548eaf57140f$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $f0ab548eaf57140f$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $f0ab548eaf57140f$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $f0ab548eaf57140f$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $f0ab548eaf57140f$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $f0ab548eaf57140f$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $f0ab548eaf57140f$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $f0ab548eaf57140f$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $f0ab548eaf57140f$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $f0ab548eaf57140f$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $f0ab548eaf57140f$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $f0ab548eaf57140f$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $f0ab548eaf57140f$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $f0ab548eaf57140f$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $f0ab548eaf57140f$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $f0ab548eaf57140f$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $f0ab548eaf57140f$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $f0ab548eaf57140f$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';
parcelRegister("1XsIp", function(module, exports) {
    $parcel$export(module.exports, "clearFetchIssueNetworkTimes", ()=>$80f3a44fca71778e$export$8d777cefeb6b914e);
    $parcel$export(module.exports, "getFetchIssueNetworkTimes", ()=>$80f3a44fca71778e$export$48cecd0d00931806);
    var $7OOGM;
    var $6RCeq;
    var $60SGJ;
    const $80f3a44fca71778e$var$fetchIssueNetworkMarks = [
        (0, (0, parcelRequire("60SGJ")).fetchUploadPerf),
        (0, (0, parcelRequire("60SGJ")).fetchCommentsPerf),
        (0, (0, parcelRequire("60SGJ")).fetchIssuePropertiesPerf),
        (0, (0, parcelRequire("60SGJ")).fetchIssueLinkPerf),
        (0, (0, parcelRequire("60SGJ")).fetchViewContextPerf),
        (0, (0, parcelRequire("60SGJ")).fetchSubtaskTypesPerf),
        (0, (0, parcelRequire("60SGJ")).fetchFieldDataPerf),
        (0, (0, parcelRequire("60SGJ")).fetchUserAuthPerf)
    ];
    let $80f3a44fca71778e$var$fetchIssueNetworkTimes;
    const $80f3a44fca71778e$var$calculateFetchIssueNetworkTimes = ()=>{
        const issueNetworkTimes = $80f3a44fca71778e$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
            const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
            const endMarkName = `END_${perf.prefix}_${perf.key}`;
            const networkTime = (0, (0, parcelRequire("7OOGM")).timeBetweenMarks)(beginMarkName, endMarkName);
            if (networkTime != null && networkTime > 0) {
                const aggregated = {
                    ...obj,
                    [`${perf.key}_NETWORK`]: networkTime
                };
                if ((0, (0, parcelRequire("6RCeq")).default).clearMarks) {
                    (0, (0, parcelRequire("6RCeq")).default).clearMarks(beginMarkName);
                    (0, (0, parcelRequire("6RCeq")).default).clearMarks(endMarkName);
                }
                return aggregated;
            }
            return obj;
        }, {});
        return issueNetworkTimes;
    };
    const $80f3a44fca71778e$export$8d777cefeb6b914e = ()=>{
        $80f3a44fca71778e$var$fetchIssueNetworkMarks.forEach((perf)=>{
            const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
            const endMarkName = `END_${perf.prefix}_${perf.key}`;
            if ((0, (0, parcelRequire("6RCeq")).default).clearMarks) {
                (0, (0, parcelRequire("6RCeq")).default).clearMarks(beginMarkName);
                (0, (0, parcelRequire("6RCeq")).default).clearMarks(endMarkName);
            }
        });
        $80f3a44fca71778e$var$fetchIssueNetworkTimes = null;
        window.ISSUE_DATA_AVAILABLE = null;
    };
    const $80f3a44fca71778e$export$48cecd0d00931806 = ()=>{
        if (!$80f3a44fca71778e$var$fetchIssueNetworkTimes) $80f3a44fca71778e$var$fetchIssueNetworkTimes = $80f3a44fca71778e$var$calculateFetchIssueNetworkTimes();
        return $80f3a44fca71778e$var$fetchIssueNetworkTimes;
    };
});
parcelRegister("7OOGM", function(module, exports) {
    $parcel$export(module.exports, "timeBetweenMarks", ()=>$9a82ffbeaa8b7a7f$export$9c25bf1893ba64c);
    var $x9xyg;
    const $9a82ffbeaa8b7a7f$export$9c25bf1893ba64c = (startMarkName, endMarkName)=>{
        const startMark = (0, (0, parcelRequire("x9xyg")).getMark)(startMarkName);
        const endMark = (0, (0, parcelRequire("x9xyg")).getMark)(endMarkName);
        if (!startMark || !endMark || startMark.startTime > endMark.startTime) return null;
        return endMark.startTime - startMark.startTime;
    };
});
parcelRegister("60SGJ", function(module, exports) {
    $parcel$export(module.exports, "fetchFieldDataPerf", ()=>$9e43cd7de2afe373$export$b97d963a8496fa2f);
    $parcel$export(module.exports, "fetchCommentsPerf", ()=>$9e43cd7de2afe373$export$179836a99669cbe7);
    $parcel$export(module.exports, "fetchIssueLinkPerf", ()=>$9e43cd7de2afe373$export$8d0984a0f9f31117);
    $parcel$export(module.exports, "fetchSubtaskTypesPerf", ()=>$9e43cd7de2afe373$export$c1324bd586e9a53a);
    $parcel$export(module.exports, "fetchUploadPerf", ()=>$9e43cd7de2afe373$export$72fcc6cb1cdc70e0);
    $parcel$export(module.exports, "fetchUserAuthPerf", ()=>$9e43cd7de2afe373$export$4052b1eae3373c3b);
    $parcel$export(module.exports, "fetchViewContextPerf", ()=>$9e43cd7de2afe373$export$b4e2588a18d8d980);
    $parcel$export(module.exports, "fetchIssuePropertiesPerf", ()=>$9e43cd7de2afe373$export$2ee73dd298bdfe8a);
    const $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
    const $9e43cd7de2afe373$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
    const $9e43cd7de2afe373$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
    const $9e43cd7de2afe373$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
    const $9e43cd7de2afe373$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
    const $9e43cd7de2afe373$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
    const $9e43cd7de2afe373$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
    const $9e43cd7de2afe373$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
    const $9e43cd7de2afe373$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
    const $9e43cd7de2afe373$export$b97d963a8496fa2f = {
        key: $9e43cd7de2afe373$var$FETCH_FIELD_DATA_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$179836a99669cbe7 = {
        key: $9e43cd7de2afe373$var$FETCH_INITIAL_COMMENTS_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$8d0984a0f9f31117 = {
        key: $9e43cd7de2afe373$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$c1324bd586e9a53a = {
        key: $9e43cd7de2afe373$var$FETCH_SUBTASK_TYPES_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$72fcc6cb1cdc70e0 = {
        key: $9e43cd7de2afe373$var$FETCH_UPLOAD_CONTEXT_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$4052b1eae3373c3b = {
        key: $9e43cd7de2afe373$var$FETCH_USER_AUTH_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$b4e2588a18d8d980 = {
        key: $9e43cd7de2afe373$var$FETCH_VIEW_CONTEXT_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
    const $9e43cd7de2afe373$export$2ee73dd298bdfe8a = {
        key: $9e43cd7de2afe373$var$FETCH_ISSUE_PROPERTIES_REQUEST,
        prefix: $9e43cd7de2afe373$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
});
parcelRegister("EKr1h", function(module, exports) {
    $parcel$export(module.exports, "issueViewLoad", ()=>$4f120a802ce83bc9$export$49371c2cc4aaa4f6);
    $parcel$export(module.exports, "issueViewOnPageLoad", ()=>$4f120a802ce83bc9$export$2f6837d06b669285);
    $parcel$export(module.exports, "embeddedIssueViewLoad", ()=>$4f120a802ce83bc9$export$9d773f01a8da623e);
    $parcel$export(module.exports, "epicDropdownOpenInteraction", ()=>$4f120a802ce83bc9$export$8d33579ffe76aa5b);
    $parcel$export(module.exports, "epicModalOpenInteraction", ()=>$4f120a802ce83bc9$export$8f0deabe791d5bb9);
    var $dGrdR;
    const $4f120a802ce83bc9$export$49371c2cc4aaa4f6 = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: 'issue-view-load',
        virtual: true,
        timings: [
            {
                key: 'legacy-tti-2021',
                startMark: 'metrics_init',
                endMark: $f0ab548eaf57140f$export$b292c195104c50d3
            },
            {
                key: 'timeBlockedOnBackend',
                startMark: $f0ab548eaf57140f$export$e64e32643802b552,
                endMark: $f0ab548eaf57140f$export$e52cc35f872875f7
            }
        ]
    });
    const $4f120a802ce83bc9$export$2f6837d06b669285 = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: 'issue-view-on-page-load',
        timings: [
            {
                key: 'issue-mounted',
                endMark: $f0ab548eaf57140f$export$3a9e4a905dec520d
            },
            {
                key: 'latest-lcp',
                endMark: $f0ab548eaf57140f$export$4d1080224e02ef0b
            }
        ]
    });
    const $4f120a802ce83bc9$export$9d773f01a8da623e = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: 'embedded-issue-view-load',
        until: $4f120a802ce83bc9$export$49371c2cc4aaa4f6,
        include: [
            $4f120a802ce83bc9$export$49371c2cc4aaa4f6
        ]
    });
    const $4f120a802ce83bc9$export$1e32b6c8e1e31a3d = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'service-management.queues.issue'
    });
    const $4f120a802ce83bc9$export$4be279014c4d8d39 = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'service-management.reports.issue'
    });
    const $4f120a802ce83bc9$export$8d33579ffe76aa5b = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-epic-dropdown-menu-open'
    });
    const $4f120a802ce83bc9$export$8f0deabe791d5bb9 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-epic-modal-open'
    });
});
parcelRegister("5x8df", function(module, exports) {
    $parcel$export(module.exports, "isSwitcherooRealtimeExposuresTestFlagEnabled", ()=>$2d2a43f633413bc6$export$a73c9c09ec24e5e9);
    $parcel$export(module.exports, "isJsmTimelineEnabled", ()=>$2d2a43f633413bc6$export$575e1bf822db15b5);
    $parcel$export(module.exports, "isBM3EmitOnRafTopExperiencesEnabled", ()=>$2d2a43f633413bc6$export$ee410f0ba32dc900);
    $parcel$export(module.exports, "isIssueViewWhiteboardsStandaloneEnabled", ()=>$2d2a43f633413bc6$export$6f64fb042a8db7d9);
    var $joX8T;
    var $6s1PB;
    var $co1wz;
    const $2d2a43f633413bc6$export$7f7b600c4eafe68f = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue_view_quick_actions_revamp_l8mbx');
    const $2d2a43f633413bc6$export$2fe22bada87c2b25 = ()=>(0, (0, parcelRequire("co1wz")).ff)('pin_field_exp_launch_darkly_flag_ef4mc');
    const $2d2a43f633413bc6$export$c8aa8a13c42858dd = ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-issue-history-data-classification_mhyjw', false);
    const $2d2a43f633413bc6$export$91d9e9331bcb489f = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration');
    const $2d2a43f633413bc6$export$bb7bcfe9ba7992e5 = ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-intelligent-issue-breakdown_18syl', false);
    const $2d2a43f633413bc6$export$4166161ebaa7c45b = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);
    const $2d2a43f633413bc6$export$c3e066f7be7868e8 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');
    const $2d2a43f633413bc6$export$cdd5c612352d7bf0 = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('invite.from.assign', (0, (0, parcelRequire("joX8T")).NOT_ENROLLED), [
            (0, (0, parcelRequire("joX8T")).CONTROL),
            (0, (0, parcelRequire("joX8T")).NOT_ENROLLED),
            (0, (0, parcelRequire("joX8T")).VARIATION)
        ]) === (0, (0, parcelRequire("joX8T")).VARIATION);
    const $2d2a43f633413bc6$export$5b9220081498abd7 = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
            'control',
            'not-enrolled',
            'variation'
        ]);
    const $2d2a43f633413bc6$export$89f18660d3a3bb78 = ()=>(0, (0, parcelRequire("co1wz")).ff)('invite.from.assign.modal.fe.event', false);
    const $2d2a43f633413bc6$export$dcc4742bc52ec465 = ()=>(0, (0, parcelRequire("co1wz")).ff)('comment-limit-exceed-warning-flag_3rx53', false);
    const $2d2a43f633413bc6$export$fa2b2d3091ee4acb = ()=>(0, (0, parcelRequire("co1wz")).ff)('worklog-limit-exceed-warning-flag_hh86h', false);
    const $2d2a43f633413bc6$export$d0ed2d8440fb5bbc = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.hard-limits.milestone-1');
    const $2d2a43f633413bc6$export$41470180bace44ba = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.hard-limits.issue-remote-link');
    const $2d2a43f633413bc6$export$9a5cf06e051f6deb = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.hard-limits.issue-attachments-limit');
    const $2d2a43f633413bc6$export$e3bcb7ed6340e909 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.hard-limits.issue-weblinks-limit');
    const $2d2a43f633413bc6$export$67305b99ef59566c = ()=>(0, (0, parcelRequire("co1wz")).ff)('project.config.pce.modern.global-issue-create.trigger', false);
    const $2d2a43f633413bc6$export$dbaf42ba39b66293 = ()=>$2d2a43f633413bc6$export$67305b99ef59566c();
    const $2d2a43f633413bc6$export$a73c9c09ec24e5e9 = ()=>(0, (0, parcelRequire("co1wz")).ff)('switcheroo-realtime-exposures-test-flag_648u4', false);
    const $2d2a43f633413bc6$export$6df7a6ecffbd200 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-soft-refresh-ld');
    const $2d2a43f633413bc6$export$6c3661f793bf9d1 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-priority_ri9vi');
    const $2d2a43f633413bc6$export$7000df6bbe3f5099 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-reporter_jfzs2');
    const $2d2a43f633413bc6$export$5b6e3c64e3051457 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-parent_5p1ac');
    const $2d2a43f633413bc6$export$12afaf05e3ffffed = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.fix-issue-status-transition-loading_6s8n8', false);
    const $2d2a43f633413bc6$export$47d240e96e9bc1b3 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.fix-incorrect-state-closed-sprint-field_mpzbh', false);
    const $2d2a43f633413bc6$export$369fa0ed6b2504fb = ()=>(0, (0, parcelRequire("co1wz")).ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
    const $2d2a43f633413bc6$export$a792a3f88a852f06 = ()=>(0, (0, parcelRequire("co1wz")).ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
    const $2d2a43f633413bc6$export$575e1bf822db15b5 = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-timelines-phase-2_70gja', false);
    const $2d2a43f633413bc6$export$6f0be57bd65ee8bc = ()=>(0, (0, parcelRequire("co1wz")).ff)('responders-field-in-all-projects-issues-ui', false);
    const $2d2a43f633413bc6$export$317ab03e75769d4f = ()=>(0, (0, parcelRequire("co1wz")).ff)('ken-545-display-hide-when-empty-button-to-user-_fjpw9');
    const $2d2a43f633413bc6$export$c108c03095e0e655 = ()=>(0, (0, parcelRequire("co1wz")).ff)('enable-archived-issues-page-link', false);
    const $2d2a43f633413bc6$export$ee410f0ba32dc900 = ()=>(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences', false);
    const $2d2a43f633413bc6$export$98dcb5ffd7beaf00 = ()=>(0, (0, parcelRequire("co1wz")).ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
    const $2d2a43f633413bc6$export$33008660eb5353ef = ()=>(0, (0, parcelRequire("co1wz")).ff)('compass-components-in-jira-components_xw42u', false);
    const $2d2a43f633413bc6$export$176e4d6701700463 = ()=>(0, (0, parcelRequire("co1wz")).ff)('hide-icc-for-all-users_avyh5', false);
    const $2d2a43f633413bc6$export$c567845e4f18ee11 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.issue-link-limit-exceed-warning-flag');
    const $2d2a43f633413bc6$export$2b839c758c080224 = ()=>(0, (0, parcelRequire("co1wz")).ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
    const $2d2a43f633413bc6$export$882e8ff421f7744c = ()=>(0, (0, parcelRequire("co1wz")).ff)('devops_app_recommendation_on_link_paste', false) && (0, (0, parcelRequire("6s1PB")).expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
    const $2d2a43f633413bc6$export$d4fe7150f9d83fa = ()=>(0, (0, parcelRequire("co1wz")).ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9', false);
    const $2d2a43f633413bc6$export$f6bbc5e1c7a75195 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue-jiv-14530-comments-consistency-check_x716d', false);
    const $2d2a43f633413bc6$export$bc3ae4e1219a64e = ()=>(0, (0, parcelRequire("co1wz")).ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s');
    const $2d2a43f633413bc6$export$5a53bba8e442c4f9 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue.details.gira-agg-migration-attachments_ecebe', false);
    const $2d2a43f633413bc6$export$6f64fb042a8db7d9 = ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-issue-view-whiteboards-standalone', false);
    const $2d2a43f633413bc6$export$667dd70f296d7a79 = ()=>(0, (0, parcelRequire("co1wz")).ff)('platform_embed-conf_jira-issue_create_cross-join', false);
    const $2d2a43f633413bc6$export$590b056868f89976 = ()=>(0, (0, parcelRequire("co1wz")).ff)('im-tokens-and-styled-components-migration_qpsld', false);
    const $2d2a43f633413bc6$export$f67982569b9aab31 = ()=>(0, (0, parcelRequire("co1wz")).ff)('issue-unarchival_wdpb9', false);
    const $2d2a43f633413bc6$export$9e983b29015333eb = ()=>(0, (0, parcelRequire("co1wz")).ff)('jiv-17158-agg-use-iseditableinview_8nogh', false);
    const $2d2a43f633413bc6$export$8fa51a766c2ece72 = ()=>(0, (0, parcelRequire("co1wz")).ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
    const $2d2a43f633413bc6$export$1262b52679049b5e = ()=>(0, (0, parcelRequire("co1wz")).ff)('jiv-18175-usemutation-for-remaining-estimate-field_ar10h', false);
    const $2d2a43f633413bc6$export$4399c72174f6c25d = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.xflow.issue-view-nudge-experiment', false);
    const $2d2a43f633413bc6$export$6ff28b2229a27899 = ()=>(0, (0, parcelRequire("co1wz")).ff)('third_party_app_nudge_on_issues_watch', false) && (0, (0, parcelRequire("6s1PB")).expValEquals)('third_party_app_nudge_on_issues_watch', 'cohort', 'variation');
    const $2d2a43f633413bc6$export$aff6e532ec3ced01 = ()=>(0, (0, parcelRequire("co1wz")).ff)('linked_mentioned_pages_handle_restricted_page_on_click', false);
    const $2d2a43f633413bc6$export$c3c0abcc7a24c315 = ()=>(0, (0, parcelRequire("co1wz")).ff)('polaris.jpd-panel-in-issue-view', false);
    const $2d2a43f633413bc6$export$44436302a680c0e0 = ()=>(0, (0, parcelRequire("co1wz")).ff)('jira.issue-view.create-confluence-page.template-browser', false);
    const $2d2a43f633413bc6$export$ebdc109f22d5762d = ()=>(0, (0, parcelRequire("co1wz")).ff)('fix-for-jracloud-84181_dm5fg', false);
    const $2d2a43f633413bc6$export$3336aec97cc6ad82 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-sprint_jozpu');
    const $2d2a43f633413bc6$export$1ebd956541101430 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-metadata_d42b0');
    const $2d2a43f633413bc6$export$f523e13f8d29cd4d = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-assignee-ld', false);
    const $2d2a43f633413bc6$export$d51d9f0f8bb8e5d5 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-number_q0em4', false);
    const $2d2a43f633413bc6$export$b15e700f73951a90 = ()=>(0, (0, parcelRequire("co1wz")).ff)('compiled-react-migration-issue-view_zilee', false);
    const $2d2a43f633413bc6$export$3215b3331a7b187a = ()=>(0, (0, parcelRequire("co1wz")).ff)('compiled-react-migration-issue-view_u9myz', false);
    const $2d2a43f633413bc6$export$a465afdb16c2fb1e = ()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9', false);
    const $2d2a43f633413bc6$export$39e338620e4f1561 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-single-line-text_in6w6', false);
    const $2d2a43f633413bc6$export$fb62da0fafc1b47b = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-date_ptj72', false);
    const $2d2a43f633413bc6$export$b41fe6134b9dd04b = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-project-select_w0xem', false);
    const $2d2a43f633413bc6$export$d705591f59096b16 = ()=>(0, (0, parcelRequire("co1wz")).ff)('add-team-id-analytics-data');
    const $2d2a43f633413bc6$export$386ddedc27abb46a = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-date-time_eaqd2', false);
    const $2d2a43f633413bc6$export$8fac1563227555f2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);
    const $2d2a43f633413bc6$export$b4501966f3d67615 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-url_ob8uu', false);
    const $2d2a43f633413bc6$export$404ba26ddf44eb5c = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv', false);
    const $2d2a43f633413bc6$export$51e354a6287b4e6f = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v', false);
    const $2d2a43f633413bc6$export$60d59ed70ac781ae = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-single-line-text-message', false);
    const $2d2a43f633413bc6$export$95907a52a35b3961 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-user');
    const $2d2a43f633413bc6$export$b6e9d0a9667c0f05 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-approvers', false);
    const $2d2a43f633413bc6$export$4d3db41296db446d = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false);
    const $2d2a43f633413bc6$export$1f73bbaf5f11f42e = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n', false);
    const $2d2a43f633413bc6$export$6cc75390b4e231dc = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-people', false);
    const $2d2a43f633413bc6$export$bb9056b4adf9c3e2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-color_wrbay', false);
    const $2d2a43f633413bc6$export$8503e8a8212316b2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-components-select_prpz1', false);
    const $2d2a43f633413bc6$export$8edffc79742276c2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-original-estimate_eb4wv', false);
    const $2d2a43f633413bc6$export$855117875c5f0f07 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-team-field-next_nctbt', false);
    const $2d2a43f633413bc6$export$6d146d32e1568e7d = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user', false);
    const $2d2a43f633413bc6$export$cc7a044e1c23b678 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants', false);
    const $2d2a43f633413bc6$export$158817712c605fd5 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm', false);
    const $2d2a43f633413bc6$export$99f9e0265c10ef5c = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt', false);
    const $2d2a43f633413bc6$export$1861acdee7d5d7dd = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd', false);
    const $2d2a43f633413bc6$export$91ba7c1b79a06cd5 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-restrictions_yudid', false);
    const $2d2a43f633413bc6$export$fdfb9c8eeb7e7911 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4', false);
    const $2d2a43f633413bc6$export$2136270e216e4b7a = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya', false);
    const $2d2a43f633413bc6$export$415ccba21fc64c06 = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-group-picker', false);
    const $2d2a43f633413bc6$export$d455c142260381bc = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-group-picker', false);
    const $2d2a43f633413bc6$export$ab8923270560686a = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c', false);
    const $2d2a43f633413bc6$export$f0011255c99e780d = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-radio_6gqb3', false);
    const $2d2a43f633413bc6$export$f6eddd9f0d4f005a = ()=>(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo', false);
});
parcelRegister("joX8T", function(module, exports) {
    $parcel$export(module.exports, "COHORT", ()=>$a85d1363752adaec$export$3d370c33621572df);
    $parcel$export(module.exports, "NOT_ENROLLED", ()=>$a85d1363752adaec$export$5b7423264d48ab04);
    $parcel$export(module.exports, "CONTROL", ()=>$a85d1363752adaec$export$43f367b3e957f219);
    $parcel$export(module.exports, "VARIATION", ()=>$a85d1363752adaec$export$fa04ad826acc90da);
    var $co1wz;
    const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
    const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
    const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
    const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
    const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
    const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
    const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
    const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
    const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
    const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
        $a85d1363752adaec$export$5b7423264d48ab04,
        $a85d1363752adaec$export$43f367b3e957f219,
        $a85d1363752adaec$export$9ba2bc3b1bdc1519,
        $a85d1363752adaec$export$fa04ad826acc90da,
        $a85d1363752adaec$export$6486974e39493fa6,
        $a85d1363752adaec$export$7d994996134ad562,
        $a85d1363752adaec$export$795e7d69b248dcd0,
        $a85d1363752adaec$export$c9c947c57470b787
    ];
    var $a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);
});
parcelRegister("72N4j", function(module, exports) {
    $parcel$export(module.exports, "serverTimingSelector", ()=>$2bce567eae8a73a3$export$a0b21c7e17057a47);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $bcoYn;
    const $2bce567eae8a73a3$export$8ef68fa2b28a6d0f = (state)=>state.timing;
    const $2bce567eae8a73a3$export$a0b21c7e17057a47 = (0, $dGvGJ.createSelector)($2bce567eae8a73a3$export$8ef68fa2b28a6d0f, (0, (0, parcelRequire("bcoYn")).isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);
});
parcelRegister("bcoYn", function(module, exports) {
    $parcel$export(module.exports, "entitiesSelector", ()=>$468fb8d2be99a4f5$export$ccebe5cc5854d0fa);
    $parcel$export(module.exports, "projectSelector", ()=>$468fb8d2be99a4f5$export$852a6c34ff1a2e77);
    $parcel$export(module.exports, "uiSelector", ()=>$468fb8d2be99a4f5$export$185c0864c82372e3);
    $parcel$export(module.exports, "entitiesIssueSelector", ()=>$468fb8d2be99a4f5$export$fa3ac1f794979805);
    $parcel$export(module.exports, "entitiesRefreshedOnSelector", ()=>$468fb8d2be99a4f5$export$c4ebdc93969b82cc);
    $parcel$export(module.exports, "flagsSelector", ()=>$468fb8d2be99a4f5$export$40cfdc5e96db7759);
    $parcel$export(module.exports, "projectIdSelector", ()=>$468fb8d2be99a4f5$export$4c9d6034f65d22f4);
    $parcel$export(module.exports, "projectIdsSelector", ()=>$468fb8d2be99a4f5$export$9edb3f63d1bd8546);
    $parcel$export(module.exports, "projectKeySelector", ()=>$468fb8d2be99a4f5$export$404de5ac601b84bc);
    $parcel$export(module.exports, "projectTypeSelector", ()=>$468fb8d2be99a4f5$export$69316f88206ca90b);
    $parcel$export(module.exports, "isSimplifiedProjectSelector", ()=>$468fb8d2be99a4f5$export$d94d544d4b2e1310);
    $parcel$export(module.exports, "loggedInUserDetailsSelector", ()=>$468fb8d2be99a4f5$export$b5a68452fc64275d);
    $parcel$export(module.exports, "loggedInUserAvatarUrlSelector", ()=>$468fb8d2be99a4f5$export$e0efa9c12379be7a);
    $parcel$export(module.exports, "loggedInUserDisplayNameSelector", ()=>$468fb8d2be99a4f5$export$4f56a07246719eb0);
    $parcel$export(module.exports, "parentIssueEntitySelector", ()=>$468fb8d2be99a4f5$export$e10c57d263d23c49);
    $parcel$export(module.exports, "loggedInUserTimeZoneSelector", ()=>$468fb8d2be99a4f5$export$ac6f9fd801c94fff);
    $parcel$export(module.exports, "idSelector", ()=>$468fb8d2be99a4f5$export$66c501bed2fcd648);
    $parcel$export(module.exports, "isClassicProjectSelector", ()=>$468fb8d2be99a4f5$export$45347d9f8a67561b);
    $parcel$export(module.exports, "isLoadingSelector", ()=>$468fb8d2be99a4f5$export$c077f23183070903);
    $parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", ()=>$468fb8d2be99a4f5$export$2ca9575c7da6bf18);
    $parcel$export(module.exports, "isPreviewSelector", ()=>$468fb8d2be99a4f5$export$b33a1a8958a8d805);
    $parcel$export(module.exports, "isCompletedLoadingSelector", ()=>$468fb8d2be99a4f5$export$9b99fb9e23fc133);
    $parcel$export(module.exports, "loadingStageSelector", ()=>$468fb8d2be99a4f5$export$18bc980d36bf93d);
    $parcel$export(module.exports, "isDeleteIssueModalOpenSelector", ()=>$468fb8d2be99a4f5$export$7cfd3e0dd7059b87);
    $parcel$export(module.exports, "isDeletingIssueSelector", ()=>$468fb8d2be99a4f5$export$d414d8eddcb409e4);
    $parcel$export(module.exports, "didIssueDeleteFailSelector", ()=>$468fb8d2be99a4f5$export$834732624d2c73e1);
    $parcel$export(module.exports, "errorSelector", ()=>$468fb8d2be99a4f5$export$47aec13333381be0);
    $parcel$export(module.exports, "errorMessageSelector", ()=>$468fb8d2be99a4f5$export$9b1097e17c0e6dc2);
    $parcel$export(module.exports, "getUserByIdSelector", ()=>$468fb8d2be99a4f5$export$801a2f2bd4059665);
    $parcel$export(module.exports, "parentLevelIssuesSelector", ()=>$468fb8d2be99a4f5$export$aa8980c49aba4478);
    $parcel$export(module.exports, "baseAriSelector", ()=>$468fb8d2be99a4f5$export$fa12ae06e35ebd67);
    $parcel$export(module.exports, "issueAriSelector", ()=>$468fb8d2be99a4f5$export$a2cdbba2136e72d3);
    $parcel$export(module.exports, "epicLinkFieldKeySelector", ()=>$468fb8d2be99a4f5$export$27abc48b8d528300);
    $parcel$export(module.exports, "isEpicSelector", ()=>$468fb8d2be99a4f5$export$6e8ebe94ad8bb62b);
    $parcel$export(module.exports, "isServiceDeskSelector", ()=>$468fb8d2be99a4f5$export$43d733e4b7e8c7d0);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $2vSU6;
    var $fOGZN;
    var $g5X3G;
    var $a1ky2;
    var $7Ow8a;
    const $468fb8d2be99a4f5$export$ccebe5cc5854d0fa = (state)=>state.entities;
    const $468fb8d2be99a4f5$export$852a6c34ff1a2e77 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
    const $468fb8d2be99a4f5$export$185c0864c82372e3 = (state)=>state.ui;
    const $468fb8d2be99a4f5$export$27493ac3d8611290 = (state)=>state.agile;
    const $468fb8d2be99a4f5$export$fa3ac1f794979805 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
    const $468fb8d2be99a4f5$export$c4ebdc93969b82cc = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
    const $468fb8d2be99a4f5$export$40cfdc5e96db7759 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.flags);
    const $468fb8d2be99a4f5$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
    const $468fb8d2be99a4f5$export$9edb3f63d1bd8546 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
            project.projectId
        ] : []);
    const $468fb8d2be99a4f5$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
    const $468fb8d2be99a4f5$export$69316f88206ca90b = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
    const $468fb8d2be99a4f5$export$d94d544d4b2e1310 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
    const $468fb8d2be99a4f5$export$b5a68452fc64275d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, (0, parcelRequire("a1ky2")).accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
    const $468fb8d2be99a4f5$export$e0efa9c12379be7a = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, (0, parcelRequire("a1ky2")).accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
        const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
        return loggedInUser ? loggedInUser.avatarUrl : null;
    });
    const $468fb8d2be99a4f5$export$4f56a07246719eb0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (0, (0, parcelRequire("a1ky2")).accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
        const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
        return loggedInUser ? loggedInUser.displayName : null;
    });
    const $468fb8d2be99a4f5$export$e10c57d263d23c49 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
    const $468fb8d2be99a4f5$export$ac6f9fd801c94fff = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
    const $468fb8d2be99a4f5$export$66c501bed2fcd648 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$fa3ac1f794979805, (issue)=>issue && (0, (0, parcelRequire("g5X3G")).toIssueId)(issue.id));
    const $468fb8d2be99a4f5$export$45347d9f8a67561b = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
    const $468fb8d2be99a4f5$export$c077f23183070903 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$26d55645375ca9a));
    const $468fb8d2be99a4f5$export$2ca9575c7da6bf18 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
    const $468fb8d2be99a4f5$export$b33a1a8958a8d805 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$1b56cc494043d9bf));
    const $468fb8d2be99a4f5$export$9b99fb9e23fc133 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $fdfab07e3d100124$export$1660a2d7c2fff354));
    const $468fb8d2be99a4f5$export$18bc980d36bf93d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.loadingStage);
    const $468fb8d2be99a4f5$export$7cfd3e0dd7059b87 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
    const $468fb8d2be99a4f5$export$d414d8eddcb409e4 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
    const $468fb8d2be99a4f5$export$834732624d2c73e1 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
    const $468fb8d2be99a4f5$export$47aec13333381be0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.error);
    const $468fb8d2be99a4f5$export$9b1097e17c0e6dc2 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$185c0864c82372e3, (ui)=>ui.errorMessage);
    const $468fb8d2be99a4f5$export$801a2f2bd4059665 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
    const $468fb8d2be99a4f5$export$aa8980c49aba4478 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
    const $468fb8d2be99a4f5$export$a60a6c96db10acc4 = ()=>'jira';
    const $468fb8d2be99a4f5$export$57c6957997fb7f1d = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$69316f88206ca90b, (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId));
    const $468fb8d2be99a4f5$export$fa12ae06e35ebd67 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$a60a6c96db10acc4, (0, (0, parcelRequire("a1ky2")).cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
    const $468fb8d2be99a4f5$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$fa12ae06e35ebd67, $468fb8d2be99a4f5$export$66c501bed2fcd648, (baseAri, issueId)=>{
        if (!baseAri || !issueId) return null;
        return `${baseAri}:issue/${issueId}`;
    });
    const $468fb8d2be99a4f5$export$27abc48b8d528300 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
    const $468fb8d2be99a4f5$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, (0, parcelRequire("fOGZN")).EPIC_ISSUES));
    const $468fb8d2be99a4f5$export$6e8ebe94ad8bb62b = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("7Ow8a")).fieldsSelector), (fields)=>$468fb8d2be99a4f5$export$d062a59cf4fc9cec(fields));
    const $468fb8d2be99a4f5$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($468fb8d2be99a4f5$export$69316f88206ca90b, (projectType)=>projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT));
});
const $fdfab07e3d100124$export$26d55645375ca9a = 'LOADING';
const $fdfab07e3d100124$export$1b56cc494043d9bf = 'PREVIEW';
const $fdfab07e3d100124$export$1660a2d7c2fff354 = 'COMPLETE';
parcelRegister("fOGZN", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$1df76d38eb6e3f90$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_SUMMARY", ()=>$1df76d38eb6e3f90$export$a464614f8f5fe986);
    $parcel$export(module.exports, "SUBTASK_PARENT", ()=>$1df76d38eb6e3f90$export$a311a3c9b207604e);
    $parcel$export(module.exports, "WATCHES", ()=>$1df76d38eb6e3f90$export$289917d9a7031e1d);
    $parcel$export(module.exports, "VOTES", ()=>$1df76d38eb6e3f90$export$81614f6dc3be5b00);
    $parcel$export(module.exports, "SECURITY", ()=>$1df76d38eb6e3f90$export$72a5630aa398d6b4);
    $parcel$export(module.exports, "ISSUE_RESTRICTION", ()=>$1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
    $parcel$export(module.exports, "ASSIGNEE", ()=>$1df76d38eb6e3f90$export$f8f7545d2bb78afb);
    $parcel$export(module.exports, "REPORTER", ()=>$1df76d38eb6e3f90$export$6d7021166edc895c);
    $parcel$export(module.exports, "DUE_DATE", ()=>$1df76d38eb6e3f90$export$cf7e173386d30cdd);
    $parcel$export(module.exports, "PRIORITY", ()=>$1df76d38eb6e3f90$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "LABELS", ()=>$1df76d38eb6e3f90$export$79b91d4669dcadcb);
    $parcel$export(module.exports, "EPIC", ()=>$1df76d38eb6e3f90$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "FIX_VERSIONS", ()=>$1df76d38eb6e3f90$export$d7e18f5730074533);
    $parcel$export(module.exports, "AFFECTS_VERSIONS", ()=>$1df76d38eb6e3f90$export$c435f0000304e508);
    $parcel$export(module.exports, "TIME_TRACKING", ()=>$1df76d38eb6e3f90$export$ee99ef6ee562a446);
    $parcel$export(module.exports, "TIME_ESTIMATE", ()=>$1df76d38eb6e3f90$export$a6a74b4bc927d39f);
    $parcel$export(module.exports, "STATUS", ()=>$1df76d38eb6e3f90$export$e50006273435e7d4);
    $parcel$export(module.exports, "CREATED", ()=>$1df76d38eb6e3f90$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "SUMMARY", ()=>$1df76d38eb6e3f90$export$913055729e1380b2);
    $parcel$export(module.exports, "DESCRIPTION", ()=>$1df76d38eb6e3f90$export$d44826c816b5619b);
    $parcel$export(module.exports, "COMMENT", ()=>$1df76d38eb6e3f90$export$a29989082612d0d9);
    $parcel$export(module.exports, "EPIC_ISSUES", ()=>$1df76d38eb6e3f90$export$8fe3d5be8cb17459);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$1df76d38eb6e3f90$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "ENVIRONMENT", ()=>$1df76d38eb6e3f90$export$be46596bc6608f3b);
    $parcel$export(module.exports, "SUBTASKS", ()=>$1df76d38eb6e3f90$export$f528fadbfdb3c25e);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$1df76d38eb6e3f90$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "PARENT", ()=>$1df76d38eb6e3f90$export$e0dfb65d1047c53c);
    $parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", ()=>$1df76d38eb6e3f90$export$aba22e09a66f6826);
    $parcel$export(module.exports, "FLAG_ACTIONS", ()=>$1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
    $parcel$export(module.exports, "CARD_COVER_ACTIONS", ()=>$1df76d38eb6e3f90$export$c161a774ec2e7e56);
    $parcel$export(module.exports, "specialFields", ()=>$1df76d38eb6e3f90$export$89e5c40c0f5c7561);
    $parcel$export(module.exports, "ecosystemCustomFields", ()=>$1df76d38eb6e3f90$export$87934b3672715c91);
    $parcel$export(module.exports, "customFieldsToDisplay", ()=>$1df76d38eb6e3f90$export$efd443bccc4c01ed);
    $parcel$export(module.exports, "itemDocumentationUrls", ()=>$1df76d38eb6e3f90$export$a18b3a656ee9c709);
    $parcel$export(module.exports, "emptyConfiguration", ()=>$1df76d38eb6e3f90$export$a52507e68e7aeeb);
    $parcel$export(module.exports, "softwareConfiguration", ()=>$1df76d38eb6e3f90$export$27e0678365e5dcff);
    $parcel$export(module.exports, "simpleSoftwareBoardConfiguration", ()=>$1df76d38eb6e3f90$export$aebf676dfa727a1c);
    $parcel$export(module.exports, "standardRoadmapConfiguration", ()=>$1df76d38eb6e3f90$export$1afca4d3eb6b218b);
    $parcel$export(module.exports, "bitbucketConfiguration", ()=>$1df76d38eb6e3f90$export$8a060ed6f66c43b0);
    $parcel$export(module.exports, "mobileConfiguration", ()=>$1df76d38eb6e3f90$export$78a2cb921e46f5eb);
    $parcel$export(module.exports, "serviceDeskConfiguration", ()=>$1df76d38eb6e3f90$export$db1115186532f6d5);
    $parcel$export(module.exports, "connectConfiguration", ()=>$1df76d38eb6e3f90$export$557d5094ec5cf234);
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$1df76d38eb6e3f90$export$902f6c5cc939598a);
    var $65mz3;
    var $2vSU6;
    var $5fc53;
    const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
    const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
    const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
    const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
    const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent';
    const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
    const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
    const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
    const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
    const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
    const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
    const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
    const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
    const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
    const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
    const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
    const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
    const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
    const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
    const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
    const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
    const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
    const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
    const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
    const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
    const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
    const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
    const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
    const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
    const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
    const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
    const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
    const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
    const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
    const $1df76d38eb6e3f90$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
    const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
    const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
    const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
    const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
    const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
    const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
    const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues';
    const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
    const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
    const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
    const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
    const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE);
    const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
    const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
        const fields = {
            [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
            [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
            [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
            [(0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE)]: (0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE),
            [(0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE)]: (0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE)
        };
        return fields;
    };
    const $1df76d38eb6e3f90$export$87934b3672715c91 = [
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
    ];
    const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
        (0, (0, parcelRequire("5fc53")).REQUEST_PARTICIPANTS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).APPROVALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).APPROVERS_LIST_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MAJOR_INCIDENT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ORGANIZATION_CF_TYPE)
    ];
    const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
            (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PARTICIPANTS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).READ_ONLY_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).EPIC_STATUS_TYPE),
            (0, (0, parcelRequire("5fc53")).MESSAGE_VIEW_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
            (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
            ...$1df76d38eb6e3f90$export$87934b3672715c91,
            ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
        ];
    const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
    };
    const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SOFTWARE_ISSUE,
            issueActions: [
                $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
                $1df76d38eb6e3f90$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).MOBILE_ISSUE,
            issueActions: []
        });
    const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CONNECT_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
                return $1df76d38eb6e3f90$export$27e0678365e5dcff();
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $1df76d38eb6e3f90$export$381ce08838c53afa();
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $1df76d38eb6e3f90$export$db1115186532f6d5();
            default:
                return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        }
        return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    };
});
parcelRegister("65mz3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7178ba5d31d0f054$export$2e2bcd8739ae039);
    const $7178ba5d31d0f054$var$keys = {
        CONNECT_ISSUE: 'connect-issue',
        BITBUCKET_ISSUE: 'bitbucket-issue',
        CORE_ISSUE: 'core-issue',
        MOBILE_ISSUE: 'mobile-issue',
        SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
        SOFTWARE_ISSUE: 'software-issue',
        STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
        SERVICE_DESK: 'service-desk',
        EMPTY_APPLICATION_KEY: ''
    };
    var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;
});
parcelRegister("5fc53", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_LINK_SEARCH", ()=>$81f079589240b9b7$export$b144116dae474c88);
    $parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$bc917bc699b25f75);
    $parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", ()=>$81f079589240b9b7$export$5f26ca419fdffbe7);
    $parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$ce9bfd823c7e1a6d);
    $parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$346b72b1f7cd6d5a);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$b20fbcacd7942c2a);
    $parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", ()=>$81f079589240b9b7$export$a2e8554bffc61ece);
    $parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$f25cd4907cbb25b9);
    $parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5600354b43577e17);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$5dbc9917f72d0d2a);
    $parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$253649f07fb55948);
    $parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", ()=>$81f079589240b9b7$export$eb39592ba5247ee7);
    $parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", ()=>$81f079589240b9b7$export$f48a9be226105736);
    $parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$42e2e93fc721df5d);
    $parcel$export(module.exports, "APPROVALS_PANEL_TYPE", ()=>$81f079589240b9b7$export$7773375e72c953ed);
    $parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", ()=>$81f079589240b9b7$export$80ad0037098f3919);
    $parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", ()=>$81f079589240b9b7$export$6875c7efa3a5e380);
    $parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", ()=>$81f079589240b9b7$export$7c1a5c7d37b8f968);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$c5931a5d7dbfb40b);
    $parcel$export(module.exports, "BOOLEAN_GQL_FIELD", ()=>$81f079589240b9b7$export$c979d9c548c05133);
    $parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ff25e7412c4ae9c7);
    $parcel$export(module.exports, "CHECKBOX_GQL_FIELD", ()=>$81f079589240b9b7$export$16dbdf57e34e8d63);
    $parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$1bf8bec92e6e84df);
    $parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$c32f5d822fe5ea95);
    $parcel$export(module.exports, "CMDB_GQL_FIELD", ()=>$81f079589240b9b7$export$b0deb225eed90fbd);
    $parcel$export(module.exports, "COLOR_GQL_FIELD", ()=>$81f079589240b9b7$export$add3775cfea8fde3);
    $parcel$export(module.exports, "COMPONENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9631d4098abab3eb);
    $parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$ee42bc16c09ee564);
    $parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$fbcebbdce821f712);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$41dd2eb1f33d3042);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$f4e3e72a3be84e5b);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$d6738c8a6d1a735d);
    $parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$79a75502a3f0c4c4);
    $parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$ed2eabcf0931df31);
    $parcel$export(module.exports, "DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$1f17904e959f2f0b);
    $parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", ()=>$81f079589240b9b7$export$6d8da4497234455);
    $parcel$export(module.exports, "FLAG_GQL_FIELD", ()=>$81f079589240b9b7$export$9bcfac568e4fa59c);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", ()=>$81f079589240b9b7$export$dd84cd6c957c6f5e);
    $parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5cc7c39d7d1cf6d5);
    $parcel$export(module.exports, "LABEL_GQL_FIELD", ()=>$81f079589240b9b7$export$810709f0c5c2e9db);
    $parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$82cb6735134c23a2);
    $parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$85e04e9a3a81ee1);
    $parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$24c916a8a33ed20c);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$c049920d930c3b8a);
    $parcel$export(module.exports, "NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$3b6d7fc1833bf7da);
    $parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", ()=>$81f079589240b9b7$export$bd3e2fe853319c13);
    $parcel$export(module.exports, "PARENT_GQL_FIELD", ()=>$81f079589240b9b7$export$6dfd3fc78bc751a0);
    $parcel$export(module.exports, "PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$31aea7548807c6b5);
    $parcel$export(module.exports, "PRIORITY_GQL_FIELD", ()=>$81f079589240b9b7$export$e89fbbf3983c0219);
    $parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", ()=>$81f079589240b9b7$export$f5e2fb1022ff7912);
    $parcel$export(module.exports, "PROJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$12f54499c6252188);
    $parcel$export(module.exports, "RADIO_GQL_FIELD", ()=>$81f079589240b9b7$export$8e4293d806f435e0);
    $parcel$export(module.exports, "REPORTER_GQL_FIELD", ()=>$81f079589240b9b7$export$c69486dd643dfb69);
    $parcel$export(module.exports, "RESOLUTION_GQL_FIELD", ()=>$81f079589240b9b7$export$1e4faa0d6dc58a81);
    $parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$37f4daaa7b409554);
    $parcel$export(module.exports, "SECURITY_GQL_FIELD", ()=>$81f079589240b9b7$export$ca57cccd6d7bf97c);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$bea889616fd5bdab);
    $parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ab5cecc580898d1c);
    $parcel$export(module.exports, "SPRINT_GQL_FIELD", ()=>$81f079589240b9b7$export$bb63813d13e8eaf7);
    $parcel$export(module.exports, "STATUS_GQL_FIELD", ()=>$81f079589240b9b7$export$e40f819979b3881d);
    $parcel$export(module.exports, "TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$6c243704a22baffe);
    $parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", ()=>$81f079589240b9b7$export$6c32429bac235203);
    $parcel$export(module.exports, "TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$61b514b470cbbf07);
    $parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", ()=>$81f079589240b9b7$export$e4bcb1729da5683);
    $parcel$export(module.exports, "URL_GQL_FIELD", ()=>$81f079589240b9b7$export$37ccd11f08a93ccb);
    $parcel$export(module.exports, "USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$abf1bf8c1106ba7d);
    $parcel$export(module.exports, "VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$b55604041ae7179e);
    $parcel$export(module.exports, "VOTES_GQL_FIELD", ()=>$81f079589240b9b7$export$c8bf66d62e74cdd2);
    $parcel$export(module.exports, "WATCHES_GQL_FIELD", ()=>$81f079589240b9b7$export$aa815aaa741ae18);
    $parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", ()=>$81f079589240b9b7$export$e805f89b15d2abf4);
    $parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$5bfd36acd96f04c2);
    $parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", ()=>$81f079589240b9b7$export$695423a2bc8a9ac4);
    $parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", ()=>$81f079589240b9b7$export$d29b0ba0d80bc129);
    $parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", ()=>$81f079589240b9b7$export$ac6c7b30703608d6);
    $parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$478b546dccd33e1e);
    $parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", ()=>$81f079589240b9b7$export$f90c042e9eb983e7);
    $parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", ()=>$81f079589240b9b7$export$753ca4fb34ff3f2b);
    $parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$b7aed9efb4a9154b);
    $parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", ()=>$81f079589240b9b7$export$1763713d718f7ef0);
    $parcel$export(module.exports, "FORGE_USER_GQL_FIELD", ()=>$81f079589240b9b7$export$ebb0caa2a98dcf9e);
    $parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", ()=>$81f079589240b9b7$export$671131ba12d94144);
    $parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", ()=>$81f079589240b9b7$export$c48132adab502d6b);
    $parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", ()=>$81f079589240b9b7$export$6cd83226f31c7072);
    $parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$7de726bd6d97a9a7);
    $parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$8e4b538f77340a05);
    $parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", ()=>$81f079589240b9b7$export$10ba8c0d74470907);
    $parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", ()=>$81f079589240b9b7$export$1756bb4eff1cc3c6);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5876b4be3c4407b);
    $parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", ()=>$81f079589240b9b7$export$e7fe49e6f36c7154);
    $parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", ()=>$81f079589240b9b7$export$aeed3395a6bca18b);
    $parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9b725a1eafd02e4f);
    $parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", ()=>$81f079589240b9b7$export$699805cbca2c41d);
    $parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", ()=>$81f079589240b9b7$export$f658d5c0f0b5dbc2);
    $parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", ()=>$81f079589240b9b7$export$e469bcb2060000af);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$81f079589240b9b7$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "GOALS_GQL_FIELD", ()=>$81f079589240b9b7$export$bfcb1a91094f113a);
    $parcel$export(module.exports, "DURATION_GQL_FIELD", ()=>$81f079589240b9b7$export$db0bd6c04eb7d04a);
    $parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", ()=>$81f079589240b9b7$export$798d2f5814884447);
    $parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", ()=>$81f079589240b9b7$export$269d70c1b1c9fb80);
    $parcel$export(module.exports, "APPROVALS_CF_TYPE", ()=>$81f079589240b9b7$export$f0f17ef462331df4);
    $parcel$export(module.exports, "CATEGORY_TYPE", ()=>$81f079589240b9b7$export$3c7d8923295a5199);
    $parcel$export(module.exports, "PEOPLE_CF_TYPE", ()=>$81f079589240b9b7$export$fb431e758c9252df);
    $parcel$export(module.exports, "NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$c7faa96db185cfc6);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", ()=>$81f079589240b9b7$export$492b0fa4fe201a22);
    $parcel$export(module.exports, "URL_CF_TYPE", ()=>$81f079589240b9b7$export$60f0bd6e4b582fe6);
    $parcel$export(module.exports, "TEXT_CF_TYPE", ()=>$81f079589240b9b7$export$68c7e01d5460d298);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$81f079589240b9b7$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", ()=>$81f079589240b9b7$export$977db5973ce73e44);
    $parcel$export(module.exports, "LABELS_CF_TYPE", ()=>$81f079589240b9b7$export$ad4eb83f78528e13);
    $parcel$export(module.exports, "DATE_CF_TYPE", ()=>$81f079589240b9b7$export$ff745f432984005d);
    $parcel$export(module.exports, "DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$42d097f7b1622ef1);
    $parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", ()=>$81f079589240b9b7$export$65524be5675e57e6);
    $parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", ()=>$81f079589240b9b7$export$5280e5501a801dc0);
    $parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c5d13ea26562d57a);
    $parcel$export(module.exports, "SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$22ac48a51c014e4b);
    $parcel$export(module.exports, "EPIC_STATUS_TYPE", ()=>$81f079589240b9b7$export$6769c2c97b828e11);
    $parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$39866626496bbfc8);
    $parcel$export(module.exports, "VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$24382b4e8c58336b);
    $parcel$export(module.exports, "GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b075907882e80160);
    $parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b600addfa3355c57);
    $parcel$export(module.exports, "USER_CF_TYPE", ()=>$81f079589240b9b7$export$c491a4b98394028e);
    $parcel$export(module.exports, "MULTI_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5365f2d3fac5261a);
    $parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$cc8ffff49170b0f4);
    $parcel$export(module.exports, "FLAGGED_CF_TYPE", ()=>$81f079589240b9b7$export$b7178f601d7373f9);
    $parcel$export(module.exports, "TEAM_CF_TYPE", ()=>$81f079589240b9b7$export$eb1f1dca13a0f02d);
    $parcel$export(module.exports, "PARENT_CF_TYPE", ()=>$81f079589240b9b7$export$3e71e11f80203acb);
    $parcel$export(module.exports, "BASELINE_START_CF_TYPE", ()=>$81f079589240b9b7$export$d10d66823a65e688);
    $parcel$export(module.exports, "BASELINE_END_CF_TYPE", ()=>$81f079589240b9b7$export$dfc6da4a9963d5dc);
    $parcel$export(module.exports, "COLOR_CF_TYPE", ()=>$81f079589240b9b7$export$b4a1fbc1cf0059cf);
    $parcel$export(module.exports, "EPIC_COLOR_TYPE", ()=>$81f079589240b9b7$export$4838a8a8d62a64fd);
    $parcel$export(module.exports, "ASSETS_CF_TYPE", ()=>$81f079589240b9b7$export$ed2de20ab8b7ad3d);
    $parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", ()=>$81f079589240b9b7$export$b755e97dbfa92610);
    $parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$1be1ecd4dfc06fab);
    $parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", ()=>$81f079589240b9b7$export$34317c2d84a93553);
    $parcel$export(module.exports, "ORGANIZATION_CF_TYPE", ()=>$81f079589240b9b7$export$c1e26582406f77ec);
    $parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", ()=>$81f079589240b9b7$export$555b4f35f98a3210);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", ()=>$81f079589240b9b7$export$1f2859a3ef701a14);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$68f62eb762e4157f);
    $parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", ()=>$81f079589240b9b7$export$6da975fce1fbd38e);
    $parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", ()=>$81f079589240b9b7$export$c6dd874aae21e51f);
    $parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c3c9f8a8a8dc0b30);
    $parcel$export(module.exports, "RANK_CF_TYPE", ()=>$81f079589240b9b7$export$af89c0396aaf23e3);
    $parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$3b5a62bb34372404);
    $parcel$export(module.exports, "READ_ONLY_CF_TYPE", ()=>$81f079589240b9b7$export$247829aef464243f);
    $parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", ()=>$81f079589240b9b7$export$65a6076c0927d413);
    $parcel$export(module.exports, "RESPONDERS_CF_TYPE", ()=>$81f079589240b9b7$export$bcf83e1d934501c9);
    $parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", ()=>$81f079589240b9b7$export$ae0eeec12e90a01e);
    $parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23f6b40da18371a);
    $parcel$export(module.exports, "SENTIMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23cfbdf83daa90d);
    $parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", ()=>$81f079589240b9b7$export$21dda64db57e4883);
    $parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", ()=>$81f079589240b9b7$export$45700f3bf92a003a);
    $parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", ()=>$81f079589240b9b7$export$2d75b47d12efc812);
    $parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", ()=>$81f079589240b9b7$export$7b79405842547ccb);
    $parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", ()=>$81f079589240b9b7$export$96201d0ae03ca323);
    $parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$fc276d6ccf118a14);
    $parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", ()=>$81f079589240b9b7$export$8b0718167d092603);
    $parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", ()=>$81f079589240b9b7$export$904b40dd2afd17a2);
    $parcel$export(module.exports, "GOALS_CF_TYPE", ()=>$81f079589240b9b7$export$2bbb7f69c97ea279);
    $parcel$export(module.exports, "ASSIGNEE_TYPE", ()=>$81f079589240b9b7$export$fba8634fd401ba8b);
    $parcel$export(module.exports, "REPORTER_TYPE", ()=>$81f079589240b9b7$export$a91aea2438afcce8);
    $parcel$export(module.exports, "DUE_DATE_TYPE", ()=>$81f079589240b9b7$export$b159f8b8f27aae4c);
    $parcel$export(module.exports, "PRIORITY_TYPE", ()=>$81f079589240b9b7$export$34740f8d07d23ac0);
    $parcel$export(module.exports, "LABELS_TYPE", ()=>$81f079589240b9b7$export$43b6e33ec70f2272);
    $parcel$export(module.exports, "CREATED", ()=>$81f079589240b9b7$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$81f079589240b9b7$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "RESOLUTION_DATE", ()=>$81f079589240b9b7$export$6a052efb0b4ec5d2);
    $parcel$export(module.exports, "COMPONENTS_TYPE", ()=>$81f079589240b9b7$export$37abf56f13f61ec5);
    $parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", ()=>$81f079589240b9b7$export$aef0c22aecd16996);
    $parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", ()=>$81f079589240b9b7$export$cff5b6d1e7135679);
    $parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", ()=>$81f079589240b9b7$export$791007408faf42f4);
    $parcel$export(module.exports, "DEV_SUMMARY_TYPE", ()=>$81f079589240b9b7$export$827a1c600bac12a3);
    $parcel$export(module.exports, "RELEASES_TYPE", ()=>$81f079589240b9b7$export$e9ba671d077969f8);
    $parcel$export(module.exports, "SPRINT_TYPE", ()=>$81f079589240b9b7$export$3d37701ba6fb68ec);
    $parcel$export(module.exports, "STORY_POINTS_TYPE", ()=>$81f079589240b9b7$export$36fd22f47020f37b);
    $parcel$export(module.exports, "EPIC_TYPE", ()=>$81f079589240b9b7$export$9f2fedcd916d2a79);
    $parcel$export(module.exports, "EPIC_NAME_TYPE", ()=>$81f079589240b9b7$export$dfc63737b8c0150d);
    $parcel$export(module.exports, "FIX_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$a5c9f63aadcb220);
    $parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$94009605902e4fe5);
    $parcel$export(module.exports, "DESCRIPTION_TYPE", ()=>$81f079589240b9b7$export$5e7324042f1d6b31);
    $parcel$export(module.exports, "ENVIRONMENT_TYPE", ()=>$81f079589240b9b7$export$113281d03e6830ef);
    $parcel$export(module.exports, "WATCHES_TYPE", ()=>$81f079589240b9b7$export$5ff798870a3dffbf);
    $parcel$export(module.exports, "SUMMARY_TYPE", ()=>$81f079589240b9b7$export$907219511d14ba3d);
    $parcel$export(module.exports, "PROFORMA_FORMS", ()=>$81f079589240b9b7$export$d09aa6a4f3538063);
    $parcel$export(module.exports, "RESOLUTION_TYPE", ()=>$81f079589240b9b7$export$3aca8c91b58a42e2);
    $parcel$export(module.exports, "TIME_TRACKING_TYPE", ()=>$81f079589240b9b7$export$ccb5ffefbf8b987c);
    $parcel$export(module.exports, "TIME_ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$c8bedad98a5e7f5f);
    $parcel$export(module.exports, "STATUS_TYPE", ()=>$81f079589240b9b7$export$358267065be1e);
    $parcel$export(module.exports, "STATUS_CATEGORY_TYPE", ()=>$81f079589240b9b7$export$dcaa788c7ada56de);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$81f079589240b9b7$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_KEY_TYPE", ()=>$81f079589240b9b7$export$5e91047fe9955d0e);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$81f079589240b9b7$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$335851d83a79891);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$7b76bbcb87d41695);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$297b67ac63f09f72);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$ae87161126086be);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$6a88420fc2f6901d);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$ef1a0421bd42c0e4);
    $parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$dd695c8c5ab62f9d);
    $parcel$export(module.exports, "SLA_PANEL_TYPE", ()=>$81f079589240b9b7$export$7b3d247435a784fa);
    $parcel$export(module.exports, "LINKED_ALERTS_TYPE", ()=>$81f079589240b9b7$export$17b7080ed1fe8cfd);
    $parcel$export(module.exports, "CHAT_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$29fe745131dad7ba);
    $parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$9c245100c3091ec3);
    $parcel$export(module.exports, "ZOOM_MEETING_TYPE", ()=>$81f079589240b9b7$export$51eb15cea47a37ba);
    $parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", ()=>$81f079589240b9b7$export$c7ae0622b0bd5d56);
    $parcel$export(module.exports, "CONFERENCE_CALL_TYPE", ()=>$81f079589240b9b7$export$f7dcde9e9e88aff2);
    $parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", ()=>$81f079589240b9b7$export$b5358afda8ff335e);
    $parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", ()=>$81f079589240b9b7$export$63cf6f392da16c25);
    $parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", ()=>$81f079589240b9b7$export$22f61ccc2730431f);
    $parcel$export(module.exports, "SUBTASKS_TYPE", ()=>$81f079589240b9b7$export$8bbb446f57294715);
    $parcel$export(module.exports, "VOTES_TYPE", ()=>$81f079589240b9b7$export$34fcd7cb291a1e4d);
    $parcel$export(module.exports, "PARENT_TYPE", ()=>$81f079589240b9b7$export$5e93f2a57cc4ca3a);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$81f079589240b9b7$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "TIME_SPENT_TYPE", ()=>$81f079589240b9b7$export$ede0a4c20124ec85);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", ()=>$81f079589240b9b7$export$3eeb79d48fb5f667);
    $parcel$export(module.exports, "SENTIMENT_TYPE", ()=>$81f079589240b9b7$export$45e72c9a63ab61ab);
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$81f079589240b9b7$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$81f079589240b9b7$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", ()=>$81f079589240b9b7$export$84e5674890d55030);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE", ()=>$81f079589240b9b7$export$326a5522a485e43d);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", ()=>$81f079589240b9b7$export$c9f3f01e2c535302);
    $parcel$export(module.exports, "TEAM_TYPE", ()=>$81f079589240b9b7$export$66519f3bbff1796a);
    $parcel$export(module.exports, "ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$a4ee0bca77cc8463);
    $parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", ()=>$81f079589240b9b7$export$fed53408e89e0497);
    $parcel$export(module.exports, "TARGET_START_TYPE", ()=>$81f079589240b9b7$export$d53c26f9ce31f56b);
    $parcel$export(module.exports, "TARGET_END_TYPE", ()=>$81f079589240b9b7$export$48f82d653f85e459);
    $parcel$export(module.exports, "START_DATE_TYPE", ()=>$81f079589240b9b7$export$ea5a888f39f722c7);
    $parcel$export(module.exports, "COLOR_TYPE", ()=>$81f079589240b9b7$export$f245bbec12cc0e40);
    $parcel$export(module.exports, "ATTACHMENT_TYPE", ()=>$81f079589240b9b7$export$aed630b4b7114a59);
    $parcel$export(module.exports, "ISSUE_LINKS_TYPE", ()=>$81f079589240b9b7$export$b50c1a8fef07104);
    $parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", ()=>$81f079589240b9b7$export$ea3d72f4bb7738ba);
    $parcel$export(module.exports, "COMMENT_TYPE", ()=>$81f079589240b9b7$export$a4cab0124760d860);
    $parcel$export(module.exports, "WORK_LOG_TYPE", ()=>$81f079589240b9b7$export$734929aef118d7e2);
    $parcel$export(module.exports, "PARENT_FIELD_TYPE", ()=>$81f079589240b9b7$export$ffbacacb07c1d46d);
    $parcel$export(module.exports, "getLayoutFieldTypes", ()=>$81f079589240b9b7$export$3c3e26aadbfa2c32);
    var $8QpSo;
    var $4R6GH;
    const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
    const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
    const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
    const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
    const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
    const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
    const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option';
    const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
    const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
    const $81f079589240b9b7$export$5600354b43577e17 = 'user';
    const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
    const $81f079589240b9b7$export$253649f07fb55948 = 'object';
    const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
    const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
    const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
    const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues';
    const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
    const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
    const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
    const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
    const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
    const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
    const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
    const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
    const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
    const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
    const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
    const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
    const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
    const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
    const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
    const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
    const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
    const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
    const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
    const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
    const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
    const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
    const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
    const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
    const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
    const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
    const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
    const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
    const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
    const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
    const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
    const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
    const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
    const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
    const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
    const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
    const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
    const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
    const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
    const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
    const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
    const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
    const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
    const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
    const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
    const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
    const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
    const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
    const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
    const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
    const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
    const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
    const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
    const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
    const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
    const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
    const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
    const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
    const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
    const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
    const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
    const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
    const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
    const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
    const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
    const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
    const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
    const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
    const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
    const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
    const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
    const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
    const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
    const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
    const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
    const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
    const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
    const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
    const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
    const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
    const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
    const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
    const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
    const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
    const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
    const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
    const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
    const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
    const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
    const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
    const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
    const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
    const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
    const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
    const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
    const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
    const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
    const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
    const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
    const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
    const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
    const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
    const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
    const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
    const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
    const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
    const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
    const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
    const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
    const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
    const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
    const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
    const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
    const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
    const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
    const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
    const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
    const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
    const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
    const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
    const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
    const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
    const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
    const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
    const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
    const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
    const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
    const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
    const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
    const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
    const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
    const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
    const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
    const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
    const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
    const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
    const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
    const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
    const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
    const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
    const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
    const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
    const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
    const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
    const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
    const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
    const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
    const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
    const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
    const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
    const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
    const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
    const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
    const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
    const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
    const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
    const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
    const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
    const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
    const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
    const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
    const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
    const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
    const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
    const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
    const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
    const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
    const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
    const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
    const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
    const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
    const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
    const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
    const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
    const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
    const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
    const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
    const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
    const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
    const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
    const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
    const $81f079589240b9b7$export$358267065be1e = 'status';
    const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
    const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
    const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
    const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
    const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
    const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
    const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
    const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
    const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
    const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
    const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
    const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
    const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
    const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
    const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
    const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
    const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
    const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
    const $81f079589240b9b7$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
    const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
    const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
    const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
    const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
    const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
    const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
    const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue';
    const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
    const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
    const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
    const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
    const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
    const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
    const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
    const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
    const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
    const $81f079589240b9b7$export$326a5522a485e43d = 'security';
    const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
    const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
    const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
    const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
    const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
    const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
    const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
    const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
    const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
    const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
    const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
    const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
    const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
    const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
    const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
    const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
    const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
    const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
    const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
    const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
    const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
    const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
        const types = {
            ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
            DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
            PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
            REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
            DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
            LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
            COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
            SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
            STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
            TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
            FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
            AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
            TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
            TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
            ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
            DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
            APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
            KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
            SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
            LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
            CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
            MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
            ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
            MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
            CONFERENCE_CALL_TYPE: $81f079589240b9b7$export$f7dcde9e9e88aff2,
            ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
            RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
            MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
            COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
            EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
            RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
            BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
            BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
            LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
            TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
            MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
            PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
            URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
            NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
            STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
            SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
            EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
            MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
            ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
            FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
            ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
            ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
            ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
            FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
            TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
            MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
            VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
            DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
            GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
            MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
            USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
            DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
            MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
            RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
            TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
            ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
            ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
            ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
            ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
            ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
            REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
            SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
            REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
            ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
            REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
            PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
            REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
            ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
            APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
            CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
            PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
            CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
            READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
            MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
            MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
            EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
            ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
            CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
            ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
            GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
            PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a
        };
        Object.assign(types, {
            FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm-sentiment-analysis')) Object.assign(types, {
            SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
        });
        Object.assign(types, {
            SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('remove_epic_link_and_parent_link_from_issue_view')) {
            Object.assign(types, {
                EPIC_TYPE: $81f079589240b9b7$export$9f2fedcd916d2a79
            });
            Object.assign(types, {
                PARENT_CF_TYPE: $81f079589240b9b7$export$3e71e11f80203acb
            });
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap')) Object.assign(types, {
            ORGANIZATION_CF_TYPE: $81f079589240b9b7$export$c1e26582406f77ec
        });
        return types;
    };
    const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, (0, parcelRequire("8QpSo")).default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);
});
parcelRegister("a1ky2", function(module, exports) {
    $parcel$export(module.exports, "contextSelector", ()=>$df15ab6efcbffe76$export$c420c9f40402ab6d);
    $parcel$export(module.exports, "accountIdloggedInUserSelector", ()=>$df15ab6efcbffe76$export$cb29341089829e17);
    $parcel$export(module.exports, "orgIdSelector", ()=>$df15ab6efcbffe76$export$24984a39db14d8);
    $parcel$export(module.exports, "baseUrlSelector", ()=>$df15ab6efcbffe76$export$1ca9a92a5f28e233);
    $parcel$export(module.exports, "loginRedirectUrlSelector", ()=>$df15ab6efcbffe76$export$767583fcce1653ec);
    $parcel$export(module.exports, "issueKeySelector", ()=>$df15ab6efcbffe76$export$d22bc6271070f453);
    $parcel$export(module.exports, "issueIdSelector", ()=>$df15ab6efcbffe76$export$31efbca30077ec1e);
    $parcel$export(module.exports, "projectKeySelector", ()=>$df15ab6efcbffe76$export$404de5ac601b84bc);
    $parcel$export(module.exports, "analyticsSourceSelector", ()=>$df15ab6efcbffe76$export$85a9d212d56669b4);
    $parcel$export(module.exports, "cloudIdSelector", ()=>$df15ab6efcbffe76$export$b5a643cfff945455);
    $parcel$export(module.exports, "activationIdSelector", ()=>$df15ab6efcbffe76$export$2335b963a9875096);
    $parcel$export(module.exports, "isAnonymousSelector", ()=>$df15ab6efcbffe76$export$a165ec261432d0b8);
    $parcel$export(module.exports, "localeSelector", ()=>$df15ab6efcbffe76$export$f7b7935883444b11);
    $parcel$export(module.exports, "issueActionsSelector", ()=>$df15ab6efcbffe76$export$b62cb5286b153905);
    $parcel$export(module.exports, "applicationKeySelector", ()=>$df15ab6efcbffe76$export$6c7d07328f197de7);
    $parcel$export(module.exports, "isMobileSelector", ()=>$df15ab6efcbffe76$export$4cbb8c74e98876a5);
    $parcel$export(module.exports, "isBitbucketSelector", ()=>$df15ab6efcbffe76$export$245e5ba54167b84a);
    $parcel$export(module.exports, "isServiceDeskSelector", ()=>$df15ab6efcbffe76$export$43d733e4b7e8c7d0);
    $parcel$export(module.exports, "isEcosystemEnabledSelector", ()=>$df15ab6efcbffe76$export$9bffc1987c753bd9);
    $parcel$export(module.exports, "rapidViewIdSelector", ()=>$df15ab6efcbffe76$export$718e830000b27a0e);
    $parcel$export(module.exports, "boardTypeSelector", ()=>$df15ab6efcbffe76$export$5af08fd769c0f0);
    $parcel$export(module.exports, "boardIdSelector", ()=>$df15ab6efcbffe76$export$955e7dbf76b61f80);
    $parcel$export(module.exports, "siteAdminStatusSelector", ()=>$df15ab6efcbffe76$export$93badd2a066af8bd);
    $parcel$export(module.exports, "appPermissionsSelector", ()=>$df15ab6efcbffe76$export$5b71e1eb43056b6c);
    $parcel$export(module.exports, "isModalSelector", ()=>$df15ab6efcbffe76$export$5fa593caa6a15917);
    $parcel$export(module.exports, "shouldRenderHeaderSelector", ()=>$df15ab6efcbffe76$export$631793d49dec78de);
    $parcel$export(module.exports, "viewModeSelector", ()=>$df15ab6efcbffe76$export$1f11fe78e4f22d45);
    $parcel$export(module.exports, "appEditionsSelector", ()=>$df15ab6efcbffe76$export$28ca74e18c8f4529);
    $parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", ()=>$df15ab6efcbffe76$export$96c87532aec3474a);
    $parcel$export(module.exports, "hasShownIntentToXflowToConfluenceTraitSelector", ()=>$df15ab6efcbffe76$export$ab1f876d8f682229);
    $parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", ()=>$df15ab6efcbffe76$export$2b8e6729c89e24f5);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $70Rr2;
    var $lb7qa;
    var $eZDAP;
    var $it1wb;
    var $pyK8a;
    var $4Pf62;
    var $k3PbQ;
    var $fOGZN;
    var $g5X3G;
    var $ef5Xn;
    const $df15ab6efcbffe76$export$c420c9f40402ab6d = (state)=>state.context;
    const $df15ab6efcbffe76$export$cb29341089829e17 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
    const $df15ab6efcbffe76$export$24984a39db14d8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
    const $df15ab6efcbffe76$export$1ca9a92a5f28e233 = (_)=>'';
    const $df15ab6efcbffe76$export$767583fcce1653ec = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
    const $df15ab6efcbffe76$export$d22bc6271070f453 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>(0, (0, parcelRequire("g5X3G")).toIssueKey)(context.issueKey));
    const $df15ab6efcbffe76$export$31efbca30077ec1e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueId);
    const $df15ab6efcbffe76$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$d22bc6271070f453, (issueKey)=>(0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey));
    const $df15ab6efcbffe76$export$85a9d212d56669b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
    const $df15ab6efcbffe76$export$b5a643cfff945455 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, (0, parcelRequire("g5X3G")).toCloudId)(''));
    const $df15ab6efcbffe76$export$2335b963a9875096 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.activationId || (0, (0, parcelRequire("g5X3G")).toActivationId)(''));
    const $df15ab6efcbffe76$export$a165ec261432d0b8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
    const $df15ab6efcbffe76$export$f7b7935883444b11 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.locale);
    const $df15ab6efcbffe76$export$b62cb5286b153905 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
    const $df15ab6efcbffe76$export$6c7d07328f197de7 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.applicationKey);
    const $df15ab6efcbffe76$export$4cbb8c74e98876a5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$ce88447986394f2d));
    const $df15ab6efcbffe76$export$6fbe1dbaf5b67cc5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, (0, parcelRequire("fOGZN")).simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, (0, parcelRequire("fOGZN")).standardRoadmapConfiguration)().applicationKey);
    const $df15ab6efcbffe76$export$7479ef2453efd3b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, (0, parcelRequire("fOGZN")).softwareConfiguration)().applicationKey);
    const $df15ab6efcbffe76$export$245e5ba54167b84a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$7552fe2669628499));
    const $df15ab6efcbffe76$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, (0, parcelRequire("fOGZN")).serviceDeskConfiguration)().applicationKey);
    const $df15ab6efcbffe76$export$9bffc1987c753bd9 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
    const $df15ab6efcbffe76$export$718e830000b27a0e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
    const $df15ab6efcbffe76$export$8065de5fbcf23af5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
    const $df15ab6efcbffe76$export$5af08fd769c0f0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardType);
    const $df15ab6efcbffe76$export$955e7dbf76b61f80 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardId);
    const $df15ab6efcbffe76$export$93badd2a066af8bd = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
    const $df15ab6efcbffe76$export$b468116a08f9183e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
    const $df15ab6efcbffe76$export$f29192b357e6beca = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
    const $df15ab6efcbffe76$export$5b71e1eb43056b6c = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appPermissions);
    const $df15ab6efcbffe76$export$5fa593caa6a15917 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isModal);
    const $df15ab6efcbffe76$export$631793d49dec78de = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$5fa593caa6a15917, $df15ab6efcbffe76$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
    const $df15ab6efcbffe76$export$1f11fe78e4f22d45 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.viewMode);
    const $df15ab6efcbffe76$export$28ca74e18c8f4529 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appEditions);
    const $df15ab6efcbffe76$export$beea798086c18f0a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licenseStates);
    const $df15ab6efcbffe76$export$40487a15195e570e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE));
    const $df15ab6efcbffe76$export$96c87532aec3474a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
    const $df15ab6efcbffe76$export$ab1f876d8f682229 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.hasShownIntentToXflowToConfluence);
    const $df15ab6efcbffe76$export$747a61878b414bda = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
    const $df15ab6efcbffe76$export$2b8e6729c89e24f5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
        try {
            if (!confluenceActivationDate) return false;
            const today = (0, (0, parcelRequire("70Rr2")).default)(new Date());
            const fourteenDaysAgo = (0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("pyK8a")).default)(today, 14));
            const dateToCheck = (0, (0, parcelRequire("eZDAP")).default)(confluenceActivationDate);
            return (0, (0, parcelRequire("lb7qa")).default)(dateToCheck, {
                start: fourteenDaysAgo,
                end: today
            });
        } catch (error) {
            return false;
        }
    });
});
parcelRegister("7Ow8a", function(module, exports) {
    $parcel$export(module.exports, "fieldsSelector", ()=>$04968168b83fddb5$export$e1512647ca813bfa);
    $parcel$export(module.exports, "getFieldHandlingSpecialFields", ()=>$04968168b83fddb5$export$46dde968006cd8d4);
    $parcel$export(module.exports, "fieldByCustomTypeSelector", ()=>$04968168b83fddb5$export$72dfc619a02c972c);
    $parcel$export(module.exports, "customFieldIdSelector", ()=>$04968168b83fddb5$export$8ad8506b941e30dc);
    $parcel$export(module.exports, "fieldSelector", ()=>$04968168b83fddb5$export$4ee5e7baedf94214);
    $parcel$export(module.exports, "issueTypeIdSelector", ()=>$04968168b83fddb5$export$22410768c09b3a82);
    $parcel$export(module.exports, "hasSubtasksSelector", ()=>$04968168b83fddb5$export$f363078714850fd9);
    $parcel$export(module.exports, "hasSubtasksValuesSelector", ()=>$04968168b83fddb5$export$689f8f96c9d81e1b);
    $parcel$export(module.exports, "hasPortfolioChildIssuesSelector", ()=>$04968168b83fddb5$export$724b8972771ff092);
    $parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", ()=>$04968168b83fddb5$export$c6d2d4f8e243ac37);
    $parcel$export(module.exports, "hasChildrenIssuesSelector", ()=>$04968168b83fddb5$export$29f34d4d7c528e9c);
    $parcel$export(module.exports, "hasChildrenIssueValuesSelector", ()=>$04968168b83fddb5$export$9034aaa32d45814b);
    $parcel$export(module.exports, "childIssuesLimitUrlSelector", ()=>$04968168b83fddb5$export$762e13908aaafb2d);
    $parcel$export(module.exports, "availableFieldIdsSelector", ()=>$04968168b83fddb5$export$641248fa887fb9ea);
    $parcel$export(module.exports, "fieldSchemaConfigurationSelector", ()=>$04968168b83fddb5$export$3c65874760e68948);
    $parcel$export(module.exports, "isFieldEditableSelector", ()=>$04968168b83fddb5$export$76ece3d8c4244af2);
    $parcel$export(module.exports, "fieldNameSelector", ()=>$04968168b83fddb5$export$2d1abc174b8a710e);
    $parcel$export(module.exports, "fieldMetaKeySelector", ()=>$04968168b83fddb5$export$351970d5fcbd0b29);
    $parcel$export(module.exports, "fieldARISelector", ()=>$04968168b83fddb5$export$f6363cecfaa3a9b0);
    $parcel$export(module.exports, "fieldAutoCompleteUrlSelector", ()=>$04968168b83fddb5$export$d27105f13ab27906);
    $parcel$export(module.exports, "fieldAllowedValuesSelector", ()=>$04968168b83fddb5$export$351dc1c32c2771ea);
    $parcel$export(module.exports, "isFieldRequiredSelector", ()=>$04968168b83fddb5$export$4c5f76e28914074);
    $parcel$export(module.exports, "fieldTypeSelector", ()=>$04968168b83fddb5$export$9e2f15437ff59992);
    $parcel$export(module.exports, "fieldPersistedValueSelector", ()=>$04968168b83fddb5$export$ae4660b0b7ebeee9);
    $parcel$export(module.exports, "fieldPendingValueSelector", ()=>$04968168b83fddb5$export$2ae929653dce6648);
    $parcel$export(module.exports, "fieldEditingValueSelector", ()=>$04968168b83fddb5$export$487becf51bedcd03);
    $parcel$export(module.exports, "fieldEditingAdfValueSelector", ()=>$04968168b83fddb5$export$31406f841bca5b75);
    $parcel$export(module.exports, "fieldHtmlValueSelector", ()=>$04968168b83fddb5$export$e69c8171ecd8fde2);
    $parcel$export(module.exports, "isFieldEditingSelector", ()=>$04968168b83fddb5$export$29e6b1cade110749);
    $parcel$export(module.exports, "fieldEditSessionIdSelector", ()=>$04968168b83fddb5$export$c53ab145ef243c95);
    $parcel$export(module.exports, "isFieldWaitingSelector", ()=>$04968168b83fddb5$export$30e972ebce44d9b8);
    $parcel$export(module.exports, "fieldInvalidMessageSelector", ()=>$04968168b83fddb5$export$d323462f155519c3);
    $parcel$export(module.exports, "fieldInvalidSelector", ()=>$04968168b83fddb5$export$e35f4d21d9739426);
    $parcel$export(module.exports, "isRichTextFieldSelector", ()=>$04968168b83fddb5$export$120a4249e9b3c231);
    $parcel$export(module.exports, "richTextFieldIdsSelector", ()=>$04968168b83fddb5$export$862745d3ab4003e5);
    $parcel$export(module.exports, "isRichTextFieldEditingSelector", ()=>$04968168b83fddb5$export$df9b7004d8b93e46);
    $parcel$export(module.exports, "isMultilineFieldSelector", ()=>$04968168b83fddb5$export$4d0b1fe809ae5e75);
    $parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", ()=>$04968168b83fddb5$export$2469330614f0dba9);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $1sWm7 = parcelRequire("1sWm7");
    var $dJl1T;
    var $69oHP;
    var $fOGZN;
    var $5fc53;
    var $a1ky2;
    var $aOGHX;
    var $3Uijm;
    const $04968168b83fddb5$var$STABLE_EMPTY_ARRAY = [];
    const $04968168b83fddb5$var$STABLE_EMPTY_OBJECT = {};
    const $04968168b83fddb5$export$e1512647ca813bfa = (state)=>state.fields || $04968168b83fddb5$var$STABLE_EMPTY_OBJECT;
    const $04968168b83fddb5$var$getFieldByCustomType = (customType, fields)=>(0, ($parcel$interopDefault($1sWm7)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
    const $04968168b83fddb5$export$46dde968006cd8d4 = (fieldId, fields)=>{
        let field = fields[fieldId];
        const customSystemFields = (0, (0, parcelRequire("fOGZN")).specialFields)();
        if (!field && Object.keys(customSystemFields).includes(fieldId)) {
            const customType = customSystemFields[fieldId];
            field = $04968168b83fddb5$var$getFieldByCustomType(customType, fields);
        }
        return field;
    };
    const $04968168b83fddb5$export$cb67eba45dd11f50 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
    const $04968168b83fddb5$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
    const $04968168b83fddb5$export$72dfc619a02c972c = (customType)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$var$getFieldByCustomType(customType, fields));
    const $04968168b83fddb5$export$8ad8506b941e30dc = (customFieldType)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$72dfc619a02c972c(customFieldType), (customField)=>{
            const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
            return idCandidates ? +idCandidates[1] : null;
        });
    const $04968168b83fddb5$export$4ee5e7baedf94214 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldId, fields));
    const $04968168b83fddb5$var$issueTypeFieldSelector = $04968168b83fddb5$export$4ee5e7baedf94214((0, (0, parcelRequire("fOGZN")).ISSUE_TYPE));
    const $04968168b83fddb5$export$22410768c09b3a82 = (0, $dGvGJ.createSelector)($04968168b83fddb5$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.id) ?? null);
    const $04968168b83fddb5$export$b8de62018cc85a18 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldId, fields));
    const $04968168b83fddb5$export$3c65f67962ca81cc = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $e9be48d6d2c01760$export$a5fc282ab2bf9b89)));
    const $04968168b83fddb5$export$f363078714850fd9 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
    const $04968168b83fddb5$export$689f8f96c9d81e1b = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, 'subtasks'));
    const $04968168b83fddb5$export$724b8972771ff092 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, (0, parcelRequire("fOGZN")).PORTFOLIO_CHILD_ISSUES)));
    const $04968168b83fddb5$export$c6d2d4f8e243ac37 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, (0, (0, parcelRequire("fOGZN")).PORTFOLIO_CHILD_ISSUES)));
    const $04968168b83fddb5$export$29f34d4d7c528e9c = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, (0, parcelRequire("fOGZN")).CHILDREN_ISSUES)));
    const $04968168b83fddb5$export$9034aaa32d45814b = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>$04968168b83fddb5$export$309344981947f228(fields, (0, (0, parcelRequire("fOGZN")).CHILDREN_ISSUES)));
    const $04968168b83fddb5$export$762e13908aaafb2d = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>{
        const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
        return getChildIssueUrlSelector;
    });
    const $04968168b83fddb5$export$9ee3b3f5d4ad4423 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$04968168b83fddb5$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
    const $04968168b83fddb5$export$641248fa887fb9ea = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
    const $04968168b83fddb5$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
    const $04968168b83fddb5$export$3c65874760e68948 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && field.schema.configuration.reduce((config, { key: key, value: value })=>({
                    ...config,
                    [key]: value
                }), {}));
    const $04968168b83fddb5$export$76ece3d8c4244af2 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>$04968168b83fddb5$export$e50b5889a6b86caf(field));
    const $04968168b83fddb5$export$2d1abc174b8a710e = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>{
            if (field && field.title) return field.title;
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
            return '';
        });
    const $04968168b83fddb5$export$d20285fb6e3fb007 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
        if (field?.title) return field.title;
        (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
    const $04968168b83fddb5$export$351970d5fcbd0b29 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
    const $04968168b83fddb5$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
    const $04968168b83fddb5$export$d27105f13ab27906 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
    const $04968168b83fddb5$export$351dc1c32c2771ea = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $04968168b83fddb5$var$STABLE_EMPTY_ARRAY);
    const $04968168b83fddb5$export$4c5f76e28914074 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
    const $04968168b83fddb5$export$9e2f15437ff59992 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, (0, parcelRequire("69oHP")).getFieldType)(field));
    const $04968168b83fddb5$export$ae4660b0b7ebeee9 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
    const $04968168b83fddb5$export$bf3f8fd2c145740 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (field)=>field?.value);
    const $04968168b83fddb5$export$2ae929653dce6648 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, (0, parcelRequire("3Uijm")).default)(field));
    const $04968168b83fddb5$export$487becf51bedcd03 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, (0, parcelRequire("aOGHX")).default)(field));
    const $04968168b83fddb5$export$31406f841bca5b75 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, (0, parcelRequire("aOGHX")).getEditingAdfValue)(field));
    const $04968168b83fddb5$export$e69c8171ecd8fde2 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
    const $04968168b83fddb5$export$4e96991314eba25 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$b8de62018cc85a18, (field)=>field?.renderedValue);
    const $04968168b83fddb5$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
    const $04968168b83fddb5$export$29e6b1cade110749 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>$04968168b83fddb5$export$18ec1d851ee244b3(field));
    const $04968168b83fddb5$export$c53ab145ef243c95 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
    const $04968168b83fddb5$export$30e972ebce44d9b8 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
    const $04968168b83fddb5$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
    const $04968168b83fddb5$export$e35f4d21d9739426 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
    const $04968168b83fddb5$export$448aaad27e620666 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
    const $04968168b83fddb5$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE) || fieldType === (0, (0, parcelRequire("fOGZN")).ENVIRONMENT) || fieldType === (0, (0, parcelRequire("fOGZN")).DESCRIPTION);
    const $04968168b83fddb5$export$120a4249e9b3c231 = (fieldId)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isServiceDeskSelector), $04968168b83fddb5$export$9e2f15437ff59992(fieldId), $04968168b83fddb5$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
            const isDescription = fieldId === (0, (0, parcelRequire("fOGZN")).DESCRIPTION);
            const isMultilineRichTextField = $04968168b83fddb5$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $650578330a102f55$export$89b8c5d86c10a68c);
            return isDescription || isMultilineRichTextField;
        });
    const $04968168b83fddb5$export$862745d3ab4003e5 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$04968168b83fddb5$export$120a4249e9b3c231(fieldId)(state)));
    const $04968168b83fddb5$export$df9b7004d8b93e46 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$04968168b83fddb5$export$29e6b1cade110749(fieldId)(state)));
    const $04968168b83fddb5$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $dGvGJ.createSelector)($04968168b83fddb5$export$9e2f15437ff59992(fieldId), (fieldType)=>$04968168b83fddb5$export$94cc87cea4e06b09(fieldType));
    const $04968168b83fddb5$export$3263c202444b0e0 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$04968168b83fddb5$export$4d0b1fe809ae5e75(fieldId)(state)));
    const $04968168b83fddb5$export$2469330614f0dba9 = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$04968168b83fddb5$export$29e6b1cade110749(fieldId)(state)));
    const $04968168b83fddb5$export$a2fc0905011957cb = (0, $dGvGJ.createSelector)($04968168b83fddb5$export$4ee5e7baedf94214((0, (0, parcelRequire("fOGZN")).FIX_VERSIONS)), $04968168b83fddb5$export$4ee5e7baedf94214((0, (0, parcelRequire("fOGZN")).AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
        const ids = [];
        if (fixVersions) ids.push(fixVersions.key);
        if (affectsVersions) ids.push(affectsVersions.key);
        return ids;
    });
});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';
parcelRegister("69oHP", function(module, exports) {
    $parcel$export(module.exports, "getFieldType", ()=>$53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
    $parcel$export(module.exports, "isRichTextSupported", ()=>$53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);
    var $fOGZN;
    var $5fc53;
    const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
        const customSystemFields = (0, (0, parcelRequire("fOGZN")).specialFields)();
        return [
            ...(0, (0, parcelRequire("fOGZN")).customFieldsToDisplay)().filter((cf)=>!(0, (0, parcelRequire("fOGZN")).ecosystemCustomFields).includes(cf)),
            ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
            (0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE)
        ];
    };
    const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
    const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
        const fieldSchema = field ? field.schema : undefined;
        return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
    };
    const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
        const fieldSchema = field ? field.schema : undefined;
        return fieldSchema ? fieldSchema.type === (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE) : false;
    };
});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
parcelRegister("aOGHX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf727673620c8917$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getEditingAdfValue", ()=>$bf727673620c8917$export$a799cf637c5b7727);
    var $3Uijm;
    var $bf727673620c8917$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, (0, parcelRequire("3Uijm")).default)(field);
    const $bf727673620c8917$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, (0, parcelRequire("3Uijm")).getPendingAdfValue)(field);
});
parcelRegister("3Uijm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de9626bc322e3072$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getPendingAdfValue", ()=>$de9626bc322e3072$export$5012210a9f91b010);
    var $de9626bc322e3072$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
    const $de9626bc322e3072$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;
});
parcelRegister("iAWa3", function(module, exports) {
    $parcel$export(module.exports, "afterPaintEmit", ()=>$8ad29d98765af503$export$dc4c3408669b8f4e);
    var $x9xyg;
    const $8ad29d98765af503$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
        const stopTime = performance.now();
        setTimeout(()=>{
            metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
            setTimeout(()=>{
                emitMetrics(stopTime);
            }, 500);
        });
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("ieOir", function(module, exports) {
    $parcel$export(module.exports, "startUimTti", ()=>$d393971e74bda871$export$1422384676f6de7a);
    $parcel$export(module.exports, "markUimTtiIssueViewLoaded", ()=>$d393971e74bda871$export$5a9389b70d93def2);
    $parcel$export(module.exports, "stopTTI", ()=>$d393971e74bda871$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$d393971e74bda871$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$d393971e74bda871$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$d393971e74bda871$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$d393971e74bda871$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $d393971e74bda871$var$uimInIssueViewTTI = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'ui-modifications-in-issue-view',
        timings: [
            {
                key: 'issue-view-tti-delta',
                startMark: 'issue-view-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $d393971e74bda871$export$1422384676f6de7a = ()=>{
        $d393971e74bda871$var$uimInIssueViewTTI.start();
    };
    const $d393971e74bda871$export$5a9389b70d93def2 = ()=>{
        $d393971e74bda871$var$uimInIssueViewTTI.mark('issue-view-tti');
    };
    const $d393971e74bda871$export$30ca4c461fab486c = (customData)=>{
        $d393971e74bda871$var$uimInIssueViewTTI.stop({
            customData: customData
        });
    };
    const $d393971e74bda871$export$27f2445288b528c = ()=>{
        $d393971e74bda871$var$uimInIssueViewTTI.cancel();
    };
    const $d393971e74bda871$export$7a2709fc1e33401a = ()=>{
        $d393971e74bda871$var$uimInIssueViewTTI.mark('iframe-load');
    };
    const $d393971e74bda871$export$cf3893335c93e33b = ()=>{
        $d393971e74bda871$var$uimInIssueViewTTI.mark('fields-registered');
    };
    const $d393971e74bda871$export$d86f4868694f2aa7 = ()=>{
        $d393971e74bda871$var$uimInIssueViewTTI.mark('oninit-resolved');
    };
});
parcelRegister("a1HyB", function(module, exports) {
    $parcel$export(module.exports, "TTIFFs", ()=>$aec371b77b607203$export$c396ba1504d97f3f);
    const $aec371b77b607203$export$c396ba1504d97f3f = [];
});
parcelRegister("Rsnea", function(module, exports) {
    $parcel$export(module.exports, "blockedOnBackendEntryLog", ()=>$09eba838967fcf46$export$dd1b3502b1e8ca97);
    $parcel$export(module.exports, "getBackendBlockingTime", ()=>$09eba838967fcf46$export$8720c1f879c7ca46);
    var $x9xyg;
    var $eR8VP;
    var $5HSWG;
    const $09eba838967fcf46$export$dd1b3502b1e8ca97 = (0, (0, parcelRequire("eR8VP")).createBlockedOnBackendEntryLog)();
    function $09eba838967fcf46$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
        (0, (0, parcelRequire("x9xyg")).setMark)(`${measureName}Start`, {
            startTime: backendBlockingStart
        });
        (0, (0, parcelRequire("x9xyg")).setMark)(`${measureName}End`, {
            startTime: backendBlockingEnd
        });
        (0, (0, parcelRequire("x9xyg")).setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
    }
    const $09eba838967fcf46$export$8720c1f879c7ca46 = (args)=>{
        const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, (0, parcelRequire("5HSWG")).getSimplifiedBlockingTime)($09eba838967fcf46$export$dd1b3502b1e8ca97);
        const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
        const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
        args.issueViewLoad.mark($f0ab548eaf57140f$export$e52cc35f872875f7, backendBlockingEnd);
        args.issueViewLoad.mark($f0ab548eaf57140f$export$e64e32643802b552, backendBlockingStart);
        $09eba838967fcf46$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$09eba838967fcf46$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
        return {
            issueDataAvailable: backendBlockingEnd,
            issueReadyForData: backendBlockingStart
        };
    };
});
parcelRegister("eR8VP", function(module, exports) {
    $parcel$export(module.exports, "createBlockedOnBackendEntryLog", ()=>$03c2930a2b0da0b2$export$44ddca89673a78bc);
    const $03c2930a2b0da0b2$export$44ddca89673a78bc = ()=>{
        const blockedOnBackendState = {
            timestamps: {}
        };
        const clearBlockedOnBackendState = ()=>{
            blockedOnBackendState.timestamps = {};
            blockedOnBackendState.currentKey = undefined;
        };
        const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
            let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
            if (!blockingDurationTimestamps) {
                blockingDurationTimestamps = {};
                blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
            }
            return blockingDurationTimestamps;
        };
        const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
            if (key !== blockedOnBackendState.currentKey) {
                clearBlockedOnBackendState();
                blockedOnBackendState.currentKey = key;
            }
        };
        const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
            const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
            if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
        };
        const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
            const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
            if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
        };
        const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
            let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
                const [, blockingTimestamps] = entry;
                return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
            });
            if (sorted) entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
            return entries;
        };
        return {
            initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
            markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
            markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
            getBlockedOnBackendEntries: getBlockedOnBackendEntries
        };
    };
});
parcelRegister("5HSWG", function(module, exports) {
    $parcel$export(module.exports, "getSimplifiedBlockingTime", ()=>$f737b8377358abe8$export$580550d1d1ffca6c);
    var $fV2OJ;
    const $f737b8377358abe8$export$580550d1d1ffca6c = (entryLog)=>{
        const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
            sorted: true
        });
        const blockingSpans = (0, (0, parcelRequire("fV2OJ")).mergeOverlappingBlockingEntries)(blockingTimestampEntries);
        const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
        const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
        const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
            0
        ]);
        const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
        return {
            blockingStart: blockingStart,
            totalBlockingDuration: totalBlockingDuration
        };
    };
});
parcelRegister("fV2OJ", function(module, exports) {
    $parcel$export(module.exports, "mergeOverlappingBlockingEntries", ()=>$a9340f8b2f19c6fe$export$e63ec487944afc72);
    function $a9340f8b2f19c6fe$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
        return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
            const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
            if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
                blockingStart: blockingStart,
                blockingEnd: blockingEnd
            });
            else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
            return nonOverlappingSpans;
        }, []);
    }
});
parcelRegister("1UioC", function(module, exports) {
    $parcel$export(module.exports, "issueScaleabilityReporterFactory", ()=>$1f39c5825b4f5e5a$export$9f6c068bd6582299);
    var $co1wz;
    var $kuVxL;
    var $fOGZN;
    var $i84pu;
    var $b5LNN;
    var $a1ky2;
    var $7Ow8a;
    var $bcoYn;
    var $gYUjk;
    var $lMzxr;
    var $jMY7o;
    var $hwyJi;
    var $lssfC;
    var $d4MOh;
    var $9acDX;
    var $ifezr;
    var $3Ke60;
    var $aN61o;
    var $5fc53;
    var $dvijh;
    var $fKtck;
    const $1f39c5825b4f5e5a$var$getCascadingSelectFields = (state)=>Object.values((0, (0, parcelRequire("7Ow8a")).fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE));
    const $1f39c5825b4f5e5a$var$getAtlassianTeamFields = (state)=>Object.values((0, (0, parcelRequire("7Ow8a")).fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE));
    const $1f39c5825b4f5e5a$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
        if (cascadingSelectFieldValue.length === 0) return 0;
        return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
    };
    const $1f39c5825b4f5e5a$var$getCascadingSelectOptionsTotalCount = (state)=>{
        const cascadingSelectFields = $1f39c5825b4f5e5a$var$getCascadingSelectFields(state);
        if (cascadingSelectFields.length === 0) return 0;
        return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($1f39c5825b4f5e5a$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
    };
    const $1f39c5825b4f5e5a$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
        let open = 0;
        let closed = 0;
        if (projectKey !== undefined) {
            const groupLocalStorageName = (0, (0, parcelRequire("i84pu")).getGroupLocalStorageName)(projectKey, 'context-group');
            try {
                const installedPanels = [
                    ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, (0, parcelRequire("b5LNN")).generateContextPanelId)(item)}`),
                    ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
                ];
                open = Object.values((0, (0, parcelRequire("i84pu")).getGroupsLocalStorage)(installedPanels, (0, $135ded4f9a1460dc$export$e1184c3be46bd7cb))).filter(Boolean).length;
                closed = installedPanels.length - open;
            } catch  {}
        }
        return {
            open: open,
            closed: closed
        };
    };
    const $1f39c5825b4f5e5a$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
            const state = store.getState();
            const { permalinkType: permalinkType } = (0, (0, parcelRequire("fKtck")).getPermalinkTypeAndId)() || {};
            const childIssues = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("5fc53")).CHILDREN_ISSUES))(state);
            const proformaHarmonisation = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("5fc53")).PROFORMA_FORMS))(state);
            const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $1f39c5825b4f5e5a$export$ae327590f8230d00({
                projectKey: state?.entities?.project?.projectKey,
                ecosystem: (0, (0, parcelRequire("gYUjk")).contextPanelEntitiesSelector)(state),
                forge: (0, (0, parcelRequire("lMzxr")).forgeContextPanelsSelector)(state)
            });
            const subtaskCount = (0, (0, parcelRequire("7Ow8a")).childIssuesLimitUrlSelector)(state)((0, (0, parcelRequire("fOGZN")).SUBTASKS)) && issueContextActions ? (0, (0, parcelRequire("kuVxL")).getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, (0, parcelRequire("aN61o")).subtaskEntitiesSelector)(state).length;
            const childIssuesCount = (0, (0, parcelRequire("7Ow8a")).childIssuesLimitUrlSelector)(state)((0, (0, parcelRequire("5fc53")).CHILDREN_ISSUES)) && issueContextActions ? (0, (0, parcelRequire("kuVxL")).getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
            let portfolioChildIssueCount;
            let actualSubtaskCount;
            let actualChildIssueCount;
            let actualEpicIssueCount;
            let epicIssueCount;
            const subtasks = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("fOGZN")).SUBTASKS))(state);
            const epicIssues = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("fOGZN")).EPIC_ISSUES))(state);
            const portfolioChildIssues = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("fOGZN")).PORTFOLIO_CHILD_ISSUES))(state);
            const getChildIssuesLimitUrl = (0, (0, parcelRequire("7Ow8a")).childIssuesLimitUrlSelector)(state);
            const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, (0, parcelRequire("fOGZN")).EPIC_ISSUES)));
            const isOverLimit = Boolean(getChildIssuesLimitUrl((0, (0, parcelRequire("fOGZN")).SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, (0, parcelRequire("5fc53")).CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
            if (isOverLimit) {
                actualChildIssueCount = childIssues?.originalContentLength ?? 0;
                actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
                actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
                epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, (0, parcelRequire("kuVxL")).getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
                portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
            } else {
                actualChildIssueCount = childIssues?.value.length ?? 0;
                actualSubtaskCount = subtasks?.value.length ?? 0;
                actualEpicIssueCount = epicIssues?.value.length ?? 0;
                portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
                epicIssueCount = actualEpicIssueCount;
            }
            return {
                ecosystemGlances: (0, (0, parcelRequire("gYUjk")).glancesSelector)(state).length,
                ecosystemContentPanels: (0, (0, parcelRequire("gYUjk")).allContentPanelsSelector)(state).length,
                contextPanelOpenCount: contextPanelOpenCount,
                contextPanelClosedCount: contextPanelClosedCount,
                ecosystemActivityPanels: (0, (0, parcelRequire("gYUjk")).activityPanelsSelector)(state).length,
                ...!(0, (0, parcelRequire("co1wz")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? {
                    ecosystemOperations: (0, (0, parcelRequire("gYUjk")).operationsSelector)(state).length
                } : {},
                ecosystemCustomsFields: (0, (0, parcelRequire("hwyJi")).ecosystemCustomFieldIdsSelector)(state).length,
                childIssues: childIssuesCount,
                linkIssueCount: (0, (0, parcelRequire("9acDX")).combinedLinkedIssueCountSelector)(state),
                subtaskCount: subtaskCount,
                actualChildIssueCount: actualChildIssueCount,
                actualSubtaskCount: actualSubtaskCount,
                actualEpicIssueCount: actualEpicIssueCount,
                actualPortfolioChildIssueCount: portfolioChildIssueCount,
                epicIssueCount: epicIssueCount,
                portfolioChildIssueCount: portfolioChildIssueCount,
                issueId: (0, (0, parcelRequire("a1ky2")).issueIdSelector)(state),
                commentsTotalCount: (0, (0, parcelRequire("d4MOh")).totalCommentsSelector)(state),
                hasCommentPermalink: permalinkType === (0, (0, parcelRequire("dvijh")).COMMENTS),
                cascadingSelectCount: $1f39c5825b4f5e5a$var$getCascadingSelectFields(state).length,
                isAtlassianTeamFieldEnabled: $1f39c5825b4f5e5a$var$getAtlassianTeamFields(state).length > 0,
                cascadingSelectOptionsTotalCount: $1f39c5825b4f5e5a$var$getCascadingSelectOptionsTotalCount(state),
                proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
                hasSubtasksTypes: (0, (0, parcelRequire("3Ke60")).isSubtaskTypesPresentSelector)(state),
                issueTypesCount: (0, (0, parcelRequire("ifezr")).issueTypesSelector)(state).length,
                issueTypeHierarchyLevel: !(0, (0, parcelRequire("bcoYn")).isSimplifiedProjectSelector)(state) ? (0, (0, parcelRequire("lssfC")).issueTypeHierarchyLevelSelector)(state) : (0, (0, parcelRequire("jMY7o")).hierarchyLevelSelector)(state)
            };
        };
});
const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';
parcelRegister("kuVxL", function(module, exports) {
    $parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", ()=>$352d0cb4ab81075d$export$8cbe27041ec414b7);
    const $352d0cb4ab81075d$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
    const $352d0cb4ab81075d$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;
});
parcelRegister("i84pu", function(module, exports) {
    $parcel$export(module.exports, "getGroupLocalStorageName", ()=>$28741fb0cc9e4bb5$export$a3b190a19b138f2e);
    $parcel$export(module.exports, "isGroupPanelOpen", ()=>$28741fb0cc9e4bb5$export$e79995f22545fd3e);
    $parcel$export(module.exports, "getGroupsLocalStorage", ()=>$28741fb0cc9e4bb5$export$d0a5ccc42f3bcd33);
    $parcel$export(module.exports, "useGroupLocalStorage", ()=>$28741fb0cc9e4bb5$export$4e1a840a45fb467c);
    var $5uXOq = parcelRequire("5uXOq");
    const $28741fb0cc9e4bb5$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
    const $28741fb0cc9e4bb5$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
        try {
            const item = window.localStorage.getItem(keyName);
            if (item === 'true') return true;
            if (item === 'false') return false;
            throw Error('Invalid group state value');
        } catch (_) {
            return defaultValue;
        }
    };
    const $28741fb0cc9e4bb5$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
        const groupLocalStorageName = $28741fb0cc9e4bb5$export$a3b190a19b138f2e(projectKey, group);
        return $28741fb0cc9e4bb5$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
    };
    const $28741fb0cc9e4bb5$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
        const items = {};
        keyNames.forEach((key)=>{
            items[key] = $28741fb0cc9e4bb5$export$a7e7b7df48874d2c(key, initialOpened);
        });
        return items;
    };
    const $28741fb0cc9e4bb5$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
        const keyName = $28741fb0cc9e4bb5$export$a3b190a19b138f2e(projectKey, id);
        const [storedValue, setStoredValue] = (0, $5uXOq.useState)(()=>$28741fb0cc9e4bb5$export$a7e7b7df48874d2c(keyName, initialOpened));
        const setValue = (0, $5uXOq.useCallback)((value)=>{
            try {
                setStoredValue(value);
                window.localStorage.setItem(keyName, String(value));
            } catch (_) {}
        }, [
            keyName
        ]);
        return [
            storedValue,
            setValue
        ];
    };
});
parcelRegister("b5LNN", function(module, exports) {
    $parcel$export(module.exports, "shouldHideNullUneditableField", ()=>$8e792d10938fd7f7$export$e7987ba89f8e2996);
    $parcel$export(module.exports, "ecosystemGlancesToLayoutItem", ()=>$8e792d10938fd7f7$export$8dd9174e11169a13);
    $parcel$export(module.exports, "ecosystemContextsToLayoutItem", ()=>$8e792d10938fd7f7$export$ff0381f8ed1f6cc7);
    $parcel$export(module.exports, "useForgeGlancesAsLayoutItems", ()=>$8e792d10938fd7f7$export$969c8278a214a2d9);
    $parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", ()=>$8e792d10938fd7f7$export$b4095ac407369aa0);
    $parcel$export(module.exports, "addChangeboardingRefToFirstItem", ()=>$8e792d10938fd7f7$export$b7aff69af7ee8f70);
    $parcel$export(module.exports, "getPinnedFieldItems", ()=>$8e792d10938fd7f7$export$7fc9f8048722ede9);
    $parcel$export(module.exports, "generateContextPanelId", ()=>$8e792d10938fd7f7$export$c55ff2c236d30544);
    var $1sWm7 = parcelRequire("1sWm7");
    var $4R6GH;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $2gCtH;
    var $3fAi8;
    var $41gqO;
    var $awmXl;
    var $cUUmI;
    var $fOGZN;
    var $2ewrm;
    var $vuOaC;
    var $5fc53;
    var $93Yeu;
    var $17Gip;
    const $8e792d10938fd7f7$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
    const $8e792d10938fd7f7$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, ($parcel$interopDefault($1sWm7)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
    const $8e792d10938fd7f7$var$getFieldConfiguration = (fieldId, fields)=>{
        const field = fields[fieldId];
        const customSystemFields = (0, (0, parcelRequire("fOGZN")).specialFields)();
        const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
        if (condition) {
            const customType = customSystemFields[fieldId];
            return $8e792d10938fd7f7$var$getFieldByCustomType(customType, fields);
        }
        return field;
    };
    const $8e792d10938fd7f7$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
        const fieldConfig = $8e792d10938fd7f7$var$getFieldConfiguration(itemId, issueFieldsConfig);
        const fieldType = (0, (0, parcelRequire("vuOaC")).getFieldType)(fieldConfig);
        if ((0, (0, parcelRequire("vuOaC")).getPanels)().includes(itemId)) return false;
        if (!fieldConfig || fieldType === undefined) return true;
        if ((0, (0, parcelRequire("vuOaC")).isEmpty)(value) && !fieldConfig.isEditable) {
            if (itemId === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE) || fieldType === (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE) || fieldType === (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE)) return false;
            if ((0, (0, parcelRequire("cUUmI")).isForgeField)(fieldConfig)) return false;
            if (itemId === (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)) return $8e792d10938fd7f7$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
            return true;
        }
        return false;
    };
    const $8e792d10938fd7f7$export$8dd9174e11169a13 = (ecosystemGlances)=>{
        const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
            const ecosystem = ecosystemGlances[next];
            const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
            return [
                ...acc,
                ...modules
            ];
        }, []);
        return result.map((connectGlance)=>({
                id: `${0, (0, parcelRequire("5fc53")).ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
                type: (0, (0, parcelRequire("5fc53")).ECOSYSTEM_GLANCE_TYPE),
                payload: {
                    ...connectGlance,
                    glanceType: (0, (0, parcelRequire("awmXl")).CONNECT_ENTITY_TYPE)
                }
            }));
    };
    const $8e792d10938fd7f7$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
        const contextPanels = [];
        Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
            contextPanels.push(Object.values(contextPanelObject)[0]);
        });
        return contextPanels.map((connectContextPanel)=>({
                id: `${0, (0, parcelRequire("5fc53")).ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
                type: (0, (0, parcelRequire("5fc53")).ECOSYSTEM_CONTEXT_TYPE),
                payload: {
                    ...connectContextPanel,
                    contextPanelType: (0, (0, parcelRequire("awmXl")).CONNECT_ENTITY_TYPE)
                }
            }));
    };
    const $8e792d10938fd7f7$var$ISSUE_TYPE = 'issuetype';
    const $8e792d10938fd7f7$export$ea6c3ae2bd3a5510 = ()=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const issueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const [permissions] = (0, (0, parcelRequire("17Gip")).useProjectPermissions)(projectKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        const projectId = (0, (0, parcelRequire("93Yeu")).useProjectId)(projectKey);
        const [issueType] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: $8e792d10938fd7f7$var$ISSUE_TYPE
        });
        return {
            issueId: issueId || null,
            issueKey: issueKey,
            issueType: issueType && issueType.name,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType || null,
            canAddComments: permissions.canAddComments,
            canAdministerJira: permissions.canAdministerJira,
            canAdministerProjects: permissions.canAdministerProject,
            canAssignIssues: permissions.canAssignIssues,
            canBeAssignedToIssues: permissions.canBeAssignedToIssues,
            canCloneIssues: permissions.canCloneIssue,
            canCreateAttachments: permissions.canCreateAttachments,
            canCreateChildren: permissions.canCreateChildren,
            canCreateSubtasks: permissions.canCreateSubtask,
            canDeleteAllAttachments: permissions.canDeleteAllAttachments,
            canDeleteAllComments: permissions.canDeleteAllComments,
            canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
            canDeleteIssues: permissions.canDeleteIssue,
            canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
            canDeleteOwnComments: permissions.canDeleteOwnComments,
            canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
            canEditAllComments: permissions.canEditAllComments,
            canEditAllWorklogs: permissions.canEditAllWorklogs,
            canEditIssues: permissions.canEditIssues,
            canEditOwnComments: permissions.canEditOwnComments,
            canEditOwnWorklogs: permissions.canEditOwnWorklogs,
            canLinkIssues: permissions.canLinkIssues,
            canLogWork: permissions.canLogWork,
            canManageWatchers: permissions.canManageWatchers,
            canModifyReporters: permissions.canModifyReporter,
            canMoveIssues: permissions.canMoveIssue,
            canScheduleIssues: permissions.canScheduleIssues,
            canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
            canBrowseUsers: permissions.canBrowseUsers,
            canViewDevTools: permissions.canViewDevTools,
            canViewWatchers: permissions.canViewWatchers
        };
    };
    const $8e792d10938fd7f7$export$969c8278a214a2d9 = ()=>{
        const [forgeGlances] = (0, (0, parcelRequire("2ewrm")).useForgeGlances)();
        const staticContext = $8e792d10938fd7f7$export$ea6c3ae2bd3a5510();
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(forgeGlances, staticContext, 'glances-as-layout-items');
        return forgeGlances.filter((extension)=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5cmSg")).isExtensionVisible)(extension) : (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, staticContext)).map((forgeGlance)=>{
            const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
            return {
                id: id,
                type: (0, (0, parcelRequire("5fc53")).FORGE_GLANCE_TYPE),
                payload: {
                    label: label,
                    title: title,
                    status: status,
                    icon: icon,
                    extension: forgeGlance,
                    glanceType: (0, $f17db2727085e590$export$6f3804b3f188f650),
                    moduleKey: id,
                    appKey: id
                }
            };
        });
    };
    const $8e792d10938fd7f7$export$b4095ac407369aa0 = ()=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const { ecosystemEnabled: ecosystemEnabled } = (0, (0, parcelRequire("93Yeu")).useProjectConfiguration)(projectKey);
        const [forgeContextPanels] = (0, (0, parcelRequire("2ewrm")).useForgeContextPanels)();
        const staticContext = $8e792d10938fd7f7$export$ea6c3ae2bd3a5510();
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(forgeContextPanels, staticContext, 'context-panels-as-layout-items');
        if (!ecosystemEnabled) return [];
        return forgeContextPanels.filter((extension)=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5cmSg")).isExtensionVisible)(extension) : (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, staticContext)).map((contextPanels)=>{
            const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
            return {
                id: id,
                type: (0, (0, parcelRequire("41gqO")).FORGE_CONTEXT_TYPE),
                payload: {
                    type: (0, (0, parcelRequire("41gqO")).FORGE_CONTEXT_TYPE),
                    label: label,
                    name: title,
                    status: status || null,
                    icon: url ? {
                        url: url
                    } : null,
                    extension: contextPanels,
                    contextPanelType: (0, $f17db2727085e590$export$6f3804b3f188f650),
                    moduleKey: id,
                    appKey: id,
                    options: null
                }
            };
        });
    };
    const $8e792d10938fd7f7$export$b7aff69af7ee8f70 = (items)=>{
        let wrapperAdded = false;
        const allowedTypes = [
            (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).field,
            (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).panel
        ];
        const disallowedIds = [
            (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
            (0, (0, parcelRequire("5fc53")).SLA_PANEL_TYPE)
        ];
        return items.map((item)=>{
            const typename = item.type !== undefined ? item.type : '';
            if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
                wrapperAdded = true;
                return {
                    ...item,
                    globalRef: (0, $acf4ef636a959927$export$95ff4d03075475e2)
                };
            }
            return item;
        });
    };
    const $8e792d10938fd7f7$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
            const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
            if (item !== undefined) result.push(item);
            return result;
        }, []);
    const $8e792d10938fd7f7$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, (0, parcelRequire("5fc53")).ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;
});
parcelRegister("awp3q", function(module, exports) {
    $parcel$export(module.exports, "useDoesExtensionMeetConditions", ()=>$bd52741229b769de$export$642911220fb6609f);
    $parcel$export(module.exports, "doesExtensionMeetConditions", ()=>$bd52741229b769de$export$b1e4ed7044e85aa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQVg = parcelRequire("kvQVg");
    var $4Pf62;
    var $daoB1;
    var $9OXo1;
    const $bd52741229b769de$export$642911220fb6609f = ()=>{
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return (0, $5uXOq.useCallback)((extension, extraContext)=>{
            const { displayConditions: displayConditions } = extension.properties;
            if (displayConditions == null) return true;
            const context = {
                ...extraContext,
                isAdmin: isAdmin,
                isLoggedIn: !isAnonymous,
                isSiteAdmin: isSiteAdmin,
                hasCoreAccess: hasCoreAccess,
                hasServiceManagementAccess: hasServiceManagementAccess,
                hasSoftwareAccess: hasSoftwareAccess
            };
            return (0, $kvQVg.doesMeetConditions)(displayConditions, context);
        }, [
            hasCoreAccess,
            hasServiceManagementAccess,
            hasSoftwareAccess,
            isAdmin,
            isAnonymous,
            isSiteAdmin
        ]);
    };
    const $bd52741229b769de$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const context = {
            ...extraContext,
            isAdmin: isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasSoftwareAccess: hasSoftwareAccess,
            hasServiceManagementAccess: hasServiceDeskAccess,
            hasCoreAccess: hasCoreAccess
        };
        return displayConditions ? (0, $kvQVg.doesMeetConditions)(displayConditions, context) : true;
    };
});
parcelRegister("dvdr4", function(module, exports) {
    $parcel$export(module.exports, "useDisplayConditionsConsistencyCheck", ()=>$79a96011350576c4$export$cd62caf01a15f56b);
    $parcel$export(module.exports, "checkDisplayConditionsConsistency", ()=>$79a96011350576c4$export$4169695e1a68bda7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $dJl1T;
    var $4R6GH;
    var $awp3q;
    var $5cmSg;
    const $79a96011350576c4$export$cd62caf01a15f56b = (data, context = {}, consumer)=>{
        const memoizedContext = $79a96011350576c4$var$useMemoizedStateObject(context);
        const memoizedData = $79a96011350576c4$var$useMemoizedStateObject(data);
        (0, $5uXOq.useEffect)(()=>{
            $79a96011350576c4$export$4169695e1a68bda7(memoizedData, memoizedContext, consumer);
        }, [
            memoizedContext,
            memoizedData,
            consumer
        ]);
    };
    const $79a96011350576c4$export$4169695e1a68bda7 = (data, context = {}, consumer)=>{
        if (data == null) return;
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            if ('extensions' in data) {
                (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called with a data from the old query', {
                    consumer: consumer
                });
                return;
            }
        } else {
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called while the FG is being turned off', {
                consumer: consumer
            });
            return;
        }
        const falsePositives = new Set();
        const falseNegatives = new Set();
        data.forEach((extension)=>{
            const perClient = (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context);
            const perServer = !(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByDisplayConditions)(extension);
            if (perClient !== perServer) {
                if (perServer) falsePositives.add(extension);
                else falseNegatives.add(extension);
            }
        });
        if (falsePositives.size || falseNegatives.size) (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'Display conditions evaluation is not consistent', {
            consumer: consumer,
            context: JSON.stringify(context),
            falsePositives_count: falsePositives.size,
            falsePositives_data: falsePositives.size ? JSON.stringify(Array.from(falsePositives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null,
            falseNegatives_count: falseNegatives.size,
            falseNegatives_data: falseNegatives.size ? JSON.stringify(Array.from(falseNegatives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null
        });
    };
    const $79a96011350576c4$var$useMemoizedStateObject = (data, equalityCheck = (0, ($parcel$interopDefault($ajpes))))=>{
        const memoizedData = (0, $5uXOq.useRef)(data);
        return (0, $5uXOq.useMemo)(()=>{
            if (!equalityCheck(data, memoizedData.current)) {
                memoizedData.current = data;
                return data;
            }
            return memoizedData.current;
        }, [
            data,
            equalityCheck
        ]);
    };
});
parcelRegister("5cmSg", function(module, exports) {
    $parcel$export(module.exports, "isExtensionVisible", ()=>$30771269db74e480$export$41e48b53c2cc2013);
    $parcel$export(module.exports, "isExtensionHidden", ()=>$30771269db74e480$export$3f5b3e61d567ef3);
    $parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", ()=>$30771269db74e480$export$5c38dfa9d1f96e61);
    $parcel$export(module.exports, "isExtensionHiddenByDisplayConditions", ()=>$30771269db74e480$export$3cc53b8cca25d64);
    const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
    const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
    const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
    const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';
});
parcelRegister("2gCtH", function(module, exports) {
    $parcel$export(module.exports, "useChildIssuesLimit", ()=>$9e67f38435565e11$export$8d75f312eaa63aec);
    $parcel$export(module.exports, "useChildIssuesIssueLimitUrl", ()=>$9e67f38435565e11$export$65a59acd1ffc5bba);
    $parcel$export(module.exports, "useIsModal", ()=>$9e67f38435565e11$export$9ce8428ff198804a);
    $parcel$export(module.exports, "useIssueKey", ()=>$9e67f38435565e11$export$22108eca27445997);
    $parcel$export(module.exports, "useIssueId", ()=>$9e67f38435565e11$export$9df8176b5ffce5ab);
    $parcel$export(module.exports, "useIsArchived", ()=>$9e67f38435565e11$export$7cd1821433aafaee);
    $parcel$export(module.exports, "useIsClassifyEditEnabled", ()=>$9e67f38435565e11$export$b23b36ed5c42e920);
    $parcel$export(module.exports, "useProjectKey", ()=>$9e67f38435565e11$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useAnalyticsSource", ()=>$9e67f38435565e11$export$aad3917152559b87);
    $parcel$export(module.exports, "useIssueContextActions", ()=>$9e67f38435565e11$export$d6ec1293313f49ac);
    $parcel$export(module.exports, "useRapidViewMap", ()=>$9e67f38435565e11$export$4d204e800e4e0be7);
    $parcel$export(module.exports, "useEstimationStatistic", ()=>$9e67f38435565e11$export$5b20e30ee6db56e9);
    $parcel$export(module.exports, "useViewMode", ()=>$9e67f38435565e11$export$3a7c3e259b6adb93);
    $parcel$export(module.exports, "useBackButtonUrl", ()=>$9e67f38435565e11$export$cfe64a334903927c);
    $parcel$export(module.exports, "useIssueNavigatorData", ()=>$9e67f38435565e11$export$aa008a00bae7e7ab);
    $parcel$export(module.exports, "useOnIssueKeyChange", ()=>$9e67f38435565e11$export$52c975cf0b623556);
    $parcel$export(module.exports, "useRapidViewId", ()=>$9e67f38435565e11$export$b34d0ea0bf41fee);
    $parcel$export(module.exports, "useViewScreenId", ()=>$9e67f38435565e11$export$7c142b5701b4c3f9);
    $parcel$export(module.exports, "useHasSoftwareAccess", ()=>$9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
    $parcel$export(module.exports, "useIsFullPageIssueView", ()=>$9e67f38435565e11$export$2e131fc4108f9106);
    $parcel$export(module.exports, "useIsEmbedPageIssueView", ()=>$9e67f38435565e11$export$4596c26005fbb859);
    $parcel$export(module.exports, "useIsAiOptInEnabled", ()=>$9e67f38435565e11$export$b131d9f6da853161);
    $parcel$export(module.exports, "useIsAiEnabledForIssue", ()=>$9e67f38435565e11$export$db5174c7538abe4b);
    $parcel$export(module.exports, "useIsJiraIssue", ()=>$9e67f38435565e11$export$cf5fc815f761fb4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4Pf62;
    var $93Yeu;
    var $g5X3G;
    var $ef5Xn;
    var $7trqb;
    var $hqBSi;
    var $koiRX;
    const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
        const [childIssuesLimit] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesLimit)();
        return childIssuesLimit;
    };
    const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
        const [childIssuesIssueLimitUrls] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesIssueLimitUrls)();
        return childIssuesIssueLimitUrls;
    };
    const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
        const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
        return childIssuesIssueLimitUrls?.[fieldId];
    };
    const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
        const [isModal] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsModal)();
        return isModal;
    };
    const $9e67f38435565e11$export$22108eca27445997 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return issueKey;
    };
    const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
        const [issueId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueId)();
        return issueId;
    };
    const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
        const [isArchived] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsArchived)();
        return isArchived;
    };
    const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
        const [isClassifyEditEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsClassifyEditEnabled)();
        return isClassifyEditEnabled;
    };
    const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    };
    const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
        const [analyticsSource] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreAnalyticsSource)();
        return analyticsSource;
    };
    const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
        const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setIssueContext: setIssueContext,
                mergeIssueContext: mergeIssueContext,
                getChildIssuesLimit: getChildIssuesLimit,
                getMaxTokenLength: getMaxTokenLength,
                getIsLoadedWithPage: getIsLoadedWithPage,
                getBackButtonUrl: getBackButtonUrl,
                getIsSpaEnabled: getIsSpaEnabled,
                getIssueKey: getIssueKey,
                setDetailViewAsModal: setDetailViewAsModal,
                setDetailViewAsSidebar: setDetailViewAsSidebar,
                resetDetailView: resetDetailView
            }), [
            setIssueContext,
            mergeIssueContext,
            getChildIssuesLimit,
            getMaxTokenLength,
            getIsLoadedWithPage,
            getBackButtonUrl,
            getIsSpaEnabled,
            getIssueKey,
            setDetailViewAsModal,
            setDetailViewAsSidebar,
            resetDetailView
        ]);
        return [
            undefined,
            actions
        ];
    };
    const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
        const [rapidViewMap] = (0, (0, parcelRequire("koiRX")).useIssueContextRapidViewMap)();
        return rapidViewMap;
    };
    const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
        const [maxTokenLength] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreMaxTokenLength)();
        return maxTokenLength;
    };
    const $9e67f38435565e11$export$b4199f923267161e = ()=>{
        const [isLoadedWithPage] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoadedWithPage)();
        return isLoadedWithPage;
    };
    const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
        const [estimationStatistic] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreEstimationStatistic)();
        return estimationStatistic;
    };
    const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
        const [isLoading] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoading)();
        return isLoading;
    };
    const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
        const [viewMode] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewMode)();
        return viewMode;
    };
    const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
        const [backButtonUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBackButtonUrl)();
        return backButtonUrl;
    };
    const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
        const [issueNavigatorData] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueNavigatorData)();
        return issueNavigatorData;
    };
    const $9e67f38435565e11$export$b49754504c41149f = ()=>{
        const [boardId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardId)();
        return boardId;
    };
    const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
        const [boardType] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardType)();
        return boardType;
    };
    const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
        const [isSpaEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsSpaEnabled)();
        return isSpaEnabled;
    };
    const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
        const [loginRedirectUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreLoginRedirctUrl)();
        return loginRedirectUrl;
    };
    const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
        const [onIssueKeyChange] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreOnIssueKeyChange)();
        return onIssueKeyChange;
    };
    const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
        const [rapidViewId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreRapidViewId)();
        return rapidViewId;
    };
    const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
        const [viewScreenId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewScreenId)();
        return viewScreenId;
    };
    const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const licenseStates = (0, (0, parcelRequire("7trqb")).useLicenseStates)();
        const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE);
        return licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
    };
    const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
    };
    const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
    };
    const $9e67f38435565e11$export$b131d9f6da853161 = ()=>{
        const [isAiOptInEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiOptInEnabled)();
        return isAiOptInEnabled;
    };
    const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
        const [isAiEnabledForIssue] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiEnabledForIssue)();
        return isAiEnabledForIssue;
    };
    const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
        const issueKey = $9e67f38435565e11$export$22108eca27445997();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        return [
            (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT),
            (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
        ].some((type)=>type === projectType);
    };
});
parcelRegister("93Yeu", function(module, exports) {
    $parcel$export(module.exports, "useProjectKey", ()=>$5f0f9360597cdbd8$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useProjectContextActions", ()=>$5f0f9360597cdbd8$export$bd73624ca941f105);
    $parcel$export(module.exports, "useProjectType", ()=>$5f0f9360597cdbd8$export$6de29d851c914935);
    $parcel$export(module.exports, "useProjectContext", ()=>$5f0f9360597cdbd8$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useApplication", ()=>$5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
    $parcel$export(module.exports, "useEdition", ()=>$5f0f9360597cdbd8$export$d56c02945cf5a9e5);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$5f0f9360597cdbd8$export$524ef4f6102ed540);
    $parcel$export(module.exports, "useIsClassicProject", ()=>$5f0f9360597cdbd8$export$e2cf96f40a8867ce);
    $parcel$export(module.exports, "useProjectId", ()=>$5f0f9360597cdbd8$export$16d1475ed6c26568);
    $parcel$export(module.exports, "useProjectStatus", ()=>$5f0f9360597cdbd8$export$30f16f2782a4113b);
    $parcel$export(module.exports, "useProjectConfiguration", ()=>$5f0f9360597cdbd8$export$af19ad68b52fa1a6);
    $parcel$export(module.exports, "useProjectIssueTypes", ()=>$5f0f9360597cdbd8$export$80bef597b440cf71);
    var $5uXOq = parcelRequire("5uXOq");
    var $efvDm;
    var $ldyPw;
    var $g5X3G;
    var $9OXo1;
    var $buby4;
    var $1daUm;
    const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
        const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, (0, parcelRequire("buby4")).useProjectContextActionStore)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectContext: setProjectContext,
                mergeProjectProperty: mergeProjectProperty
            }), [
            setProjectContext,
            mergeProjectProperty
        ]);
        return [
            null,
            actions
        ];
    };
    const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
        const [projectType] = (0, (0, parcelRequire("buby4")).useProjectContextProjectTypeStore)({
            projectKey: projectKey
        });
        return projectType;
    };
    const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext;
    };
    const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        if (projectType === undefined) {
            if (failSafely) return undefined;
            throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
        }
        return (0, (0, parcelRequire("efvDm")).getApplicationForProject)(projectType);
    };
    const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
        const { appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
        if (!application) return undefined;
        return (0, (0, parcelRequire("ldyPw")).getEdition)(application, appEditions);
    };
    const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.isSimplified || false;
    };
    const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return !projectContext?.isSimplified;
    };
    const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectId;
    };
    const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectStatus;
    };
    const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
        return (0, (0, parcelRequire("1daUm")).getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        });
    };
    const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
        const [projectName] = (0, (0, parcelRequire("buby4")).useProjectContextProjectNameStore)({
            projectKey: projectKey
        });
        return projectName;
    };
    const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
        const [issueTypes] = (0, (0, parcelRequire("buby4")).useProjectContextIssueTypesStore)({
            projectKey: projectKey
        });
        return issueTypes;
    };
});
parcelRegister("buby4", function(module, exports) {
    $parcel$export(module.exports, "useProjectContextActionStore", ()=>$42c27dedc1310bb2$export$9afb89c1fe103bbe);
    $parcel$export(module.exports, "useProjectContextStore", ()=>$42c27dedc1310bb2$export$8b09478b33186ec);
    $parcel$export(module.exports, "useProjectContextProjectTypeStore", ()=>$42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
    $parcel$export(module.exports, "useProjectContextProjectNameStore", ()=>$42c27dedc1310bb2$export$9469fde70658518);
    $parcel$export(module.exports, "useProjectContextIssueTypesStore", ()=>$42c27dedc1310bb2$export$f73e9904779f6be5);
    var $7JoAD = parcelRequire("7JoAD");
    var $aDpiK;
    const $42c27dedc1310bb2$var$initialState = {};
    const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        name: 'project-context',
        initialState: $42c27dedc1310bb2$var$initialState,
        actions: (0, parcelRequire("aDpiK"))
    });
    const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
    const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectContext
    });
    const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectType;
    };
    const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectType
    });
    const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectName;
    };
    const $42c27dedc1310bb2$export$9469fde70658518 = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectName
    });
    const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.issueTypes;
    };
    const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getIssueTypes
    });
});
parcelRegister("aDpiK", function(module, exports) {
    $parcel$export(module.exports, "setProjectContext", ()=>$ad16c28ce51d4ccf$export$d64151aab9ae5f09);
    $parcel$export(module.exports, "mergeProjectProperty", ()=>$ad16c28ce51d4ccf$export$78f1c6052937615f);
    const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
            setState({
                [key]: projectContext
            });
        };
    const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentProjectContext = currentState[key];
            const newProjectContext = {
                ...currentProjectContext,
                ...projectContext
            };
            setState({
                [key]: newProjectContext
            });
        };
});
parcelRegister("1daUm", function(module, exports) {
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$7afb7a15cd46bd62$export$902f6c5cc939598a);
    var $65mz3;
    var $2vSU6;
    const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
    const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SOFTWARE_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
                $7afb7a15cd46bd62$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).MOBILE_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $7afb7a15cd46bd62$export$381ce08838c53afa();
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $7afb7a15cd46bd62$export$db1115186532f6d5();
            default:
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        }
        return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    };
});
parcelRegister("7trqb", function(module, exports) {
    $parcel$export(module.exports, "useLicenseStates", ()=>$5fcaa3f734e9c444$export$268651a63abe408a);
    var $9OXo1;
    const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licenseStates;
    };
});
parcelRegister("hqBSi", function(module, exports) {
    $parcel$export(module.exports, "useLicensedProducts", ()=>$7564850c0894983d$export$54d534cc91e54850);
    var $9OXo1;
    const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licensedProducts || {};
    };
});
parcelRegister("koiRX", function(module, exports) {
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", ()=>$35da250daae5206d$export$abdbea56d86b4aac);
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", ()=>$35da250daae5206d$export$326ff2b963d51c5c);
    $parcel$export(module.exports, "useIssueContextStoreIssueKey", ()=>$35da250daae5206d$export$44bcaaabb74e402b);
    $parcel$export(module.exports, "useIssueContextStoreIssueId", ()=>$35da250daae5206d$export$332dcee0cf9f4e45);
    $parcel$export(module.exports, "useIssueContextStoreIsArchived", ()=>$35da250daae5206d$export$c940355b1fc6e1c4);
    $parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", ()=>$35da250daae5206d$export$b9eebaa1da421997);
    $parcel$export(module.exports, "useIssueContextStoreIsModal", ()=>$35da250daae5206d$export$daa47fd600e43a32);
    $parcel$export(module.exports, "useIssueContextStoreViewScreenId", ()=>$35da250daae5206d$export$ba2e9546ab5ba6f);
    $parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", ()=>$35da250daae5206d$export$74d38d6c437efc1b);
    $parcel$export(module.exports, "useIssueContextRapidViewMap", ()=>$35da250daae5206d$export$2092528ee170d9e7);
    $parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", ()=>$35da250daae5206d$export$57898374e6239a5a);
    $parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", ()=>$35da250daae5206d$export$ff0264ec4c015dc1);
    $parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", ()=>$35da250daae5206d$export$6c8b81f6dca8c23d);
    $parcel$export(module.exports, "useIssueContextStoreIsLoading", ()=>$35da250daae5206d$export$fe7085456138f0fc);
    $parcel$export(module.exports, "useIssueContextStoreViewMode", ()=>$35da250daae5206d$export$c339e36468c12443);
    $parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", ()=>$35da250daae5206d$export$ef3bfa2642bb98cd);
    $parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", ()=>$35da250daae5206d$export$8accd063c74cd455);
    $parcel$export(module.exports, "useIssueContextStoreBoardId", ()=>$35da250daae5206d$export$e7edffc2a20027e7);
    $parcel$export(module.exports, "useIssueContextStoreBoardType", ()=>$35da250daae5206d$export$48aaa3a6bc2085d7);
    $parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", ()=>$35da250daae5206d$export$4a4b96bcf5166327);
    $parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", ()=>$35da250daae5206d$export$bbd8ba0180545556);
    $parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", ()=>$35da250daae5206d$export$aaa89627762c7d00);
    $parcel$export(module.exports, "useIssueContextStoreRapidViewId", ()=>$35da250daae5206d$export$796589b0ec52848a);
    $parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", ()=>$35da250daae5206d$export$7e70ee570119a0a7);
    $parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", ()=>$35da250daae5206d$export$455ae7fd9d68b157);
    $parcel$export(module.exports, "IssueContextContainer", ()=>$35da250daae5206d$export$93db6a8f3342dddf);
    $parcel$export(module.exports, "useIssueContextStoreActions", ()=>$35da250daae5206d$export$965360ae27fcae98);
    var $g5X3G;
    var $7JoAD = parcelRequire("7JoAD");
    var $fMAcJ;
    var $iElCl;
    var $edJtc;
    const $35da250daae5206d$export$d4c72bab9d6cc13a = {
        childIssuesLimit: undefined,
        childIssuesIssueLimitUrls: undefined,
        issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(''),
        isArchived: false,
        isClassifyEditEnabled: false,
        isModal: false,
        maxTokenLength: 0,
        isLoadedWithPage: false,
        rapidViewMap: undefined,
        estimationStatistic: undefined,
        isLoading: false,
        viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)(),
        analyticsSource: undefined,
        backButtonUrl: undefined,
        issueNavigatorData: undefined,
        boardId: undefined,
        boardType: undefined,
        isSpaEnabled: false,
        loginRedirectUrl: undefined,
        onIssueKeyChange: undefined,
        rapidViewId: undefined,
        viewScreenId: undefined,
        isAiOptInEnabled: false,
        isAiEnabledForIssue: false
    };
    const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        name: 'issue-context',
        initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("fMAcJ")).actions
    });
    const $35da250daae5206d$var$getIssueContext = (state)=>state;
    const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
    const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
    const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
    const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
    const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
    const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
    const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
    const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
    const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
    const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
    const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
    const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
    const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
    const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
    const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
    const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
    const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
    const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
    const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
    const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
    const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
    const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
    const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
    const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueContext
    });
    const $35da250daae5206d$export$abdbea56d86b4aac = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesLimit)
    });
    const $35da250daae5206d$export$326ff2b963d51c5c = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesIssueLimitUrls)
    });
    const $35da250daae5206d$export$44bcaaabb74e402b = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueKey
    });
    const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueId
    });
    const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsArchived
    });
    const $35da250daae5206d$export$b9eebaa1da421997 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsClassifyEditEnabled
    });
    const $35da250daae5206d$export$daa47fd600e43a32 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsModal
    });
    const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewScreenId
    });
    const $35da250daae5206d$export$74d38d6c437efc1b = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getAnalyticsSource
    });
    const $35da250daae5206d$export$2092528ee170d9e7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewMap
    });
    const $35da250daae5206d$export$57898374e6239a5a = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getMaxTokenLength
    });
    const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoadedWithPage
    });
    const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getEstimationStatistic
    });
    const $35da250daae5206d$export$fe7085456138f0fc = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoading
    });
    const $35da250daae5206d$export$c339e36468c12443 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewMode
    });
    const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBackButtonUrl
    });
    const $35da250daae5206d$export$8accd063c74cd455 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueNavigatorData
    });
    const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardId
    });
    const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardType
    });
    const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsSpaEnabled
    });
    const $35da250daae5206d$export$bbd8ba0180545556 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getLoginRedirectUrl
    });
    const $35da250daae5206d$export$aaa89627762c7d00 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getOnIssueKeyChange
    });
    const $35da250daae5206d$export$796589b0ec52848a = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewId
    });
    const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsAiOptInEnabled
    });
    const $35da250daae5206d$export$455ae7fd9d68b157 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getisAiEnabledForIssue
    });
    const $35da250daae5206d$export$93db6a8f3342dddf = (0, $7JoAD.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
    const $35da250daae5206d$export$965360ae27fcae98 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("fMAcJ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$043cabfbcc6107f0$export$e324594224ef24da);
    var $7l48d;
    var $iElCl;
    var $edJtc;
    const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
                ...issueContext,
                issueId: undefined,
                viewMode: issueContext.viewMode || getState().viewMode
            });
            else setState({
                ...issueContext,
                viewMode: issueContext.viewMode || getState().viewMode
            });
        };
    const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
                ...getState(),
                ...partialIssueContext,
                issueId: undefined
            });
            else setState({
                ...getState(),
                ...partialIssueContext
            });
        };
    const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, (0, parcelRequire("iElCl")).getChildIssuesLimit)(getState());
    const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
    const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
    const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
    const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
    const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
    const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
    const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'MODAL');
            setState({
                viewMode: 'MODAL'
            });
        };
    const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
            setState({
                viewMode: 'SIDEBAR'
            });
        };
    const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
            setState({
                viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)()
            });
        };
    const $043cabfbcc6107f0$export$e324594224ef24da = {
        setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
        mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
        getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
        getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
        getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
        getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
        getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
        getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
        getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
        setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
        setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
        resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
    };
});
parcelRegister("7l48d", function(module, exports) {
    $parcel$export(module.exports, "LOG_LOCATION", ()=>$e736233a6ed098e3$export$25a759e49d5049db);
    $parcel$export(module.exports, "localStorage", ()=>$e736233a6ed098e3$export$c2ed3351cac403d1);
    $parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", ()=>$e736233a6ed098e3$export$a13f7f627010bccd);
    var $bSSG7;
    const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
    const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_issue_view');
    const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';
});
parcelRegister("iElCl", function(module, exports) {
    $parcel$export(module.exports, "getChildIssuesLimit", ()=>$fde75c94a28741e3$export$89b6937a83edcaa6);
    $parcel$export(module.exports, "getChildIssuesIssueLimitUrls", ()=>$fde75c94a28741e3$export$8f43520910e8128c);
    var $dJl1T;
    var $7l48d;
    const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
    const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`${(0, (0, parcelRequire("7l48d")).LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
        return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
    };
    const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
    const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;
});
parcelRegister("edJtc", function(module, exports) {
    $parcel$export(module.exports, "getViewModeFromLocalStorage", ()=>$75ce4ce78f606e67$export$cae7c4c591dcc261);
    var $7l48d;
    const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>(0, (0, parcelRequire("7l48d")).localStorage).get((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $7JoAD = parcelRequire("7JoAD");
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, $7JoAD.createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $7JoAD.createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
parcelRegister("41gqO", function(module, exports) {
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$b08b2795aecf222d$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$b08b2795aecf222d$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$b08b2795aecf222d$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "FORGE_CONTEXT_TYPE", ()=>$b08b2795aecf222d$export$be8e68fb1aed253e);
    $parcel$export(module.exports, "CONTEXT_AREA", ()=>$b08b2795aecf222d$export$7bf561e6ab380ea1);
    $parcel$export(module.exports, "CONTENT_AREA", ()=>$b08b2795aecf222d$export$f42c11634d75863e);
    $parcel$export(module.exports, "CONTENT_REQUEST_AREA", ()=>$b08b2795aecf222d$export$b38842736b6dbc1d);
    $parcel$export(module.exports, "REACT_KEY_SUMMARY", ()=>$b08b2795aecf222d$export$605c43f1b33ab69);
    $parcel$export(module.exports, "CUSTOM_ITEM_TYPE", ()=>$b08b2795aecf222d$export$e655b77b9efe622f);
    $parcel$export(module.exports, "layoutContainerItemTypes", ()=>$b08b2795aecf222d$export$5507f31126c8b283);
    $parcel$export(module.exports, "isLayoutContainerTabItem", ()=>$b08b2795aecf222d$export$ad3536b13febb432);
    const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
    const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
    const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
    const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
    const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
    const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
    const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
    const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
    const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
    const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
    const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
    const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
    const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
    const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
    const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
    const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
    const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
    const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
    const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
    const $b08b2795aecf222d$export$5507f31126c8b283 = {
        field: 'JiraIssueItemFieldItem',
        panel: 'JiraIssueItemPanelItem',
        tab: 'JiraIssueItemTabContainer'
    };
    const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;
});
parcelRegister("awmXl", function(module, exports) {
    $parcel$export(module.exports, "FORGE_ENTITY_TYPE", ()=>$c65c130bf8cdb044$export$6f3804b3f188f650);
    $parcel$export(module.exports, "CONNECT_ENTITY_TYPE", ()=>$c65c130bf8cdb044$export$1b2059a011c9174d);
    const $c65c130bf8cdb044$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
    const $c65c130bf8cdb044$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
    const $c65c130bf8cdb044$export$38f0fc1cf1f24cba = [
        $c65c130bf8cdb044$export$6f3804b3f188f650,
        $c65c130bf8cdb044$export$1b2059a011c9174d
    ];
});
const $acf4ef636a959927$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $acf4ef636a959927$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $acf4ef636a959927$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $acf4ef636a959927$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $acf4ef636a959927$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $acf4ef636a959927$export$7b98e5a33c854454 = 30;
const $acf4ef636a959927$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $acf4ef636a959927$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $acf4ef636a959927$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $acf4ef636a959927$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$483d9bcbbd8280a6 = 'status-spotlight';
const $acf4ef636a959927$export$95f98990d7202b31 = 'SHOW_MORE';
const $acf4ef636a959927$export$95ff4d03075475e2 = 'PIN_FIELD';
const $acf4ef636a959927$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $acf4ef636a959927$export$6f48b612d5c03f4d = 'PERMALINK';
const $acf4ef636a959927$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $acf4ef636a959927$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $acf4ef636a959927$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $acf4ef636a959927$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $acf4ef636a959927$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $acf4ef636a959927$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $acf4ef636a959927$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';
const $acf4ef636a959927$export$ddb80c23a62a41e = 'jira.user.issue.has.seen.quick-actions.change-boarding.message';
parcelRegister("cUUmI", function(module, exports) {
    $parcel$export(module.exports, "isForgeField", ()=>$15b9f0b6efc77660$export$f4484ef180517e0e);
    $parcel$export(module.exports, "getForgeFieldType", ()=>$15b9f0b6efc77660$export$3f8bcfe7fea0362a);
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $5fc53;
    const $15b9f0b6efc77660$export$f4484ef180517e0e = (field)=>field && (0, ($parcel$interopDefault($561FV)))(field, 'schema.custom') && !(0, ($parcel$interopDefault($hGgHi)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
    const $15b9f0b6efc77660$export$3f8bcfe7fea0362a = (field)=>{
        if (!$15b9f0b6efc77660$export$f4484ef180517e0e(field)) return null;
        if (false) return field.schema.type;
        return 0, (0, parcelRequire("5fc53")).FORGE_CUSTOM_FIELD_TYPE;
    };
});
parcelRegister("2ewrm", function(module, exports) {
    $parcel$export(module.exports, "useForgeGlances", ()=>$27dec4fa64c988e8$export$dc79f3e7b8a6c3e1);
    $parcel$export(module.exports, "useForgeContextPanels", ()=>$27dec4fa64c988e8$export$a1a589b738ca01b8);
    $parcel$export(module.exports, "useForgeDataComplete", ()=>$27dec4fa64c988e8$export$db75d05b888b2963);
    $parcel$export(module.exports, "useForgeCustomField", ()=>$27dec4fa64c988e8$export$2a006c08e9ab6fc3);
    $parcel$export(module.exports, "useForgeActions", ()=>$27dec4fa64c988e8$export$4f3ebb446fd03f21);
    $parcel$export(module.exports, "useForgeLoadingFailed", ()=>$27dec4fa64c988e8$export$25b2fc6a75c5447b);
    $parcel$export(module.exports, "useForgeUimModules", ()=>$27dec4fa64c988e8$export$37d5ed3ba137e5df);
    $parcel$export(module.exports, "useHasBlockedExtensions", ()=>$27dec4fa64c988e8$export$955dca49c49bfb60);
    $parcel$export(module.exports, "useBlockedExtensions", ()=>$27dec4fa64c988e8$export$61349d0d8e89be3);
    $parcel$export(module.exports, "useIsForgeDataEmpty", ()=>$27dec4fa64c988e8$export$57f2fa4b04feb8c2);
    var $5uXOq = parcelRequire("5uXOq");
    var $fr1K2 = parcelRequire("fr1K2");
    var $f7nug;
    var $dknBT;
    const $27dec4fa64c988e8$export$dc79f3e7b8a6c3e1 = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return [
            forge.issueGlance
        ];
    };
    const $27dec4fa64c988e8$export$a1a589b738ca01b8 = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return [
            forge.issueContext
        ];
    };
    const $27dec4fa64c988e8$export$db75d05b888b2963 = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return [
            forge.isForgeDataComplete
        ];
    };
    const $27dec4fa64c988e8$export$1a3a35919478733d = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return [
            [
                ...forge.customField,
                ...forge.customFieldType
            ]
        ];
    };
    const $27dec4fa64c988e8$export$2a006c08e9ab6fc3 = (extensionId)=>{
        const [customFieldExtensions] = $27dec4fa64c988e8$export$1a3a35919478733d();
        return (0, (0, parcelRequire("f7nug")).useMemoizedStateObject)((0, $5uXOq.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
            customFieldExtensions,
            extensionId
        ]));
    };
    const $27dec4fa64c988e8$export$4f3ebb446fd03f21 = ()=>{
        const [, actions] = (0, (0, parcelRequire("dknBT")).useForgeActionsStore)();
        return [
            undefined,
            actions
        ];
    };
    const $27dec4fa64c988e8$export$25b2fc6a75c5447b = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return forge.isForgeLoadingFailed;
    };
    const $27dec4fa64c988e8$export$37d5ed3ba137e5df = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return forge.uiModifications;
    };
    const $27dec4fa64c988e8$export$955dca49c49bfb60 = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return (0, $5uXOq.useMemo)(()=>forge.blockedExtensions ? Object.values((0, ($parcel$interopDefault($fr1K2)))(forge.blockedExtensions, [
                'jiraIssueViewBackgroundScript',
                'jiraUiModifications'
            ])).some((blockedExtensions)=>blockedExtensions.length > 0) : false, [
            forge.blockedExtensions
        ]);
    };
    const $27dec4fa64c988e8$export$61349d0d8e89be3 = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        return forge.blockedExtensions;
    };
    const $27dec4fa64c988e8$export$57f2fa4b04feb8c2 = ()=>{
        const [forge] = (0, (0, parcelRequire("dknBT")).useForgeStore)();
        const isExtensionsEmpty = Object.keys(forge).every((key)=>Array.isArray(forge[key]) ? forge[key].length === 0 : true);
        const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every((key)=>forge.blockedExtensions[key].length === 0);
        return isExtensionsEmpty && isBlockedExtensionsEmpty;
    };
});
parcelRegister("f7nug", function(module, exports) {
    $parcel$export(module.exports, "useMemoizedStateObject", ()=>$8c9f7903bb5ef000$export$cc725e2aa41de44a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $8c9f7903bb5ef000$export$cc725e2aa41de44a = (data, equalityCheck = (0, ($parcel$interopDefault($ajpes))))=>{
        const memoizedData = (0, $5uXOq.useRef)(data);
        return (0, $5uXOq.useMemo)(()=>{
            if (!equalityCheck(data, memoizedData.current)) {
                memoizedData.current = data;
                return data;
            }
            return memoizedData.current;
        }, [
            data,
            equalityCheck
        ]);
    };
});
parcelRegister("dknBT", function(module, exports) {
    $parcel$export(module.exports, "useForgeStore", ()=>$2746553070b63d5f$export$10f3118dc1498dfc);
    $parcel$export(module.exports, "useForgeActionsStore", ()=>$2746553070b63d5f$export$7dd6be1114d73937);
    $parcel$export(module.exports, "ForceStoreContainer", ()=>$2746553070b63d5f$export$540c057b33607be9);
    var $7JoAD = parcelRequire("7JoAD");
    var $e1HQk;
    const $2746553070b63d5f$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        name: 'issue-view-layout-forge-apps-service',
        initialState: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: [],
            activeAction: null,
            uiModifications: [],
            isForgeLoadingFailed: false,
            isForgeDataComplete: false,
            blockedExtensions: {
                issueGlance: [],
                issueContext: [],
                issueAction: [],
                issuePanel: [],
                issueActivity: [],
                customField: [],
                issueViewBackgroundScript: [],
                customFieldType: [],
                uiModifications: []
            },
            forgeRateLimitedUntil: 0,
            failedEventsCount: 0
        },
        actions: (0, parcelRequire("e1HQk"))
    });
    const $2746553070b63d5f$export$10f3118dc1498dfc = (0, $7JoAD.createHook)($2746553070b63d5f$export$6f57813fe9f31bf9);
    const $2746553070b63d5f$export$7dd6be1114d73937 = (0, $7JoAD.createHook)($2746553070b63d5f$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $2746553070b63d5f$export$540c057b33607be9 = (0, $7JoAD.createContainer)($2746553070b63d5f$export$6f57813fe9f31bf9);
});
parcelRegister("e1HQk", function(module, exports) {
    $parcel$export(module.exports, "setForge", ()=>$02561657ceb6a564$export$8307a9da1b91b3b4);
    $parcel$export(module.exports, "setForgeLoadingFailed", ()=>$02561657ceb6a564$export$7ff580b28fd472d0);
    $parcel$export(module.exports, "setFailedEventsCount", ()=>$02561657ceb6a564$export$2c9ac2591e62f664);
    $parcel$export(module.exports, "isForgeRateLimited", ()=>$02561657ceb6a564$export$161809ef1d8417c5);
    var $6oFik;
    const $02561657ceb6a564$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
            setState(forge);
        };
    const $02561657ceb6a564$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
            setState({
                isForgeLoadingFailed: true
            });
        };
    const $02561657ceb6a564$export$2c9ac2591e62f664 = (param)=>({ setState: setState, getState: getState })=>{
            if (typeof param === 'function') {
                const currentFailedEventsCount = getState().failedEventsCount;
                const result = param(currentFailedEventsCount);
                setState({
                    failedEventsCount: result,
                    forgeRateLimitedUntil: (0, (0, parcelRequire("6oFik")).calculateRateLimitedUntil)(result)
                });
                return;
            }
            setState({
                failedEventsCount: param,
                forgeRateLimitedUntil: (0, (0, parcelRequire("6oFik")).calculateRateLimitedUntil)(param)
            });
        };
    const $02561657ceb6a564$export$161809ef1d8417c5 = ()=>({ getState: getState })=>{
            const state = getState();
            const throttleTime = state.forgeRateLimitedUntil - Date.now();
            return throttleTime > 0;
        };
});
parcelRegister("6oFik", function(module, exports) {
    $parcel$export(module.exports, "calculateRateLimitedUntil", ()=>$6bec126d11da12eb$export$d47414e51d623595);
    const $6bec126d11da12eb$export$565f18fa3aa433b0 = [
        0,
        3,
        8,
        21
    ];
    function $6bec126d11da12eb$export$d47414e51d623595(failedEventsCount) {
        const currentDate = new Date();
        const gap = $6bec126d11da12eb$export$565f18fa3aa433b0[Math.min($6bec126d11da12eb$export$565f18fa3aa433b0.length - 1, failedEventsCount)];
        return gap ? new Date(currentDate.getTime() + gap * 1000).getTime() : 0;
    }
});
const $f17db2727085e590$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
parcelRegister("vuOaC", function(module, exports) {
    $parcel$export(module.exports, "getPanels", ()=>$61748c84e0a1e553$export$be078297eeb6e8a2);
    $parcel$export(module.exports, "isEmpty", ()=>$61748c84e0a1e553$export$dd1bc94b04021eeb);
    $parcel$export(module.exports, "getAtlassianCustomFieldType", ()=>$61748c84e0a1e553$export$f521834fc2bfcd81);
    $parcel$export(module.exports, "fieldTypeHandler", ()=>$61748c84e0a1e553$export$b2cc0ead6ce019e3);
    $parcel$export(module.exports, "getFieldType", ()=>$61748c84e0a1e553$export$b9089a6e41ed43aa);
    $parcel$export(module.exports, "addGlobalRefToLayoutContainerTemplateItems", ()=>$61748c84e0a1e553$export$fa197d31f946730e);
    $parcel$export(module.exports, "isUnsupportedItem", ()=>$61748c84e0a1e553$export$3d38168d24278ebb);
    var $8LQ84 = parcelRequire("8LQ84");
    var $hGgHi = parcelRequire("hGgHi");
    var $1QOns = parcelRequire("1QOns");
    var $aIZdc;
    var $co1wz;
    var $41gqO;
    var $cUUmI;
    var $fOGZN;
    var $cNJ33;
    var $5fc53;
    const $61748c84e0a1e553$export$272b07e3e852ec4 = [
        (0, (0, parcelRequire("5fc53")).ASSET_ONBOARDING_TYPE),
        (0, (0, parcelRequire("5fc53")).DEV_SUMMARY_TYPE),
        (0, (0, parcelRequire("5fc53")).KNOWLEDGE_BASE_TYPE),
        (0, (0, parcelRequire("5fc53")).SENTIMENT_TYPE),
        (0, (0, parcelRequire("5fc53")).SLA_PANEL_TYPE)
    ];
    const $61748c84e0a1e553$export$be078297eeb6e8a2 = ()=>[
            ...$61748c84e0a1e553$export$272b07e3e852ec4,
            (0, (0, parcelRequire("5fc53")).LINKED_ALERTS_TYPE),
            ...(0, (0, parcelRequire("aIZdc")).isFedRamp)() ? [] : [
                (0, (0, parcelRequire("5fc53")).CHAT_CHANNEL_TYPE)
            ],
            ...(0, (0, parcelRequire("aIZdc")).isFedRamp)() ? [] : [
                (0, (0, parcelRequire("5fc53")).MSTEAMS_CHANNEL_TYPE)
            ],
            ...(0, (0, parcelRequire("aIZdc")).isFedRamp)() ? [] : [
                (0, (0, parcelRequire("5fc53")).ZOOM_MEETING_TYPE)
            ],
            (0, (0, parcelRequire("5fc53")).MANAGE_STAKEHOLDERS_TYPE),
            ...(0, (0, parcelRequire("co1wz")).ff)('hide-icc-for-all-users_avyh5') ? [] : [
                (0, (0, parcelRequire("5fc53")).CONFERENCE_CALL_TYPE)
            ]
        ];
    const $61748c84e0a1e553$export$dd1bc94b04021eeb = (value)=>(0, ($parcel$interopDefault($hGgHi)))(value) || (0, ($parcel$interopDefault($8LQ84)))(value) && value.length === 0 || (0, ($parcel$interopDefault($1QOns)))(value) && Object.keys(value).length === 0 || (0, ($parcel$interopDefault($1QOns)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
    const $61748c84e0a1e553$var$atlassianSystemCFTypes = ()=>{
        const customSystemFields = (0, (0, parcelRequire("fOGZN")).specialFields)();
        return [
            ...(0, (0, parcelRequire("fOGZN")).customFieldsToDisplay)().filter((cf)=>!(0, (0, parcelRequire("fOGZN")).ecosystemCustomFields).includes(cf)),
            ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
            (0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE)
        ];
    };
    const $61748c84e0a1e553$export$f521834fc2bfcd81 = (custom)=>$61748c84e0a1e553$var$atlassianSystemCFTypes().find((type)=>type === custom);
    const $61748c84e0a1e553$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
        const id = (0, (0, parcelRequire("cNJ33")).getLayoutItemId)(layoutItem);
        const { type: type } = layoutItem;
        if (type === (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).tab || type === (0, (0, parcelRequire("5fc53")).ECOSYSTEM_GLANCE_TYPE) || type === (0, (0, parcelRequire("5fc53")).FORGE_GLANCE_TYPE) || type === (0, (0, parcelRequire("5fc53")).ECOSYSTEM_CONTEXT_TYPE) || type === (0, (0, parcelRequire("41gqO")).FORGE_CONTEXT_TYPE)) return {
            type: type,
            id: id
        };
        if ($61748c84e0a1e553$export$be078297eeb6e8a2().includes(id)) return {
            id: id,
            type: id
        };
        const forgeCustomField = (0, (0, parcelRequire("cUUmI")).getForgeFieldType)(fieldConfig);
        if (forgeCustomField !== null) return {
            type: forgeCustomField,
            id: id
        };
        const fieldSchema = fieldConfig?.schema || {};
        const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
        return {
            type: $61748c84e0a1e553$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
            id: id
        };
    };
    const $61748c84e0a1e553$export$b9089a6e41ed43aa = (field)=>{
        const fieldSchema = field ? field.schema : undefined;
        return fieldSchema ? $61748c84e0a1e553$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
    };
    const $61748c84e0a1e553$var$fieldsWithGlobalTargets = [
        (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE)
    ];
    const $61748c84e0a1e553$export$fa197d31f946730e = (items, issueFieldsConfig)=>{
        if (!items || !issueFieldsConfig) return [];
        return items.map((item)=>{
            const { type: type, id: id } = $61748c84e0a1e553$export$b2cc0ead6ce019e3(issueFieldsConfig[(0, (0, parcelRequire("cNJ33")).getLayoutItemId)(item)], item);
            if ($61748c84e0a1e553$var$fieldsWithGlobalTargets.includes(type)) return {
                ...item,
                globalRef: `${0, $135ded4f9a1460dc$export$2028cf1423b28cf8}${id}`
            };
            return item;
        });
    };
    const $61748c84e0a1e553$var$BASE_SUPPORTED_ITEMS = {
        [(0, (0, parcelRequire("5fc53")).ECOSYSTEM_GLANCE_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).FORGE_GLANCE_TYPE)]: true,
        [(0, (0, parcelRequire("41gqO")).FORGE_CONTEXT_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ECOSYSTEM_CONTEXT_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).EPIC_STATUS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).EPIC_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).PARTICIPANTS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).APPROVALS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).REQUEST_PARTICIPANTS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).APPROVERS_LIST_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).READ_ONLY_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).FORGE_CUSTOM_FIELD_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).KNOWLEDGE_BASE_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).SLA_PANEL_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).SENTIMENT_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).RELEASES_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ASSET_ONBOARDING_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).LINKED_ALERTS_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).CHAT_CHANNEL_TYPE)]: !false && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(),
        [(0, (0, parcelRequire("5fc53")).MSTEAMS_CHANNEL_TYPE)]: !false && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(),
        [(0, (0, parcelRequire("5fc53")).ZOOM_MEETING_TYPE)]: !false && !(0, (0, parcelRequire("aIZdc")).isFedRamp)(),
        [(0, (0, parcelRequire("5fc53")).MANAGE_STAKEHOLDERS_TYPE)]: !false,
        [(0, (0, parcelRequire("5fc53")).CONFERENCE_CALL_TYPE)]: !false && !(0, (0, parcelRequire("co1wz")).ff)('hide-icc-for-all-users_avyh5'),
        [(0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MAJOR_INCIDENT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).MESSAGE_VIEW_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: true,
        [(0, (0, parcelRequire("5fc53")).ORGANIZATION_CF_TYPE)]: true
    };
    const $61748c84e0a1e553$export$3d38168d24278ebb = (type)=>!$61748c84e0a1e553$var$BASE_SUPPORTED_ITEMS[type];
});
parcelRegister("cNJ33", function(module, exports) {
    $parcel$export(module.exports, "getLayoutItemId", ()=>$0c6b6ff40aad7732$export$fec1c0749fa149f4);
    $parcel$export(module.exports, "filterOutItemsWithProvidedIds", ()=>$0c6b6ff40aad7732$export$355607dae809ec65);
    var $41gqO;
    const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
        switch(layoutItem.type){
            case (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).field:
                return layoutItem.fieldItemId;
            case (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).panel:
                return layoutItem.panelItemId;
            case (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).tab:
                return layoutItem.tabContainerId;
            default:
                return layoutItem.id;
        }
    };
    const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
        const filteredOutIdsSet = new Set(idsToBeFilteredOut);
        return items.filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item))).map((item)=>{
            if (item.type === (0, (0, parcelRequire("41gqO")).layoutContainerItemTypes).tab && item.items?.nodes) return {
                ...item,
                items: {
                    nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
                }
            };
            return item;
        });
    };
});
parcelRegister("17Gip", function(module, exports) {
    $parcel$export(module.exports, "useProjectPermissions", ()=>$0b32a3d32d712870$export$c6c6b35628cf47a8);
    $parcel$export(module.exports, "useCanAdministerProject", ()=>$0b32a3d32d712870$export$f39ed5a161efa614);
    $parcel$export(module.exports, "useCanAdministerJira", ()=>$0b32a3d32d712870$export$ec12ddafd19b95ac);
    $parcel$export(module.exports, "useCanConfigureIssue", ()=>$0b32a3d32d712870$export$e7267b8a084eadb3);
    $parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", ()=>$0b32a3d32d712870$export$756d7c97077a2f76);
    $parcel$export(module.exports, "useProjectPermissionsActions", ()=>$0b32a3d32d712870$export$86c656cdb87052cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $khL17;
    const $0b32a3d32d712870$export$c6c6b35628cf47a8 = (projectKey)=>{
        const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectPermissions: setProjectPermissions
            }), [
            setProjectPermissions
        ]);
        return [
            permissions,
            actions
        ];
    };
    const $0b32a3d32d712870$export$f39ed5a161efa614 = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canAdministerProject;
    };
    const $0b32a3d32d712870$export$ec12ddafd19b95ac = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canAdministerJira;
    };
    const $0b32a3d32d712870$export$e7267b8a084eadb3 = (projectKey)=>{
        const canConfigureAdministerProject = $0b32a3d32d712870$export$f39ed5a161efa614(projectKey);
        const canAdministerJira = $0b32a3d32d712870$export$ec12ddafd19b95ac(projectKey);
        return canConfigureAdministerProject || canAdministerJira;
    };
    const $0b32a3d32d712870$export$756d7c97077a2f76 = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
    };
    const $0b32a3d32d712870$export$86c656cdb87052cd = ()=>{
        const [, { setProjectPermissions: setProjectPermissions }] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectPermissions: setProjectPermissions
            }), [
            setProjectPermissions
        ]);
        return [
            null,
            actions
        ];
    };
});
parcelRegister("khL17", function(module, exports) {
    $parcel$export(module.exports, "defaultPermissions", ()=>$472e428a487a401f$export$ccfee65526b322ca);
    $parcel$export(module.exports, "useProjectPermissionsStore", ()=>$472e428a487a401f$export$4919fa09a3d81224);
    $parcel$export(module.exports, "useProjectPermissionsStoreActions", ()=>$472e428a487a401f$export$e8436ef485b33bdb);
    var $7JoAD = parcelRequire("7JoAD");
    var $l5qXF;
    const $472e428a487a401f$export$ccfee65526b322ca = {
        canAddComments: false,
        canAdministerJira: false,
        canAdministerProject: false,
        canAssignIssues: false,
        canBeAssignedToIssues: false,
        canCloneIssue: false,
        canCreateAttachments: false,
        canCreateChildren: false,
        canCreateSubtask: false,
        canDeleteAllAttachments: false,
        canDeleteAllComments: false,
        canDeleteAllWorklogs: false,
        canDeleteIssue: false,
        canDeleteOwnAttachments: false,
        canDeleteOwnComments: false,
        canDeleteOwnWorklogs: false,
        canEditAllComments: false,
        canEditAllWorklogs: false,
        canEditIssues: false,
        canEditOwnComments: false,
        canEditOwnWorklogs: false,
        canLinkIssues: false,
        canLogWork: false,
        canManageWatchers: false,
        canMoveIssue: false,
        canModifyReporter: false,
        canScheduleIssues: false,
        canUseServiceDeskAgentFeatures: false,
        canBrowseUsers: false,
        canViewDevTools: false,
        canViewWatchers: false,
        canViewVoters: false,
        canCreateIssuesInClassicProjectEpic: false,
        canResolveIssues: false,
        canExportIssue: false,
        canArchiveIssue: false,
        canUnarchiveIssue: false
    };
    const $472e428a487a401f$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        name: 'project-permissions',
        initialState: {},
        actions: (0, parcelRequire("l5qXF"))
    });
    const $472e428a487a401f$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $472e428a487a401f$export$ccfee65526b322ca;
    const $472e428a487a401f$export$4919fa09a3d81224 = (0, $7JoAD.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
        selector: $472e428a487a401f$var$getProjectPermissionSelector
    });
    const $472e428a487a401f$export$e8436ef485b33bdb = (0, $7JoAD.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("l5qXF", function(module, exports) {
    $parcel$export(module.exports, "setProjectPermissions", ()=>$f3418fe5fb58759f$export$53f5cc27627e5fe3);
    const $f3418fe5fb58759f$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
            setState({
                [projectKey]: permissions
            });
        };
});
parcelRegister("gYUjk", function(module, exports) {
    $parcel$export(module.exports, "issueViewBackgroundScriptsSelector", ()=>$e729124ed69c9647$export$eef935056c1a5112);
    $parcel$export(module.exports, "issueContentPanelsSelector", ()=>$e729124ed69c9647$export$80fcdb58a34c02a8);
    $parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", ()=>$e729124ed69c9647$export$7d77b0f1f3d84166);
    $parcel$export(module.exports, "canInstallAddonsSelector", ()=>$e729124ed69c9647$export$779e1275bbd7ba59);
    $parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", ()=>$e729124ed69c9647$export$528e2c054f1a65f6);
    $parcel$export(module.exports, "contextPanelEntitiesSelector", ()=>$e729124ed69c9647$export$830512515d42357);
    $parcel$export(module.exports, "glancesSelector", ()=>$e729124ed69c9647$export$d73d3447fc053be);
    $parcel$export(module.exports, "ecosystemGlancesSelector", ()=>$e729124ed69c9647$export$df7140249f849373);
    $parcel$export(module.exports, "glancePanelSelector", ()=>$e729124ed69c9647$export$e8938da368c7c5c4);
    $parcel$export(module.exports, "allContentPanelsSelector", ()=>$e729124ed69c9647$export$7bc028a03185fc96);
    $parcel$export(module.exports, "ecosystemAllPanelsSelector", ()=>$e729124ed69c9647$export$47d3fa7df862ae6f);
    $parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", ()=>$e729124ed69c9647$export$a48c28ad36cb708e);
    $parcel$export(module.exports, "selectedContentPanelSelector", ()=>$e729124ed69c9647$export$1a9c93efcb1ffec7);
    $parcel$export(module.exports, "operationsSelector", ()=>$e729124ed69c9647$export$5244c0030b3a418e);
    $parcel$export(module.exports, "ecosystemOperationsSelector", ()=>$e729124ed69c9647$export$5d88ae12b2751fc1);
    $parcel$export(module.exports, "activityPanelsSelector", ()=>$e729124ed69c9647$export$dd6c9850f9e61a72);
    $parcel$export(module.exports, "ecosystemActivityPanelsSelector", ()=>$e729124ed69c9647$export$9222e43f5478367f);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $183uB = parcelRequire("183uB");
    var $rgIDe;
    var $eOKTW;
    var $awmXl;
    var $a2FgJ;
    var $a1ky2;
    var $bcoYn;
    var $hKi22;
    var $4L22Y;
    var $lMzxr;
    const $e729124ed69c9647$export$eef935056c1a5112 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), (forge)=>forge.backgroundScripts || []);
    const $e729124ed69c9647$export$80fcdb58a34c02a8 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.issueContentPanels || []);
    const $e729124ed69c9647$export$7d77b0f1f3d84166 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $ad485f85fe233a83$export$bdafa6b589be8b30)));
    const $e729124ed69c9647$export$779e1275bbd7ba59 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
    const $e729124ed69c9647$export$528e2c054f1a65f6 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
    const $e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
    const $e729124ed69c9647$var$glanceEntitiesSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
    const $e729124ed69c9647$export$830512515d42357 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
    const $e729124ed69c9647$var$contentPanelsEntitiesSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
    const $e729124ed69c9647$var$activityPanelsEntitiesSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>$e729124ed69c9647$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels));
    const $e729124ed69c9647$export$7fec16e3d5cd5f4e = (selector)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), selector, (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
    const $e729124ed69c9647$export$d73d3447fc053be = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
                appKey: entity.appKey,
                moduleKey: entity.moduleKey,
                name: entity.name,
                icon: entity.icon && entity.icon.url && {
                    url: entity.icon.url
                },
                label: entity.label,
                status: entity.status,
                type: entity.type,
                glanceType: (0, (0, parcelRequire("awmXl")).CONNECT_ENTITY_TYPE)
            }))));
    const $e729124ed69c9647$export$df7140249f849373 = (0, $dGvGJ.createSelector)([
        (0, (0, parcelRequire("lMzxr")).forgeGlancesSelector),
        $e729124ed69c9647$export$d73d3447fc053be
    ], (forge, connect)=>[
            ...forge,
            ...connect
        ]);
    const $e729124ed69c9647$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
    const $e729124ed69c9647$export$7bc028a03185fc96 = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
    const $e729124ed69c9647$export$47d3fa7df862ae6f = (0, $dGvGJ.createSelector)([
        (0, (0, parcelRequire("lMzxr")).forgePanelsSelector),
        $e729124ed69c9647$export$7bc028a03185fc96
    ], (forge, connect)=>[
            ...forge,
            ...connect
        ]);
    const $e729124ed69c9647$var$panelsComparator = (firstPanel, secondPanel)=>{
        if (firstPanel.type === (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE)) {
            const firstValue = firstPanel.dateAdded || 1;
            if (secondPanel.type === (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE)) {
                const secondValue = secondPanel.dateAdded || 1;
                return firstValue - secondValue;
            }
            return firstValue;
        }
        return Infinity;
    };
    const $e729124ed69c9647$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels.map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$e729124ed69c9647$var$panelsComparator(firstPanel[0], secondPanel[0]));
    const $e729124ed69c9647$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
        if (firstActivity.type === (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE)) {
            const firstValue = firstActivity.name.toLowerCase();
            if (secondActivity.type === (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE)) {
                const secondValue = secondActivity.name.toLowerCase();
                if (firstValue < secondValue) return -Infinity;
                if (firstValue > secondValue) return Infinity;
                return 0;
            }
            return Infinity;
        }
        return Infinity;
    };
    const $e729124ed69c9647$export$a48c28ad36cb708e = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)($e729124ed69c9647$export$80fcdb58a34c02a8, $e729124ed69c9647$export$47d3fa7df862ae6f, $e729124ed69c9647$export$7d77b0f1f3d84166, $e729124ed69c9647$export$528e2c054f1a65f6, (0, (0, parcelRequire("a1ky2")).analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
        const allPanelsToAddedPanels = allPanels.map((panel)=>{
            if (panel.type === (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE)) {
                const forgePanel = panel;
                if (!forgePanel.iconUrl) return forgePanel;
                const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
                const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, (0, parcelRequire("eOKTW")).isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                    const panelProperties = (0, (0, parcelRequire("a2FgJ")).parseForgeIssuePanel)(sPanel);
                    if (panelProperties == null) (0, (0, parcelRequire("rgIDe")).fireOperationalFailedEvent)(analyticsSource, {
                        error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                    });
                    return panelProperties && {
                        ...forgePanel,
                        dateAdded: panelProperties.added,
                        panelInstanceId: panelProperties.id
                    };
                }).filter(Boolean);
                return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
            }
            if (!customised && !newIssue) return panel;
            const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || selectedPanels.includes(`${panel.appKey}_${(0, (0, parcelRequire("a2FgJ")).removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
            return isSelected && panel;
        });
        const addedPanels = (0, ($parcel$interopDefault($183uB)))($e729124ed69c9647$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
        return addedPanels;
    }));
    const $e729124ed69c9647$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
    const $e729124ed69c9647$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, (0, parcelRequire("a2FgJ")).removeTimestamp)(moduleKey, 10)}`)));
    const $e729124ed69c9647$export$5244c0030b3a418e = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>ecosystem.operations || []));
    const $e729124ed69c9647$export$5d88ae12b2751fc1 = $e729124ed69c9647$export$7fec16e3d5cd5f4e((0, $dGvGJ.createSelector)([
        (0, (0, parcelRequire("lMzxr")).forgeIssueActionsSelector),
        $e729124ed69c9647$export$5244c0030b3a418e
    ], (forge, connect)=>[
            ...forge,
            ...connect
        ]));
    const $e729124ed69c9647$export$dd6c9850f9e61a72 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), $e729124ed69c9647$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
                name: entity.name,
                appKey: entity.appKey,
                moduleKey: entity.moduleKey,
                options: entity.options,
                type: (0, (0, parcelRequire("awmXl")).CONNECT_ENTITY_TYPE)
            })) : []);
    const $e729124ed69c9647$export$9222e43f5478367f = (0, $dGvGJ.createSelector)([
        (0, (0, parcelRequire("lMzxr")).forgeIssueActivitySelector),
        $e729124ed69c9647$export$dd6c9850f9e61a72
    ], (forge, connect)=>[
            ...forge,
            ...connect
        ].sort($e729124ed69c9647$export$b2c15e41218fc96));
});
parcelRegister("rgIDe", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$2523bd8d1139b039$export$add44f896fb31ba3);
    $parcel$export(module.exports, "fireUiActionClickedEvent", ()=>$2523bd8d1139b039$export$a645c87ca2607d94);
    $parcel$export(module.exports, "fireTrackActionSucceedEvent", ()=>$2523bd8d1139b039$export$435f030e21a120be);
    $parcel$export(module.exports, "fireOperationalActionFailedEvent", ()=>$2523bd8d1139b039$export$828a66ad00e9a886);
    $parcel$export(module.exports, "fireTrackSavedEvent", ()=>$2523bd8d1139b039$export$1dbf5d2537a38bd8);
    $parcel$export(module.exports, "fireOperationalSaveFailedEvent", ()=>$2523bd8d1139b039$export$cda76554fa8eee1d);
    $parcel$export(module.exports, "fireUiRemoveClickedEvent", ()=>$2523bd8d1139b039$export$2e4d409fc887e7e);
    $parcel$export(module.exports, "fireTrackRemovedEvent", ()=>$2523bd8d1139b039$export$daf10221407e1b30);
    $parcel$export(module.exports, "fireOperationalRemoveFailedEvent", ()=>$2523bd8d1139b039$export$d12e864ea545eb36);
    $parcel$export(module.exports, "fireUiTriggerSelectedEvent", ()=>$2523bd8d1139b039$export$4d7a3fdb2dd15cbb);
    $parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", ()=>$2523bd8d1139b039$export$c157193e598947ac);
    $parcel$export(module.exports, "fireTrackUpdateSucceedEvent", ()=>$2523bd8d1139b039$export$98e4a25792520246);
    $parcel$export(module.exports, "fireOperationalUpdateFailedEvent", ()=>$2523bd8d1139b039$export$9ee09996d253231a);
    var $k2DRb;
    var $8uOa6;
    var $9BrHy;
    var $8kVg1;
    var $hBuqR;
    const $2523bd8d1139b039$var$moduleEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION)
    });
    const $2523bd8d1139b039$var$triggerEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER)
    });
    const $2523bd8d1139b039$export$add44f896fb31ba3 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$a645c87ca2607d94 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).ACTION_CLICKED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$435f030e21a120be = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).ACTION_SUCCEED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$828a66ad00e9a886 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).ACTION_FAILED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).SAVED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$cda76554fa8eee1d = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).SAVE_FAILED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$2e4d409fc887e7e = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).REMOVE_CLICKED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$daf10221407e1b30 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).REMOVED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$d12e864ea545eb36 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).REMOVE_FAILED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$4d7a3fdb2dd15cbb = (extensionId, source, attributes)=>{
        (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
            startTime: performance.now()
        });
        return (0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).SELECTED, {
            id: $2523bd8d1139b039$var$triggerEventId,
            source: source,
            attributes: attributes
        });
    };
    const $2523bd8d1139b039$export$c157193e598947ac = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$98e4a25792520246 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).UPDATE_SUCCEED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $2523bd8d1139b039$export$9ee09996d253231a = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).UPDATE_FAILED, {
            id: $2523bd8d1139b039$var$moduleEventId,
            source: source,
            attributes: attributes
        });
});
parcelRegister("9BrHy", function(module, exports) {
    $parcel$export(module.exports, "getEventId", ()=>$10bc2a9e37d5a5bb$export$5639f6a927500d9);
    $parcel$export(module.exports, "getBrowserMetricsEventId", ()=>$10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
    $parcel$export(module.exports, "getEventActionName", ()=>$10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);
    var $k2DRb;
    var $6yg2S;
    var $hBuqR;
    const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
    const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
    const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
    const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, (0, parcelRequire("k2DRb")).SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
    const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
        const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
        return (0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
    };
    const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
    const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${eventId} ${action}`;
});
parcelRegister("eOKTW", function(module, exports) {
    $parcel$export(module.exports, "toForgeKey", ()=>$2db6ad1a44c67382$export$fef910e3c6a21573);
    $parcel$export(module.exports, "toForgeKeyWithDate", ()=>$2db6ad1a44c67382$export$4a8bc976ef8470fb);
    $parcel$export(module.exports, "toForgeKeyFromExtensionId", ()=>$2db6ad1a44c67382$export$72368b9e5ac31f04);
    $parcel$export(module.exports, "toConnectKey", ()=>$2db6ad1a44c67382$export$f1cde82a5f64810e);
    $parcel$export(module.exports, "toEcosystemKeys", ()=>$2db6ad1a44c67382$export$c9483bbc66b4fb20);
    $parcel$export(module.exports, "isForgeExtension", ()=>$2db6ad1a44c67382$export$b0ed77f2dd403096);
    $parcel$export(module.exports, "isKeyMatchPrefix", ()=>$2db6ad1a44c67382$export$75f2b72396a13fc0);
    var $k2DRb;
    const $2db6ad1a44c67382$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
    const $2db6ad1a44c67382$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
    const $2db6ad1a44c67382$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, (0, parcelRequire("k2DRb")).NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
    const $2db6ad1a44c67382$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
    const $2db6ad1a44c67382$export$c9483bbc66b4fb20 = (extensionId)=>{
        const [prefix, appId, envId, ...rest] = extensionId.split('/');
        const appKey = [
            prefix,
            appId,
            envId
        ].join('/');
        const moduleKey = rest.join('/');
        return {
            appKey: appKey,
            moduleKey: moduleKey
        };
    };
    const $2db6ad1a44c67382$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, (0, parcelRequire("k2DRb")).FORGE_FIELD_TYPE_PREFIX));
    const $2db6ad1a44c67382$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));
});
parcelRegister("a2FgJ", function(module, exports) {
    $parcel$export(module.exports, "removeTimestamp", ()=>$b16ff4531ea7aeeb$export$8144a1156e1fc1b3);
    $parcel$export(module.exports, "parseForgeIssuePanel", ()=>$b16ff4531ea7aeeb$export$a21b4e384e411f26);
    const $b16ff4531ea7aeeb$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
        const indexOfHyphen = str.lastIndexOf('-');
        const tail = str.substr(indexOfHyphen + 1);
        if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
        return str;
    };
    const $b16ff4531ea7aeeb$export$a21b4e384e411f26 = (panelKey)=>{
        const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
        if (match == null) return null;
        const [, extensionId, id, timestamp] = match;
        const added = Number(timestamp);
        return {
            extensionId: extensionId,
            id: id,
            added: added
        };
    };
});
parcelRegister("hKi22", function(module, exports) {
    $parcel$export(module.exports, "permissionsSelector", ()=>$73bbd0df9e2a988a$export$7a13e26fbaa74911);
    $parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", ()=>$73bbd0df9e2a988a$export$6da6e9cc5af6cc92);
    $parcel$export(module.exports, "canAdministerProjectPermissionsSelector", ()=>$73bbd0df9e2a988a$export$106fd3c30fc8b230);
    $parcel$export(module.exports, "canAdministerJiraPermissionsSelector", ()=>$73bbd0df9e2a988a$export$adf4ccad5657586d);
    $parcel$export(module.exports, "canModifyReporterPermissionsSelector", ()=>$73bbd0df9e2a988a$export$85a3c8518f632ff1);
    $parcel$export(module.exports, "canExportIssueSelector", ()=>$73bbd0df9e2a988a$export$a409252beda5dd99);
    $parcel$export(module.exports, "watchersPermissionsSelector", ()=>$73bbd0df9e2a988a$export$b3bd1cf4683807d8);
    $parcel$export(module.exports, "canViewDevToolsPermissionsSelector", ()=>$73bbd0df9e2a988a$export$dfc7b576e23ac861);
    $parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", ()=>$73bbd0df9e2a988a$export$1b79be16305d8111);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $dPSWJ = parcelRequire("dPSWJ");
    var $2vSU6;
    var $a1ky2;
    var $bcoYn;
    const $73bbd0df9e2a988a$var$internalPermissionsSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.permissions);
    const $73bbd0df9e2a988a$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
        'canUseServiceDeskAgentFeatures',
        'canEditIssues',
        'canTransitionIssues',
        'canScheduleIssues',
        'canMoveIssue',
        'canAssignIssues',
        'canBeAssignedToIssues',
        'canDeleteIssue',
        'canManageWatchers',
        'canEditAllComments',
        'canDeleteAllComments',
        'canDeleteAllAttachments',
        'canLogWork',
        'canEditOwnWorklogs',
        'canEditAllWorklogs',
        'canDeleteOwnWorklogs',
        'canDeleteAllWorklogs',
        'canResolveIssues',
        'canViewReadonlyWorkflow',
        'canCloseIssues',
        'canModifyReporter',
        'canSetIssueSecurity',
        'canArchiveIssue',
        'canUnarchiveIssue'
    ]);
    const $73bbd0df9e2a988a$export$7a13e26fbaa74911 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).appPermissionsSelector), (0, (0, parcelRequire("bcoYn")).projectTypeSelector), $73bbd0df9e2a988a$var$internalPermissionsSelector, (0, (0, parcelRequire("a1ky2")).tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
            const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
            const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
            return (0, ($parcel$interopDefault($dPSWJ)))(permissions, (hasPermission, key)=>$73bbd0df9e2a988a$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
        }
        return permissions;
    });
    const $73bbd0df9e2a988a$export$6da6e9cc5af6cc92 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
    const $73bbd0df9e2a988a$export$106fd3c30fc8b230 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
    const $73bbd0df9e2a988a$export$adf4ccad5657586d = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
    const $73bbd0df9e2a988a$var$canViewWatchersPermissionsSelector = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
    const $73bbd0df9e2a988a$var$canManageWatchersPermissionsSelector = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
    const $73bbd0df9e2a988a$export$85a3c8518f632ff1 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
    const $73bbd0df9e2a988a$export$a409252beda5dd99 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
    const $73bbd0df9e2a988a$export$b3bd1cf4683807d8 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$var$canViewWatchersPermissionsSelector, $73bbd0df9e2a988a$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
            canViewWatchers: canViewWatchers,
            canManageWatchers: canManageWatchers
        }));
    const $73bbd0df9e2a988a$export$ca6b7f39a3de4ff9 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
    const $73bbd0df9e2a988a$export$dfc7b576e23ac861 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
    const $73bbd0df9e2a988a$export$1b79be16305d8111 = (0, $dGvGJ.createSelector)($73bbd0df9e2a988a$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);
});
parcelRegister("dPSWJ", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, key, iteratee(value, key, object));
        });
        return result;
    }
    module.exports = $a12aa8fd8ab9a7da$var$mapValues;
});
const $ad485f85fe233a83$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';
parcelRegister("4L22Y", function(module, exports) {
    $parcel$export(module.exports, "ecosystemEntitiesSelector", ()=>$6d9cf82623af37b7$export$8db07a5bb000e56f);
    $parcel$export(module.exports, "forgeEntitiesSelector", ()=>$6d9cf82623af37b7$export$92b32d478f0e29fb);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $bcoYn;
    var $7G3DM;
    const $6d9cf82623af37b7$export$8db07a5bb000e56f = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.ecosystem || {});
    const $6d9cf82623af37b7$export$92b32d478f0e29fb = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.forge || (0, (0, parcelRequire("7G3DM")).initialState));
});
parcelRegister("7G3DM", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$73241870ac7c200f$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "default", ()=>$73241870ac7c200f$export$2e2bcd8739ae039);
    var $aJ8eZ;
    var $jXy0Q;
    var $akbnA;
    const $73241870ac7c200f$export$d4c72bab9d6cc13a = {
        actions: [],
        glances: [],
        issueContexts: [],
        panels: [],
        activities: [],
        customFields: [],
        customFieldTypes: [],
        backgroundScripts: [],
        activeAction: null,
        panelsKeys: {
            newPanels: [],
            collapsedPanels: []
        },
        uiModifications: []
    };
    var $73241870ac7c200f$export$2e2bcd8739ae039 = (state = $73241870ac7c200f$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("aJ8eZ")).FETCH_FORGE_SUCCESS:
                return {
                    ...state,
                    actions: action.payload.issueAction,
                    glances: action.payload.issueGlance,
                    issueContexts: action.payload.issueContext,
                    panels: action.payload.issuePanel,
                    activities: action.payload.issueActivity,
                    customFields: action.payload.customField,
                    customFieldTypes: action.payload.customFieldType,
                    backgroundScripts: action.payload.issueViewBackgroundScript,
                    activeAction: null,
                    panelsKeys: {
                        ...state.panelsKeys,
                        newPanels: []
                    },
                    uiModifications: action.payload.uiModifications
                };
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_ISSUE_ACTION_EXEC:
                return {
                    ...state,
                    activeAction: {
                        action: action.payload,
                        isLoading: true
                    }
                };
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_ISSUE_ACTION_RENDERED:
                return {
                    ...state,
                    activeAction: {
                        ...state.activeAction,
                        isLoading: false
                    }
                };
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_ISSUE_ACTION_CLOSE:
                return {
                    ...state,
                    activeAction: null
                };
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_ISSUE_PANEL_ADDED:
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        newPanels: [
                            ...state.panelsKeys.newPanels,
                            action.payload
                        ]
                    }
                };
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_NEW_ISSUE_PANEL_UNTRACK:
                {
                    const removedPanelKey = action.payload;
                    const { panelsKeys: panelsKeys } = state;
                    return {
                        ...state,
                        panelsKeys: {
                            ...panelsKeys,
                            newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                        }
                    };
                }
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_ISSUE_PANEL_REMOVED:
                {
                    const removedPanelKey = action.payload;
                    return {
                        ...state,
                        panelsKeys: {
                            newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                            collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                        }
                    };
                }
            case 0, (0, parcelRequire("aJ8eZ")).FORGE_ISSUE_PANEL_UPDATED:
                {
                    const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                    const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                        ...state.panelsKeys.collapsedPanels,
                        panelKey
                    ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                    return {
                        ...state,
                        panelsKeys: {
                            ...state.panelsKeys,
                            collapsedPanels: updatedCollapsedPanels
                        }
                    };
                }
            case 0, (0, parcelRequire("akbnA")).FETCH_ISSUE_SUCCESS:
            case 0, (0, parcelRequire("akbnA")).REFRESH_ISSUE_SUCCESS:
            case 0, (0, parcelRequire("jXy0Q")).FETCH_ISSUE_REMOTE_DATA_SUCCESS:
                {
                    const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                    return {
                        ...state,
                        panelsKeys: {
                            ...state.panelsKeys,
                            collapsedPanels: Array.from(new Set([
                                ...state.panelsKeys.collapsedPanels,
                                ...collapsedPanels
                            ]))
                        }
                    };
                }
            default:
                return state;
        }
    };
});
parcelRegister("aJ8eZ", function(module, exports) {
    $parcel$export(module.exports, "FETCH_FORGE_SUCCESS", ()=>$e621a0f6e2386727$export$b40fce05e753d390);
    $parcel$export(module.exports, "fetchForgeSuccess", ()=>$e621a0f6e2386727$export$1b05a0184822bc74);
    $parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", ()=>$e621a0f6e2386727$export$8c062df60fb76839);
    $parcel$export(module.exports, "forgeIssueActionExec", ()=>$e621a0f6e2386727$export$3a189763780c504b);
    $parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", ()=>$e621a0f6e2386727$export$dd307b8c5e0de67d);
    $parcel$export(module.exports, "forgeIssueActionRendered", ()=>$e621a0f6e2386727$export$2484a0b7a9a14f92);
    $parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", ()=>$e621a0f6e2386727$export$d91b51ae909f8e95);
    $parcel$export(module.exports, "forgeIssueActionClose", ()=>$e621a0f6e2386727$export$335a03a463c5945a);
    $parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", ()=>$e621a0f6e2386727$export$7d7831d10e022e0);
    $parcel$export(module.exports, "forgeIssuePanelAdded", ()=>$e621a0f6e2386727$export$f24c609edeac582f);
    $parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", ()=>$e621a0f6e2386727$export$d36cecbf4e320d4a);
    $parcel$export(module.exports, "forgeNewIssuePanelUntrack", ()=>$e621a0f6e2386727$export$b93b979485d242c8);
    $parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", ()=>$e621a0f6e2386727$export$798e467d6a4cb5c);
    $parcel$export(module.exports, "forgeIssuePanelRemoved", ()=>$e621a0f6e2386727$export$b584e6f1797702be);
    $parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", ()=>$e621a0f6e2386727$export$bb2e005bc0498829);
    $parcel$export(module.exports, "forgeIssuePanelUpdateRequest", ()=>$e621a0f6e2386727$export$c67c4f64ec92ba7f);
    $parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", ()=>$e621a0f6e2386727$export$2ce5fe154022894b);
    $parcel$export(module.exports, "forgeIssuePanelUpdated", ()=>$e621a0f6e2386727$export$e2eebb5b364492ce);
    const $e621a0f6e2386727$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
    const $e621a0f6e2386727$export$1b05a0184822bc74 = (payload)=>({
            type: $e621a0f6e2386727$export$b40fce05e753d390,
            payload: payload
        });
    const $e621a0f6e2386727$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
    const $e621a0f6e2386727$export$3a189763780c504b = (action)=>({
            type: $e621a0f6e2386727$export$8c062df60fb76839,
            payload: action
        });
    const $e621a0f6e2386727$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
    const $e621a0f6e2386727$export$2484a0b7a9a14f92 = ()=>({
            type: $e621a0f6e2386727$export$dd307b8c5e0de67d
        });
    const $e621a0f6e2386727$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
    const $e621a0f6e2386727$export$335a03a463c5945a = ()=>({
            type: $e621a0f6e2386727$export$d91b51ae909f8e95
        });
    const $e621a0f6e2386727$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
    const $e621a0f6e2386727$export$f24c609edeac582f = (issuePanelKey)=>({
            type: $e621a0f6e2386727$export$7d7831d10e022e0,
            payload: issuePanelKey
        });
    const $e621a0f6e2386727$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
    const $e621a0f6e2386727$export$b93b979485d242c8 = (issuePanelKey)=>({
            type: $e621a0f6e2386727$export$d36cecbf4e320d4a,
            payload: issuePanelKey
        });
    const $e621a0f6e2386727$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
    const $e621a0f6e2386727$export$b584e6f1797702be = (issuePanelKey)=>({
            type: $e621a0f6e2386727$export$798e467d6a4cb5c,
            payload: issuePanelKey
        });
    const $e621a0f6e2386727$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
    const $e621a0f6e2386727$export$c67c4f64ec92ba7f = (payload)=>({
            type: $e621a0f6e2386727$export$bb2e005bc0498829,
            payload: payload
        });
    const $e621a0f6e2386727$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
    const $e621a0f6e2386727$export$e2eebb5b364492ce = (payload)=>({
            type: $e621a0f6e2386727$export$2ce5fe154022894b,
            payload: payload
        });
});
parcelRegister("jXy0Q", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", ()=>$6d3151fa7c469cff$export$d8a6e69b46d6d184);
    $parcel$export(module.exports, "fetchIssueRemoteDataRequest", ()=>$6d3151fa7c469cff$export$222125e4e0f166e4);
    $parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", ()=>$6d3151fa7c469cff$export$2cdd723fc40cdd47);
    $parcel$export(module.exports, "fetchIssueRemoteDataSuccess", ()=>$6d3151fa7c469cff$export$615a2d29b149df95);
    $parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", ()=>$6d3151fa7c469cff$export$396f0d977db541d9);
    $parcel$export(module.exports, "fetchIssueRemoteDataFailure", ()=>$6d3151fa7c469cff$export$f7fd18472eaf2b77);
    const $6d3151fa7c469cff$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
    const $6d3151fa7c469cff$export$222125e4e0f166e4 = (issueKey)=>({
            type: $6d3151fa7c469cff$export$d8a6e69b46d6d184,
            payload: issueKey
        });
    const $6d3151fa7c469cff$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
    const $6d3151fa7c469cff$export$615a2d29b149df95 = (entities)=>({
            type: $6d3151fa7c469cff$export$2cdd723fc40cdd47,
            payload: entities
        });
    const $6d3151fa7c469cff$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
    const $6d3151fa7c469cff$export$f7fd18472eaf2b77 = ()=>({
            type: $6d3151fa7c469cff$export$396f0d977db541d9
        });
});
parcelRegister("akbnA", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ISSUE_REQUEST", ()=>$96f907481cd25e73$export$afc8565512ebbf99);
    $parcel$export(module.exports, "fetchIssueRequest", ()=>$96f907481cd25e73$export$ff7cd1a46115d8ca);
    $parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", ()=>$96f907481cd25e73$export$c32d0e1f370b7914);
    $parcel$export(module.exports, "fetchIssueSuccess", ()=>$96f907481cd25e73$export$1e39a30e3f37e9d1);
    $parcel$export(module.exports, "FETCH_ISSUE_FAILURE", ()=>$96f907481cd25e73$export$700ca24f76d5bbe6);
    $parcel$export(module.exports, "fetchIssueFailure", ()=>$96f907481cd25e73$export$625e6e61fad65793);
    $parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", ()=>$96f907481cd25e73$export$b48f53bf5b842d57);
    $parcel$export(module.exports, "refreshIssueRequest", ()=>$96f907481cd25e73$export$ccd0db94940d9159);
    $parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", ()=>$96f907481cd25e73$export$6b6ca6acd76420d1);
    $parcel$export(module.exports, "cancelRefreshIssueRequest", ()=>$96f907481cd25e73$export$a7629a657f902cbc);
    $parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", ()=>$96f907481cd25e73$export$de11c913f06a7952);
    $parcel$export(module.exports, "refreshIssueSuccess", ()=>$96f907481cd25e73$export$cbd1c08fb706639c);
    $parcel$export(module.exports, "FETCH_FORGE_REQUEST", ()=>$96f907481cd25e73$export$36b76b7384d868f3);
    $parcel$export(module.exports, "fetchForgeRequest", ()=>$96f907481cd25e73$export$6ce2430992033a55);
    const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
    const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
            type: $96f907481cd25e73$export$afc8565512ebbf99
        });
    const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
    const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
            type: $96f907481cd25e73$export$c32d0e1f370b7914,
            payload: entities
        });
    const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
    const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
            type: $96f907481cd25e73$export$700ca24f76d5bbe6,
            payload: failureDescription
        });
    const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
    const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
            type: $96f907481cd25e73$export$b48f53bf5b842d57,
            payload: payload,
            meta: meta
        });
    const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
    const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
            type: $96f907481cd25e73$export$6b6ca6acd76420d1
        });
    const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
    const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
            type: $96f907481cd25e73$export$de11c913f06a7952,
            payload: entities
        });
    const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
    const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
            type: $96f907481cd25e73$export$36b76b7384d868f3
        });
});
parcelRegister("lMzxr", function(module, exports) {
    $parcel$export(module.exports, "forgeContextPanelsSelector", ()=>$98da256956b02977$export$94c701814d50fed3);
    $parcel$export(module.exports, "forgeGlancesSelector", ()=>$98da256956b02977$export$92747468cb57714e);
    $parcel$export(module.exports, "forgeUiModificationsSelector", ()=>$98da256956b02977$export$325ea69d1eb5eda0);
    $parcel$export(module.exports, "forgeIssueActionsSelector", ()=>$98da256956b02977$export$9bcd40b01af57823);
    $parcel$export(module.exports, "forgePanelsSelector", ()=>$98da256956b02977$export$ca115d43abfd7206);
    $parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", ()=>$98da256956b02977$export$ae25fce59e44b253);
    $parcel$export(module.exports, "forgeJustAddedPanelSelector", ()=>$98da256956b02977$export$9c375a0b9a6e5017);
    $parcel$export(module.exports, "forgeActiveIssueActionSelector", ()=>$98da256956b02977$export$ccad5f28efcec42d);
    $parcel$export(module.exports, "forgeIssueDataSelector", ()=>$98da256956b02977$export$d3cd515b7639ce61);
    $parcel$export(module.exports, "forgeIssueActivitySelector", ()=>$98da256956b02977$export$18ce84b90b4920eb);
    $parcel$export(module.exports, "isForgePanelNewToIssueSelector", ()=>$98da256956b02977$export$97dadedc102bebdf);
    $parcel$export(module.exports, "getForgeIssuePanel", ()=>$98da256956b02977$export$b01f1fc9eba6d8cd);
    $parcel$export(module.exports, "forgeIsCollapsedPanelSelector", ()=>$98da256956b02977$export$3d7856e5c65d2291);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $hGgHi = parcelRequire("hGgHi");
    var $4R6GH;
    var $awp3q;
    var $eOKTW;
    var $dvdr4;
    var $5cmSg;
    var $41gqO;
    var $awmXl;
    var $a2FgJ;
    var $g5X3G;
    var $a1ky2;
    var $7Ow8a;
    var $bcoYn;
    var $hKi22;
    var $lssfC;
    var $4L22Y;
    const $98da256956b02977$var$filterExtensions = (list, staticContext)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            (0, (0, parcelRequire("dvdr4")).checkDisplayConditionsConsistency)(list, staticContext, 'issue-view-filter-extensions');
            return list.filter((0, (0, parcelRequire("5cmSg")).isExtensionVisible));
        }
        return list.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, staticContext));
    };
    const $98da256956b02977$var$sortIssuePanels = (first, second)=>{
        if (first.name === second.name) return 0;
        return first.name > second.name ? 1 : -1;
    };
    const $98da256956b02977$export$b302c9df74ede99a = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (0, (0, parcelRequire("a1ky2")).issueIdSelector), (0, (0, parcelRequire("a1ky2")).issueKeySelector), (0, (0, parcelRequire("lssfC")).issueTypeNameSelector), (0, (0, parcelRequire("bcoYn")).projectIdSelector), (0, (0, parcelRequire("a1ky2")).projectKeySelector), (0, (0, parcelRequire("bcoYn")).projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
            issueId: issueId || null,
            issueKey: issueKey,
            issueType: issueType,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType || null,
            canAddComments: permissions.canAddComments,
            canAdministerJira: permissions.canAdministerJira,
            canAdministerProjects: permissions.canAdministerProject,
            canArchiveIssue: permissions.canArchiveIssue,
            canAssignIssues: permissions.canAssignIssues,
            canBeAssignedToIssues: permissions.canBeAssignedToIssues,
            canCloneIssues: permissions.canCloneIssue,
            canCreateAttachments: permissions.canCreateAttachments,
            canCreateChildren: permissions.canCreateChildren,
            canCreateSubtasks: permissions.canCreateSubtask,
            canDeleteAllAttachments: permissions.canDeleteAllAttachments,
            canDeleteAllComments: permissions.canDeleteAllComments,
            canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
            canDeleteIssues: permissions.canDeleteIssue,
            canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
            canDeleteOwnComments: permissions.canDeleteOwnComments,
            canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
            canEditAllComments: permissions.canEditAllComments,
            canEditAllWorklogs: permissions.canEditAllWorklogs,
            canEditIssues: permissions.canEditIssues,
            canEditOwnComments: permissions.canEditOwnComments,
            canEditOwnWorklogs: permissions.canEditOwnWorklogs,
            canLinkIssues: permissions.canLinkIssues,
            canLogWork: permissions.canLogWork,
            canManageWatchers: permissions.canManageWatchers,
            canModifyReporters: permissions.canModifyReporter,
            canMoveIssues: permissions.canMoveIssue,
            canScheduleIssues: permissions.canScheduleIssues,
            canUnarchiveIssue: permissions.canUnarchiveIssue,
            canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
            canBrowseUsers: permissions.canBrowseUsers,
            canViewDevTools: permissions.canViewDevTools,
            canViewWatchers: permissions.canViewWatchers,
            canExportIssue: permissions.canExportIssue
        }));
    const $98da256956b02977$export$94c701814d50fed3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) (0, (0, parcelRequire("dvdr4")).checkDisplayConditionsConsistency)(forge.issueContexts, issueViewStaticContext, 'context-panels-selector');
        return forge.issueContexts.filter((extension)=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5cmSg")).isExtensionVisible)(extension) : (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, issueViewStaticContext)).map((contextPanels)=>{
            const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
            return {
                id: id,
                type: (0, (0, parcelRequire("41gqO")).FORGE_CONTEXT_TYPE),
                payload: {
                    type: (0, (0, parcelRequire("41gqO")).FORGE_CONTEXT_TYPE),
                    label: label,
                    name: title,
                    status: status || null,
                    icon: url ? {
                        url: url
                    } : null,
                    contextPanelType: (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE),
                    moduleKey: id,
                    appKey: id,
                    options: null
                }
            };
        });
    });
    const $98da256956b02977$export$92747468cb57714e = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
        return $98da256956b02977$var$filterExtensions(forge.glances, issueViewStaticContext).map((extension)=>{
            const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
            return {
                title: title,
                label: label,
                status: status,
                icon: icon,
                extension: extension,
                glanceType: (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id
            };
        });
    });
    const $98da256956b02977$export$325ea69d1eb5eda0 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.uiModifications)) return [];
        return forge.uiModifications;
    });
    const $98da256956b02977$export$9bcd40b01af57823 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
        return $98da256956b02977$var$filterExtensions(forge.actions, issueViewStaticContext).map((extension)=>{
            const { id: id, properties: { title: title } } = extension;
            return {
                id: id,
                title: title,
                extension: extension,
                type: (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE)
            };
        });
    });
    const $98da256956b02977$export$ca115d43abfd7206 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
        return $98da256956b02977$var$filterExtensions(forge.panels, issueViewStaticContext).filter((extension)=>extension.properties.icon != null).map((extension)=>{
            const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
            const { appKey: appKey, moduleKey: moduleKey } = (0, (0, parcelRequire("eOKTW")).toEcosystemKeys)(id);
            return {
                name: title,
                tooltip: title,
                iconUrl: icon,
                extension: extension,
                allowMultiple: !!allowMultiple,
                showByDefault: false,
                type: (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE),
                moduleKey: moduleKey,
                appKey: appKey
            };
        }).sort($98da256956b02977$var$sortIssuePanels);
    });
    const $98da256956b02977$export$ae25fce59e44b253 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
    const $98da256956b02977$export$9c375a0b9a6e5017 = (panelKey)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
    const $98da256956b02977$export$38dd8c9ba1d48d98 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
        return $98da256956b02977$var$filterExtensions(forge.customFields, issueViewStaticContext);
    });
    const $98da256956b02977$export$9cef69a20109a92c = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
        return $98da256956b02977$var$filterExtensions(forge.customFieldTypes, issueViewStaticContext);
    });
    const $98da256956b02977$export$2f1d736b0e7e1293 = (0, $dGvGJ.createSelector)($98da256956b02977$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
    const $98da256956b02977$export$252a589d17b14921 = (0, $dGvGJ.createSelector)($98da256956b02977$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
    const $98da256956b02977$export$89b67d7e4e300f7d = (0, $dGvGJ.createSelector)($98da256956b02977$export$2f1d736b0e7e1293, $98da256956b02977$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
    const $98da256956b02977$export$e824cf91ff446be9 = (0, $dGvGJ.createSelector)($98da256956b02977$export$38dd8c9ba1d48d98, $98da256956b02977$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
            ...customFields,
            ...customFieldTypes
        ]);
    const $98da256956b02977$export$ccad5f28efcec42d = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
        if (!isEcosystemEnabled) return null;
        return forge.activeAction || null;
    });
    const $98da256956b02977$export$e04b25b621339356 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("7Ow8a")).fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
    const $98da256956b02977$export$fbab82209930cdab = (0, $dGvGJ.createSelector)($98da256956b02977$export$e824cf91ff446be9, $98da256956b02977$export$e04b25b621339356, (forgeFields, extensionId)=>{
        const extension = forgeFields.find((field)=>field.id === extensionId);
        return extension || null;
    });
    const $98da256956b02977$export$c9095ffee4d5bbc0 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$e04b25b621339356, $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, extensionId, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.customFields) || !Array.isArray(forge.customFieldTypes)) return false;
        const extension = [
            ...forge.customFields,
            ...forge.customFieldTypes
        ].find((field)=>field.id === extensionId);
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            if (extension) (0, (0, parcelRequire("dvdr4")).checkDisplayConditionsConsistency)([
                extension
            ], issueViewStaticContext, 'is-custom-field-filtered-store');
            return !extension ? false : !(0, (0, parcelRequire("5cmSg")).isExtensionVisible)(extension);
        }
        return !extension ? false : !(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, issueViewStaticContext);
    });
    const $98da256956b02977$export$7640f867620fe598 = (0, $dGvGJ.createSelector)($98da256956b02977$export$fbab82209930cdab, (extension)=>{
        if (!extension) return false;
        const hasRenderingFunction = !(0, ($parcel$interopDefault($hGgHi)))(extension.properties.function);
        const hasFormatterDefined = !(0, ($parcel$interopDefault($hGgHi)))(extension.properties.formatter);
        return !hasRenderingFunction && hasFormatterDefined;
    });
    const $98da256956b02977$export$d3cd515b7639ce61 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).issueKeySelector), (0, (0, parcelRequire("a1ky2")).issueIdSelector), (0, (0, parcelRequire("lssfC")).issueTypeIdSelector), (0, (0, parcelRequire("lssfC")).issueTypeNameSelector), (0, (0, parcelRequire("a1ky2")).projectKeySelector), (0, (0, parcelRequire("bcoYn")).projectIdSelector), (0, (0, parcelRequire("bcoYn")).projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
            issue: {
                key: issueKey,
                id: issueId,
                type: issueType,
                typeId: issueTypeId
            },
            project: {
                id: projectId !== null ? (0, (0, parcelRequire("g5X3G")).toProjectId)(projectId.toString()) : projectId,
                key: projectKey,
                type: projectType
            }
        }));
    const $98da256956b02977$export$18ce84b90b4920eb = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isEcosystemEnabledSelector), (0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), $98da256956b02977$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
        if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
        return $98da256956b02977$var$filterExtensions(forge.activities, issueViewStaticContext).map((extension)=>{
            const { id: id, properties: { title: title } } = extension;
            const { appKey: appKey, moduleKey: moduleKey } = (0, (0, parcelRequire("eOKTW")).toEcosystemKeys)(id);
            return {
                name: title,
                extension: extension,
                type: (0, (0, parcelRequire("awmXl")).FORGE_ENTITY_TYPE),
                moduleKey: moduleKey,
                appKey: appKey
            };
        });
    });
    const $98da256956b02977$export$97dadedc102bebdf = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
    const $98da256956b02977$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $dGvGJ.createSelector)($98da256956b02977$export$ca115d43abfd7206, (panels)=>{
            const { extensionId: extensionId } = (0, (0, parcelRequire("a2FgJ")).parseForgeIssuePanel)(forgePanelKey) || {};
            return panels.find((panel)=>extensionId === panel.extension.id);
        });
    const $98da256956b02977$export$3d7856e5c65d2291 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4L22Y")).forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));
});
parcelRegister("lssfC", function(module, exports) {
    $parcel$export(module.exports, "createFullIssueUrl", ()=>$470f41730d0b2b6c$export$f107e3172d0c8a79);
    $parcel$export(module.exports, "issueTypeSelector", ()=>$470f41730d0b2b6c$export$c5a236f192993436);
    $parcel$export(module.exports, "issueUrlSelector", ()=>$470f41730d0b2b6c$export$7855e152de23b9ca);
    $parcel$export(module.exports, "fullIssueUrlSelector", ()=>$470f41730d0b2b6c$export$14eeb219bfe6649b);
    $parcel$export(module.exports, "issueTypeNameSelector", ()=>$470f41730d0b2b6c$export$477df8db13e4dac3);
    $parcel$export(module.exports, "issueTypeHierarchyLevelSelector", ()=>$470f41730d0b2b6c$export$2bcfec06e5c80ef6);
    $parcel$export(module.exports, "issueTypeIdSelector", ()=>$470f41730d0b2b6c$export$22410768c09b3a82);
    $parcel$export(module.exports, "issueTypeIconUrlSelector", ()=>$470f41730d0b2b6c$export$4cf7e4622f7b8aee);
    $parcel$export(module.exports, "isIssueTypeFieldEditableSelector", ()=>$470f41730d0b2b6c$export$580b385a93b77724);
    $parcel$export(module.exports, "getParentIssuesSelector", ()=>$470f41730d0b2b6c$export$1e6d1c8ba22c2162);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $fOGZN;
    var $a1ky2;
    var $7Ow8a;
    var $bcoYn;
    const $470f41730d0b2b6c$var$createRelativeIssueUrl = (baseUrl, issueKey)=>`${baseUrl ? baseUrl.replace(/\/?$/, '/') : '/'}browse/${issueKey}`;
    const $470f41730d0b2b6c$export$f107e3172d0c8a79 = (baseUrl, issueKey)=>`${window.location.protocol}//${window.location.host}${$470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issueKey)}`;
    const $470f41730d0b2b6c$var$issueTypeFieldSelector = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("fOGZN")).ISSUE_TYPE));
    const $470f41730d0b2b6c$var$subtaskIssueFieldSelector = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("fOGZN")).SUBTASK_PARENT));
    const $470f41730d0b2b6c$var$portfolioParentFieldSelector = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("fOGZN")).PARENT));
    const $470f41730d0b2b6c$export$c5a236f192993436 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
    const $470f41730d0b2b6c$export$7855e152de23b9ca = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).baseUrlSelector), (0, (0, parcelRequire("a1ky2")).issueKeySelector), $470f41730d0b2b6c$var$createRelativeIssueUrl);
    const $470f41730d0b2b6c$export$14eeb219bfe6649b = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).baseUrlSelector), (0, (0, parcelRequire("a1ky2")).issueKeySelector), $470f41730d0b2b6c$export$f107e3172d0c8a79);
    const $470f41730d0b2b6c$export$477df8db13e4dac3 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
    const $470f41730d0b2b6c$export$2bcfec06e5c80ef6 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>{
        if (!issueType) return null;
        return issueType && issueType.hierarchyLevel;
    });
    const $470f41730d0b2b6c$export$22410768c09b3a82 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
    const $470f41730d0b2b6c$export$4cf7e4622f7b8aee = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
    const $470f41730d0b2b6c$export$580b385a93b77724 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
    const $470f41730d0b2b6c$var$transformParentIssue = (issue, baseUrl)=>issue ? {
            summary: issue.summary,
            key: issue.key,
            url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issue.key),
            issueTypeName: issue.issueTypeName || '',
            issueTypeIconUrl: issue.issueTypeIconUrl || ''
        } : null;
    const $470f41730d0b2b6c$var$transformSubtaskParentIssue = (issue, baseUrl)=>issue ? {
            summary: issue.fields.summary,
            key: issue.key,
            url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, issue.key),
            issueTypeName: issue.issueTypeName || '',
            issueTypeIconUrl: issue.issueTypeIconUrl || ''
        } : null;
    const $470f41730d0b2b6c$var$transformPortfolioParentIssue = (value, baseUrl)=>value && value.data ? {
            summary: value.data.summary,
            key: value.data.key,
            url: $470f41730d0b2b6c$var$createRelativeIssueUrl(baseUrl, value.data.key),
            issueTypeName: value.data.issueTypeName || '',
            issueTypeIconUrl: value.data.issueTypeIconUrl || ''
        } : null;
    const $470f41730d0b2b6c$export$77f9f02e63a0906f = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$portfolioParentFieldSelector, (0, (0, parcelRequire("a1ky2")).baseUrlSelector), (portfolioParentIssue, baseUrl)=>$470f41730d0b2b6c$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value, baseUrl));
    const $470f41730d0b2b6c$var$subtaskIssueParentSelector = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$subtaskIssueFieldSelector, (0, (0, parcelRequire("a1ky2")).baseUrlSelector), (subtaskIssue, baseUrl)=>$470f41730d0b2b6c$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value, baseUrl));
    const $470f41730d0b2b6c$var$parentIssueSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).parentIssueEntitySelector), (0, (0, parcelRequire("a1ky2")).baseUrlSelector), (parentIssue, baseUrl)=>$470f41730d0b2b6c$var$transformParentIssue(parentIssue, baseUrl));
    const $470f41730d0b2b6c$export$dfeb83ef40558422 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$parentIssueSelector, $470f41730d0b2b6c$var$subtaskIssueParentSelector, $470f41730d0b2b6c$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
    const $470f41730d0b2b6c$export$1e6d1c8ba22c2162 = (0, $dGvGJ.createSelector)($470f41730d0b2b6c$var$parentIssueSelector, (parentIssue)=>[
            parentIssue
        ].filter(Boolean));
});
parcelRegister("jMY7o", function(module, exports) {
    $parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", ()=>$67134f469e001b64$export$1e8043fccfcba3b9);
    $parcel$export(module.exports, "supportsChildCreationSelector", ()=>$67134f469e001b64$export$1af32b549149f3d9);
    $parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", ()=>$67134f469e001b64$export$be50776e2ae27cf6);
    $parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", ()=>$67134f469e001b64$export$57b3549670d3627b);
    $parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", ()=>$67134f469e001b64$export$a81bfe971074142b);
    $parcel$export(module.exports, "hierarchyLevelSelector", ()=>$67134f469e001b64$export$4f7eb1d272a8015);
    $parcel$export(module.exports, "isIssueBaseLevel", ()=>$67134f469e001b64$export$d9c73da87a448c4);
    $parcel$export(module.exports, "canLinkToParentSelector", ()=>$67134f469e001b64$export$5530450eb840ecb2);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $g4tDr;
    var $5fc53;
    var $7Ow8a;
    var $bcoYn;
    var $hKi22;
    var $6UM3P;
    const $67134f469e001b64$var$childLevelValueSelector = (0, (0, parcelRequire("7Ow8a")).fieldPersistedValueSelector)((0, (0, parcelRequire("5fc53")).HIERARCHY_LEVEL_BELOW)) || null;
    const $67134f469e001b64$var$isChildLevelSubtaskLevelSelector = (0, $dGvGJ.createSelector)($67134f469e001b64$var$childLevelValueSelector, (childLevelFieldValue)=>{
        if (!childLevelFieldValue) return false;
        return (0, (0, parcelRequire("g4tDr")).isSubtaskHierarchyLevel)(childLevelFieldValue.level);
    });
    const $67134f469e001b64$export$7a45e255c239753 = (0, $dGvGJ.createSelector)($67134f469e001b64$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
    const $67134f469e001b64$export$1e8043fccfcba3b9 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), $67134f469e001b64$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
        const allIssueTypes = entities.issueTypes;
        const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
        return allIssueTypes.filter((issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
    });
    const $67134f469e001b64$export$1af32b549149f3d9 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), $67134f469e001b64$export$7a45e255c239753, $67134f469e001b64$var$isChildLevelSubtaskLevelSelector, (0, (0, parcelRequire("bcoYn")).isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
    const $67134f469e001b64$var$parentLevelValueSelector = (0, (0, parcelRequire("7Ow8a")).fieldPersistedValueSelector)((0, (0, parcelRequire("5fc53")).HIERARCHY_LEVEL_ABOVE)) || null;
    const $67134f469e001b64$export$55a6507420d37093 = (0, $dGvGJ.createSelector)($67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
    const $67134f469e001b64$export$be50776e2ae27cf6 = (0, $dGvGJ.createSelector)($67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
    const $67134f469e001b64$export$57b3549670d3627b = (0, $dGvGJ.createSelector)($67134f469e001b64$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
    const $67134f469e001b64$export$121e4a84c99db916 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
    const $67134f469e001b64$var$sameLevelValueSelector = (0, (0, parcelRequire("7Ow8a")).fieldPersistedValueSelector)((0, (0, parcelRequire("5fc53")).HIERARCHY_LEVEL_SAME_LEVEL)) || null;
    const $67134f469e001b64$export$26996c7f0f08c0d8 = (0, $dGvGJ.createSelector)($67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
        if (!sameLevelFieldValue) return false;
        return (0, (0, parcelRequire("g4tDr")).isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
    });
    const $67134f469e001b64$export$a81bfe971074142b = (0, $dGvGJ.createSelector)($67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
    const $67134f469e001b64$export$4f7eb1d272a8015 = (0, $dGvGJ.createSelector)($67134f469e001b64$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, (0, parcelRequire("g4tDr")).toHierarchyLevel)(sameLevelFieldValue.level) : null);
    const $67134f469e001b64$export$d9c73da87a448c4 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$4f7eb1d272a8015, (level)=>{
        if (level == null) return true;
        return (0, (0, parcelRequire("g4tDr")).isBaseHierarchyLevel)(level);
    });
    const $67134f469e001b64$export$5530450eb840ecb2 = (0, $dGvGJ.createSelector)($67134f469e001b64$export$55a6507420d37093, (0, (0, parcelRequire("6UM3P")).canEditIssuesSelector), $67134f469e001b64$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);
});
parcelRegister("g4tDr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", ()=>$03dd5f7faa501890$export$2294cfc7730248df);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", ()=>$03dd5f7faa501890$export$961a1d6da881600c);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", ()=>$03dd5f7faa501890$export$e11dea67b88ee556);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", ()=>$03dd5f7faa501890$export$9ad20e435294162a);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", ()=>$03dd5f7faa501890$export$a454b3474c5ee5f5);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", ()=>$03dd5f7faa501890$export$b69c1b48ce8f83de);
    $parcel$export(module.exports, "BASE_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$ba7c785763a2a58f);
    $parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$e09d07f2dcff2603);
    $parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$1165245f61159842);
    $parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$8a96a83b3f957e58);
    $parcel$export(module.exports, "toHierarchyLevel", ()=>$03dd5f7faa501890$export$c0c893ca5ccae9dd);
    $parcel$export(module.exports, "isBaseHierarchyLevel", ()=>$03dd5f7faa501890$export$bcf91a9d8c5b0f58);
    $parcel$export(module.exports, "isEpicHierarchyLevel", ()=>$03dd5f7faa501890$export$e415cf60723c7aae);
    $parcel$export(module.exports, "isSubtaskHierarchyLevel", ()=>$03dd5f7faa501890$export$41f00a40e2ebd6e8);
    $parcel$export(module.exports, "getHierarchyLevelType", ()=>$03dd5f7faa501890$export$556b686fea6fb229);
    $parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", ()=>$03dd5f7faa501890$export$638ac52227e67c8);
    const $03dd5f7faa501890$export$2294cfc7730248df = 4;
    const $03dd5f7faa501890$export$961a1d6da881600c = 3;
    const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
    const $03dd5f7faa501890$export$9ad20e435294162a = 1;
    const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
    const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
    const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
    const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
    const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
    const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
    const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
    const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return true;
        return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
    };
    const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
    };
    const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
    };
    const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
    const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
        if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
});
parcelRegister("6UM3P", function(module, exports) {
    $parcel$export(module.exports, "canEditIssuesSelector", ()=>$ab04ad11f2d2260b$export$cdd6892c8add3e54);
    $parcel$export(module.exports, "canLinkIssuesSelector", ()=>$ab04ad11f2d2260b$export$50487d0d29271836);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $hKi22;
    const $ab04ad11f2d2260b$export$a7a483ca0afc4ab3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canCloneIssue);
    const $ab04ad11f2d2260b$export$c1f4ef01259b4eb = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canDeleteIssue);
    const $ab04ad11f2d2260b$export$2f9dd165cbf0c5ea = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canMoveIssue);
    const $ab04ad11f2d2260b$export$cdd6892c8add3e54 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canEditIssues);
    const $ab04ad11f2d2260b$export$f48030c6644c0c4d = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
    const $ab04ad11f2d2260b$export$4e8dac873f71d13e = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canAssignIssues);
    const $ab04ad11f2d2260b$export$50487d0d29271836 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canLinkIssues);
});
parcelRegister("hwyJi", function(module, exports) {
    $parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", ()=>$7ea8e744bda72f86$export$c16e6010c2ccc7b2);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $69oHP;
    var $fOGZN;
    var $7Ow8a;
    const $7ea8e744bda72f86$export$1caf4359a6680b64 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("7Ow8a")).fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
            const type = (0, (0, parcelRequire("69oHP")).getFieldType)(fields[id]);
            return type && (0, (0, parcelRequire("fOGZN")).customFieldsToDisplay)().includes(type);
        }));
    const $7ea8e744bda72f86$export$c16e6010c2ccc7b2 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("7Ow8a")).fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
            const type = (0, (0, parcelRequire("69oHP")).getFieldType)(fields[id]);
            return type && (0, (0, parcelRequire("fOGZN")).ecosystemCustomFields).includes(type);
        }));
});
parcelRegister("d4MOh", function(module, exports) {
    $parcel$export(module.exports, "entitiesCommentsSelector", ()=>$1d69b1e69b91ee0e$export$2bcb958351592bb9);
    $parcel$export(module.exports, "totalCommentsSelector", ()=>$1d69b1e69b91ee0e$export$3873a5701cda7746);
    $parcel$export(module.exports, "startIndexCommentsSelector", ()=>$1d69b1e69b91ee0e$export$10621129a0e171e5);
    $parcel$export(module.exports, "loadedCommentsSelector", ()=>$1d69b1e69b91ee0e$export$c3802eebab78988b);
    $parcel$export(module.exports, "isLoadingMoreCommentsSelector", ()=>$1d69b1e69b91ee0e$export$5d4ebbdab84a3a1);
    $parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", ()=>$1d69b1e69b91ee0e$export$3190c124f9d4af8a);
    $parcel$export(module.exports, "loadingStageSelector", ()=>$1d69b1e69b91ee0e$export$18bc980d36bf93d);
    $parcel$export(module.exports, "commentAuthorSelector", ()=>$1d69b1e69b91ee0e$export$6f6ac03c75ab3545);
    $parcel$export(module.exports, "commentUpdateAuthorSelector", ()=>$1d69b1e69b91ee0e$export$7190d6fab16715b8);
    $parcel$export(module.exports, "commentEditingBodySelector", ()=>$1d69b1e69b91ee0e$export$3e2634438f2a9b1a);
    $parcel$export(module.exports, "commentEditingVisibilitySelector", ()=>$1d69b1e69b91ee0e$export$3c2f8c0a34054ef7);
    $parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", ()=>$1d69b1e69b91ee0e$export$b0e0bc0c48cf00e6);
    $parcel$export(module.exports, "commentOutsiderCommentSelector", ()=>$1d69b1e69b91ee0e$export$e7022c391905c53f);
    $parcel$export(module.exports, "commentBodyHtmlSelector", ()=>$1d69b1e69b91ee0e$export$b9c6e85825c49cba);
    $parcel$export(module.exports, "commentIsDeletedSelector", ()=>$1d69b1e69b91ee0e$export$e6360edf7c25f03d);
    $parcel$export(module.exports, "commentRepliesSelector", ()=>$1d69b1e69b91ee0e$export$9fdd1ba68d7464f1);
    $parcel$export(module.exports, "commentCreatedDateSelector", ()=>$1d69b1e69b91ee0e$export$b580f3d971b4e6fb);
    $parcel$export(module.exports, "commentUpdatedDateSelector", ()=>$1d69b1e69b91ee0e$export$8b9935e49715b2d6);
    $parcel$export(module.exports, "commentEditedSelector", ()=>$1d69b1e69b91ee0e$export$eff4fd551b2f55a1);
    $parcel$export(module.exports, "pendingCommentSelector", ()=>$1d69b1e69b91ee0e$export$d63578bef1057cae);
    $parcel$export(module.exports, "commentIsOptimisticSelector", ()=>$1d69b1e69b91ee0e$export$be047268481f07d8);
    $parcel$export(module.exports, "commentSaveFailedSelector", ()=>$1d69b1e69b91ee0e$export$72075ae8ef4d6f6a);
    $parcel$export(module.exports, "commentHasDeleteModalSelector", ()=>$1d69b1e69b91ee0e$export$c756ab72f25508bb);
    $parcel$export(module.exports, "commentVisibilitySelector", ()=>$1d69b1e69b91ee0e$export$2cf9d22f626e5db0);
    $parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", ()=>$1d69b1e69b91ee0e$export$82fbf902093fe491);
    $parcel$export(module.exports, "commentEditingEventOccurredAtSelector", ()=>$1d69b1e69b91ee0e$export$d820e1c3ac105e35);
    $parcel$export(module.exports, "commentEventOccurredAtSelector", ()=>$1d69b1e69b91ee0e$export$9c8937d1bd8cf4a);
    $parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", ()=>$1d69b1e69b91ee0e$export$8c7be677b9a2cbf3);
    $parcel$export(module.exports, "isInternalCommentSelector", ()=>$1d69b1e69b91ee0e$export$b99aa78c1374f9fe);
    $parcel$export(module.exports, "isEditingInternalCommentSelector", ()=>$1d69b1e69b91ee0e$export$54205c8c886a2b43);
    $parcel$export(module.exports, "canAddCommentsSelector", ()=>$1d69b1e69b91ee0e$export$a34c155854eb296b);
    $parcel$export(module.exports, "canDeleteCommentSelector", ()=>$1d69b1e69b91ee0e$export$8cc876bb72dc09b7);
    $parcel$export(module.exports, "canEditCommentSelector", ()=>$1d69b1e69b91ee0e$export$eb110f3a00a8432);
    $parcel$export(module.exports, "visibleCommentIdsSelector", ()=>$1d69b1e69b91ee0e$export$3b3d01d442cb684a);
    $parcel$export(module.exports, "sortedVisibleCommentIdsSelector", ()=>$1d69b1e69b91ee0e$export$81c523e14f04df2d);
    $parcel$export(module.exports, "isEditingCommentSelector", ()=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e);
    $parcel$export(module.exports, "getEditingCommentIdsSelector", ()=>$1d69b1e69b91ee0e$export$3a00787e516c672c);
    $parcel$export(module.exports, "commentIdsSelector", ()=>$1d69b1e69b91ee0e$export$4c04cd370caea884);
    $parcel$export(module.exports, "isEditingAnyCommentSelector", ()=>$1d69b1e69b91ee0e$export$2e24e984817b4c7b);
    $parcel$export(module.exports, "isAddCommentEditorExpandedSelector", ()=>$1d69b1e69b91ee0e$export$5373a6bfd674797c);
    $parcel$export(module.exports, "addCommentEditorForceFocusSelector", ()=>$1d69b1e69b91ee0e$export$37aee7d1ec9d42d3);
    $parcel$export(module.exports, "isCommentEditorOpenSelector", ()=>$1d69b1e69b91ee0e$export$6df0ef2ac2b35c13);
    $parcel$export(module.exports, "isCommentAttachmentInProgressSelector", ()=>$1d69b1e69b91ee0e$export$f140c5c89826efc6);
    $parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", ()=>$1d69b1e69b91ee0e$export$2ce513eb85289331);
    $parcel$export(module.exports, "isReplyingToCommentSelector", ()=>$1d69b1e69b91ee0e$export$ab64c511f5921cdf);
    $parcel$export(module.exports, "isCommentReplyEditorOpenSelector", ()=>$1d69b1e69b91ee0e$export$d89d07d36d57d778);
    $parcel$export(module.exports, "replyContentSelector", ()=>$1d69b1e69b91ee0e$export$bb44f1aa6771eeb6);
    $parcel$export(module.exports, "replyingToAuthorSelector", ()=>$1d69b1e69b91ee0e$export$6fe69cb268473af1);
    $parcel$export(module.exports, "commentParentIdSelector", ()=>$1d69b1e69b91ee0e$export$9f25935861e23f9b);
    $parcel$export(module.exports, "isCommentEmptyStateEnabledSelector", ()=>$1d69b1e69b91ee0e$export$963d46e45450aaaf);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $dMEgP = parcelRequire("dMEgP");
    var $g7reD;
    var $8ikER;
    var $2vSU6;
    var $6s1PB;
    var $g2C8o;
    var $32bya;
    var $a1ky2;
    var $bcoYn;
    var $hKi22;
    var $7Vj9c;
    var $2QmDq;
    const $1d69b1e69b91ee0e$export$9832028921909a8f = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.pendingDeletedIds);
    const $1d69b1e69b91ee0e$export$2bcb958351592bb9 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.comments);
    const $1d69b1e69b91ee0e$export$3873a5701cda7746 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.totalComments);
    const $1d69b1e69b91ee0e$export$10621129a0e171e5 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.commentsStartIndex);
    const $1d69b1e69b91ee0e$export$c3802eebab78988b = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.loadedComments);
    const $1d69b1e69b91ee0e$export$5d4ebbdab84a3a1 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
    const $1d69b1e69b91ee0e$export$3190c124f9d4af8a = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
    const $1d69b1e69b91ee0e$export$cb15fb58f04e4339 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.pendingSavedValues);
    const $1d69b1e69b91ee0e$var$deleteModalCommentIdSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.deleteModalCommentId);
    const $1d69b1e69b91ee0e$export$18bc980d36bf93d = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.loadingStage);
    const $1d69b1e69b91ee0e$export$f82d111da9150583 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, $1d69b1e69b91ee0e$export$cb15fb58f04e4339, (comments, optimisticComments)=>({
            ...comments,
            ...optimisticComments
        }));
    const $1d69b1e69b91ee0e$var$commentSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, (comments)=>comments[commentId]);
    const $1d69b1e69b91ee0e$var$persistedCommentSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, (comments)=>comments[commentId]);
    const $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (0, (0, parcelRequire("a1ky2")).accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
    const $1d69b1e69b91ee0e$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (0, (0, parcelRequire("bcoYn")).getUserByIdSelector), (comment, userByIdSelector)=>comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
    const $1d69b1e69b91ee0e$var$uiAllCommentsSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui && ui.comments || null);
    const $1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
    const $1d69b1e69b91ee0e$var$uiCommentEditorSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
    const $1d69b1e69b91ee0e$export$6f6ac03c75ab3545 = (commentId)=>$1d69b1e69b91ee0e$var$authorSelector(commentId, 'authorId');
    const $1d69b1e69b91ee0e$export$7190d6fab16715b8 = (commentId)=>$1d69b1e69b91ee0e$var$authorSelector(commentId, 'updateAuthorId');
    const $1d69b1e69b91ee0e$export$3e2634438f2a9b1a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
    const $1d69b1e69b91ee0e$export$3c2f8c0a34054ef7 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
    const $1d69b1e69b91ee0e$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3e2634438f2a9b1a(commentId), $1d69b1e69b91ee0e$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
    const $1d69b1e69b91ee0e$export$e7022c391905c53f = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
    const $1d69b1e69b91ee0e$export$b9c6e85825c49cba = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
    const $1d69b1e69b91ee0e$export$e6360edf7c25f03d = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.isDeleted : null);
    const $1d69b1e69b91ee0e$export$9fdd1ba68d7464f1 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$persistedCommentSelector(commentId), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comment, allComments, deletedIds)=>{
            if (comment?.replies && comment.replies.length > 0) {
                const nonDeletedReplies = comment.replies.filter((id)=>!deletedIds.includes(id) && allComments[id]);
                if (nonDeletedReplies.length > 0) return nonDeletedReplies.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(allComments)).sort($1d69b1e69b91ee0e$var$compareComments).map((sortedComment)=>sortedComment.id);
            }
            return null;
        });
    const $1d69b1e69b91ee0e$export$b580f3d971b4e6fb = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
    const $1d69b1e69b91ee0e$export$8b9935e49715b2d6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
    const $1d69b1e69b91ee0e$export$eff4fd551b2f55a1 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
    const $1d69b1e69b91ee0e$export$d63578bef1057cae = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
    const $1d69b1e69b91ee0e$export$be047268481f07d8 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
    const $1d69b1e69b91ee0e$export$72075ae8ef4d6f6a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
    const $1d69b1e69b91ee0e$export$c756ab72f25508bb = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
    const $1d69b1e69b91ee0e$export$2cf9d22f626e5db0 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), $1d69b1e69b91ee0e$export$8f158a3cc48edde6(commentId), (comment, parent)=>{
            if ($1d69b1e69b91ee0e$var$isThreadedCommentsEnabled() && parent && !parent.isDeleted) return parent.visibility || (0, (0, parcelRequire("g2C8o")).COMMENT_VISIBILITY_PUBLIC);
            return comment ? comment.visibility : (0, (0, parcelRequire("g2C8o")).COMMENT_VISIBILITY_PUBLIC);
        });
    const $1d69b1e69b91ee0e$var$commentIsInternalSelector = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
    const $1d69b1e69b91ee0e$export$82fbf902093fe491 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3c2f8c0a34054ef7(commentId), $1d69b1e69b91ee0e$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
    const $1d69b1e69b91ee0e$export$d820e1c3ac105e35 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
    const $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
    const $1d69b1e69b91ee0e$export$9b5c22d8443e21d6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$d820e1c3ac105e35(commentId), $1d69b1e69b91ee0e$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
    const $1d69b1e69b91ee0e$export$8c7be677b9a2cbf3 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
    const $1d69b1e69b91ee0e$export$b99aa78c1374f9fe = (commentId)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).isServiceDeskSelector), $1d69b1e69b91ee0e$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal);
    const $1d69b1e69b91ee0e$export$54205c8c886a2b43 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
    const $1d69b1e69b91ee0e$export$a34c155854eb296b = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), (permissions)=>permissions.canAddComments);
    const $1d69b1e69b91ee0e$export$8cc876bb72dc09b7 = (commentId)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
    const $1d69b1e69b91ee0e$export$eb110f3a00a8432 = (commentId)=>(0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), $1d69b1e69b91ee0e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
    const $1d69b1e69b91ee0e$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
            const comment = comments[id];
            return {
                id: id,
                createdDate: new Date(comment.createdDate),
                eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null
            };
        };
    const $1d69b1e69b91ee0e$var$compareComments = (a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, (0, parcelRequire("g7reD")).default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, (0, parcelRequire("g7reD")).default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return (0, (0, parcelRequire("g7reD")).default)(dateForA, dateForB);
    };
    const $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorOld = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comments, deletedIds)=>{
        const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
        const sortedIds = nonDeletedCommentIds.map((id)=>({
                id: id,
                createdDate: new Date(comments[id].createdDate)
            })).sort((a, b)=>(0, (0, parcelRequire("g7reD")).default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
        return sortedIds;
    });
    const $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorNew = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (comments, deletedIds)=>{
        const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
        const sortedIds = nonDeletedCommentIds.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(comments)).sort($1d69b1e69b91ee0e$var$compareComments).map((comment)=>comment.id);
        return sortedIds;
    });
    const $1d69b1e69b91ee0e$export$3b3d01d442cb684a = (0, (0, parcelRequire("32bya")).selectorWithCondition)((0, (0, parcelRequire("7Vj9c")).isJsmTimelineEnabled), $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorNew, $1d69b1e69b91ee0e$var$visibleCommentIdsSelectorOld);
    const $1d69b1e69b91ee0e$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
            if (a.eventOccurredAt && b.eventOccurredAt && (0, (0, parcelRequire("g7reD")).default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, (0, parcelRequire("g7reD")).default)(a.createdDate, b.createdDate) : (0, (0, parcelRequire("8ikER")).default)(a.createdDate, b.createdDate);
            const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
            const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
            return sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, (0, parcelRequire("g7reD")).default)(dateForA, dateForB) : (0, (0, parcelRequire("8ikER")).default)(dateForA, dateForB);
        };
    const $1d69b1e69b91ee0e$var$isThreadedCommentsEnabled = ()=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_threaded_comment_experiment');
        return expConfig.get('is_enabled', false);
    };
    const $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorOld = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2QmDq")).getSelectedActivitySortOrder), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
        const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && $1d69b1e69b91ee0e$var$isThreadedCommentsEnabled() || !deletedIds.includes(id)) && ($1d69b1e69b91ee0e$var$isThreadedCommentsEnabled() ? !comments[id].parentId : true));
        const sortedIds = nonDeletedCommentIds.map((id)=>{
            const comment = comments[id];
            return {
                id: id,
                createdDate: new Date(comment.createdDate)
            };
        }).sort((a, b)=>sortOrderType === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, (0, parcelRequire("g7reD")).default)(a.createdDate, b.createdDate) : (0, (0, parcelRequire("8ikER")).default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
        return sortedIds;
    });
    const $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorNew = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2QmDq")).getSelectedActivitySortOrder), $1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
        const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && $1d69b1e69b91ee0e$var$isThreadedCommentsEnabled() || !deletedIds.includes(id)) && ($1d69b1e69b91ee0e$var$isThreadedCommentsEnabled() ? !comments[id].parentId : true));
        const sortedIds = nonDeletedCommentIds.map($1d69b1e69b91ee0e$var$mapIdToCommentSortInfo(comments)).sort($1d69b1e69b91ee0e$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>comment.id);
        return sortedIds;
    });
    const $1d69b1e69b91ee0e$export$81c523e14f04df2d = (0, (0, parcelRequire("32bya")).selectorWithCondition)((0, (0, parcelRequire("7Vj9c")).isJsmTimelineEnabled), $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorNew, $1d69b1e69b91ee0e$var$sortedVisibleCommentIdsSelectorOld);
    const $1d69b1e69b91ee0e$export$6eba3f548a7f384e = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
    const $1d69b1e69b91ee0e$export$3a00787e516c672c = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e(commentId)(state)));
    const $1d69b1e69b91ee0e$export$4c04cd370caea884 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
    const $1d69b1e69b91ee0e$export$2e24e984817b4c7b = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$1d69b1e69b91ee0e$export$6eba3f548a7f384e(id)(state)));
    const $1d69b1e69b91ee0e$export$5373a6bfd674797c = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
    const $1d69b1e69b91ee0e$export$37aee7d1ec9d42d3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
    const $1d69b1e69b91ee0e$export$6df0ef2ac2b35c13 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$5373a6bfd674797c, $1d69b1e69b91ee0e$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, ($parcel$interopDefault($dMEgP)))(commentEditors).some((editor)=>editor.isEditing) : false));
    const $1d69b1e69b91ee0e$export$f140c5c89826efc6 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
    const $1d69b1e69b91ee0e$export$2ce513eb85289331 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).isSimplifiedProjectSelector), (0, (0, parcelRequire("bcoYn")).projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)));
    const $1d69b1e69b91ee0e$var$replyingToCommentIdSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.replyingToCommentId);
    const $1d69b1e69b91ee0e$export$ab64c511f5921cdf = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToCommentIdSelector, (replyingToCommentId)=>replyingToCommentId === commentId);
    const $1d69b1e69b91ee0e$export$d89d07d36d57d778 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToCommentIdSelector, (replyingToCommentId)=>!!replyingToCommentId);
    const $1d69b1e69b91ee0e$export$bb44f1aa6771eeb6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$3e2634438f2a9b1a(`${(0, $7a0695d910e98a34$export$56251dcfec1ad08d)}-${commentId}`), (editingComment)=>editingComment || undefined);
    const $1d69b1e69b91ee0e$var$replyingToAuthorIdSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.comments.replyingToAuthorId);
    const $1d69b1e69b91ee0e$export$6fe69cb268473af1 = (0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$replyingToAuthorIdSelector, (0, (0, parcelRequire("bcoYn")).getUserByIdSelector), (replyingToAuthorId, getUserById)=>getUserById(replyingToAuthorId));
    const $1d69b1e69b91ee0e$export$9f25935861e23f9b = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$var$commentSelector(commentId), (comment)=>comment && comment.parentId);
    const $1d69b1e69b91ee0e$export$8f158a3cc48edde6 = (commentId)=>(0, $dGvGJ.createSelector)($1d69b1e69b91ee0e$export$f82d111da9150583, $1d69b1e69b91ee0e$export$9f25935861e23f9b(commentId), (comments, parentId)=>parentId ? comments[parentId] : undefined);
    const $1d69b1e69b91ee0e$export$963d46e45450aaaf = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).projectTypeSelector), $1d69b1e69b91ee0e$export$3873a5701cda7746, $1d69b1e69b91ee0e$export$cb15fb58f04e4339, (projectType, totalComments, pendingComments)=>(projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) && totalComments === 0 && Object.keys(pendingComments).length === 0);
});
const $c97bf8752afb1bcb$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $c97bf8752afb1bcb$export$e86669f498228fff = 'OLDEST_FIRST';
parcelRegister("g2C8o", function(module, exports) {
    $parcel$export(module.exports, "SAVE_COMMENT_LOADING", ()=>$a2ddc97999af5bc9$export$ea56f55e95ac48c4);
    $parcel$export(module.exports, "LOADING", ()=>$a2ddc97999af5bc9$export$26d55645375ca9a);
    $parcel$export(module.exports, "COMPLETE", ()=>$a2ddc97999af5bc9$export$1660a2d7c2fff354);
    $parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", ()=>$a2ddc97999af5bc9$export$5dd24cf16d0bbf18);
    const $a2ddc97999af5bc9$export$34e5759f24cbaeac = (value)=>value;
    const $a2ddc97999af5bc9$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
    const $a2ddc97999af5bc9$export$26d55645375ca9a = 'LOADING';
    const $a2ddc97999af5bc9$export$1660a2d7c2fff354 = 'COMPLETE';
    const $a2ddc97999af5bc9$export$5dd24cf16d0bbf18 = {
        type: (0, $b276debff3ef22b6$export$a3863626f98a38c2),
        value: ''
    };
});
const $b276debff3ef22b6$export$537a061b2f9c8800 = 'group';
const $b276debff3ef22b6$export$28a8bb936dce2def = 'role';
const $b276debff3ef22b6$export$a3863626f98a38c2 = 'public';
parcelRegister("32bya", function(module, exports) {
    $parcel$export(module.exports, "selectorWithCondition", ()=>$269c1eb4b07b4fa1$export$6be2ebff06b95055);
    const $269c1eb4b07b4fa1$export$6be2ebff06b95055 = (condition, selectorTrue, selectorFalse)=>{
        const selector = (...args)=>{
            if (condition()) return selectorTrue(...args);
            return selectorFalse(...args);
        };
        return selector;
    };
});
parcelRegister("7Vj9c", function(module, exports) {
    $parcel$export(module.exports, "isJsmTimelineEnabled", ()=>$bc9eb3af4e788bdb$export$575e1bf822db15b5);
    var $co1wz;
    const $bc9eb3af4e788bdb$export$575e1bf822db15b5 = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-timelines-phase-2_70gja', false);
});
parcelRegister("2QmDq", function(module, exports) {
    $parcel$export(module.exports, "getSelectedActivityItem", ()=>$9baa1155ae0bb232$export$49b8848afae8c381);
    $parcel$export(module.exports, "getSelectedActivitySortOrder", ()=>$9baa1155ae0bb232$export$7091381d8f3bc5cc);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $bcoYn;
    const $9baa1155ae0bb232$var$getUiActivityFeed = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.activityFeed);
    const $9baa1155ae0bb232$export$49b8848afae8c381 = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
    const $9baa1155ae0bb232$export$7091381d8f3bc5cc = (0, $dGvGJ.createSelector)($9baa1155ae0bb232$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);
});
const $7a0695d910e98a34$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';
const $7a0695d910e98a34$export$56251dcfec1ad08d = 'NEW_OPTIMISTIC_COMMENT_REPLY';
parcelRegister("9acDX", function(module, exports) {
    $parcel$export(module.exports, "isIssueLinksEnabledSelector", ()=>$2fb14f2dbdb6e11c$export$a8cf8910b8314c1a);
    $parcel$export(module.exports, "remoteIssuesSelector", ()=>$2fb14f2dbdb6e11c$export$13978ee723866c4d);
    $parcel$export(module.exports, "optimisticLinksDataSelector", ()=>$2fb14f2dbdb6e11c$export$819781ef7e99d6c7);
    $parcel$export(module.exports, "hasCombinedIssueLinksSelector", ()=>$2fb14f2dbdb6e11c$export$8b1b2dfb6701d22c);
    $parcel$export(module.exports, "combinedLinkedIssueCountSelector", ()=>$2fb14f2dbdb6e11c$export$7e10bfdc67ac9362);
    $parcel$export(module.exports, "combinedLinksSelector", ()=>$2fb14f2dbdb6e11c$export$a101eb6fc884a8a0);
    $parcel$export(module.exports, "issueLinkSelector", ()=>$2fb14f2dbdb6e11c$export$b82f4900195f5854);
    $parcel$export(module.exports, "linkedIssueSelector", ()=>$2fb14f2dbdb6e11c$export$f5f26ceb5c86ee0);
    $parcel$export(module.exports, "quickAddClickedCountSelector", ()=>$2fb14f2dbdb6e11c$export$d545d81c8e208408);
    $parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", ()=>$2fb14f2dbdb6e11c$export$3bf48255064c85d5);
    $parcel$export(module.exports, "quickAddClickedIssueSelector", ()=>$2fb14f2dbdb6e11c$export$2c43c6abed5983de);
    $parcel$export(module.exports, "shouldDisplayAddLinksSelector", ()=>$2fb14f2dbdb6e11c$export$5757979a0baa9c47);
    $parcel$export(module.exports, "shouldDisplayRelatedIssuePanelSelector", ()=>$2fb14f2dbdb6e11c$export$eea0e617974abf06);
    $parcel$export(module.exports, "canCreateLinkedIssueSelector", ()=>$2fb14f2dbdb6e11c$export$99914e520087b170);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $gccSB = parcelRequire("gccSB");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $h6fst = parcelRequire("h6fst");
    var $2vSU6;
    var $co1wz;
    var $bkUsp;
    var $bcoYn;
    var $1uvGd;
    const $2fb14f2dbdb6e11c$var$issueLinksRootSelector = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.issueLinks);
    const $2fb14f2dbdb6e11c$export$a8cf8910b8314c1a = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (root)=>!!root);
    const $2fb14f2dbdb6e11c$var$linksDataSelector = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
    const $2fb14f2dbdb6e11c$export$13978ee723866c4d = (state)=>state.entities.remoteIssueLinks.remoteIssues;
    const $2fb14f2dbdb6e11c$export$819781ef7e99d6c7 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (issueLinks)=>issueLinks && (0, ($parcel$interopDefault($4f8Oj)))(issueLinks, (link)=>link.isOptimistic));
    const $2fb14f2dbdb6e11c$var$linkedIssuesSelector = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
    const $2fb14f2dbdb6e11c$export$701dc165268e44de = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
    const $2fb14f2dbdb6e11c$export$3c65f67962ca81cc = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (links)=>!(0, ($parcel$interopDefault($gccSB)))(links));
    const $2fb14f2dbdb6e11c$export$8b1b2dfb6701d22c = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteLinks)=>!(0, ($parcel$interopDefault($gccSB)))(links) || !(0, ($parcel$interopDefault($gccSB)))(remoteLinks));
    const $2fb14f2dbdb6e11c$export$7e10bfdc67ac9362 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$701dc165268e44de, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
    const $2fb14f2dbdb6e11c$export$f9c1778e36ca60f9 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, $2fb14f2dbdb6e11c$var$linkedIssuesSelector, (0, (0, parcelRequire("1uvGd")).jpdDeliverLinkTypeIdSelector), (links, issues, jpdDeliverLinkTypeId)=>{
        if (!(0, ($parcel$interopDefault($gccSB)))(links)) return (0, ($parcel$interopDefault($h6fst)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey).filter($2fb14f2dbdb6e11c$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues)).map((link)=>({
                ...link,
                linkedIssue: issues[link.linkedIssueKey]
            })).reduce((linksMap, link)=>Object.assign(linksMap, {
                [link.typeName]: [
                    ...linksMap[link.typeName] || [],
                    link
                ]
            }), {});
        return null;
    });
    function $2fb14f2dbdb6e11c$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues) {
        return (link)=>{
            if ((0, (0, parcelRequire("co1wz")).ff)('polaris.jpd-panel-filter-by-delivery-link-type') && jpdDeliverLinkTypeId) {
                const isImplementsLink = link.typeId === jpdDeliverLinkTypeId;
                const isOutwardLink = link.direction === (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION);
                const isIdea = issues[link.linkedIssueKey]?.issueProjectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT);
                if (isIdea && isImplementsLink && isOutwardLink) return false;
            }
            return true;
        };
    }
    const $2fb14f2dbdb6e11c$export$a101eb6fc884a8a0 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$f9c1778e36ca60f9, $2fb14f2dbdb6e11c$export$13978ee723866c4d, (links, remoteIssues)=>{
        if (links == null && remoteIssues.length === 0) return null;
        const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
                id: remoteIssueLinkEntity.remoteIssueId,
                issueKey: remoteIssueLinkEntity.issueKey,
                issueLink: remoteIssueLinkEntity.issueLinkUrl,
                issueSummary: remoteIssueLinkEntity.summary,
                issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
            });
        return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
            const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
            if (relationship != null && isDeleted !== true) return {
                ...combinedLinks,
                [relationship]: [
                    ...combinedLinks[relationship] || [],
                    {
                        id: id.toString(),
                        direction: (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION),
                        typeName: relationship,
                        linkedIssueKey: issueKey,
                        linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                        isRemote: true,
                        globalId: globalId,
                        remoteServerHostname: new URL(issueLinkUrl).hostname,
                        remoteIssueLinkError: remoteIssueLinkError,
                        isSaved: isSaved,
                        isLoading: isLoading,
                        isOptimistic: isOptimistic,
                        hasError: hasError
                    }
                ]
            };
            return combinedLinks;
        }, {
            ...links
        });
    });
    const $2fb14f2dbdb6e11c$export$b82f4900195f5854 = (issueLinkId)=>(0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
    const $2fb14f2dbdb6e11c$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
    const $2fb14f2dbdb6e11c$export$d545d81c8e208408 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
    const $2fb14f2dbdb6e11c$export$3bf48255064c85d5 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
    const $2fb14f2dbdb6e11c$export$2c43c6abed5983de = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
    const $2fb14f2dbdb6e11c$export$5757979a0baa9c47 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$export$d545d81c8e208408, (count)=>!!count);
    const $2fb14f2dbdb6e11c$export$eea0e617974abf06 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.aiLinkedIssueSuggestion);
    const $2fb14f2dbdb6e11c$export$99914e520087b170 = (0, $dGvGJ.createSelector)($2fb14f2dbdb6e11c$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);
});
parcelRegister("h6fst", function(module, exports) {
    var $7Q2q6 = parcelRequire("7Q2q6");
    var $jHlUS = parcelRequire("jHlUS");
    var $jtBGw = parcelRequire("jtBGw");
    var $hTJwX = parcelRequire("hTJwX");
    var $agVdz = parcelRequire("agVdz");
    var $cY2dI = parcelRequire("cY2dI");
    var $f1B3k = parcelRequire("f1B3k");
    var $eUuIg = parcelRequire("eUuIg");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $dMEgP = parcelRequire("dMEgP");
    var $c72efce4841a6f93$var$mapTag = '[object Map]', $c72efce4841a6f93$var$setTag = '[object Set]';
    var $c72efce4841a6f93$var$symIterator = $7Q2q6 ? $7Q2q6.iterator : undefined;
    function $c72efce4841a6f93$var$toArray(value) {
        if (!value) return [];
        if ($hTJwX(value)) return $agVdz(value) ? $jx6Tp(value) : $jHlUS(value);
        if ($c72efce4841a6f93$var$symIterator && value[$c72efce4841a6f93$var$symIterator]) return $cY2dI(value[$c72efce4841a6f93$var$symIterator]());
        var tag = $jtBGw(value), func = tag == $c72efce4841a6f93$var$mapTag ? $f1B3k : tag == $c72efce4841a6f93$var$setTag ? $eUuIg : $dMEgP;
        return func(value);
    }
    module.exports = $c72efce4841a6f93$var$toArray;
});
parcelRegister("agVdz", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $8LQ84 = parcelRequire("8LQ84");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $77a7c84c5ee0b808$var$stringTag = '[object String]';
    function $77a7c84c5ee0b808$var$isString(value) {
        return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
    }
    module.exports = $77a7c84c5ee0b808$var$isString;
});
parcelRegister("cY2dI", function(module, exports) {
    function $970ccf8c01557998$var$iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    module.exports = $970ccf8c01557998$var$iteratorToArray;
});
parcelRegister("bkUsp", function(module, exports) {
    $parcel$export(module.exports, "INWARD_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
    $parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$5dec99d71ec794ba);
    $parcel$export(module.exports, "BOTH_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$6cdcf74878b11d34);
    $parcel$export(module.exports, "IssueLinkDirectionTypes", ()=>$1e4a31a537751af2$export$4b7bcc27238c61b9);
    const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
    const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
    const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
    const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
        [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
        [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
        [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
    };
});
parcelRegister("1uvGd", function(module, exports) {
    $parcel$export(module.exports, "jpdDeliverLinkTypeIdSelector", ()=>$20ab26563cc602b2$export$c25a0be5d19458d3);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $bcoYn;
    const $20ab26563cc602b2$export$c25a0be5d19458d3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.jpdDeliveryIssueLinkTypeId);
});
parcelRegister("ifezr", function(module, exports) {
    $parcel$export(module.exports, "issueTypesSelector", ()=>$1b8b68c890f5544b$export$f5378064bf877b95);
    $parcel$export(module.exports, "hasUnsupportedType", ()=>$1b8b68c890f5544b$export$1f59505fa2d77635);
    $parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", ()=>$1b8b68c890f5544b$export$a0efcb09d3e23dc1);
    $parcel$export(module.exports, "fetchIssueTypesStatusSelector", ()=>$1b8b68c890f5544b$export$bfbb65ccb13a16eb);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $gccSB = parcelRequire("gccSB");
    var $bcoYn;
    var $lssfC;
    const $1b8b68c890f5544b$export$f5378064bf877b95 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.issueTypes);
    const $1b8b68c890f5544b$var$providedRequiredFields = [
        'summary',
        'issuetype',
        'parent',
        'project'
    ];
    const $1b8b68c890f5544b$var$isRequiredFieldProvided = (fieldName)=>$1b8b68c890f5544b$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
    const $1b8b68c890f5544b$var$hasUnsupportedRequiredField = (fields)=>!!Object.keys(fields).find((fieldName)=>!$1b8b68c890f5544b$var$isRequiredFieldProvided(fieldName) && !fields[fieldName].hasDefaultValue && fields[fieldName].required);
    const $1b8b68c890f5544b$export$1f59505fa2d77635 = (issueType)=>(0, ($parcel$interopDefault($gccSB)))(issueType.fields) || $1b8b68c890f5544b$var$hasUnsupportedRequiredField(issueType.fields);
    const $1b8b68c890f5544b$export$a0efcb09d3e23dc1 = (0, $dGvGJ.createSelector)($1b8b68c890f5544b$export$f5378064bf877b95, (0, (0, parcelRequire("lssfC")).issueTypeSelector), (0, (0, parcelRequire("bcoYn")).isEpicSelector), (issueTypes, currentIssueType, isCurrentIssueAnEpic)=>{
        const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
        return issueTypes.filter((issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
    });
    const $1b8b68c890f5544b$export$bfbb65ccb13a16eb = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).uiSelector), (ui)=>ui.fetchIssueTypesStatus);
});
parcelRegister("3Ke60", function(module, exports) {
    $parcel$export(module.exports, "subtaskTypesSelector", ()=>$e14dab62dd4bafa5$export$86a4f97fc27a0c44);
    $parcel$export(module.exports, "isSubtaskTypesPresentSelector", ()=>$e14dab62dd4bafa5$export$9a147dcac364dd81);
    $parcel$export(module.exports, "hasUnsupportedTypeSelector", ()=>$e14dab62dd4bafa5$export$3fbfbdcf57f34c2);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $ifezr;
    const $e14dab62dd4bafa5$export$86a4f97fc27a0c44 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("ifezr")).issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
    const $e14dab62dd4bafa5$export$9a147dcac364dd81 = (0, $dGvGJ.createSelector)($e14dab62dd4bafa5$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
    const $e14dab62dd4bafa5$export$3fbfbdcf57f34c2 = (0, $dGvGJ.createSelector)($e14dab62dd4bafa5$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, (0, parcelRequire("ifezr")).hasUnsupportedType)));
});
parcelRegister("aN61o", function(module, exports) {
    $parcel$export(module.exports, "isSubtaskSelector", ()=>$37d2c831d03fb4f0$export$15fea4741156936);
    $parcel$export(module.exports, "subtaskEntitiesSelector", ()=>$37d2c831d03fb4f0$export$17e529874841c746);
    $parcel$export(module.exports, "hasSubtasksSelector", ()=>$37d2c831d03fb4f0$export$f363078714850fd9);
    $parcel$export(module.exports, "canCreateSubtaskSelector", ()=>$37d2c831d03fb4f0$export$151aaebeef1cfe63);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $fOGZN;
    var $a1ky2;
    var $7Ow8a;
    var $bcoYn;
    var $hKi22;
    var $gnp10;
    var $jMY7o;
    var $lssfC;
    var $fbv6S;
    var $3Ke60;
    const $37d2c831d03fb4f0$export$15fea4741156936 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("lssfC")).issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
    const $37d2c831d03fb4f0$export$17e529874841c746 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), (entities)=>entities.subtasks);
    const $37d2c831d03fb4f0$export$f363078714850fd9 = (0, $dGvGJ.createSelector)($37d2c831d03fb4f0$export$17e529874841c746, (0, (0, parcelRequire("7Ow8a")).childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, (0, parcelRequire("fOGZN")).SUBTASKS))));
    const $37d2c831d03fb4f0$export$899afcd59181acbb = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).isSimplifiedProjectSelector), (0, (0, parcelRequire("jMY7o")).isIssueBaseLevel), (0, (0, parcelRequire("gnp10")).hasChildrenIssuesSelector), $37d2c831d03fb4f0$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
    const $37d2c831d03fb4f0$export$58b46fbc7ab224f6 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("3Ke60")).hasUnsupportedTypeSelector), (0, (0, parcelRequire("fbv6S")).projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
    const $37d2c831d03fb4f0$export$94f22e5d109e9b04 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bcoYn")).entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings.subtasksConfiguration.enabled);
    const $37d2c831d03fb4f0$export$151aaebeef1cfe63 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hKi22")).permissionsSelector), $37d2c831d03fb4f0$export$15fea4741156936, (0, (0, parcelRequire("3Ke60")).isSubtaskTypesPresentSelector), $37d2c831d03fb4f0$export$58b46fbc7ab224f6, (0, (0, parcelRequire("a1ky2")).isMobileSelector), (0, (0, parcelRequire("a1ky2")).isBitbucketSelector), (0, (0, parcelRequire("a1ky2")).isServiceDeskSelector), (0, (0, parcelRequire("bcoYn")).isSimplifiedProjectSelector), $37d2c831d03fb4f0$export$94f22e5d109e9b04, (0, (0, parcelRequire("bcoYn")).projectSelector), ({ canCreateSubtask: canCreateSubtask }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project)=>{
        const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
        const isProjectActive = (project?.projectStatus ?? (0, $cd476f3ecebdab63$export$62113557945f790a)) === (0, $cd476f3ecebdab63$export$62113557945f790a);
        const shouldShowSubtask = isServicedesk ? !isSimplified : true;
        return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
    });
});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';
parcelRegister("gnp10", function(module, exports) {
    $parcel$export(module.exports, "hasChildrenIssuesSelector", ()=>$29aeec2b4781c452$export$29f34d4d7c528e9c);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $gccSB = parcelRequire("gccSB");
    var $5fc53;
    var $7Ow8a;
    const $29aeec2b4781c452$var$childrenIssueSelector = (0, (0, parcelRequire("7Ow8a")).fieldSelector)((0, (0, parcelRequire("5fc53")).CHILDREN_ISSUES));
    const $29aeec2b4781c452$export$29f34d4d7c528e9c = (0, $dGvGJ.createSelector)($29aeec2b4781c452$var$childrenIssueSelector, (0, (0, parcelRequire("7Ow8a")).childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, ($parcel$interopDefault($gccSB)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, (0, parcelRequire("5fc53")).CHILDREN_ISSUES))) : false);
});
parcelRegister("fbv6S", function(module, exports) {
    $parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", ()=>$cb6f2b5c3e56bbb6$export$ecfed315b19a7565);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $cb6f2b5c3e56bbb6$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $5d539a63717f8747$export$4c02edeb1b5e410a) && hasValidators.value;
    const $cb6f2b5c3e56bbb6$var$unknown = (hasValidators)=>hasValidators.status === (0, $5d539a63717f8747$export$26d55645375ca9a) || hasValidators.status === (0, $5d539a63717f8747$export$d71930f7f5807a72);
    const $cb6f2b5c3e56bbb6$export$ecfed315b19a7565 = (0, $dGvGJ.createSelector)((state)=>state.validators, (validators)=>{
        const val = validators.projectHasSubtaskValidators;
        return $cb6f2b5c3e56bbb6$var$hasSubtaskValidators(val) || $cb6f2b5c3e56bbb6$var$unknown(val);
    });
});
const $5d539a63717f8747$export$26d55645375ca9a = 'LOADING';
const $5d539a63717f8747$export$d71930f7f5807a72 = 'FAILED';
const $5d539a63717f8747$export$4c02edeb1b5e410a = 'LOADED';
parcelRegister("dvijh", function(module, exports) {
    $parcel$export(module.exports, "COMMENTS", ()=>$1403612d0fe1296c$export$4cab9dfa8fc858f4);
    $parcel$export(module.exports, "WORKLOG", ()=>$1403612d0fe1296c$export$df36fc05622c402);
    $parcel$export(module.exports, "PermalinkType", ()=>$1403612d0fe1296c$export$b18d061fc042df1a);
    const $1403612d0fe1296c$export$4cab9dfa8fc858f4 = 'Comments';
    const $1403612d0fe1296c$export$df36fc05622c402 = 'Worklog';
    const $1403612d0fe1296c$export$b18d061fc042df1a = {
        COMMENTS: 'focusedCommentId',
        WORKLOG: 'focusedWorklogId'
    };
});
parcelRegister("fKtck", function(module, exports) {
    $parcel$export(module.exports, "getPermalinkTypeAndId", ()=>$11ab2af1eff70e7f$export$f72cac1fa8a03e80);
    $parcel$export(module.exports, "getPermalinkStatus", ()=>$11ab2af1eff70e7f$export$f79ae8c396759c89);
    $parcel$export(module.exports, "getUrlPermalinkParameter", ()=>$11ab2af1eff70e7f$export$b66f3e03c722c21c);
    var $8QpSo;
    var $ebyGx = parcelRequire("ebyGx");
    var $dvijh;
    const $11ab2af1eff70e7f$export$58d3deae755361f = (0, (0, parcelRequire("8QpSo")).default)((searchString)=>{
        const params = (0, ($parcel$interopDefault($ebyGx))).parseUrl(searchString).query;
        if (params[(0, (0, parcelRequire("dvijh")).PermalinkType).COMMENTS]) return {
            permalinkType: (0, (0, parcelRequire("dvijh")).COMMENTS),
            permalinkId: params[(0, (0, parcelRequire("dvijh")).PermalinkType).COMMENTS]
        };
        if (params[(0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG]) return {
            permalinkType: (0, (0, parcelRequire("dvijh")).WORKLOG),
            permalinkId: params[(0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG]
        };
        return null;
    });
    const $11ab2af1eff70e7f$export$f72cac1fa8a03e80 = ()=>$11ab2af1eff70e7f$export$58d3deae755361f(window.location.search);
    const $11ab2af1eff70e7f$export$f79ae8c396759c89 = (targetPermalinkType)=>{
        const { permalinkId: permalinkId, permalinkType: permalinkType } = $11ab2af1eff70e7f$export$f72cac1fa8a03e80() || {};
        const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
        return {
            hasPermalink: hasPermalink,
            permalinkId: hasPermalink ? permalinkId : ''
        };
    };
    const $11ab2af1eff70e7f$export$b66f3e03c722c21c = (id, permalinkType)=>{
        const pathName = window.location.pathname;
        let urlQueryParam = `?${permalinkType}=${id}`;
        if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
            const url = new URL(window.location.href);
            url.searchParams.delete(permalinkType === (0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG ? (0, (0, parcelRequire("dvijh")).PermalinkType).COMMENTS : (0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG);
            url.searchParams.set(permalinkType, id);
            urlQueryParam = url.search;
        }
        return urlQueryParam;
    };
});
parcelRegister("jf6us", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bdbb34cd5461e74$export$2e2bcd8739ae039);
    class $6bdbb34cd5461e74$export$2e2bcd8739ae039 {
        constructor(state){
            this.hasLoadedEditor = false;
            this.startTime = Math.floor(performance.now());
            this.immutableState = state;
            this.isLoadedWithPage = state.isLoadedWithPage;
        }
        lazyMetricsProps() {
            return this.immutableState.lazyMetricsProps;
        }
        getDataProvider() {
            return this.immutableState.dataProvider;
        }
        getIsFullIssue() {
            return this.immutableState.analyticsSource === 'full-issue';
        }
        getIsLoadedWithPage() {
            return this.immutableState.isLoadedWithPage;
        }
        setIsLoadedWithPage(newValue) {
            this.isLoadedWithPage = newValue;
        }
        getIsSPA() {
            return this.immutableState.isSPA;
        }
        getIsRecentIssue() {
            return this.immutableState.isRecentIssue;
        }
        getRecentIssuesCount() {
            return this.immutableState.recentIssuesCount;
        }
        getAnalyticsSource() {
            return this.immutableState.analyticsSource;
        }
        getCorrelationId() {
            return this.immutableState.correlationId;
        }
        getIssueScaleabilityReporter() {
            return this.immutableState.issueScaleabilityReporter;
        }
        getStartTime() {
            return this.startTime;
        }
        setPreviewEnd(end) {
            this.previewEnd = end === null ? 0 : Math.floor(end);
        }
        getPreviewEnd() {
            return this.previewEnd;
        }
        setFMP(end) {
            this.fmp = end === null ? 0 : Math.floor(end);
        }
        getFMP() {
            return this.fmp;
        }
        setInteractiveEnd(millisSinceEpoch) {
            this.interactiveEnd = millisSinceEpoch;
        }
        getInteractiveEnd() {
            return this.interactiveEnd;
        }
        setTrueInteractiveEnd(millisSinceEpoch) {
            this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
        }
        getTrueInteractiveEnd() {
            return Math.floor(this.trueInteractiveEnd);
        }
        getHasLoadedEditor() {
            return this.hasLoadedEditor;
        }
        getIsInitial() {
            return this.getIsFullIssue() && !this.getIsSPA();
        }
        getLocation() {
            const { route: route } = this.immutableState;
            const routeName = route?.name;
            return routeName || '';
        }
    }
});
parcelRegister("fdHx2", function(module, exports) {
    $parcel$export(module.exports, "metricsStateSelector", ()=>$e53f50d927a7fce5$export$8cfb2e5f509cb762);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $fuw6O;
    var $a1ky2;
    const $e53f50d927a7fce5$export$8cfb2e5f509cb762 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("a1ky2")).applicationKeySelector), (0, (0, parcelRequire("a1ky2")).viewModeSelector), (0, (0, parcelRequire("a1ky2")).issueIdSelector), (analyticsKey, viewMode, issueId)=>({
            analyticsKey: analyticsKey,
            viewMode: (0, (0, parcelRequire("fuw6O")).getSafeViewMode)(viewMode),
            issueId: issueId
        }));
});
parcelRegister("fuw6O", function(module, exports) {
    $parcel$export(module.exports, "getSafeViewMode", ()=>$f501923c845d9095$export$abc152b4d639d329);
    const $f501923c845d9095$var$getViewMode = ()=>window.localStorage && window.localStorage.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
    const $f501923c845d9095$var$mapPredefinedViewMode = (predefinedViewMode)=>{
        switch(predefinedViewMode){
            case 'MODAL':
                return 'modal';
            case 'SIDEBAR':
                return 'sidebar';
            default:
                return null;
        }
    };
    const $f501923c845d9095$export$abc152b4d639d329 = (predefinedViewMode = null)=>$f501923c845d9095$var$mapPredefinedViewMode(predefinedViewMode) || $f501923c845d9095$var$getViewMode().replace(/"/g, '');
});
parcelRegister("a1E0h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d74b2d5db613050c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jzjy1;
    var $dJl1T;
    var $co1wz;
    var $7eqRV;
    var $5gJcp;
    var $eVPAx;
    var $2NMNM;
    var $9noxX;
    var $4wxhn;
    var $ebuBP;
    var $g5X3G;
    var $jQ7vZ;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    const $d74b2d5db613050c$var$isEcClientEnabled = ()=>{
        const experiences = (0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
        return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
    };
    const $d74b2d5db613050c$export$8c70dcc4643464f8 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("82uFl")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $d74b2d5db613050c$export$5aebed4b5cba826a = ({ backButtonUrl: backButtonUrl, issueNavigatorData: issueNavigatorData, issueKey: issueKey, onDispatchExternalActionRef: onDispatchExternalActionRef, onIssueDeleteSuccess: onIssueDeleteSuccess, analyticsSource: analyticsSource, ServiceDeskAnalyticsContext: ServiceDeskAnalyticsContext = (0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext) })=>{
        const routerActions = (0, $dIdda.useRouterActions)();
        const [selectedIssueKey, setIssueKey] = (0, (0, parcelRequire("jQ7vZ")).useQueryParam)('selectedIssue');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        let saveIssueMutationToCache;
        if ($d74b2d5db613050c$var$isEcClientEnabled()) saveIssueMutationToCache = (0, (0, parcelRequire("eVPAx")).useEcClient)().saveIssueMutationToCache;
        const onIssueKeyChange = (data)=>{
            setIssueKey(data.toIssueKey);
            (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('jsm.issue.view.issue-key-change', 'Invalid issue key, redirecting to correct issue key');
            routerActions.push(`/browse/${data.toIssueKey}`);
        };
        const onChangeHandler = (event)=>{
            (0, (0, parcelRequire("4wxhn")).saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ebuBP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(ServiceDeskAnalyticsContext, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7eqRV")).IssueBoundary), {
            packageName: "servicedesk-issue-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d74b2d5db613050c$export$8c70dcc4643464f8, {
            onClose: (0, ($parcel$interopDefault($8Rkzz))),
            analyticsSource: analyticsSource,
            backButtonUrl: backButtonUrl,
            dispatchExternalActionRef: onDispatchExternalActionRef,
            shouldSetInitialFocus: true,
            isLoadedWithPage: true,
            issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(selectedIssueKey) || issueKey,
            onIssueDeleteSuccess: onIssueDeleteSuccess,
            onIssueKeyChange: onIssueKeyChange,
            issueMaxWidth: (0, (0, parcelRequire("5gJcp")).getIssueContainerMaxWidth)(),
            onChange: onChangeHandler,
            issueNavigatorData: issueNavigatorData
        }))));
    };
    const $d74b2d5db613050c$var$getAnalyticsSourceFromUrl = ()=>{
        const { pathname: pathname } = window.location;
        if (pathname.includes('reports')) return 'viewReportIssue';
        return 'viewQueueIssue';
    };
    const $d74b2d5db613050c$var$WrappedIssueView = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)($d74b2d5db613050c$var$getAnalyticsSourceFromUrl(), (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($d74b2d5db613050c$export$5aebed4b5cba826a);
    const $d74b2d5db613050c$var$IssueViewContainer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($d74b2d5db613050c$var$WrappedIssueView, props);
    var $d74b2d5db613050c$export$2e2bcd8739ae039 = $d74b2d5db613050c$var$IssueViewContainer;
});
parcelRegister("7eqRV", function(module, exports) {
    $parcel$export(module.exports, "IssueBoundary", ()=>$e3c8771effba3477$export$fbf48ede0cf52b5a);
    $parcel$export(module.exports, "IssueModalBoundary", ()=>$e3c8771effba3477$export$74d408982642a541);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $gjEtj;
    var $lfTZh;
    var $c65JB;
    const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "issue",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isEmbedView: isEmbedView
            })
        }, children));
    const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "issue-modal",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-modal-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isModalView: true
            })
        }, children));
});
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $iqr2y;
    var $heNNl;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
parcelRegister("gAeCk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5368db3a32c0eb20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $x9xyg;
    const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
        const renderRef = (0, $5uXOq.useRef)(false);
        if (!renderRef.current) {
            renderRef.current = true;
            (0, (0, parcelRequire("x9xyg")).setMark)(metricKey);
            onSet && onSet();
        }
        return null;
    };
    var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;
});
parcelRegister("c65JB", function(module, exports) {
    $parcel$export(module.exports, "IssueViewSkeleton", ()=>$10d0ed34bb3215dd$export$49addbcdecb6e6ff);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iMqhh;
    var $gnABE;
    var $gERis = parcelRequire("gERis");
    const $10d0ed34bb3215dd$var$fullpageStyles = null;
    const $10d0ed34bb3215dd$var$modalStyles = null;
    const $10d0ed34bb3215dd$var$customSpacingStyles = null;
    const $10d0ed34bb3215dd$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
        const customCss = [
            $10d0ed34bb3215dd$var$customSpacingStyles,
            isEmbedView !== true && isModalView !== true ? $10d0ed34bb3215dd$var$fullpageStyles : null,
            isModalView === true ? $10d0ed34bb3215dd$var$modalStyles : null
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMqhh")).CompactModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gERis))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
                isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
                isModalView === true && "_19pk10j7"
            ])
        }));
    };
});
parcelRegister("iMqhh", function(module, exports) {
    $parcel$export(module.exports, "CompactModeContext", ()=>$db79d17d45755de5$export$37eeac5cc5245b18);
    $parcel$export(module.exports, "CompactModeProvider", ()=>$db79d17d45755de5$export$10cf42790e523b8e);
    $parcel$export(module.exports, "CompactModeConsumer", ()=>$db79d17d45755de5$export$20feb77b5b617e44);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8kj45;
    var $dIdda = parcelRequire("dIdda");
    var $hhMVP;
    const $db79d17d45755de5$export$37eeac5cc5245b18 = (0, $5uXOq.createContext)(false);
    const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
    const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
    const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
    function $db79d17d45755de5$var$useRouteKey() {
        const [routeState] = (0, $dIdda.useRouter)();
        const { match: { path: path, params: params } } = routeState;
        const hasIssueKey = params?.issueKey !== undefined;
        return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
    }
    const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
        const key = $db79d17d45755de5$var$useRouteKey();
        (0, (0, parcelRequire("hhMVP")).invalidateCacheIfRouteChanged)(key);
        let defaultState = (0, (0, parcelRequire("hhMVP")).getCachedIsCompactValue)(key);
        if (defaultState === undefined) {
            defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
            (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(defaultState, key);
        }
        const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8kj45")).ContainerQueryObserver), {
            query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
            onChange: (state)=>{
                (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(state, key);
                setIsCompact(state);
            },
            defaultState: defaultState
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
            value: isCompact
        }, children));
    };
    const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
    const $db79d17d45755de5$var$StyledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;
parcelRegister("8kj45", function(module, exports) {
    $parcel$export(module.exports, "ContainerQueryObserver", ()=>$ed10e3c030ea0408$export$e9574287678b8467);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ed10e3c030ea0408$var$QueryContext = (0, $5uXOq.createContext)(undefined);
    let $ed10e3c030ea0408$var$currentIdSeed = 0;
    function $ed10e3c030ea0408$var$generateAttributeValue() {
        return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
    }
    function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
        const [active, setActive] = (0, $5uXOq.useState)(defaultState);
        const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
            onChange?.(isContainerQueryActive);
            setActive(isContainerQueryActive);
        }, [
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
            value: active
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
            query: query,
            notifyIntersectionStatusChanged: handleQueryStatusChange
        }), children);
    }
    function $ed10e3c030ea0408$export$b66a67697973e01() {
        const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
        if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
        return currentState;
    }
    function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
        const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
        const spanRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const queryStatusChangedCallback = (entries)=>{
                if (!containerRef.current || containerRef.current.clientWidth === 0) return;
                if (entries.length > 0) {
                    const isContainerQueryActive = entries[0].isIntersecting;
                    if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
                }
            };
            const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
            const spanElement = spanRef.current;
            spanElement && intersectionObserver.observe(spanElement);
            return ()=>{
                spanElement && intersectionObserver.unobserve(spanElement);
                intersectionObserver.disconnect();
            };
        }, [
            currentState,
            handleChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
            ref: containerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            type: "text/css"
        }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ref: spanRef,
            "data-container-query-indicator-id": attributeValue
        }));
    }
    const $ed10e3c030ea0408$var$ContainerToBeQueried = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hhMVP", function(module, exports) {
    $parcel$export(module.exports, "getCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$c47621d55d10906c);
    $parcel$export(module.exports, "setCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$568b2dd75c2027b4);
    $parcel$export(module.exports, "invalidateCacheIfRouteChanged", ()=>$cd61c7d28b4f2500$export$a81477a3594bcaab);
    const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
    let $cd61c7d28b4f2500$var$previousRouteKey;
    function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
        return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
    }
    function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
        $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
    }
    function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
        if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
            $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
            delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
        }
    }
});
parcelRegister("gnABE", function(module, exports) {
    $parcel$export(module.exports, "AppSkeletonImage", ()=>$93b95cd5afe27e51$export$45b107c5dc7b51a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $koVbs;
    var $d0Ozr;
    const $93b95cd5afe27e51$var$skeletonImageStyles = null;
    const $93b95cd5afe27e51$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "app-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($93b95cd5afe27e51$var$SkeletonWrapper, {
            style: containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: src,
            alt: `${formatMessage((0, (0, parcelRequire("d0Ozr")).default).loading)}...`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
                className
            ])
        })));
    };
    const $93b95cd5afe27e51$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d0Ozr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6abc81adadf77f72$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loading: {
            "id": "skeletons.common.loading",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("gERis", function(module, exports) {
    module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();
});
parcelRegister("5gJcp", function(module, exports) {
    $parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$eb0ef5297b0cdc23);
    $parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", ()=>$0350c967e71738f5$export$9c0a7052eb43d49c);
    $parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$ff64d9f93169b1f0);
    $parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", ()=>$0350c967e71738f5$export$e696e07345d019c7);
    $parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$39f2c7a88d6952c7);
    $parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", ()=>$0350c967e71738f5$export$6b38db117e6a59c3);
    $parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$e4ec603cd2ae64c3);
    $parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", ()=>$0350c967e71738f5$export$485e8138df2fade3);
    $parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$37c39403f63dfe50);
    $parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", ()=>$0350c967e71738f5$export$bcac34901554ce05);
    $parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$cfd354167a2170f3);
    $parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", ()=>$0350c967e71738f5$export$e20857c483438d46);
    $parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$2f7e8d259a68175d);
    $parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", ()=>$0350c967e71738f5$export$8c4857e697bb9a6b);
    $parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", ()=>$0350c967e71738f5$export$6669013ba0004c0);
    $parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", ()=>$0350c967e71738f5$export$ff2ebe781d7bd44e);
    $parcel$export(module.exports, "defaultRatioRightColumn", ()=>$0350c967e71738f5$export$7fec582ac43ca9da);
    $parcel$export(module.exports, "getIssueContainerMaxWidth", ()=>$0350c967e71738f5$export$c76181843186885);
    const $0350c967e71738f5$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
    const $0350c967e71738f5$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
    const $0350c967e71738f5$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
    const $0350c967e71738f5$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
    const $0350c967e71738f5$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
    const $0350c967e71738f5$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
    const $0350c967e71738f5$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
    const $0350c967e71738f5$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
    const $0350c967e71738f5$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
    const $0350c967e71738f5$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
    const $0350c967e71738f5$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
    const $0350c967e71738f5$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
    const $0350c967e71738f5$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
    const $0350c967e71738f5$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
    const $0350c967e71738f5$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
    const $0350c967e71738f5$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
    const $0350c967e71738f5$export$7fec582ac43ca9da = 0.35;
    const $0350c967e71738f5$export$c76181843186885 = ()=>1680;
});
parcelRegister("eVPAx", function(module, exports) {
    $parcel$export(module.exports, "useEcClient", ()=>$cc73f0417ca1290f$export$9da409beb25e67da);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $9OXo1;
    var $6I26d;
    const $cc73f0417ca1290f$export$9da409beb25e67da = ()=>{
        let tenantContext;
        try {
            tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
        }
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("6I26d")).EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
        }, [
            tenantContext
        ]);
        const saveIssueMutationToCache = (0, $5uXOq.useCallback)((issueMutation, key = {
            analyticsMetadata: {
                scenario: 'unknown'
            }
        }, analyticsFailureEventObj = {})=>(0, (0, parcelRequire("6I26d")).default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
        const saveIssueMutationsToCache = (0, $5uXOq.useCallback)((issueMutations, key = {
            analyticsMetadata: {
                scenario: 'unknown'
            }
        }, analyticsFailureEventObj = {})=>(0, (0, parcelRequire("6I26d")).default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
        const searchAndReconcile = (0, $5uXOq.useCallback)((matchApiUrl, jqlMatchingKey, search, parseIssueData, capability)=>(0, (0, parcelRequire("6I26d")).default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
        const getIssueMutationFromCache = (key)=>(0, (0, parcelRequire("6I26d")).default).getIssueMutationFromCache(key);
        return {
            saveIssueMutationToCache: saveIssueMutationToCache,
            saveIssueMutationsToCache: saveIssueMutationsToCache,
            searchAndReconcile: searchAndReconcile,
            getIssueMutationFromCache: getIssueMutationFromCache
        };
    };
});
parcelRegister("6I26d", function(module, exports) {
    $parcel$export(module.exports, "EcClient", ()=>$5fae311104e1f2c3$export$a736992aaac2307a);
    $parcel$export(module.exports, "getEcClient", ()=>$5fae311104e1f2c3$export$c9342bd32f51406b);
    $parcel$export(module.exports, "default", ()=>$5fae311104e1f2c3$export$2e2bcd8739ae039);
    var $dJl1T;
    var $co1wz;
    var $7f4tk;
    var $8zOmE;
    var $fjcgS;
    var $eKonk;
    var $cz9EJ;
    var $iTj50;
    var $6timm;
    class $5fae311104e1f2c3$export$a736992aaac2307a {
        #issueCache;
        #config;
        constructor(){
            this.#issueCache = new (0, (0, parcelRequire("iTj50")).default)('issue-cache-v1');
            this.#config = {};
        }
        static setTenantDetails(activationID, cloudID, atlassianAccountId) {
            (0, (0, parcelRequire("iTj50")).default).setTenantDetails(activationID, cloudID, atlassianAccountId);
        }
        static fireAnalyticsEvents(issueMutations, key = {
            analyticsMetadata: {
                scenario: 'unknown'
            }
        }, isSaved, analyticsFailureEventObj = {}) {
            try {
                let trackingId = '-1';
                if (Array.isArray(issueMutations)) trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, (0, parcelRequire("iTj50")).default).userID;
                else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, (0, parcelRequire("iTj50")).default).userID;
                const payload = {
                    action: 'mutated',
                    actionSubject: 'issue',
                    source: key?.analyticsMetadata?.scenario || 'unknown',
                    attributes: {
                        ...key.analyticsMetadata,
                        trackingId: trackingId
                    }
                };
                if (!isSaved) {
                    if (!analyticsFailureEventObj) analyticsFailureEventObj = {
                        error: true,
                        errorMsg: payload.source
                    };
                    payload.attributes = {
                        ...payload.attributes,
                        ...analyticsFailureEventObj
                    };
                }
                if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
                else (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                    client.getInstance().sendTrackEvent(payload);
                });
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsis-ec-client', e);
            }
        }
        async saveIssueMutationToCache(issueMutation, key = {
            analyticsMetadata: {
                scenario: 'unknown'
            }
        }, analyticsFailureEventObj = {}) {
            if ((0, (0, parcelRequire("co1wz")).ff)('odin.enable.backend.cache.ec.client')) {
                const isSaved = (0, (0, parcelRequire("iTj50")).default).setBackendCache(issueMutation);
                $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
                return isSaved;
            }
            return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, (0, parcelRequire("cz9EJ")).MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
                return new Promise((resolve)=>resolve(isSaved));
            });
        }
        async saveIssueMutationsToCache(issueMutations, key = {
            analyticsMetadata: {
                scenario: 'unknown'
            }
        }, analyticsFailureEventObj = {}) {
            const data = [];
            if ((0, (0, parcelRequire("co1wz")).ff)('odin.enable.backend.cache.ec.client')) {
                const isSaved = (0, (0, parcelRequire("iTj50")).default).setBackendCache(issueMutations);
                $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
                return [
                    isSaved
                ];
            }
            issueMutations.forEach(async (issueMutation)=>{
                this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                    let isSaved = false;
                    if (issueMutation.mutationType === (0, (0, parcelRequire("cz9EJ")).MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                    else if (result || issueMutation.mutationType === (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                    else isSaved = await this.#issueCache.create(issueMutation.issueId);
                    data.push(isSaved);
                    $5fae311104e1f2c3$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
                });
            });
            return new Promise((resolve)=>resolve(data));
        }
        getIssueMutationFromCache(key) {
            return this.#issueCache.get(key);
        }
        async filterData(data) {
            const localStorageData = await this.getIssueMutationFromCache(null);
            const deletedData = new Set();
            Object.values(localStorageData).forEach((element)=>{
                if (element.mutationType === (0, (0, parcelRequire("cz9EJ")).MutationSource).DELETE) deletedData.add(element.issueId);
            });
            const filteredData = [];
            let success = true;
            Object.values(data).forEach((element)=>{
                if (!element.id || typeof element.id !== 'number') success = false;
                else if (!deletedData.has(element.id.toString())) filteredData.push(element);
            });
            return new Promise((resolve, reject)=>{
                if (success) resolve(filteredData);
                else reject(new Error());
            });
        }
        async constructMatchRequest() {
            const issueData = {
                issues: [],
                hydrationMode: 0
            };
            const data = await this.getIssueMutationFromCache(null);
            Object.values(data).forEach((issueMutation)=>{
                const element = {
                    issueId: issueMutation.issueId,
                    version: issueMutation.version
                };
                issueData.issues.push(element);
            });
            const options = {
                method: 'POST',
                headers: {
                    content_type: 'application/json',
                    'x-atlassian-capability': (0, (0, parcelRequire("eKonk")).getEnhancedCapabilityHeader)(this.#config.capability)
                },
                body: JSON.stringify(issueData)
            };
            return new Promise((resolve)=>resolve(options));
        }
        static getIssueDataFromSearch(data, parseIssueData) {
            const result = parseIssueData(data);
            if (result == null) return [];
            return result;
        }
        async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability) {
            this.#config.capability = capability;
            const matchRequest = await this.constructMatchRequest();
            if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                        reconciledIssues: $5fae311104e1f2c3$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                        matchAPIResponse: {
                            response: {
                                resultsByIssueId: {}
                            },
                            issue: {
                                issuesResponse: {}
                            }
                        }
                    })));
            const matchPromise = (0, (0, parcelRequire("7f4tk")).default)(matchApiUrl, matchRequest);
            return Promise.all([
                search,
                matchPromise
            ]).then(([data, response])=>{
                const structuredData = $5fae311104e1f2c3$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
                return this.filterData(structuredData).then((filteredSearchData)=>{
                    if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                    const matchedIssueIds = response.response.resultsByIssueId;
                    const filteredMatchedIssueIdsData = [];
                    Object.entries(matchedIssueIds).forEach(([key, value])=>{
                        if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                            id: parseInt(key, 10)
                        });
                    });
                    return new Promise((resolve)=>{
                        resolve({
                            reconciledIssues: (0, (0, parcelRequire("6timm")).mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                            matchAPIResponse: response
                        });
                    });
                }).catch(()=>new Promise((resolve)=>resolve({
                            reconciledIssues: structuredData,
                            matchAPIResponse: response
                        })));
            });
        }
    }
    const $5fae311104e1f2c3$var$ecClient = new $5fae311104e1f2c3$export$a736992aaac2307a();
    function $5fae311104e1f2c3$export$c9342bd32f51406b(tenantContext = {}) {
        $5fae311104e1f2c3$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
        return $5fae311104e1f2c3$var$ecClient;
    }
    var $5fae311104e1f2c3$export$2e2bcd8739ae039 = $5fae311104e1f2c3$var$ecClient;
});
parcelRegister("cz9EJ", function(module, exports) {
    $parcel$export(module.exports, "MutationSource", ()=>$ae51bde1e2afd7bd$export$17f28c4c94a74282);
    $parcel$export(module.exports, "CacheType", ()=>$ae51bde1e2afd7bd$export$ba193b555633db78);
    const $ae51bde1e2afd7bd$export$17f28c4c94a74282 = {
        CREATE: 0,
        UPDATE: 1,
        DELETE: 2
    };
    const $ae51bde1e2afd7bd$export$ba193b555633db78 = {
        LOCAL: 'local',
        SESSION: 'session'
    };
});
parcelRegister("iTj50", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54a03fc66154e7ea$export$2e2bcd8739ae039);
    var $8Op28;
    var $dJl1T;
    var $co1wz;
    var $7f4tk;
    var $82QYR;
    var $cz9EJ;
    var $6timm;
    const $54a03fc66154e7ea$var$MAX_AGE_MIN = 5;
    const $54a03fc66154e7ea$var$MAX_AGE = $54a03fc66154e7ea$var$MAX_AGE_MIN * 60000;
    const $54a03fc66154e7ea$var$CACHE_SIZE = 100;
    const $54a03fc66154e7ea$var$CACHE_KEY_PREFIX = '__storejs';
    const $54a03fc66154e7ea$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
    class $54a03fc66154e7ea$export$2e2bcd8739ae039 {
        #localCache;
        #sessionCache;
        constructor(namespace, maxAge = $54a03fc66154e7ea$var$MAX_AGE){
            this.maxAge = maxAge;
            this.namespace = namespace;
            this.#localCache = new (0, (0, parcelRequire("8Op28")).Cache)({
                size: $54a03fc66154e7ea$var$CACHE_SIZE,
                storageType: (0, (0, parcelRequire("cz9EJ")).CacheType).LOCAL,
                cacheKey: namespace
            });
            this.#sessionCache = new (0, (0, parcelRequire("8Op28")).Cache)({
                size: $54a03fc66154e7ea$var$CACHE_SIZE,
                storageType: (0, (0, parcelRequire("cz9EJ")).CacheType).SESSION,
                cacheKey: namespace
            });
        }
        static setTenantDetails(activationID, cloudID, userID) {
            if (activationID && activationID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID) $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID = activationID;
            if (cloudID && cloudID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID) $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID = cloudID;
            if (userID && userID !== $54a03fc66154e7ea$export$2e2bcd8739ae039.userID) $54a03fc66154e7ea$export$2e2bcd8739ae039.userID = userID;
        }
        static isIssueMutationStale(issueMutation) {
            const lastModified = new Date(issueMutation.lastModified).getTime();
            return Date.now() - lastModified < $54a03fc66154e7ea$var$MAX_AGE;
        }
        static generateKey() {
            let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
            anonymousId = anonymousId ? `.${anonymousId}` : '';
            anonymousId = anonymousId.replace(/["]+/g, '');
            return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
        }
        generateReadKey() {
            return `${$54a03fc66154e7ea$var$CACHE_KEY_PREFIX}_${this.namespace}_${$54a03fc66154e7ea$export$2e2bcd8739ae039.generateKey()}`;
        }
        async get(key) {
            return this.cleanCache().then(()=>this.getWithoutClean(key));
        }
        async getWithoutClean(key) {
            if (key == null) return new Promise((resolve)=>{
                this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
            });
            return new Promise((resolve)=>{
                this.#localCache.get(this.generateReadKey()).then((data)=>{
                    if (!data) resolve({});
                    else {
                        const iterableData = data;
                        const newData = {};
                        if (typeof key === 'string') newData[key] = iterableData[key];
                        else if (Array.isArray(key)) key.forEach((issueId)=>{
                            newData[issueId] = iterableData[issueId];
                        });
                        resolve(newData);
                    }
                });
            });
        }
        static constructBackendCacheObject(value) {
            if (value instanceof (0, (0, parcelRequire("82QYR")).default)) return {
                issueId: value.issueId,
                mutationType: value.mutationType,
                mutationTimestamp: value.lastModified
            };
            const result = [];
            value.forEach((data)=>{
                result.push($54a03fc66154e7ea$export$2e2bcd8739ae039.constructBackendCacheObject(data));
            });
            return result;
        }
        static setBackendCache(data) {
            try {
                let issueBody = $54a03fc66154e7ea$export$2e2bcd8739ae039.constructBackendCacheObject(data);
                let trackingId = '-1';
                if (data instanceof (0, (0, parcelRequire("82QYR")).default)) {
                    trackingId = String(new Date(data.lastModified).valueOf()) + ($54a03fc66154e7ea$export$2e2bcd8739ae039.userID || '');
                    issueBody = [
                        issueBody
                    ];
                } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($54a03fc66154e7ea$export$2e2bcd8739ae039.userID || '');
                (0, (0, parcelRequire("7f4tk")).default)($54a03fc66154e7ea$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'ATL-activationId': $54a03fc66154e7ea$export$2e2bcd8739ae039.activationID || '',
                        'atl-CloudId': $54a03fc66154e7ea$export$2e2bcd8739ae039.cloudID || '',
                        trackingId: trackingId
                    },
                    body: JSON.stringify({
                        issueMutations: issueBody
                    })
                });
                return true;
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
                return false;
            }
        }
        async set(value) {
            return this.getWithoutClean().then(async (cacheData)=>{
                if (value instanceof (0, (0, parcelRequire("82QYR")).default)) {
                    const storeValue = {
                        [value.issueId]: value
                    };
                    return new Promise((resolve)=>{
                        try {
                            this.#localCache.set(this.generateReadKey(), (0, (0, parcelRequire("6timm")).mergeData)(cacheData, storeValue));
                            resolve(true);
                        } catch (e) {
                            resolve(false);
                        }
                    });
                }
                const storeData = {};
                value.forEach((data)=>{
                    storeData[data.issueId] = data;
                });
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, (0, parcelRequire("6timm")).mergeData)(cacheData, storeData));
                        resolve(true);
                    } catch (e) {
                        resolve(false);
                    }
                });
            });
        }
        async create(value) {
            return this.cleanCache().then(()=>{
                if (!Array.isArray(value)) return this.set(new (0, (0, parcelRequire("82QYR")).default)(value, (0, (0, parcelRequire("cz9EJ")).MutationSource).CREATE, '1', [], new Date().toISOString()));
                const storeData = value.map((data)=>new (0, (0, parcelRequire("82QYR")).default)(data, (0, (0, parcelRequire("cz9EJ")).MutationSource).CREATE, '1', [], new Date().toISOString()));
                return this.set(storeData);
            });
        }
        async update(value) {
            if ((0, (0, parcelRequire("co1wz")).ff)('odin.enable.backend.cache.ec.client')) {
                if (typeof value === 'string') return this.set(new (0, (0, parcelRequire("82QYR")).default)(value, (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE, '1', []));
                return this.set(value.map((issueId)=>new (0, (0, parcelRequire("82QYR")).default)(issueId, (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE, '1', [])));
            }
            return this.getWithoutClean(value).then((data)=>{
                const valueToUpdate = [];
                Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                    if (issueMutationObj instanceof (0, (0, parcelRequire("82QYR")).default)) {
                        if ($54a03fc66154e7ea$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, (0, parcelRequire("82QYR")).default)(String(issueId), (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                        else valueToUpdate.push(new (0, (0, parcelRequire("82QYR")).default)(String(issueId), (0, (0, parcelRequire("cz9EJ")).MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                    } else valueToUpdate.push(new (0, (0, parcelRequire("82QYR")).default)(String(issueId), (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE, '1', [], new Date().toISOString()));
                });
                return this.set(valueToUpdate);
            });
        }
        async delete(key) {
            if (typeof key === 'string') return this.set(new (0, (0, parcelRequire("82QYR")).default)(key, (0, (0, parcelRequire("cz9EJ")).MutationSource).DELETE, '', [], new Date().toISOString()));
            const storeData = key.map((data)=>new (0, (0, parcelRequire("82QYR")).default)(data, (0, (0, parcelRequire("cz9EJ")).MutationSource).DELETE, '', [], new Date().toISOString()));
            return this.set(storeData);
        }
        async clear() {
            return this.#localCache.clear();
        }
        async cleanCache() {
            if ((0, (0, parcelRequire("co1wz")).ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
            return this.getWithoutClean(null).then((data)=>{
                const issuesToKeep = [];
                if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                    const issueMutationObj = data[issueId];
                    if ($54a03fc66154e7ea$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
                });
                return this.clear().then(()=>this.set(issuesToKeep));
            });
        }
        isPresent(issueId) {
            return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
        }
        isEmpty() {
            return this.get(null).then((data)=>Object.keys(data).length === 0);
        }
        static getLocalStorageSizeForGivenKey(key) {
            const value = localStorage.getItem(key);
            if (value != null) {
                const keySize = value.length;
                return keySize;
            }
            return 0;
        }
        static getLocalStorageSize(key) {
            if (key != null) return $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
            let totalSize = 0;
            Object.keys(localStorage).forEach((keys)=>{
                totalSize += $54a03fc66154e7ea$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
            });
            return totalSize;
        }
    }
});
parcelRegister("8Op28", function(module, exports) {
    $parcel$export(module.exports, "Cache", ()=>$3e46065a4b1d2500$export$94affb487e701bf2);
    $parcel$export(module.exports, "default", ()=>$3e46065a4b1d2500$export$2e2bcd8739ae039);
    var $bSSG7;
    var $eNf8a;
    var $dJl1T;
    var $1NZBJ;
    const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
    function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
        const cache = new Map();
        const { size: size } = props;
        let storage;
        let hasSyncedFromStorage = false;
        const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
            name: `Cache ${props.cacheKey}`,
            serialize: true
        }) : null;
        const syncWithDevTools = (type, payload)=>{
            if ((0, (0, parcelRequire("1NZBJ")).default).devTools) devTools && devTools.send({
                type: type,
                payload: payload
            }, cache, {}, props.cacheKey);
        };
        const removeExpiredKeysFromStorage = async (store)=>{
            const updatedStore = {
                ...store
            };
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
            const { cacheKey: cacheKey, maxAge: maxAge } = props;
            if (maxAge !== undefined) {
                Object.keys(store).forEach((key)=>{
                    const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                    if (keyAge > maxAge) {
                        syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                            [String(key)]: updatedStore[key]
                        });
                        delete updatedStore[key];
                        cache.delete(key);
                    }
                });
                storage.set(cacheKey, updatedStore);
            }
            return updatedStore;
        };
        const removeExpiredEntry = (key, val)=>{
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { maxAge: maxAge } = props;
                if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: val
                    });
                    cache.delete(key);
                    return true;
                }
            }
            return false;
        };
        const createStore = ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            else storage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            return storage;
        };
        const set = async (key, value)=>{
            await load();
            cache.delete(key);
            const entry = {
                value: value,
                timestamp: Date.now()
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
                [String(key)]: entry
            });
            if (cache.size > size) {
                const keys = cache.keys();
                const firstEntry = keys.next().value;
                if (firstEntry !== undefined) {
                    cache.delete(firstEntry);
                    syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                    if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) delete storedContent[firstEntry];
                }
            }
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const load = async ()=>{
            if (false || hasSyncedFromStorage) return;
            hasSyncedFromStorage = true;
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            const { cacheKey: cacheKey } = props;
            storage = createStore();
            try {
                let data = storage.get(cacheKey) || {};
                data = await removeExpiredKeysFromStorage(data);
                syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
                const orderedKeys = Object.keys(data).sort((key1, key2)=>data[key1].timestamp - data[key2].timestamp);
                await Promise.all(orderedKeys.map(async (key)=>{
                    await set(key, data[key].value);
                }));
            } catch (err) {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
                throw err;
            }
        };
        const clear = async ()=>{
            await load();
            cache.clear();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { cacheKey: cacheKey } = props;
                storage.remove(cacheKey);
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
        };
        const get = async (key)=>{
            await load();
            let val = cache.get(key);
            if (val) {
                if (removeExpiredEntry(key, val)) val = undefined;
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
                [String(key)]: val
            });
            return val && val.value;
        };
        const update = async (key, value)=>{
            await load();
            const previousValue = cache.get(key);
            if (!previousValue) return;
            const entry = {
                value: value,
                timestamp: previousValue.timestamp
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
                [String(key)]: entry
            });
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const getEntries = async ()=>{
            await load();
            const entries = Array.from(cache.entries()).filter(([key, value])=>!removeExpiredEntry(key, value));
            syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
            return entries.map(([key, { value: value }])=>[
                    key,
                    value
                ]);
        };
        const deleteEntry = async (key)=>{
            await load();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const storedContent = storage.get(props.cacheKey) || {};
                delete storedContent[key];
                storage.set(props.cacheKey, storedContent);
            }
            cache.delete(key);
            syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
                [String(key)]: cache.get(key)
            });
        };
        const refresh = async ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            cache.clear();
            hasSyncedFromStorage = false;
            await load();
        };
        if ((0, (0, parcelRequire("1NZBJ")).default).scopes.current !== (0, (0, parcelRequire("1NZBJ")).default).scopes.prev) clear();
        return {
            cache: cache,
            get: get,
            set: set,
            delete: deleteEntry,
            clear: clear,
            load: load,
            update: update,
            getEntries: getEntries,
            refresh: refresh
        };
    }
    const $3e46065a4b1d2500$var$cacheMap = {};
    const $3e46065a4b1d2500$var$getCache = async (props)=>{
        await (0, (0, parcelRequire("1NZBJ")).scopeGuard)().catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
        });
        const { cacheKey: cacheKey } = props;
        $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
        return $3e46065a4b1d2500$var$cacheMap[cacheKey];
    };
    const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
        Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
    };
    var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;
});
parcelRegister("eNf8a", function(module, exports) {
    $parcel$export(module.exports, "createSessionStorageProvider", ()=>$b98f887ad675a269$export$a922b987e648d2fa);
    $parcel$export(module.exports, "createSessionExpirableStorageProvider", ()=>$b98f887ad675a269$export$e0a2e9a062c6a695);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $j9Vq5;
    const $b98f887ad675a269$export$a922b987e648d2fa = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("j9Vq5")).makeSessionStore)()));
    const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("j9Vq5")).makeSessionExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("j9Vq5", function(module, exports) {
    $parcel$export(module.exports, "makeSessionStore", ()=>$93ac2abe604287b3$export$fb690882d627b3b5);
    $parcel$export(module.exports, "makeSessionExpirableStore", ()=>$93ac2abe604287b3$export$a8f626c8ded9a06c);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $2NjNT = parcelRequire("2NjNT");
    var $c74za = parcelRequire("c74za");
    var $fNVZf;
    const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';
parcelRegister("1NZBJ", function(module, exports) {
    $parcel$export(module.exports, "CACHE_PREFIX", ()=>$e0fd77b45718946f$export$69ca515e4489d790);
    $parcel$export(module.exports, "scopeGuard", ()=>$e0fd77b45718946f$export$653cd03438bb0386);
    $parcel$export(module.exports, "default", ()=>$e0fd77b45718946f$export$2e2bcd8739ae039);
    var $bSSG7;
    let $e0fd77b45718946f$var$resolveCachePromise;
    const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
        $e0fd77b45718946f$var$resolveCachePromise = resolve;
    });
    const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
    const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
    const $e0fd77b45718946f$var$TIMEOUT = 10000;
    const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
        let id;
        const timeout = new Promise((resolve, reject)=>{
            id = setTimeout(()=>{
                const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
                storage.clearAll();
                reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
            }, ms);
        });
        return Promise.race([
            promise,
            timeout
        ]).then((result)=>{
            clearTimeout(id);
            return result;
        });
    };
    const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
    const $e0fd77b45718946f$var$config = {
        devTools: false,
        scopes: {
            prev: null,
            current: null
        },
        set (scopeKey) {
            const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
            if (this.scopes.prev === null && this.scopes.current === null) {
                if (scopeKeyInStorage) {
                    this.scopes.prev = scopeKeyInStorage;
                    this.scopes.current = scopeKeyInStorage;
                }
            }
            if (this.scopes.current !== scopeKey) {
                if (this.scopes.current !== null) storage.clearAll();
                this.scopes.prev = this.scopes.current;
                this.scopes.current = scopeKey;
                storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
            }
            $e0fd77b45718946f$var$resolveCachePromise();
        },
        get () {
            return this.scopes.current;
        }
    };
    var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;
});
parcelRegister("82QYR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07dcfaa1e79d8d31$export$2e2bcd8739ae039);
    class $07dcfaa1e79d8d31$export$2e2bcd8739ae039 {
        constructor(issueId, mutationType, version = '1', matchStatus = [], lastModified){
            this.issueId = issueId;
            this.mutationType = mutationType;
            this.version = version;
            this.matchStatus = matchStatus;
            this.lastModified = new Date().toISOString();
        }
    }
});
parcelRegister("6timm", function(module, exports) {
    $parcel$export(module.exports, "mergeData", ()=>$9f26803814916d08$export$696bf4df45a0ddde);
    $parcel$export(module.exports, "mergeResponseData", ()=>$9f26803814916d08$export$71923bad28063cb1);
    var $j8DrX;
    function $9f26803814916d08$export$696bf4df45a0ddde(oldData, newData) {
        const result = {};
        Object.keys(oldData).forEach((issueId)=>{
            result[issueId] = oldData[issueId];
        });
        Object.keys(newData).forEach((issueId)=>{
            result[issueId] = newData[issueId];
        });
        return result;
    }
    function $9f26803814916d08$export$71923bad28063cb1(searchData, matchData) {
        const mergedData = [];
        const issueData = new Map();
        if (matchData.length) matchData.forEach((element)=>{
            issueData.set(element.id, element);
        });
        if (searchData.length) searchData.forEach((element)=>{
            if (issueData.has(element.id)) {
                mergedData.push(issueData.get(element.id));
                issueData.delete(element.id);
            } else mergedData.push(element);
        });
        if (issueData.size) issueData.forEach((value)=>{
            mergedData.push(value);
        });
        return mergedData;
    }
    function $9f26803814916d08$export$eeaad9fa1f02ef4a(customKeys) {
        return {
            shard: (0, (0, parcelRequire("j8DrX")).default)('ajs-shard') || '',
            userId: (0, (0, parcelRequire("j8DrX")).default)('ajs-atlassian-account-id') || '',
            projectId: (0, (0, parcelRequire("j8DrX")).default)('ajs-project-key') || '',
            ...customKeys
        };
    }
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("9noxX", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskAnalyticsContext", ()=>$12b9024f66e7ef57$export$ac31f8f3368d6881);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $4DPZY;
    var $8H3A4;
    const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
        const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
        const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
        if ((0, $5uXOq.Children).count(children) > 0) {
            const loading = containerContextLoading || analyticsContextLoading;
            const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
            if (!shouldRenderChildren) return null;
            const context = {};
            if (containerContextData && containerContextData.project) {
                const { id: id, type: type } = containerContextData.project;
                context.containerType = 'project';
                context.containerId = `${id}`;
                context.containers = {
                    project: {
                        id: `${id}`,
                        type: type
                    }
                };
                if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), context, children);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    $12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
        forceRenderWhileLoading: false,
        useServiceDeskAnalyticsContext: (0, (0, parcelRequire("8H3A4")).useServiceDeskAnalyticsContext),
        useContainerContext: (0, (0, parcelRequire("4DPZY")).useContainerContext)
    };
});
parcelRegister("4DPZY", function(module, exports) {
    $parcel$export(module.exports, "useContainerContext", ()=>$a65e0c39573f7437$export$c7066c2d215990cf);
    $parcel$export(module.exports, "ContainerContextSubscriber", ()=>$a65e0c39573f7437$export$5b87a78c45d5dd17);
    var $5uXOq = parcelRequire("5uXOq");
    var $7xTO3;
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    var $6SkQo;
    const $a65e0c39573f7437$var$useProjectContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource));
        const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getProjectContext)(data), [
            data
        ]);
        return [
            {
                data: projectContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource));
        const userContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getUserContext)(data), [
            data
        ]);
        return [
            {
                data: userContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
        const projectContext = $a65e0c39573f7437$var$useProjectContext();
        const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
        if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
        return projectContext;
    };
    const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
        const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
        return props.children(data, actions);
    };
    $a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';
});
parcelRegister("6SkQo", function(module, exports) {
    $parcel$export(module.exports, "getUserContext", ()=>$84cf60e2c9c0e289$export$114c35c2c23732ab);
    $parcel$export(module.exports, "getProjectContext", ()=>$84cf60e2c9c0e289$export$d17fffd59c7b3c60);
    var $2vSU6;
    var $bsuuc;
    const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
        const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
        return {
            contextType: 'user',
            user: {
                id: owner.id,
                name: owner.name,
                avatarUrl: owner.avatarUrl,
                profileUrl: owner.profileUrl,
                accountId: owner.accountId
            },
            scope: {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            }
        };
    };
    const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
        if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
            const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
            return {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            };
        }
        return undefined;
    };
    const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
        switch(projectType){
            case 'business':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'software':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'service_desk':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'product_discovery':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
        const project = (0, (0, parcelRequire("bsuuc")).extractData)(projectNavInfo);
        const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
        if (project) {
            const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
            if (projectType) return {
                contextType: 'project',
                project: {
                    key: project.key,
                    id: project.id,
                    name: project.name,
                    type: projectType,
                    isSimplified: project.isSimplified,
                    avatarUrl: project.avatarUrl,
                    style: (0, (0, parcelRequire("bsuuc")).getStyle)(project.isSimplified)
                },
                scope: scope
            };
        }
        return null;
    };
});
parcelRegister("4wxhn", function(module, exports) {
    $parcel$export(module.exports, "saveIssueMutationAnalyticsToCache", ()=>$47fa0c6a95e9c2da$export$75fba429fd9a065f);
    var $co1wz;
    var $FTaAj;
    var $82QYR;
    var $cz9EJ;
    const $47fa0c6a95e9c2da$var$isEcClientEnabled = ()=>{
        const experiences = (0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
        return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
    };
    const $47fa0c6a95e9c2da$export$75fba429fd9a065f = (event, createAnalyticsEvent, saveIssueMutationToCache)=>{
        if ($47fa0c6a95e9c2da$var$isEcClientEnabled() && event?.type === (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).FIELD_CHANGED) {
            const mutationFailedAnalyticsPayload = {
                errorMsg: 'FAILED_JSM_ISSUEVIEW',
                error: true
            };
            const analyticsEventObj = createAnalyticsEvent({});
            const analyticsDataKey = {
                analyticsEventObj: analyticsEventObj,
                analyticsMetadata: {
                    scenario: 'jsm-issue-view',
                    type: event.type
                }
            };
            saveIssueMutationToCache(new (0, (0, parcelRequire("82QYR")).default)(event?.issueId, (0, (0, parcelRequire("cz9EJ")).MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
        }
    };
});
parcelRegister("FTaAj", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
    const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
    const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
    const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
    const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
    const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
        [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
        [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
        [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
        [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
    };
});
parcelRegister("ebuBP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c071e939b06924f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjGZV;
    const $1c071e939b06924f$export$e809a659e11e6855 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjGZV")).FullPageIssueContainer), null, props.children);
    var $1c071e939b06924f$export$2e2bcd8739ae039 = ({ ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement($1c071e939b06924f$export$e809a659e11e6855, rest);
});
parcelRegister("bjGZV", function(module, exports) {
    $parcel$export(module.exports, "FullPageIssueContainer", ()=>$70e5c13e9d9b58f1$export$f4550b4a355415eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $70e5c13e9d9b58f1$export$f4550b4a355415eb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jQ7vZ", function(module, exports) {
    $parcel$export(module.exports, "useQueryParam", ()=>$9fff0bf09ea99829$export$ae316f0eeb712a36);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $9xWGk = parcelRequire("9xWGk");
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
        const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $dIdda.useRouter)();
        const queryParamValue = query[queryParam];
        const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
            const parsedSearch = (0, ($parcel$interopDefault($9xWGk)))({
                ...query,
                [queryParam]: newValue
            }, (value)=>(0, ($parcel$interopDefault($hGgHi)))(value));
            const strSearch = (0, ($parcel$interopDefault($ebyGx))).stringify(parsedSearch);
            push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
        }, [
            pathname,
            push,
            query,
            queryParam
        ]);
        return [
            queryParamValue,
            setQueryParam
        ];
    };
});
parcelRegister("82uFl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("5jyD0", function(module, exports) {
    $parcel$export(module.exports, "Page", ()=>$5e6b53007fb447e7$export$6955bcca4cd3539f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kb4zh;
    var $jcw0u;
    var $4tcSU;
    var $iXVV6;
    var $5oFIy;
    var $bqOU1;
    var $8PRuf;
    var $lT5rg;
    var $2ZChi;
    var $bWQZB;
    var $5U9SZ;
    var $aU3oX;
    var $iwjkl;
    var $2LSga;
    var $drnjE;
    var $es7xv;
    var $gq0sA;
    var $bVDE5;
    var $aE9zr;
    var $kZ2Bs;
    var $5yfkL;
    const $5e6b53007fb447e7$var$getResources = (locale)=>[
            ...(0, (0, parcelRequire("iwjkl")).getMomentResources)(locale),
            (0, (0, parcelRequire("aU3oX")).getCalendarResources)(locale)
        ];
    const $5e6b53007fb447e7$export$6955bcca4cd3539f = (props)=>{
        const { onNavigation: onNavigation, entity: entity, issueKey: issueKey, locale: locale, wrmDataForPage: wrmDataForPage, pathname: pathname } = props;
        const outerElement = (0, $5uXOq.useRef)(null);
        const [{ data: pageContext }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext } = pageContext || {};
        const { projectKey: projectKey } = projectContext || {};
        const metricKey = typeof entity === 'string' ? 'servicedesk.queues.issue' : 'servicedesk.reports.custom.issue';
        const metric = typeof entity === 'string' ? (0, (0, parcelRequire("5yfkL")).JSMIssueViewLoad) : (0, (0, parcelRequire("5yfkL")).JSMReportsIssueViewLoad);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bWQZB")).addLinkInterceptor)(outerElement.current, onNavigation);
            (0, (0, parcelRequire("5U9SZ")).addNavigationListener)(projectKey, outerElement.current, onNavigation, false);
            (0, (0, parcelRequire("2LSga")).addMetaTags)({
                'atlassian-token': (0, (0, parcelRequire("4tcSU")).default)()
            }, {
                shouldIncludeAjsPrefix: false
            });
        }, [
            onNavigation,
            projectKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lT5rg")).AttachmentDropzoneContainer), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ZChi")).LegacyIssueShortcuts), {
            ref: outerElement
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($5e6b53007fb447e7$var$LegacyStyles, {
            ref: outerElement
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aE9zr")).default), {
            wrmData: wrmDataForPage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVDE5")).default), null, ({ isInitialRender: isInitialRender })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZ2Bs")).WRMModuleLoader), {
                modules: $5e6b53007fb447e7$var$getResources(locale)
            }, ({ loading: loading, error: error })=>{
                if (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'ServiceDeskLegacyIssuePage',
                            packageName: 'jiraServicedeskLegacyBridges'
                        }
                    });
                    throw error;
                }
                if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
                return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bqOU1")).default), {
                    metricKey: metricKey,
                    withMarks: [
                        (0, (0, parcelRequire("8PRuf")).appBundleReadyMark)
                    ],
                    isExpectedToHaveSsr: false,
                    metric: metric
                }, ({ submit: submit })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                        sourceName: "serviceDeskLegacyIssuePage",
                        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
                        attributes: {
                            pageKey: metricKey
                        }
                    }, !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), typeof entity === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drnjE")).default), {
                        queueId: entity,
                        issueKey: issueKey,
                        onSubmitApdex: submit,
                        isInitialRender: isInitialRender,
                        pathname: pathname
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("es7xv")).default), {
                        report: entity,
                        issueKey: issueKey,
                        onSubmitApdex: submit,
                        isInitialRender: isInitialRender,
                        pathname: pathname
                    }))));
            }))));
    };
    var $5e6b53007fb447e7$export$2e2bcd8739ae039 = $5e6b53007fb447e7$export$6955bcca4cd3539f;
    const $5e6b53007fb447e7$var$LegacyStyles = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4gktf _colwidpf _vbyaglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bqOU1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01e8eeb66312e558$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Qrwl;
    var $5rqex;
    class $01e8eeb66312e558$var$ApdexActions extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = (0, (0, parcelRequire("5rqex")).baseDefaultProps);
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, children: children, metric: metric } = this.props;
            (0, (0, parcelRequire("5rqex")).checkAndEmitApdexSignal)(appName, metricKey);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Qrwl")).default).Consumer, null, ({ onReady: onReady })=>children({
                    submit: ()=>onReady(metricKey || `jira.fe.spa.initial-render.${String(appName)}`, metricKey || `jira.fe.spa.transition.${String(appName)}`, extra, metric)
                }));
        }
    }
    var $01e8eeb66312e558$export$2e2bcd8739ae039 = $01e8eeb66312e558$var$ApdexActions;
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("lT5rg", function(module, exports) {
    $parcel$export(module.exports, "AttachmentDropzoneContainer", ()=>$54b12c4905a9555b$export$91f929d3b164c89f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $54b12c4905a9555b$export$91f929d3b164c89f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($54b12c4905a9555b$var$Container, {
            id: "attachment-dropzone-mask-container"
        });
    const $54b12c4905a9555b$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2ZChi", function(module, exports) {
    $parcel$export(module.exports, "LegacyIssueShortcuts", ()=>$5d5787be1ff11381$export$db79c283a92e239b);
    var $5uXOq = parcelRequire("5uXOq");
    var $3Tty1;
    const $5d5787be1ff11381$export$db79c283a92e239b = (0, $5uXOq.forwardRef)((_, ref)=>{
        const clickElementCallback = (querySelector)=>()=>{
                const element = ref && 'current' in ref ? ref.current : null;
                if (element) {
                    const elementToClick = element.querySelector(querySelector);
                    if (elementToClick) elementToClick.click();
                }
            };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: {
                e: {
                    callback: clickElementCallback('.issueaction-edit-issue')
                },
                a: {
                    callback: clickElementCallback('.issueaction-assign-issue')
                },
                i: {
                    callback: clickElementCallback('.issueaction-assign-to-me')
                },
                l: {
                    callback: clickElementCallback('#edit-labels')
                },
                s: {
                    callback: clickElementCallback('.viewissue-share')
                },
                m: {
                    callback: ()=>{
                        setTimeout(()=>JIRA.Issue.invokeCommentTrigger(), 0);
                    }
                }
            }
        });
    });
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $7JoAD = parcelRequire("7JoAD");
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, $7JoAD.createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $7JoAD.createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("bWQZB", function(module, exports) {
    $parcel$export(module.exports, "addLinkInterceptor", ()=>$a298b5251ad78ad9$export$1ce34b3859880107);
    const $a298b5251ad78ad9$var$spaUrlRegex = '(/jira/servicedesk/projects/.*)';
    const $a298b5251ad78ad9$var$assetsPageRegex = '(/jira/servicedesk/assets/.*)';
    const $a298b5251ad78ad9$var$insightPageRegex = '(/jira/servicedesk/insight/.*)';
    const $a298b5251ad78ad9$export$1ce34b3859880107 = (element, onNavigateClicked)=>{
        if (!element) return;
        element.addEventListener('click', (e)=>{
            const anchor = e.target && e.target.closest('a');
            if (anchor) {
                const { href: href } = anchor;
                if (href != null) {
                    const isAuiTab = e.target.getAttribute('role') === 'tab';
                    const opensInNewTab = e.target.target === '_blank';
                    const isPartOfSpa = href && href.match && href.match($a298b5251ad78ad9$var$spaUrlRegex) !== null;
                    const isInsightPage = href && href.match && (href.match($a298b5251ad78ad9$var$assetsPageRegex) !== null || href.match($a298b5251ad78ad9$var$insightPageRegex) !== null);
                    const hrefWithoutPath = e.target.getAttribute('href') || anchor.getAttribute('href');
                    const actsAsButton = hrefWithoutPath && hrefWithoutPath.startsWith && hrefWithoutPath.startsWith('#');
                    if (!isAuiTab && !opensInNewTab && isPartOfSpa && !actsAsButton) {
                        e.preventDefault();
                        onNavigateClicked(href.match($a298b5251ad78ad9$var$spaUrlRegex)[0]);
                    } else if (!isAuiTab && !opensInNewTab && !actsAsButton && isInsightPage) {
                        e.preventDefault();
                        let matchUrl = href.match($a298b5251ad78ad9$var$insightPageRegex);
                        if (matchUrl == null) matchUrl = href.match($a298b5251ad78ad9$var$assetsPageRegex);
                        onNavigateClicked(matchUrl[0]);
                    }
                }
            }
        });
    };
});
parcelRegister("5U9SZ", function(module, exports) {
    $parcel$export(module.exports, "addNavigationListener", ()=>$720f0c60ef4b0f3f$export$50694ac99c31244c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $alviN = parcelRequire("alviN");
    const $720f0c60ef4b0f3f$var$JSD_LEGACY_NAVIGATE_EVENT = 'jsdLegacyNavigate';
    const $720f0c60ef4b0f3f$export$50694ac99c31244c = (projectKey, element, onNavigation, isSettings)=>{
        (0, $alviN.Events).off($720f0c60ef4b0f3f$var$JSD_LEGACY_NAVIGATE_EVENT);
        (0, $alviN.Events).on($720f0c60ef4b0f3f$var$JSD_LEGACY_NAVIGATE_EVENT, (fragment)=>{
            if (isSettings) return onNavigation(`${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/${fragment}`);
            return onNavigation(`/jira/servicedesk/projects/${projectKey}/${fragment}`);
        });
    };
    const $720f0c60ef4b0f3f$export$1661a729db6303de = (onNavigation)=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, $alviN.Events).on($720f0c60ef4b0f3f$var$JSD_LEGACY_NAVIGATE_EVENT, onNavigation);
            return ()=>{
                (0, $alviN.Events).off($720f0c60ef4b0f3f$var$JSD_LEGACY_NAVIGATE_EVENT, onNavigation);
            };
        }, [
            onNavigation
        ]);
    };
});
parcelRegister("alviN", function(module, exports) {
    !function(e, t) {
        module.exports = t();
    }(module.exports, function() {
        return function(e) {
            function t(r) {
                if (n[r]) return n[r].exports;
                var o = n[r] = {
                    i: r,
                    l: !1,
                    exports: {}
                };
                return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
            }
            var n = {};
            return t.m = e, t.c = n, t.d = function(e, n, r) {
                t.o(e, n) || Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: r
                });
            }, t.n = function(e) {
                var n = e && e.__esModule ? function() {
                    return e.default;
                } : function() {
                    return e;
                };
                return t.d(n, "a", n), n;
            }, t.o = function(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }, t.p = "", t(t.s = 3);
        }([
            function(e, t) {
                var n;
                n = function() {
                    return this;
                }();
                try {
                    n = n || Function("return this")() || (0, eval)("this");
                } catch (e) {
                    "object" == typeof window && (n = window);
                }
                e.exports = n;
            },
            function(e, t, n) {
                "use strict";
                (function(e) {
                    function n() {
                        return e.window._jsdFeRouting = e.window._jsdFeRouting || {}, e.window._jsdFeRouting;
                    }
                    function r() {
                        var t = n();
                        !t || t.feRouteFn || t.beforeNavigateListener || t.willNavigateListener || delete e.window._jsdFeRouting;
                    }
                    function o() {
                        return n().feRouteFn;
                    }
                    function i() {
                        delete n().feRouteFn, r();
                    }
                    function u(e) {
                        o() && console.error("Warning: [Service Desk Frontend routing] FeRouteFunction already exists. This function should be set only once per app."), n().feRouteFn = e;
                    }
                    function a() {
                        return n().beforeNavigateListener;
                    }
                    function s(e) {
                        a() && console.error("[Service Desk Frontend routing] beforeNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().beforeNavigateListener = e;
                    }
                    function c() {
                        delete n().beforeNavigateListener, r();
                    }
                    function l(e) {
                        var t = a();
                        return t ? t(e) : Promise.resolve();
                    }
                    function g() {
                        delete n().willNavigateListener, r();
                    }
                    function f() {
                        return n().willNavigateListener;
                    }
                    function d(e) {
                        f() && console.error("[Service Desk Frontend routing] willNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().willNavigateListener = e;
                    }
                    function y() {
                        var e = f();
                        if (!e) return void console.warn("[Service Desk Frontend routing] willNavigateListener is not defined. You should unmountComponentAtNode within a willNavigateListener. This is probably a memory leak.");
                        e();
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.getFeRouteFunction = o, t.deleteFeRouteFunction = i, t.setFeRouteFunction = u, t.setBeforeNavigateListener = s, t.deleteBeforeNavigateListener = c, t.onBeforeNavigate = l, t.deleteWillNavigateListener = g, t.setWillNavigateListener = d, t.onWillNavigate = y;
                }).call(t, n(0));
            },
            function(e, t, n) {
                "use strict";
                (function(e) {
                    function n() {
                        return e.window._jsdFeComponentRegistry = e.window._jsdFeComponentRegistry || {}, e.window._jsdFeComponentRegistry;
                    }
                    function r(e, t) {
                        n()[e] = t;
                    }
                    function o(e, t, n) {
                        return new Promise(function(r, o) {
                            a(e, t, n, i, r, o);
                        });
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.registerFeComponent = r, t.renderFeComponentAsync = o;
                    var i = 20, u = t.renderFeComponent = function(e, t, r) {
                        var o = n()[e];
                        if (o) return o(t, r);
                        throw new Error("FE component not found: '" + String(e) + "'");
                    }, a = function e(t, n, r, o, i, a) {
                        try {
                            var s = u(t, n, r);
                            i(s);
                        } catch (u) {
                            o <= 0 ? a(u) : setTimeout(function() {
                                return e(t, n, r, o - 1, i, a);
                            }, 500);
                        }
                    };
                }).call(t, n(0));
            },
            function(e, t, n) {
                "use strict";
                function r(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                    return t.default = e, t;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Events = t.LegacyModuleRegistry = t.LegacyPageRegistry = t.ComponentRegistry = t.PageEnabler = t.RouterManager = void 0;
                var o = n(1), i = r(o), u = n(2), a = r(u), s = n(4), c = r(s), l = n(5), g = r(l), f = n(6), d = r(f), y = n(7), v = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }(y);
                t.RouterManager = i, t.PageEnabler = v.default, t.ComponentRegistry = a, t.LegacyPageRegistry = c, t.LegacyModuleRegistry = d, t.Events = g;
            },
            function(e, t, n) {
                "use strict";
                (function(e) {
                    function n(e, t) {
                        var n = e && e.getPage && e.getPage(t);
                        return n ? n.controllerForJiraFrontend ? n && n.controllerForJiraFrontend() : Promise.reject("Page doesn't have a suitable controller method '" + t + "'") : Promise.reject("Trying to access a page that doesn't exist: '" + t + "'");
                    }
                    function r() {
                        return e._jsdLegacyAgentPageRegistry;
                    }
                    function o(t) {
                        e._jsdLegacyAgentPageRegistry = t;
                    }
                    function i(e) {
                        return n(r(), e);
                    }
                    function u() {
                        return e._jsdLegacySettingsPageRegistry;
                    }
                    function a(t) {
                        e._jsdLegacySettingsPageRegistry = t;
                    }
                    function s(e) {
                        var t = u();
                        return t ? n(t, e) : Promise.reject("Registry does not exist");
                    }
                    function c() {
                        e._jsdLegacyAgentPageRegistry = {}, e._jsdLegacySettingsPageRegistry = {};
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.getGlobalLegacyAgentPageRegistry = r, t.registerLegacyAgentPageRegistry = o, t.runLegacyAgentPageController = i, t.getGlobalLegacySettingsPageRegistry = u, t.registerLegacySettingsPageRegistry = a, t.runLegacySettingsPageController = s, t.clearLegacyPageRegistries = c;
                }).call(t, n(0));
            },
            function(e, t, n) {
                "use strict";
                (function(e) {
                    function n() {
                        return e.__jsdLegacyEventBus = e.__jsdLegacyEventBus || {}, e.__jsdLegacyEventBus;
                    }
                    function r(e) {
                        return n()[e] || [];
                    }
                    function o(e, t) {
                        var o = n(), i = r(e);
                        i.push(t), o[e] = i;
                    }
                    function i(e, t) {
                        if (t) {
                            var o = n(), i = r(e);
                            o[e] = i.filter(function(e) {
                                return e !== t;
                            });
                        } else n()[e] = [];
                    }
                    function u(e, t) {
                        r(e).forEach(function(e) {
                            return e(t);
                        });
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.on = o, t.off = i, t.trigger = u;
                }).call(t, n(0));
            },
            function(e, t, n) {
                "use strict";
                (function(e) {
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var n = t.getLegacyModuleRegistry = function() {
                        return e._jsdLegacyModuleRegistry = e._jsdLegacyModuleRegistry || {}, e._jsdLegacyModuleRegistry;
                    };
                    t.registerLegacyModule = function(e, t) {
                        n()[e] = t;
                    };
                }).call(t, n(0));
            },
            function(e, t, n) {
                "use strict";
                (function(e) {
                    function r(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }
                    function o(t) {
                        var n = new URL(e.window.location.href), r = n.href.slice(n.origin.length), o = new URL(t), i = o.href.slice(o.origin.length), u = n.hostname === o.hostname && r.startsWith(i) ? r.slice(i.length) : r;
                        return "/" === u[0] ? u : "/" + u;
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function() {
                        function e(e, t) {
                            for(var n = 0; n < t.length; n++){
                                var r = t[n];
                                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                            }
                        }
                        return function(t, n, r) {
                            return n && e(t.prototype, n), r && e(t, r), t;
                        };
                    }(), u = n(1), a = n(2), s = function() {
                        function e() {
                            r(this, e);
                        }
                        return i(e, [
                            {
                                key: "enablePage",
                                value: function(e, t) {
                                    (0, u.deleteFeRouteFunction)();
                                    try {
                                        return (0, a.renderFeComponent)(e.feComponentId, t[0], {});
                                    } catch (e) {
                                        return Promise.reject(e);
                                    }
                                }
                            },
                            {
                                key: "updatePage",
                                value: function(e, t) {
                                    var n = (0, u.getFeRouteFunction)();
                                    if (t.feComponentId && n) n(o(e));
                                    return Promise.resolve();
                                }
                            },
                            {
                                key: "disablePage",
                                value: function() {
                                    (0, u.deleteFeRouteFunction)(), (0, u.deleteBeforeNavigateListener)(), (0, u.onWillNavigate)(), (0, u.deleteWillNavigateListener)();
                                }
                            },
                            {
                                key: "beforeNavigate",
                                value: function(e) {
                                    return (0, u.onBeforeNavigate)(e);
                                }
                            }
                        ]), e;
                    }();
                    t.default = s;
                }).call(t, n(0));
            }
        ]);
    });
});
parcelRegister("aU3oX", function(module, exports) {
    $parcel$export(module.exports, "getCalendarResources", ()=>$b7921722ff3be03e$export$7fb1869917da484d);
    var $6sEtc;
    const $b7921722ff3be03e$export$7fb1869917da484d = (locale)=>(0, (0, parcelRequire("6sEtc")).default)(locale);
});
parcelRegister("6sEtc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3196b461144533e$export$2e2bcd8739ae039);
    const $f3196b461144533e$var$calendarLocaleMap = {
        cs_CZ: 'calendar-cs',
        da_DK: 'calendar-da',
        de_DE: 'calendar-de',
        en_GB: 'calendar-en',
        en_UK: 'calendar-en',
        en_ZZ: 'calendar-en',
        en_US: 'calendar-en',
        es_ES: 'calendar-es',
        et_EE: 'calendar-en',
        fi_FI: 'calendar-fi',
        fr_FR: 'calendar-fr',
        hu_HU: 'calendar-hu',
        is_IS: 'calendar-en',
        it_IT: 'calendar-it',
        ja_JP: 'calendar-jp',
        ko_KR: 'calendar-ko',
        nb_NO: 'calendar-no',
        nl_NL: 'calendar-nl',
        pl_PL: 'calendar-pl',
        pt_BR: 'calendar-pt',
        pt_PT: 'calendar-pt',
        ro_RO: 'calendar-ro',
        ru_RU: 'calendar-ru',
        sk_SK: 'calendar-sk',
        sv_SE: 'calendar-sv',
        tr_TR: 'calendar-tr',
        zh_CN: 'calendar-zh',
        zh_TW: 'calendar-zh'
    };
    const $f3196b461144533e$var$getCalendarResource = (locale)=>$f3196b461144533e$var$calendarLocaleMap[locale] || $f3196b461144533e$var$calendarLocaleMap.en_US;
    var $f3196b461144533e$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$f3196b461144533e$var$getCalendarResource(locale)}`;
});
parcelRegister("iwjkl", function(module, exports) {
    $parcel$export(module.exports, "getMomentResources", ()=>$b32dbe59480d05e1$export$4c97d1314fac2e0c);
    var $74ySO = parcelRequire("74ySO");
    const $b32dbe59480d05e1$var$SUPPORTED_LANGUAGES = [
        'af',
        'ar-ma',
        'ar-sa',
        'ar-tn',
        'ar',
        'az',
        'be',
        'bg',
        'bn',
        'bo',
        'br',
        'bs',
        'ca',
        'cs',
        'cv',
        'cy',
        'da',
        'de-at',
        'de',
        'el',
        'en-au',
        'en-ca',
        'en-gb',
        'eo',
        'es',
        'et',
        'eu',
        'fa',
        'fi',
        'fo',
        'fr-ca',
        'fr',
        'fy',
        'gl',
        'he',
        'hi',
        'hr',
        'hu',
        'hy-am',
        'id',
        'is',
        'it',
        'ja',
        'jv',
        'ka',
        'km',
        'ko',
        'lb',
        'lt',
        'lv',
        'me',
        'mk',
        'ml',
        'mr',
        'ms-my',
        'my',
        'nb',
        'ne',
        'nl',
        'nn',
        'pl',
        'pt-br',
        'pt',
        'ro',
        'ru',
        'si',
        'sk',
        'sl',
        'sq',
        'sr-cyrl',
        'sr',
        'sv',
        'ta',
        'th',
        'tl-ph',
        'tr',
        'tzm-latn',
        'tzm',
        'uk',
        'uz',
        'vi',
        'zh-cn',
        'zh-tw'
    ];
    const $b32dbe59480d05e1$var$isSupportedLanguage = (language)=>(0, ($parcel$interopDefault($74ySO)))($b32dbe59480d05e1$var$SUPPORTED_LANGUAGES, language);
    const $b32dbe59480d05e1$var$getLanguage = (locale)=>{
        const localeStr = locale.replace('_', '-');
        if ($b32dbe59480d05e1$var$isSupportedLanguage(localeStr)) return localeStr;
        return localeStr.split('-')[0];
    };
    const $b32dbe59480d05e1$var$addMomentLanguage = (resources, locale)=>{
        const language = $b32dbe59480d05e1$var$getLanguage(locale);
        if (language !== 'en' && $b32dbe59480d05e1$var$isSupportedLanguage(language)) return resources.concat([
            `com.atlassian.servicedesk.core-ui:momentjs-sd-${language}`
        ]);
        return resources;
    };
    const $b32dbe59480d05e1$export$4c97d1314fac2e0c = (locale)=>$b32dbe59480d05e1$var$addMomentLanguage([
            'com.atlassian.servicedesk.core-ui:lib-moment'
        ], locale);
});
parcelRegister("2LSga", function(module, exports) {
    $parcel$export(module.exports, "addMetaTags", ()=>$978f1e5cbbc4f7f5$export$8db8627a2f899700);
    const $978f1e5cbbc4f7f5$var$getTagKey = (key, shouldIncludeAjsPrefix)=>`${shouldIncludeAjsPrefix ? 'ajs-' : ''}${key}`;
    const $978f1e5cbbc4f7f5$var$deleteMetaTag = (key, shouldIncludeAjsPrefix)=>{
        const existingMetaTag = document.querySelector(`meta[name='${$978f1e5cbbc4f7f5$var$getTagKey(key, shouldIncludeAjsPrefix)}']`);
        existingMetaTag && existingMetaTag.parentNode && existingMetaTag.parentNode.removeChild(existingMetaTag);
    };
    const $978f1e5cbbc4f7f5$var$createMetaTag = (key, content, shouldIncludeAjsPrefix)=>{
        const existingMetaTag = document.querySelector(`meta[name='${$978f1e5cbbc4f7f5$var$getTagKey(key, shouldIncludeAjsPrefix)}']`);
        if (!existingMetaTag) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', $978f1e5cbbc4f7f5$var$getTagKey(key, shouldIncludeAjsPrefix));
            meta.setAttribute('content', content);
            return {
                meta: meta,
                previousValue: undefined
            };
        }
        const previousValue = existingMetaTag.getAttribute('content');
        existingMetaTag.setAttribute('content', content);
        return {
            meta: existingMetaTag,
            previousValue: previousValue
        };
    };
    const $978f1e5cbbc4f7f5$export$8db8627a2f899700 = (metaDataForPage, { shouldIncludeAjsPrefix: shouldIncludeAjsPrefix } = {
        shouldIncludeAjsPrefix: true
    })=>{
        const previousValues = {};
        Object.keys(metaDataForPage).forEach((key)=>{
            if (!metaDataForPage[key]) $978f1e5cbbc4f7f5$var$deleteMetaTag(key, shouldIncludeAjsPrefix);
            else {
                const { meta: meta, previousValue: previousValue } = $978f1e5cbbc4f7f5$var$createMetaTag(key, metaDataForPage[key], shouldIncludeAjsPrefix);
                if (meta && !previousValue) document.head.appendChild(meta);
                previousValues[key] = previousValue;
            }
        });
        return ()=>{
            $978f1e5cbbc4f7f5$export$8db8627a2f899700(previousValues);
        };
    };
});
parcelRegister("drnjE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$939886590799ee34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("9o0uh");
    var $kb4zh;
    var $dJl1T;
    var $jcw0u;
    var $dOWyV;
    var $br2Pa = parcelRequire("br2Pa");
    var $4dIEX;
    class $939886590799ee34$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onSubmitApdex: ()=>{}
            };
        }
        componentDidMount() {
            this.requestForBridgedView();
        }
        shouldComponentUpdate({ issueKey: nextKey, queueId: nextQueueId }, { loading: nextLoading }) {
            const { issueKey: issueKey, queueId: queueId } = this.props;
            const { issueView: issueView } = this;
            const { loading: loading } = this.state;
            if (nextQueueId !== queueId && issueView) issueView.updateQueueId(nextQueueId);
            return nextKey !== issueKey || nextLoading !== loading;
        }
        componentDidUpdate({ issueKey: prevIssueKey }) {
            const { issueView: issueView } = this;
            const { issueKey: key, queueId: queueId } = this.props;
            const hasIssueKeyChanged = prevIssueKey !== key;
            if (hasIssueKeyChanged) {
                if (issueView) issueView.render({
                    key: key,
                    queueId: queueId
                });
                else {
                    this.bridgeSubscription.unsubscribe();
                    this.requestForBridgedView();
                }
            }
        }
        componentWillUnmount() {
            const { bridgeSubscription: bridgeSubscription, issueView: issueView } = this;
            if (bridgeSubscription) bridgeSubscription.unsubscribe();
            if (issueView) issueView.dismiss();
        }
        requestForBridgedView() {
            const { onSubmitApdex: onSubmitApdex, pathname: pathname, isInitialRender: isInitialRender } = this.props;
            this.bridgeSubscription = (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("4dIEX")).getLegacyIssueView)()).subscribe((IssueView)=>{
                let generatedPageState;
                if (!onSubmitApdex && pathname) {
                    const jsdApdexSanitizedPathname = pathname.replace('/jira/servicedesk', '');
                    generatedPageState = (0, (0, parcelRequire("dOWyV")).generatePageState)({
                        newRoute: jsdApdexSanitizedPathname,
                        isSettings: false
                    });
                    (0, $br2Pa.start)(generatedPageState, isInitialRender);
                }
                this.setState({
                    loading: false
                });
                const { queueId: queueId, issueKey: key } = this.props;
                const { current: el } = this.wrapperRef;
                if (el) {
                    this.issueView = new IssueView();
                    this.issueView.setElement(el).render({
                        key: key,
                        queueId: queueId
                    }).then(()=>{
                        if (onSubmitApdex) onSubmitApdex();
                        else generatedPageState && (0, $br2Pa.end)(generatedPageState);
                    });
                }
            }, (error)=>{
                const errMessage = `Queues Legacy issue view has failed to load: ${error}`;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'legacyIssueViewLoad',
                        packageName: 'jiraServicedeskQueuesLegacyIssueView',
                        teamName: 'jsd-shield'
                    },
                    error: new Error(errMessage)
                });
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('servicedesk.queues.legacy-issue-view.view', errMessage);
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.state.loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.wrapperRef
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                loading: true
            };
            this.wrapperRef = (0, $5uXOq.createRef)();
        }
    }
});
parcelRegister("dOWyV", function(module, exports) {
    $parcel$export(module.exports, "generatePageState", ()=>$4cfcf188c0c62ec3$export$f2c04cc57e85bfe1);
    const $4cfcf188c0c62ec3$export$f2c04cc57e85bfe1 = ({ newRoute: newRoute, isSettings: isSettings })=>{
        const processedSubRoute = newRoute.match(`/projects/[^/]+${isSettings ? '/settings' : ''}/(.*)`);
        const subRoute = processedSubRoute && processedSubRoute.length >= 2 ? processedSubRoute[1] : '';
        const splitUrl = subRoute.split('/');
        return {
            module: splitUrl[0],
            item: splitUrl[1],
            secondaryItem: splitUrl[2],
            tertiaryItem: splitUrl[3],
            quaternaryItem: splitUrl[4],
            quinternaryItem: splitUrl[5]
        };
    };
});
parcelRegister("br2Pa", function(module, exports) {
    !function(t, e) {
        module.exports = e();
    }(module.exports, function() {
        return function(t) {
            function e(n) {
                if (r[n]) return r[n].exports;
                var o = r[n] = {
                    i: n,
                    l: !1,
                    exports: {}
                };
                return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
            }
            var r = {};
            return e.m = t, e.c = r, e.d = function(t, r, n) {
                e.o(t, r) || Object.defineProperty(t, r, {
                    configurable: !1,
                    enumerable: !0,
                    get: n
                });
            }, e.n = function(t) {
                var r = t && t.__esModule ? function() {
                    return t.default;
                } : function() {
                    return t;
                };
                return e.d(r, "a", r), r;
            }, e.o = function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            }, e.p = "", e(e.s = 43);
        }([
            function(t, e) {
                var r = Array.isArray;
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(22), o = "object" == typeof self && self && self.Object === Object && self, u = n || o || Function("return this")();
                t.exports = u;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = u(t, e);
                    return o(r) ? r : void 0;
                }
                var o = r(75), u = r(78);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return null == t ? void 0 === t ? a : c : f && f in Object(t) ? u(t) : i(t);
                }
                var o = r(5), u = r(52), i = r(53), c = "[object Null]", a = "[object Undefined]", f = o ? o.toStringTag : void 0;
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return null != t && "object" == typeof t;
                }
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(1), o = n.Symbol;
                t.exports = o;
            },
            function(t, e, r) {
                function n(t) {
                    var e = -1, r = null == t ? 0 : t.length;
                    for(this.clear(); ++e < r;){
                        var n = t[e];
                        this.set(n[0], n[1]);
                    }
                }
                var o = r(65), u = r(66), i = r(67), c = r(68), a = r(69);
                n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    for(var r = t.length; r--;)if (o(t[r][0], e)) return r;
                    return -1;
                }
                var o = r(31);
                t.exports = n;
            },
            function(t, e, r) {
                var n = r(2), o = n(Object, "create");
                t.exports = o;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = t.__data__;
                    return o(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
                }
                var o = r(87);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    if ("string" == typeof t || o(t)) return t;
                    var e = t + "";
                    return "0" == e && 1 / t == -u ? "-0" : e;
                }
                var o = r(18), u = 1 / 0;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return i(t) ? o(t) : u(t);
                }
                var o = r(49), u = r(58), i = r(13);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
                }
                var n = 9007199254740991;
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    return null != t && u(t.length) && !o(t);
                }
                var o = r(28), u = r(12);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    var e = typeof t;
                    return null != t && ("object" == e || "function" == e);
                }
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(2), o = r(1), u = n(o, "Map");
                t.exports = u;
            },
            function(t, e, r) {
                function n(t) {
                    var e = -1, r = null == t ? 0 : t.length;
                    for(this.clear(); ++e < r;){
                        var n = t[e];
                        this.set(n[0], n[1]);
                    }
                }
                var o = r(79), u = r(86), i = r(88), c = r(89), a = r(90);
                n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    if (o(t)) return !1;
                    var r = typeof t;
                    return !("number" != r && "symbol" != r && "boolean" != r && null != t && !u(t)) || c.test(t) || !i.test(t) || null != e && t in Object(e);
                }
                var o = r(0), u = r(18), i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return "symbol" == typeof t || u(t) && o(t) == i;
                }
                var o = r(3), u = r(4), i = "[object Symbol]";
                t.exports = n;
            },
            function(t, e, r) {
                "use strict";
                function n(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }
                function o(t) {
                    return !isNaN(parseInt(t, 10));
                }
                function u(t) {
                    return new RegExp("[A-Z0-9]+-\\d+").test(t);
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var i = r(44), c = n(i), a = r(127), f = n(a), s = r(129), p = n(s), l = r(42);
                e.default = function(t) {
                    var e = (0, p.default)([
                        t.module,
                        t.item,
                        t.secondaryItem,
                        t.tertiaryItem,
                        t.quaternaryItem,
                        t.quinternaryItem
                    ]), r = (0, f.default)(e, function(t) {
                        return o(t) ? "ENTITY_ID" : u(t) ? "ISSUE_KEY" : t;
                    }).join(".");
                    return (0, c.default)((0, l.getKeyTransformers)(), function(t, e) {
                        return e(t);
                    }, r);
                };
            },
            function(t, e, r) {
                var n = r(46), o = r(62), u = o(n);
                t.exports = u;
            },
            function(t, e, r) {
                var n = r(51), o = r(4), u = Object.prototype, i = u.hasOwnProperty, c = u.propertyIsEnumerable, a = n(function() {
                    return arguments;
                }()) ? n : function(t) {
                    return o(t) && i.call(t, "callee") && !c.call(t, "callee");
                };
                t.exports = a;
            },
            function(t, e, r) {
                (function(e) {
                    var r = "object" == typeof e && e && e.Object === Object && e;
                    t.exports = r;
                }).call(e, r(23));
            },
            function(t, e) {
                var r;
                r = function() {
                    return this;
                }();
                try {
                    r = r || Function("return this")() || (0, eval)("this");
                } catch (t) {
                    "object" == typeof window && (r = window);
                }
                t.exports = r;
            },
            function(t, e, r) {
                (function(t) {
                    var n = r(1), o = r(54), u = "object" == typeof e && e && !e.nodeType && e, i = u && "object" == typeof t && t && !t.nodeType && t, c = i && i.exports === u, a = c ? n.Buffer : void 0, f = a ? a.isBuffer : void 0, s = f || o;
                    t.exports = s;
                }).call(e, r(25)(t));
            },
            function(t, e) {
                t.exports = function(t) {
                    return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                        enumerable: !0,
                        get: function() {
                            return t.l;
                        }
                    }), Object.defineProperty(t, "id", {
                        enumerable: !0,
                        get: function() {
                            return t.i;
                        }
                    }), t.webpackPolyfill = 1), t;
                };
            },
            function(t, e) {
                function r(t, e) {
                    var r = typeof t;
                    return !!(e = null == e ? n : e) && ("number" == r || "symbol" != r && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
                }
                var n = 9007199254740991, o = /^(?:0|[1-9]\d*)$/;
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(55), o = r(56), u = r(57), i = u && u.isTypedArray, c = i ? o(i) : n;
                t.exports = c;
            },
            function(t, e, r) {
                function n(t) {
                    if (!u(t)) return !1;
                    var e = o(t);
                    return e == c || e == a || e == i || e == f;
                }
                var o = r(3), u = r(14), i = "[object AsyncFunction]", c = "[object Function]", a = "[object GeneratorFunction]", f = "[object Proxy]";
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return "function" == typeof t ? t : null == t ? i : "object" == typeof t ? c(t) ? u(t[0], t[1]) : o(t) : a(t);
                }
                var o = r(63), u = r(114), i = r(41), c = r(0), a = r(123);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = this.__data__ = new o(t);
                    this.size = e.size;
                }
                var o = r(6), u = r(70), i = r(71), c = r(72), a = r(73), f = r(74);
                n.prototype.clear = u, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = f, t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    return t === e || t !== t && e !== e;
                }
                t.exports = r;
            },
            function(t, e) {
                function r(t) {
                    if (null != t) {
                        try {
                            return o.call(t);
                        } catch (t) {}
                        try {
                            return t + "";
                        } catch (t) {}
                    }
                    return "";
                }
                var n = Function.prototype, o = n.toString;
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e, r, i, c) {
                    return t === e || (null == t || null == e || !u(t) && !u(e) ? t !== t && e !== e : o(t, e, r, i, n, c));
                }
                var o = r(91), u = r(4);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e, r, n, f, s) {
                    var p = r & c, l = t.length, v = e.length;
                    if (l != v && !(p && v > l)) return !1;
                    var d = s.get(t);
                    if (d && s.get(e)) return d == e;
                    var y = -1, h = !0, b = r & a ? new o : void 0;
                    for(s.set(t, e), s.set(e, t); ++y < l;){
                        var x = t[y], _ = e[y];
                        if (n) var j = p ? n(_, x, y, e, t, s) : n(x, _, y, t, e, s);
                        if (void 0 !== j) {
                            if (j) continue;
                            h = !1;
                            break;
                        }
                        if (b) {
                            if (!u(e, function(t, e) {
                                if (!i(b, e) && (x === t || f(x, t, r, n, s))) return b.push(e);
                            })) {
                                h = !1;
                                break;
                            }
                        } else if (x !== _ && !f(x, _, r, n, s)) {
                            h = !1;
                            break;
                        }
                    }
                    return s.delete(t), s.delete(e), h;
                }
                var o = r(92), u = r(95), i = r(96), c = 1, a = 2;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return t === t && !o(t);
                }
                var o = r(14);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    return function(r) {
                        return null != r && r[t] === e && (void 0 !== e || t in Object(r));
                    };
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    e = o(e, t);
                    for(var r = 0, n = e.length; null != t && r < n;)t = t[u(e[r++])];
                    return r && r == n ? t : void 0;
                }
                var o = r(38), u = r(10);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    return o(t) ? t : u(t, e) ? [
                        t
                    ] : i(c(t));
                }
                var o = r(0), u = r(17), i = r(116), c = r(119);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
                    return o;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e, r) {
                    e = o(e, t);
                    for(var n = -1, s = e.length, p = !1; ++n < s;){
                        var l = f(e[n]);
                        if (!(p = null != t && r(t, l))) break;
                        t = t[l];
                    }
                    return p || ++n != s ? p : !!(s = null == t ? 0 : t.length) && a(s) && c(l, s) && (i(t) || u(t));
                }
                var o = r(38), u = r(21), i = r(0), c = r(26), a = r(12), f = r(10);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return t;
                }
                t.exports = r;
            },
            function(t, e, r) {
                "use strict";
                (function(t) {
                    function n(t) {
                        return t && t.__esModule ? t : {
                            default: t
                        };
                    }
                    function o(t, e, r) {
                        return e in t ? Object.defineProperty(t, e, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = r, t;
                    }
                    function u(e, r) {
                        t.window._jsdApdex ? (0, d.default)(t.window._jsdApdex, e) || (t.window._jsdApdex[e] = r) : t.window._jsdApdex = o({}, e, r);
                    }
                    function i() {
                        return t.window._jsdApdex || {};
                    }
                    function c(t) {
                        u("metricsRecorder", t);
                    }
                    function a() {
                        return i().metricsRecorder ? i().metricsRecorder : (console.error("APDEX metrics recorder not initialized. Not recording APDEX."), {
                            start: l.default,
                            end: l.default
                        });
                    }
                    function f(t) {
                        u("keyTransformers", t);
                    }
                    function s() {
                        return i().keyTransformers || [];
                    }
                    Object.defineProperty(e, "__esModule", {
                        value: !0
                    });
                    var p = r(41), l = n(p), v = r(130), d = n(v);
                    e.installMetricsRecorder = c, e.getMetricsRecorder = a, e.installKeyTransformers = f, e.getKeyTransformers = s;
                }).call(e, r(23));
            },
            function(t, e, r) {
                "use strict";
                function n(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }
                function o(t) {
                    return "object" === (void 0 === t ? "undefined" : f(t)) ? (0, p.default)(t) : "string" == typeof t ? (0, v.default)(t) : "";
                }
                function u(t, e) {
                    (0, y.installMetricsRecorder)(t), (0, y.installKeyTransformers)(e);
                }
                function i(t, e) {
                    var r = o(t);
                    return (0, d.withStartEventFiltering)(r, function(t) {
                        (0, y.getMetricsRecorder)().start(t, e);
                    });
                }
                function c(t) {
                    var e = o(t);
                    return (0, d.withEndEventFiltering)(e, function(t) {
                        (0, y.getMetricsRecorder)().end(t);
                    });
                }
                function a(t) {
                    return c(t);
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.getExpectedRedirect = e.hasExpectedRedirect = e.hasExpectedRedirectOf = void 0;
                var f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                };
                e.install = u, e.start = i, e.end = c, e.readyForUser = a;
                var s = r(19), p = n(s), l = r(132), v = n(l), d = r(133), y = r(42);
                e.hasExpectedRedirectOf = d.hasExpectedRedirectOf, e.hasExpectedRedirect = d.hasExpectedRedirect, e.getExpectedRedirect = d.getExpectedRedirect;
            },
            function(t, e, r) {
                function n(t, e, r) {
                    var n = a(t) ? o : c, f = arguments.length < 3;
                    return n(t, i(e, 4), r, f, u);
                }
                var o = r(45), u = r(20), i = r(29), c = r(126), a = r(0);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e, r, n) {
                    var o = -1, u = null == t ? 0 : t.length;
                    for(n && u && (r = t[++o]); ++o < u;)r = e(r, t[o], o, t);
                    return r;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    return t && o(t, e, u);
                }
                var o = r(47), u = r(11);
                t.exports = n;
            },
            function(t, e, r) {
                var n = r(48), o = n();
                t.exports = o;
            },
            function(t, e) {
                function r(t) {
                    return function(e, r, n) {
                        for(var o = -1, u = Object(e), i = n(e), c = i.length; c--;){
                            var a = i[t ? c : ++o];
                            if (!1 === r(u[a], a, u)) break;
                        }
                        return e;
                    };
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = i(t), n = !r && u(t), s = !r && !n && c(t), l = !r && !n && !s && f(t), v = r || n || s || l, d = v ? o(t.length, String) : [], y = d.length;
                    for(var h in t)!e && !p.call(t, h) || v && ("length" == h || s && ("offset" == h || "parent" == h) || l && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || a(h, y)) || d.push(h);
                    return d;
                }
                var o = r(50), u = r(21), i = r(0), c = r(24), a = r(26), f = r(27), s = Object.prototype, p = s.hasOwnProperty;
                t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
                    return n;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    return u(t) && o(t) == i;
                }
                var o = r(3), u = r(4), i = "[object Arguments]";
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = i.call(t, a), r = t[a];
                    try {
                        t[a] = void 0;
                        var n = !0;
                    } catch (t) {}
                    var o = c.call(t);
                    return n && (e ? t[a] = r : delete t[a]), o;
                }
                var o = r(5), u = Object.prototype, i = u.hasOwnProperty, c = u.toString, a = o ? o.toStringTag : void 0;
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return o.call(t);
                }
                var n = Object.prototype, o = n.toString;
                t.exports = r;
            },
            function(t, e) {
                function r() {
                    return !1;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    return i(t) && u(t.length) && !!c[o(t)];
                }
                var o = r(3), u = r(12), i = r(4), c = {};
                c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c["[object Arguments]"] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c["[object Map]"] = c["[object Number]"] = c["[object Object]"] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1, t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return function(e) {
                        return t(e);
                    };
                }
                t.exports = r;
            },
            function(t, e, r) {
                (function(t) {
                    var n = r(22), o = "object" == typeof e && e && !e.nodeType && e, u = o && "object" == typeof t && t && !t.nodeType && t, i = u && u.exports === o, c = i && n.process, a = function() {
                        try {
                            var t = u && u.require && u.require("util").types;
                            return t || c && c.binding && c.binding("util");
                        } catch (t) {}
                    }();
                    t.exports = a;
                }).call(e, r(25)(t));
            },
            function(t, e, r) {
                function n(t) {
                    if (!o(t)) return u(t);
                    var e = [];
                    for(var r in Object(t))c.call(t, r) && "constructor" != r && e.push(r);
                    return e;
                }
                var o = r(59), u = r(60), i = Object.prototype, c = i.hasOwnProperty;
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    var e = t && t.constructor;
                    return t === ("function" == typeof e && e.prototype || n);
                }
                var n = Object.prototype;
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(61), o = n(Object.keys, Object);
                t.exports = o;
            },
            function(t, e) {
                function r(t, e) {
                    return function(r) {
                        return t(e(r));
                    };
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    return function(r, n) {
                        if (null == r) return r;
                        if (!o(r)) return t(r, n);
                        for(var u = r.length, i = e ? u : -1, c = Object(r); (e ? i-- : ++i < u) && !1 !== n(c[i], i, c););
                        return r;
                    };
                }
                var o = r(13);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = u(t);
                    return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function(r) {
                        return r === t || o(r, t, e);
                    };
                }
                var o = r(64), u = r(113), i = r(36);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e, r, n) {
                    var a = r.length, f = a, s = !n;
                    if (null == t) return !f;
                    for(t = Object(t); a--;){
                        var p = r[a];
                        if (s && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1;
                    }
                    for(; ++a < f;){
                        p = r[a];
                        var l = p[0], v = t[l], d = p[1];
                        if (s && p[2]) {
                            if (void 0 === v && !(l in t)) return !1;
                        } else {
                            var y = new o;
                            if (n) var h = n(v, d, l, t, e, y);
                            if (!(void 0 === h ? u(d, v, i | c, n, y) : h)) return !1;
                        }
                    }
                    return !0;
                }
                var o = r(30), u = r(33), i = 1, c = 2;
                t.exports = n;
            },
            function(t, e) {
                function r() {
                    this.__data__ = [], this.size = 0;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    var e = this.__data__, r = o(e, t);
                    return !(r < 0) && (r == e.length - 1 ? e.pop() : i.call(e, r, 1), --this.size, !0);
                }
                var o = r(7), u = Array.prototype, i = u.splice;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = this.__data__, r = o(e, t);
                    return r < 0 ? void 0 : e[r][1];
                }
                var o = r(7);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return o(this.__data__, t) > -1;
                }
                var o = r(7);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = this.__data__, n = o(r, t);
                    return n < 0 ? (++this.size, r.push([
                        t,
                        e
                    ])) : r[n][1] = e, this;
                }
                var o = r(7);
                t.exports = n;
            },
            function(t, e, r) {
                function n() {
                    this.__data__ = new o, this.size = 0;
                }
                var o = r(6);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    var e = this.__data__, r = e.delete(t);
                    return this.size = e.size, r;
                }
                t.exports = r;
            },
            function(t, e) {
                function r(t) {
                    return this.__data__.get(t);
                }
                t.exports = r;
            },
            function(t, e) {
                function r(t) {
                    return this.__data__.has(t);
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = this.__data__;
                    if (r instanceof o) {
                        var n = r.__data__;
                        if (!u || n.length < c - 1) return n.push([
                            t,
                            e
                        ]), this.size = ++r.size, this;
                        r = this.__data__ = new i(n);
                    }
                    return r.set(t, e), this.size = r.size, this;
                }
                var o = r(6), u = r(15), i = r(16), c = 200;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return !(!i(t) || u(t)) && (o(t) ? d : f).test(c(t));
                }
                var o = r(28), u = r(76), i = r(14), c = r(32), a = /[\\^$.*+?()[\]{}|]/g, f = /^\[object .+?Constructor\]$/, s = Function.prototype, p = Object.prototype, l = s.toString, v = p.hasOwnProperty, d = RegExp("^" + l.call(v).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return !!u && u in t;
                }
                var o = r(77), u = function() {
                    var t = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
                    return t ? "Symbol(src)_1." + t : "";
                }();
                t.exports = n;
            },
            function(t, e, r) {
                var n = r(1), o = n["__core-js_shared__"];
                t.exports = o;
            },
            function(t, e) {
                function r(t, e) {
                    return null == t ? void 0 : t[e];
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n() {
                    this.size = 0, this.__data__ = {
                        hash: new o,
                        map: new (i || u),
                        string: new o
                    };
                }
                var o = r(80), u = r(6), i = r(15);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = -1, r = null == t ? 0 : t.length;
                    for(this.clear(); ++e < r;){
                        var n = t[e];
                        this.set(n[0], n[1]);
                    }
                }
                var o = r(81), u = r(82), i = r(83), c = r(84), a = r(85);
                n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
            },
            function(t, e, r) {
                function n() {
                    this.__data__ = o ? o(null) : {}, this.size = 0;
                }
                var o = r(8);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    var e = this.has(t) && delete this.__data__[t];
                    return this.size -= e ? 1 : 0, e;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    var e = this.__data__;
                    if (o) {
                        var r = e[t];
                        return r === u ? void 0 : r;
                    }
                    return c.call(e, t) ? e[t] : void 0;
                }
                var o = r(8), u = "__lodash_hash_undefined__", i = Object.prototype, c = i.hasOwnProperty;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = this.__data__;
                    return o ? void 0 !== e[t] : i.call(e, t);
                }
                var o = r(8), u = Object.prototype, i = u.hasOwnProperty;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = this.__data__;
                    return this.size += this.has(t) ? 0 : 1, r[t] = o && void 0 === e ? u : e, this;
                }
                var o = r(8), u = "__lodash_hash_undefined__";
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = o(this, t).delete(t);
                    return this.size -= e ? 1 : 0, e;
                }
                var o = r(9);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    var e = typeof t;
                    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    return o(this, t).get(t);
                }
                var o = r(9);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return o(this, t).has(t);
                }
                var o = r(9);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = o(this, t), n = r.size;
                    return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
                }
                var o = r(9);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e, r, n, h, x) {
                    var _ = f(t), j = f(e), g = _ ? d : a(t), m = j ? d : a(e);
                    g = g == v ? y : g, m = m == v ? y : m;
                    var w = g == y, O = m == y, A = g == m;
                    if (A && s(t)) {
                        if (!s(e)) return !1;
                        _ = !0, w = !1;
                    }
                    if (A && !w) return x || (x = new o), _ || p(t) ? u(t, e, r, n, h, x) : i(t, e, g, r, n, h, x);
                    if (!(r & l)) {
                        var E = w && b.call(t, "__wrapped__"), P = O && b.call(e, "__wrapped__");
                        if (E || P) {
                            var R = E ? t.value() : t, S = P ? e.value() : e;
                            return x || (x = new o), h(R, S, r, n, x);
                        }
                    }
                    return !!A && (x || (x = new o), c(t, e, r, n, h, x));
                }
                var o = r(30), u = r(34), i = r(97), c = r(101), a = r(108), f = r(0), s = r(24), p = r(27), l = 1, v = "[object Arguments]", d = "[object Array]", y = "[object Object]", h = Object.prototype, b = h.hasOwnProperty;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    var e = -1, r = null == t ? 0 : t.length;
                    for(this.__data__ = new o; ++e < r;)this.add(t[e]);
                }
                var o = r(16), u = r(93), i = r(94);
                n.prototype.add = n.prototype.push = u, n.prototype.has = i, t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return this.__data__.set(t, n), this;
                }
                var n = "__lodash_hash_undefined__";
                t.exports = r;
            },
            function(t, e) {
                function r(t) {
                    return this.__data__.has(t);
                }
                t.exports = r;
            },
            function(t, e) {
                function r(t, e) {
                    for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
                    return !1;
                }
                t.exports = r;
            },
            function(t, e) {
                function r(t, e) {
                    return t.has(e);
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e, r, n, o, w, A) {
                    switch(r){
                        case m:
                            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                            t = t.buffer, e = e.buffer;
                        case g:
                            return !(t.byteLength != e.byteLength || !w(new u(t), new u(e)));
                        case l:
                        case v:
                        case h:
                            return i(+t, +e);
                        case d:
                            return t.name == e.name && t.message == e.message;
                        case b:
                        case _:
                            return t == e + "";
                        case y:
                            var E = a;
                        case x:
                            var P = n & s;
                            if (E || (E = f), t.size != e.size && !P) return !1;
                            var R = A.get(t);
                            if (R) return R == e;
                            n |= p, A.set(t, e);
                            var S = c(E(t), E(e), n, o, w, A);
                            return A.delete(t), S;
                        case j:
                            if (O) return O.call(t) == O.call(e);
                    }
                    return !1;
                }
                var o = r(5), u = r(98), i = r(31), c = r(34), a = r(99), f = r(100), s = 1, p = 2, l = "[object Boolean]", v = "[object Date]", d = "[object Error]", y = "[object Map]", h = "[object Number]", b = "[object RegExp]", x = "[object Set]", _ = "[object String]", j = "[object Symbol]", g = "[object ArrayBuffer]", m = "[object DataView]", w = o ? o.prototype : void 0, O = w ? w.valueOf : void 0;
                t.exports = n;
            },
            function(t, e, r) {
                var n = r(1), o = n.Uint8Array;
                t.exports = o;
            },
            function(t, e) {
                function r(t) {
                    var e = -1, r = Array(t.size);
                    return t.forEach(function(t, n) {
                        r[++e] = [
                            n,
                            t
                        ];
                    }), r;
                }
                t.exports = r;
            },
            function(t, e) {
                function r(t) {
                    var e = -1, r = Array(t.size);
                    return t.forEach(function(t) {
                        r[++e] = t;
                    }), r;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e, r, n, i, a) {
                    var f = r & u, s = o(t), p = s.length;
                    if (p != o(e).length && !f) return !1;
                    for(var l = p; l--;){
                        var v = s[l];
                        if (!(f ? v in e : c.call(e, v))) return !1;
                    }
                    var d = a.get(t);
                    if (d && a.get(e)) return d == e;
                    var y = !0;
                    a.set(t, e), a.set(e, t);
                    for(var h = f; ++l < p;){
                        v = s[l];
                        var b = t[v], x = e[v];
                        if (n) var _ = f ? n(x, b, v, e, t, a) : n(b, x, v, t, e, a);
                        if (!(void 0 === _ ? b === x || i(b, x, r, n, a) : _)) {
                            y = !1;
                            break;
                        }
                        h || (h = "constructor" == v);
                    }
                    if (y && !h) {
                        var j = t.constructor, g = e.constructor;
                        j != g && "constructor" in t && "constructor" in e && !("function" == typeof j && j instanceof j && "function" == typeof g && g instanceof g) && (y = !1);
                    }
                    return a.delete(t), a.delete(e), y;
                }
                var o = r(102), u = 1, i = Object.prototype, c = i.hasOwnProperty;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return o(t, i, u);
                }
                var o = r(103), u = r(105), i = r(11);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e, r) {
                    var n = e(t);
                    return u(t) ? n : o(n, r(t));
                }
                var o = r(104), u = r(0);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
                    return t;
                }
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(106), o = r(107), u = Object.prototype, i = u.propertyIsEnumerable, c = Object.getOwnPropertySymbols, a = c ? function(t) {
                    return null == t ? [] : (t = Object(t), n(c(t), function(e) {
                        return i.call(t, e);
                    }));
                } : o;
                t.exports = a;
            },
            function(t, e) {
                function r(t, e) {
                    for(var r = -1, n = null == t ? 0 : t.length, o = 0, u = []; ++r < n;){
                        var i = t[r];
                        e(i, r, t) && (u[o++] = i);
                    }
                    return u;
                }
                t.exports = r;
            },
            function(t, e) {
                function r() {
                    return [];
                }
                t.exports = r;
            },
            function(t, e, r) {
                var n = r(109), o = r(15), u = r(110), i = r(111), c = r(112), a = r(3), f = r(32), s = f(n), p = f(o), l = f(u), v = f(i), d = f(c), y = a;
                (n && "[object DataView]" != y(new n(new ArrayBuffer(1))) || o && "[object Map]" != y(new o) || u && "[object Promise]" != y(u.resolve()) || i && "[object Set]" != y(new i) || c && "[object WeakMap]" != y(new c)) && (y = function(t) {
                    var e = a(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? f(r) : "";
                    if (n) switch(n){
                        case s:
                            return "[object DataView]";
                        case p:
                            return "[object Map]";
                        case l:
                            return "[object Promise]";
                        case v:
                            return "[object Set]";
                        case d:
                            return "[object WeakMap]";
                    }
                    return e;
                }), t.exports = y;
            },
            function(t, e, r) {
                var n = r(2), o = r(1), u = n(o, "DataView");
                t.exports = u;
            },
            function(t, e, r) {
                var n = r(2), o = r(1), u = n(o, "Promise");
                t.exports = u;
            },
            function(t, e, r) {
                var n = r(2), o = r(1), u = n(o, "Set");
                t.exports = u;
            },
            function(t, e, r) {
                var n = r(2), o = r(1), u = n(o, "WeakMap");
                t.exports = u;
            },
            function(t, e, r) {
                function n(t) {
                    for(var e = u(t), r = e.length; r--;){
                        var n = e[r], i = t[n];
                        e[r] = [
                            n,
                            i,
                            o(i)
                        ];
                    }
                    return e;
                }
                var o = r(35), u = r(11);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    return c(t) && a(e) ? f(s(t), e) : function(r) {
                        var n = u(r, t);
                        return void 0 === n && n === e ? i(r, t) : o(e, n, p | l);
                    };
                }
                var o = r(33), u = r(115), i = r(121), c = r(17), a = r(35), f = r(36), s = r(10), p = 1, l = 2;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e, r) {
                    var n = null == t ? void 0 : o(t, e);
                    return void 0 === n ? r : n;
                }
                var o = r(37);
                t.exports = n;
            },
            function(t, e, r) {
                var n = r(117), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, u = /\\(\\)?/g, i = n(function(t) {
                    var e = [];
                    return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function(t, r, n, o) {
                        e.push(n ? o.replace(u, "$1") : r || t);
                    }), e;
                });
                t.exports = i;
            },
            function(t, e, r) {
                function n(t) {
                    var e = o(t, function(t) {
                        return r.size === u && r.clear(), t;
                    }), r = e.cache;
                    return e;
                }
                var o = r(118), u = 500;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(u);
                    var r = function() {
                        var n = arguments, o = e ? e.apply(this, n) : n[0], u = r.cache;
                        if (u.has(o)) return u.get(o);
                        var i = t.apply(this, n);
                        return r.cache = u.set(o, i) || u, i;
                    };
                    return r.cache = new (n.Cache || o), r;
                }
                var o = r(16), u = "Expected a function";
                n.Cache = o, t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    return null == t ? "" : o(t);
                }
                var o = r(120);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t) {
                    if ("string" == typeof t) return t;
                    if (i(t)) return u(t, n) + "";
                    if (c(t)) return s ? s.call(t) : "";
                    var e = t + "";
                    return "0" == e && 1 / t == -a ? "-0" : e;
                }
                var o = r(5), u = r(39), i = r(0), c = r(18), a = 1 / 0, f = o ? o.prototype : void 0, s = f ? f.toString : void 0;
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    return null != t && u(t, e, o);
                }
                var o = r(122), u = r(40);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    return null != t && e in Object(t);
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    return i(t) ? o(c(t)) : u(t);
                }
                var o = r(124), u = r(125), i = r(17), c = r(10);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    return function(e) {
                        return null == e ? void 0 : e[t];
                    };
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t) {
                    return function(e) {
                        return o(e, t);
                    };
                }
                var o = r(37);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e, r, n, o) {
                    return o(t, function(t, o, u) {
                        r = n ? (n = !1, t) : e(r, t, o, u);
                    }), r;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    return (c(t) ? o : i)(t, u(e, 3));
                }
                var o = r(39), u = r(29), i = r(128), c = r(0);
                t.exports = n;
            },
            function(t, e, r) {
                function n(t, e) {
                    var r = -1, n = u(t) ? Array(t.length) : [];
                    return o(t, function(t, o, u) {
                        n[++r] = e(t, o, u);
                    }), n;
                }
                var o = r(20), u = r(13);
                t.exports = n;
            },
            function(t, e) {
                function r(t) {
                    for(var e = -1, r = null == t ? 0 : t.length, n = 0, o = []; ++e < r;){
                        var u = t[e];
                        u && (o[n++] = u);
                    }
                    return o;
                }
                t.exports = r;
            },
            function(t, e, r) {
                function n(t, e) {
                    return null != t && u(t, e, o);
                }
                var o = r(131), u = r(40);
                t.exports = n;
            },
            function(t, e) {
                function r(t, e) {
                    return null != t && o.call(t, e);
                }
                var n = Object.prototype, o = n.hasOwnProperty;
                t.exports = r;
            },
            function(t, e, r) {
                "use strict";
                function n(t) {
                    if (Array.isArray(t)) {
                        for(var e = 0, r = Array(t.length); e < t.length; e++)r[e] = t[e];
                        return r;
                    }
                    return Array.from(t);
                }
                function o(t) {
                    return f.test(t) ? t.replace(f, "") : s.test(t) ? t.replace(s, "") : p.test(t) ? t.replace(p, "") : t.substr(1);
                }
                function u(t, e, r, n, o, u) {
                    return {
                        module: t,
                        item: e,
                        secondaryItem: r,
                        tertiaryItem: n,
                        quaternaryItem: o,
                        quinternaryItem: u
                    };
                }
                function i(t) {
                    var e = o(t);
                    return u.apply(void 0, n(e.split("/")));
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.stateFromRoute = i;
                var c = r(19), a = function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }(c), f = /^\/servicedesk\/admin\/[A-Z][A-Z0-9]{1,9}\//, s = /^\/projects\/[A-Z][A-Z0-9]{1,9}\//, p = /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]{1,9}\//;
                e.default = function(t) {
                    return (0, a.default)(i(t));
                };
            },
            function(t, e, r) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var n = RegExp("\\.REDIRECT$"), o = void 0, u = e.getExpectedRedirect = function(t) {
                    return t.replace(n, "");
                }, i = e.hasExpectedRedirect = function(t) {
                    return n.test(t);
                }, c = (e.hasExpectedRedirectOf = function(t) {
                    return t + ".REDIRECT";
                }, function(t) {
                    return i(t) ? o = u(t) : (o = void 0, t);
                });
                e.resetSuppressedEvent = function() {
                    o = void 0;
                }, e.withStartEventFiltering = function(t, e) {
                    if (u(t) === o) return c(t);
                    var r = c(t);
                    return e(r), r;
                }, e.withEndEventFiltering = function(t, e) {
                    return i(t) ? u(t) : (e(t), t);
                };
            }
        ]);
    });
});
parcelRegister("4dIEX", function(module, exports) {
    $parcel$export(module.exports, "getLegacyIssueView", ()=>$edcc17545faab980$export$31910960cc695581);
    var $4su49;
    const $edcc17545faab980$export$31910960cc695581 = ()=>(0, (0, parcelRequire("4su49")).asyncWrmRequire)([
            'wrc!jira.view.issue',
            'wrc!sd.project.legacy.issue.view',
            'wrc!sd.project.queues.legacy.issue.view.bridge'
        ]).then(()=>__jsdQueues.LegacyIssueView);
});
parcelRegister("es7xv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41a9966aaeb8e865$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("9o0uh");
    var $kb4zh;
    var $dJl1T;
    var $39xOx;
    var $jcw0u;
    var $dOWyV;
    var $br2Pa = parcelRequire("br2Pa");
    var $bkr5m;
    class $41a9966aaeb8e865$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onSubmitApdex: ()=>{}
            };
        }
        componentDidMount() {
            this.requestForBridgedView();
        }
        shouldComponentUpdate({ issueKey: nextKey }, { loading: nextLoading }) {
            const { issueKey: issueKey } = this.props;
            const { loading: loading } = this.state;
            return nextKey !== issueKey || nextLoading !== loading;
        }
        componentDidUpdate({ issueKey: prevIssueKey }) {
            const { issueView: issueView } = this;
            const { issueKey: key, report: report } = this.props;
            const hasIssueKeyChanged = prevIssueKey !== key;
            if (hasIssueKeyChanged) {
                if (issueView) issueView.render({
                    key: key,
                    report: report
                });
                else {
                    this.bridgeSubscription.unsubscribe();
                    this.requestForBridgedView();
                }
            }
        }
        componentWillUnmount() {
            const { bridgeSubscription: bridgeSubscription, issueView: issueView } = this;
            if (bridgeSubscription) bridgeSubscription.unsubscribe();
            if (issueView) issueView.dismiss();
        }
        requestForBridgedView() {
            const { onSubmitApdex: onSubmitApdex, pathname: pathname, isInitialRender: isInitialRender } = this.props;
            this.bridgeSubscription = (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("bkr5m")).getLegacyIssueView)()).subscribe((IssueView)=>{
                let generatedPageState;
                if (!onSubmitApdex && pathname) {
                    const jsdApdexSanitizedPathname = pathname.replace('/jira/servicedesk', '');
                    generatedPageState = (0, (0, parcelRequire("dOWyV")).generatePageState)({
                        newRoute: jsdApdexSanitizedPathname,
                        isSettings: false
                    });
                    (0, $br2Pa.start)(generatedPageState, isInitialRender);
                }
                this.setState({
                    loading: false
                });
                const { report: report, issueKey: key } = this.props;
                const { current: el } = this.wrapperRef;
                if (el) {
                    this.issueView = new IssueView();
                    this.issueView.setElement(el).render({
                        key: key,
                        report: report
                    }).then(()=>{
                        if (onSubmitApdex) onSubmitApdex();
                        else generatedPageState && (0, $br2Pa.end)(generatedPageState);
                    });
                }
            }, (error)=>{
                const errMessage = `Reports Legacy issue view has failed to load: ${error}`;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'legacyIssueViewLoad',
                        packageName: 'jiraServicedeskReportsLegacyIssueView'
                    },
                    error: new Error(errMessage)
                });
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('servicedesk.reports.legacy-issue-view.view', errMessage);
            });
        }
        render() {
            const ReportsLegacyIssueView = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.state.loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.wrapperRef
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                id: "reportsLegacyIssueViewApp",
                packageName: "jiraServicedeskReportsLegacyIssueView",
                fallback: "flag"
            }, ReportsLegacyIssueView);
        }
        constructor(...args){
            super(...args);
            this.state = {
                loading: true
            };
            this.wrapperRef = (0, $5uXOq.createRef)();
        }
    }
});
parcelRegister("bkr5m", function(module, exports) {
    $parcel$export(module.exports, "getLegacyIssueView", ()=>$9935f05dd918bed8$export$31910960cc695581);
    var $4su49;
    const $9935f05dd918bed8$export$31910960cc695581 = ()=>(0, (0, parcelRequire("4su49")).asyncWrmRequire)([
            'wrc!jira.view.issue',
            'wrc!sd.project.legacy.issue.view',
            'wrc!sd.project.report.legacy.issue.view.bridge'
        ]).then(()=>__jsdReport.LegacyIssueView);
});
parcelRegister("aE9zr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27617637114749a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $27617637114749a1$export$eabf00abaa2cb4bf = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cagmp _4t3iidpf _tzy4idpf",
                __cmplp.className
            ])
        });
    });
    var $27617637114749a1$export$2e2bcd8739ae039 = ({ wrmData: wrmData })=>(0, ($parcel$interopDefault($5uXOq))).createElement($27617637114749a1$export$eabf00abaa2cb4bf, {
            id: "jsd-spa-page-wrm-data-container"
        }, JSON.stringify(wrmData));
});
parcelRegister("kZ2Bs", function(module, exports) {
    $parcel$export(module.exports, "WRMModuleLoader", ()=>$f9dad0607e0ed5a7$export$7b7998ab5dc5666b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $4su49;
    class $f9dad0607e0ed5a7$export$7b7998ab5dc5666b extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onLoad: ()=>{}
            };
        }
        componentDidMount() {
            this.getModules();
        }
        componentDidUpdate(prevProps, prevState) {
            if (prevProps.modules !== this.props.modules) this.getModules();
            if (prevState.loading && !this.state.loading) {
                if (!this.state.error) this.props.onLoad();
            }
        }
        getModules() {
            (0, (0, parcelRequire("4su49")).asyncWrmRequire)(this.props.modules).then(()=>{
                this.setState({
                    loading: false,
                    error: null
                });
            }).catch((error)=>{
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('wrm-module-loader.getModules', 'asyncWrmRequire error', error);
                this.setState({
                    loading: false,
                    error: error
                });
            });
        }
        render() {
            const { loading: loading, error: error } = this.state;
            return this.props.children({
                loading: loading,
                error: error
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                loading: true,
                error: null
            };
        }
    }
});
parcelRegister("5yfkL", function(module, exports) {
    $parcel$export(module.exports, "JSMIssueViewLoad", ()=>$22ff3bd19932fd10$export$1e32b6c8e1e31a3d);
    $parcel$export(module.exports, "JSMReportsIssueViewLoad", ()=>$22ff3bd19932fd10$export$30ebd3f479793fc1);
    var $dGrdR;
    const $22ff3bd19932fd10$export$1e32b6c8e1e31a3d = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'service-management.queues.issue'
    });
    const $22ff3bd19932fd10$export$30ebd3f479793fc1 = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'service-management.reports.issue'
    });
});
parcelRegister("6FTcZ", function(module, exports) {
    $parcel$export(module.exports, "useKbConfluenceContext", ()=>$5955acba1bcddf7a$export$a8450b4f39918e6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjZiV;
    var $dIdda = parcelRequire("dIdda");
    const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource);
    const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $dIdda.useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
    var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;
});
parcelRegister("aLr4F", function(module, exports) {
    $parcel$export(module.exports, "useShouldShowLegacyIssueView", ()=>$2b57f7ecaea931e5$export$ebe5701b3a084631);
    var $ebyGx = parcelRequire("ebyGx");
    var $dJl1T;
    var $jlOGG;
    const $2b57f7ecaea931e5$var$OLD_ISSUE_VIEW_QUERY_PARAM = 'oldIssueView';
    const $2b57f7ecaea931e5$var$hasOldIssueViewQueryParam = (search)=>{
        if (false) {
            const query = (0, ($parcel$interopDefault($ebyGx))).parse(search);
            return Object.keys(query).includes($2b57f7ecaea931e5$var$OLD_ISSUE_VIEW_QUERY_PARAM);
        }
        const query = new URLSearchParams(search);
        return query.get('oldIssueView') === 'true';
    };
    const $2b57f7ecaea931e5$var$useNewIssueViewLockedIn = ()=>{
        const { error: error, newIssueViewLockedIn: newIssueViewLockedIn } = (0, (0, parcelRequire("jlOGG")).useNewIssueViewLockInStatus)();
        if (newIssueViewLockedIn !== null) return newIssueViewLockedIn;
        if (error) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-commons.utils.should-show-legacy-issue-view-provider', 'Error getting new issue view lock in status, default to false');
        return false;
    };
    const $2b57f7ecaea931e5$export$ebe5701b3a084631 = (isProjectSimplified, canSeeNewIssueView, search)=>{
        const isNewIssueViewLockedIn = $2b57f7ecaea931e5$var$useNewIssueViewLockedIn();
        if (isNewIssueViewLockedIn) return {
            showLegacyIssueView: false
        };
        if (canSeeNewIssueView) return {
            showLegacyIssueView: $2b57f7ecaea931e5$var$hasOldIssueViewQueryParam(search)
        };
        return {
            showLegacyIssueView: true
        };
    };
});
